webpackJsonp([1],{

/***/ "+8JA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("50Yw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+UxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__ = __webpack_require__("711T");










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sellers-types',
	data: function data() {
		return {
			sellersTypes: [],
			menuOptions: [{
				iconClass: 'fa fa-pencil',
				name: this.$t('private.sellers.sellers_types.menu_more_options.edit_seller_type'),
				action: 'edit'
			}, {
				iconClass: 'fa fa-trash',
				name: this.$t('private.sellers.sellers_types.menu_more_options.delete_seller_type'),
				action: 'delete'
			}],
			filters: {
				name: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					value: '',
					name: this.$t('private.sellers.sellers_types.filters.name'),
					type: 'text',
					error: false,
					filters: {
						type: 'string',
						minLength: 2,
						maxLength: 100,
						required: true
					},
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				ascending: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.sellers.sellers_types.filters.sort_options.created_at'),
					value: 'createdAt',
					name: this.$t('private.sellers.sellers_types.filters.sort_ascending'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.sellers.sellers_types.filters.sort_options.created_at'),
						value: 'createdAt'
					}, {
						fakeValue: this.$t('private.sellers.sellers_types.filters.sort_options.name'),
						value: 'name'
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				descending: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.sellers.sellers_types.filters.sort_descending'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.sellers.sellers_types.filters.sort_options.created_at'),
						value: 'createdAt'
					}, {
						fakeValue: this.$t('private.sellers.sellers_types.filters.sort_options.name'),
						value: 'name'
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				limit: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.sellers.sellers_types.filters.limit_options.10'),
					value: 10,
					name: this.$t('private.sellers.sellers_types.filters.limit'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.sellers.sellers_types.filters.limit_options.10'),
						value: 10
					}, {
						fakeValue: this.$t('private.sellers.sellers_types.filters.limit_options.25'),
						value: 25
					}, {
						fakeValue: this.$t('private.sellers.sellers_types.filters.limit_options.50'),
						value: 50
					}, {
						fakeValue: this.$t('private.sellers.sellers_types.filters.limit_options.100'),
						value: 100
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				skip: {
					value: 0
				}
			},
			getSellersTypesActive: false,
			activateFilters: false,
			haveData: false,
			nextPage: false,
			formCreate: {
				fields: {
					name: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.sellers.sellers_types.fields.name'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 100,
							required: true
						}
					}
				},
				active: false
			},
			displayCreateSellerType: false,
			formUpdate: {
				fields: {
					id: {
						value: '',
						filters: {
							type: 'string',
							required: true
						}
					},
					name: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.sellers.sellers_types.fields.name'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 100,
							required: true
						}
					}
				},
				active: false
			},
			displayUpdateSellerType: false
		};
	},

	methods: {
		getSellersTypes: function getSellersTypes() {

			var vm = this;

			vm.getSellersTypesActive = true;
			vm.sellersTypes = [];

			var dataToSend = '/?name=' + vm.filters.name.value + '&ascending=' + vm.filters.ascending.value + '&descending=' + vm.filters.ascending.value + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

			__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].sellersTypes.getSellersTypes(dataToSend).then(function (response) {

				vm.getSellersTypesActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message);

					return;
				}

				vm.sellersTypes = response.data.sellersTypes;

				if (vm.sellersTypes.length > 0 && !vm.haveData) {

					vm.haveData = true;
				}

				if (vm.sellersTypes.length > vm.filters.limit.value) {

					vm.nextPage = true;

					vm.sellersTypes.pop();
				} else {

					vm.nextPage = false;
				}
			});
		},
		goToBackPage: function goToBackPage() {

			var vm = this;

			if (vm.filters.skip.value != 0) {

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

				vm.getSellersTypes();
			}
		},
		goToNextPage: function goToNextPage() {

			var vm = this;

			if (vm.nextPage) {

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

				vm.getSellersTypes();
			}
		},
		optionSelected: function optionSelected(data) {

			var vm = this;

			if (data.action == 'edit') {

				vm.formUpdate.fields.id.value = data.element.id;
				vm.formUpdate.fields.name.value = data.element.name;

				vm.displayUpdateSellerType = true;
			} else if (data.action == 'delete') {

				vm.deleteSellerType(data.element);
			}
		},
		formCreateSubmit: function formCreateSubmit() {

			var vm = this;

			if (vm.formCreate.active) {

				return;
			}

			vm.formCreate.active = true;

			vm.$root.$emit('validate', [vm.formCreate.fields, function (response) {

				if (!response.success) {

					vm.formCreate.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_3__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				var dataToSend = {
					name: vm.formCreate.fields.name.value
				};

				__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].sellersTypes.createSellerType(dataToSend).then(function (response) {

					vm.formCreate.active = false;

					if (response.status != 200) {

						var _message2 = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', _message2);

						return;
					}

					if (!response.data.success) {

						if (response.data.error.code == 101) {

							var _message3 = {
								message: [vm.$t('errors.parse.101')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message3);
						}

						return;
					}

					var message = {
						message: [vm.$t('private.sellers.sellers_types.create_success')],
						type: 'success'
					};

					vm.$root.$emit('showMessage', message);

					vm.getSellersTypes();

					vm.displayCreateSellerType = false;

					vm.formCreate.fields.name.value = '';
				});
			}]);
		},
		formUpdateSubmit: function formUpdateSubmit() {

			var vm = this;

			if (vm.formUpdate.active) {

				return;
			}

			vm.formUpdate.active = true;

			vm.$root.$emit('validate', [vm.formUpdate.fields, function (response) {

				if (!response.success) {

					vm.formUpdate.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_3__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				var dataToSend = {
					id: vm.formUpdate.fields.id.value,
					name: vm.formUpdate.fields.name.value
				};

				__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].sellersTypes.updateSellerType(dataToSend).then(function (response) {

					vm.formUpdate.active = false;

					if (response.status != 200) {

						var _message4 = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', _message4);

						return;
					}

					if (!response.data.success) {

						if (response.data.error.code == 101) {

							var _message5 = {
								message: [vm.$t('errors.parse.101')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message5);
						}

						return;
					}

					var message = {
						message: [vm.$t('private.sellers.sellers_types.update_success')],
						type: 'success'
					};

					vm.$root.$emit('showMessage', message);

					vm.displayUpdateSellerType = false;

					vm.getSellersTypes();

					vm.formUpdate.fields.name.value = '';
				});
			}]);
		},
		deleteSellerType: function deleteSellerType(element) {

			var vm = this;

			var questionModal = {
				title: this.$t('private.sellers.sellers_types.question_modal.title'),
				question: this.$t('private.sellers.sellers_types.question_modal.question')
			};

			vm.$root.$emit('question-modal', [questionModal, function (response) {

				if (response) {

					var dataToSend = '/?id=' + element.id;

					__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].sellersTypes.deleteSellerType(dataToSend).then(function (response) {

						vm.formUpdate.active = false;

						if (response.status != 200) {

							var _message6 = {
								message: [vm.$t('errors.custom.001')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message6);

							return;
						}

						if (!response.data.success) {

							if (response.data.error.code == 101) {

								var _message7 = {
									message: [vm.$t('errors.parse.101')],
									type: 'error'
								};

								vm.$root.$emit('showMessage', _message7);
							}

							return;
						}

						var message = {
							message: [vm.$t('private.sellers.sellers_types.delete_success')],
							type: 'success'
						};

						vm.$root.$emit('showMessage', message);

						vm.getSellersTypes();
					});
				}
			}]);
		}
	},
	components: {
		MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__["a" /* default */],
		TextField: __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__["a" /* default */],
		SelectField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__["a" /* default */]
	},
	created: function created() {

		var vm = this;

		vm.getSellersTypes();
	}
});

/***/ }),

/***/ "+e7V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Egf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal question-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.title)),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.optionSelected(false)}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"question"},[_vm._v(_vm._s(_vm.question))]),_c('div',{staticClass:"buttons"},[_c('i',{staticClass:"fa fa-check icon round-icon success-color",on:{"click":function($event){_vm.optionSelected(true)}}}),_c('i',{staticClass:"fa fa-times icon round-icon danger-color",on:{"click":function($event){_vm.optionSelected(false)}}})])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.optionSelected(false)}}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/euX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0EFW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0MCM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("bFOO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2c8744_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("i+3Z");
function injectStyle (ssrContext) {
  __webpack_require__("Amvz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f2c8744"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f2c8744_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0PR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("k/Ja");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6c508c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("SngM");
function injectStyle (ssrContext) {
  __webpack_require__("7G/d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e6c508c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e6c508c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0Wv9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es__ = __webpack_require__("j8CV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pt__ = __webpack_require__("p2M4");






var messages = {
	es: __WEBPACK_IMPORTED_MODULE_2__es__["a" /* default */],
	pt: __WEBPACK_IMPORTED_MODULE_3__pt__["a" /* default */]
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var locale = 'pt';

/*
let userLanguage = navigator.language || navigator.userLanguage

if( userLanguage.indexOf('pt') != -1 ){

	locale = 'pt'

}
*/

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
	locale: locale,
	fallbackLocale: 'pt',
	messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ "0ZxF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("As1f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33459116_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("pnIM");
function injectStyle (ssrContext) {
  __webpack_require__("unWL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33459116"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33459116_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1/LL":
/***/ (function(module, exports) {

module.exports = {"api":{"baseUrl":"https://dev.ptparse.contractwella.com.es","appId":"app"},"server":{"port":1360}}

/***/ }),

/***/ "1d/x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'search-field',
	props: ['data'],
	data: function data() {
		return {
			field: {
				fakeValue: this.data.fakeValue,
				value: this.data.value,
				active: false
			}
		};
	},

	methods: {
		getData: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (event) {

			var vm = this;

			this.$emit('getData', event.target.value);
		}, 300),
		optionSelected: function optionSelected(option) {

			var vm = this;

			vm.field.fakeValue = option.fakeValue;

			this.$emit('optionSelected', option.value);
		}
	}
});

/***/ }),

/***/ "1tYJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_date_date__ = __webpack_require__("D507");












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reports-master-data',
  data: function data() {
    return {
      contracts: [],
      filters: {
        since: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.master_data.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.master_data.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        exported: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.master_data.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.master_data.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.all'),
            value: 'all'
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.only_exported'),
            value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.not_exported'),
            value: 'not_exported'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.reports.master_data.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.reports.master_data.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      getContractsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      selectedContracts: [],
      allChecks: [],
      activateAllCheckbox: {
        id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
        display: true,
        error: false,
        value: {
          all: false,
          active: false

        },
        options: {
          all: {
            name: this.$t('private.reports.master_data.table.pages_options.all'),
            disabled: false
          },
          active: {
            name: this.$t('private.reports.master_data.table.pages_options.current'),
            disabled: false
          }
        },
        filters: {
          type: 'manyOptions'
        },
        style: {
          width: '120px'
        }
      },
      exportMasterDataActive: false
    };
  },

  methods: {
    getContracts: function getContracts() {
      var vm = this;

      vm.getContractsActive = true;
      vm.contracts = [];

      var exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported';

      var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
      var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

      var dataToSend = '/?state=' + 0 + '&descending=' + 'appCreationDate' + '&since=' + since + '&until=' + until + '&exported=' + exported + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value + '&virtualSignApproved=false';

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].contracts.getContracts(dataToSend).then(function (response) {
        vm.getContractsActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        var contracts = [];

        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(response.data.contracts, function (element) {
          var wellaTotalDiscount = element.wellaDiscount + element.wellaVariableDiscount;

          element.wellaTotalDiscount = !__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isNaN(wellaTotalDiscount) ? wellaTotalDiscount : 0;
          var premiumDiscount1 = element.premiumDiscount1 ? element.premiumDiscount1 * 1 : 0;
          var premiumVariableDiscount1 = element.premiumVariableDiscount1 ? element.premiumVariableDiscount1 * 1 : 0;
          element.premiumDiscountTotal = premiumDiscount1 + premiumVariableDiscount1;

          var prestigeDiscount1 = element.prestigeDiscount1 ? element.prestigeDiscount1 * 1 : 0;
          var prestigeVariableDiscount1 = element.prestigeVariableDiscount1 ? element.prestigeVariableDiscount1 * 1 : 0;
          element.prestigeDiscountTotal = prestigeDiscount1 + prestigeVariableDiscount1;

          var associatedAccounts = [];

          if (element.associatedAccount1) {
            associatedAccounts.push(element.associatedAccount1);
          }

          if (element.associatedAccount2) {
            associatedAccounts.push(element.associatedAccount2);
          }

          if (element.associatedAccount3) {
            associatedAccounts.push(element.associatedAccount3);
          }

          if (element.associatedAccount4) {
            associatedAccounts.push(element.associatedAccount4);
          }

          if (element.associatedAccount5) {
            associatedAccounts.push(element.associatedAccount5);
          }

          if (associatedAccounts.length == 0) {
            contracts.push(element);

            return;
          }

          __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(associatedAccounts, function (associatedAccount) {
            var contract = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.clone(element);

            contract.associatedAccount = associatedAccount;

            contracts.push(contract);
          });
        });

        vm.contracts = contracts;

        if (vm.contracts.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.contracts.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.contracts.pop();
        } else {
          vm.nextPage = false;
        }

        vm.allChecks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(vm.contracts, function (contract) {
          var field = {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          };

          field.value[contract.id] = false;

          field.options[contract.id] = {};

          return field;
        });
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getContracts();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getContracts();
      }
    },
    activateAllCheckboxToggle: function activateAllCheckboxToggle() {

      var vm = this;

      vm.selectedContracts = [];

      if (vm.activateAllCheckbox.value.active || vm.activateAllCheckbox.value.all) {

        for (var i = 0; i < vm.allChecks.length; i++) {

          for (var j in vm.allChecks[i].value) {

            vm.allChecks[i].value[j] = true;
          }
        }
      } else {

        for (var _i = 0; _i < vm.allChecks.length; _i++) {

          for (var _j in vm.allChecks[_i].value) {

            vm.allChecks[_i].value[_j] = false;
          }
        }
      }

      if (vm.activateAllCheckbox.value.all) vm.activateAllCheckbox.options.active.disabled = true;else vm.activateAllCheckbox.options.active.disabled = false;

      if (vm.activateAllCheckbox.value.active) vm.activateAllCheckbox.options.all.disabled = true;else vm.activateAllCheckbox.options.all.disabled = false;
    },
    exportData: function exportData() {

      var vm = this;

      if (vm.contracts.length == 0) return;

      var selectedContracts = vm.activateAllCheckbox.value.active ? __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(vm.allChecks, 'value') : vm.selectedContracts;

      var contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(selectedContracts, function (element) {

        if (!element) {

          return false;
        }

        var key = '';

        for (var i in element) {

          key = i;
        }

        return element[key];
      });

      contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(contracts, function (element) {

        var key = '';

        for (var i in element) {

          key = i;
        }

        return key;
      });

      if (contracts.length == 0 && !vm.activateAllCheckbox.value.all) {
        var message = {
          message: [vm.$t('private.reports.master_data.export.no_data')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      if (vm.exportMasterDataActive) {

        var _message2 = {
          message: [vm.$t('private.reports.master_data.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', _message2);

        return;
      }

      vm.exportMasterDataActive = true;

      var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
      var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';
      var exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported' ? 'true' : 'false';

      var dataToSend = {
        descending: 'appCreationDate',
        state: '0',
        since: since,
        until: until,
        exported: exported,
        timeZone: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()
      };

      if (contracts.length > 0 && !vm.activateAllCheckbox.value.all) dataToSend['contracts'] = contracts;
      if (vm.activateAllCheckbox.value.all) dataToSend['limit'] = vm.totalContracts;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].reports.exportMasterData(dataToSend).then(function (response) {

        vm.exportMasterDataActive = false;
        vm.selectedContracts = [];

        if (response.status != 200) {

          var _message3 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message3);

          return;
        }

        var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var fileURL = URL.createObjectURL(file);

        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'master_data.xlsx');

        vm.getContracts();
      });
    },
    parseDate: function parseDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(date).format('DD-MM-YYYY');
    },
    validateDateCTO: function validateDateCTO(contract) {
      var vm = this;

      var currentDate = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(contract.appCreationDate);

      if (contract.prorated && contract.proratedMonth) {
        var date = __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(contract.appCreationDate).month(contract.proratedMonth - 1).startOf('month');
        if (date.isAfter(currentDate)) date = date.subtract(1, 'year');
        return date.format('DD-MM-YYYY');
      }

      return contract.startDateOfPeriod;

      // return contract.prorated && contract.proratedMonth ? moment(contract.appCreationDate ).month(contract.proratedMonth).format('DD-MM-YYYY') : contract.startDateOfPeriod;
    },
    parseBrands: function parseBrands(brands) {
      var _bransd = {
        1: 'Wella',
        2: 'SP',
        3: 'Nioxin',
        4: 'SSP',
        5: 'Sassoon',
        6: 'Sebastian'
      };

      var parseBransObjs = [];

      if (brands && brands.length > 0) {
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(brands, function (value) {
          parseBransObjs.push(_bransd[value]);
        });

        return parseBransObjs.map(function (k) {
          return k;
        }).join(', ');
      } else {
        return '';
      }
    },
    getAgreement: function getAgreement(contract, key) {
      var agreements = [];

      if (contract[key + '1']) agreements.push(contract[key + '1']);
      if (contract[key + '2']) agreements.push(contract[key + '2']);
      if (contract[key + '3']) agreements.push(contract[key + '3']);

      return agreements.join(' - ');
    },
    concatValues: function concatValues(items_1, items_2, items_3) {
      var values = [];
      if (items_1) values.push(items_1);
      if (items_2) values.push(items_2);
      if (items_3) values.push(items_3);

      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniq(values).join('/');
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_checkbox_checkbox__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_date_date__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getContracts();
  }
});

/***/ }),

/***/ "2OgN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3SG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("V2bL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e600d11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("ymJa");
function injectStyle (ssrContext) {
  __webpack_require__("Au4d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e600d11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e600d11_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3YZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('private-header'),_c('private-aside'),_c('question-modal'),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "48iy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'text-field',
	props: ['data'],
	data: function data() {
		return {
			field: {
				value: this.data.value
			}
		};
	},

	methods: {
		changeData: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function (event) {

			var vm = this;

			this.$emit('changeData', event.target.value);
		}, 300)
	}
});

/***/ }),

/***/ "4tvh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[(_vm.zips.length < 5)?_c('div',{staticClass:"create-contract",on:{"click":function($event){_vm.exportZipPDFsWindow.display = true; _vm.resetForm()}}},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.export_zip_pdfs")))]):_vm._e(),(_vm.zips.length == 5)?_c('div',[_c('strong',{staticClass:"pl-5"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.limit_zips")))])]):_vm._e()]),(_vm.zips.length > 0)?_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.zips),function(element,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(element.id))])])])})):_vm._e(),_c('select-field',{attrs:{"data":_vm.filters.hidden},on:{"changeData":function($event){_vm.filters.hidden.value = $event; _vm.filters.skip.value = 0; _vm.getZips()}}}),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.zipPDF")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.state")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.year")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.month")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.totalPDFs")))]),_c('th',{staticClass:"header-column-observations"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.sizeFile")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.expire")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.table.actions")))])])]),_c('tbody',_vm._l((_vm.zips),function(element,index){return _c('tr',{class:{ selected : element.rowSelected },on:{"click":function($event){_vm.rowClicked(element, element.rowSelected ? false : true)}}},[_c('td',[_vm._v(_vm._s(_vm.parseDate(element.createdAt, 'DD-MM-YYYY HH:mm')))]),_c('td',[_vm._v(_vm._s(element.zipPDFText))]),_c('td',[_vm._v(_vm._s(element.stateText))]),_c('td',[_vm._v(_vm._s(element.year))]),_c('td',[_vm._v(_vm._s(element.month))]),_c('td',[_vm._v(_vm._s(element.valueMax))]),_c('td',[(['save_zip', 'read_pdf'].includes(element.state) && element.bytesLength == 0)?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-success progress-bar-striped",staticStyle:{"width":"0%"},attrs:{"id":element.objectId,"role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}})]):_vm._e(),(element.bytesLength > 0)?_c('span',[_vm._v(_vm._s(element.bytesLengthText))]):_vm._e()]),_c('td',[_vm._v(_vm._s(element.expire ? _vm.parseDate(element.expire, 'DD-MM-YYYY HH:mm') : ''))]),_c('td',{staticClass:"text-center"},[(element.state == 'downloadable' && element.zip_url)?_c('a',{staticClass:"d-inline-block",attrs:{"href":element.zip_url ? element.zip_url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-archive-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e(),(( ['downloadable', 'error'].includes(element.state) || _vm.validateExpire(element.expire) ))?_c('div',{staticClass:"d-inline-block pl-3",on:{"click":function($event){_vm.deleteZip(element);}}},[_c('i',{staticClass:"fa fa-trash-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e()])])}))])]),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.zips.length == 0 && !_vm.getZipsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.no_results")))]):_vm._e(),(_vm.getZipsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()],1)]),(_vm.exportZipPDFsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in",staticStyle:{"height":"500px"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.contracts.zips.export_zip_pdfs_window.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.exportZipPDFsWindow.display = false;}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.contract},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.contract.value = $event;}}})],1),_c('div',{staticClass:"offset-md-4"})]),_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.year},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.year.value = $event; _vm.generateMoths()}}})],1),_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.month},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.month.value = $event;}}})],1)])]),(_vm.exportZipPDFsWindow.fields.contract.value && _vm.exportZipPDFsWindow.fields.year.value && _vm.exportZipPDFsWindow.fields.month.value)?_c('div',{staticClass:"button",on:{"click":_vm.exportZipPDFs}},[(!_vm.exportZipPDFsWindow.downloadZipPDFsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.zips.export_zip_pdfs_window.download_button")))]):_vm._e(),(_vm.exportZipPDFsWindow.downloadZipPDFsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e()])]),_c('div',{staticClass:"back-screen"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "50Yw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "538u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_file_file__ = __webpack_require__("6YFI");













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sellers-list',
  data: function data() {
    return {
      sellers: [],
      menuOptions: [{
        iconClass: 'fa fa-pencil',
        name: this.$t('private.sellers.list.menu_more_options.edit_seller'),
        action: 'edit'
      }, {
        iconClass: 'fa fa-trash',
        name: this.$t('private.sellers.list.menu_more_options.delete_seller'),
        action: 'delete'
      }],
      filters: {
        fullname: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.sellers.list.filters.fullname'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        username: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.sellers.list.filters.username'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        email: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.sellers.list.filters.email'),
          type: 'email',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        ascending: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.sellers.list.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.sellers.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.firstname'),
            value: 'firstname'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.lastname'),
            value: 'lastname'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.sellers.list.filters.sort_options.created_at'),
          value: 'createdAt',
          name: this.$t('private.sellers.list.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.sellers.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.firstname'),
            value: 'firstname'
          }, {
            fakeValue: this.$t('private.sellers.list.filters.sort_options.lastname'),
            value: 'lastname'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.sellers.list.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.sellers.list.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.sellers.list.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.sellers.list.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.sellers.list.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.sellers.list.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '10px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      getSellersActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      formCreate: {
        fields: {
          firstname: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.firstname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          lastname: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.lastname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          username: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.username'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 4,
              maxLength: 100,
              required: true
            }
          },
          email: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          password: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.password'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          delegation: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.delegation'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          sellerType: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.seller_type'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          active: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
            value: true,
            name: this.$t('private.sellers.list.fields.active'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          multiType: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
            value: false,
            name: this.$t('private.sellers.list.fields.multi_type'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          permissions: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            name: this.$t('private.sellers.list.fields.permissions'),
            error: false,
            value: {
              sellers: false,
              clients: false,
              contracts: false,
              reports: false,
              masterData: false
            },
            options: {
              sellers: {
                name: this.$t('private.sellers.list.fields.permissions_options.sellers'),
                value: false
              },
              clients: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients'),
                value: false
              },
              clientsRecords: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients_records'),
                value: false
              },
              contracts: {
                name: this.$t('private.sellers.list.fields.permissions_options.contracts'),
                value: false
              },
              reports: {
                name: this.$t('private.sellers.list.fields.permissions_options.reports'),
                value: false
              },
              masterData: {
                name: this.$t('private.sellers.list.fields.permissions_options.master_data'),
                value: false
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['sellers', 'clients', 'clientsRecords', 'contracts', 'reports', 'masterData']
            }
          }
        },
        active: false
      },
      displayCreateSeller: false,
      formUpdate: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          firstname: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.firstname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          lastname: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.lastname'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 100,
              required: true
            }
          },
          username: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.username'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 4,
              maxLength: 100,
              required: true
            }
          },
          email: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          password: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.sellers.list.fields.password'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 100
            }
          },
          delegation: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.delegation'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          sellerType: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.seller_type'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          active: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.sellers.list.fields.active'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          multiType: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
            value: false,
            name: this.$t('private.sellers.list.fields.multi_type'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.sellers.list.fields.active_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.sellers.list.fields.active_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          permissions: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            name: this.$t('private.sellers.list.fields.permissions'),
            error: false,
            value: {
              sellers: false,
              clients: false,
              contracts: false,
              reports: false,
              masterData: false
            },
            options: {
              sellers: {
                name: this.$t('private.sellers.list.fields.permissions_options.sellers'),
                value: false
              },
              clients: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients'),
                value: false
              },
              clientsRecords: {
                name: this.$t('private.sellers.list.fields.permissions_options.clients_records'),
                value: false
              },
              contracts: {
                name: this.$t('private.sellers.list.fields.permissions_options.contracts'),
                value: false
              },
              reports: {
                name: this.$t('private.sellers.list.fields.permissions_options.reports'),
                value: false
              },
              masterData: {
                name: this.$t('private.sellers.list.fields.permissions_options.master_data'),
                value: false
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['sellers', 'clients', 'clientsRecords', 'contracts', 'reports', 'masterData']
            }
          }
        },
        active: false
      },
      migrateUsersWindow: {
        display: false,
        migrateCSVFileActive: false,
        sellersToCreated: [],
        sellersWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ',',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      displayUpdateSeller: false,
      getDelegationsActive: false,
      getSellersTypesActive: false,
      exportUsersActive: false,
      displayFoo: false
    };
  },

  methods: {
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    getSellers: function getSellers() {
      var vm = this;

      vm.getSellersActive = true;
      vm.sellers = [];

      var dataToSend = '/?fullname=' + vm.filters.fullname.value + '&username=' + vm.filters.username.value + '&email=' + vm.filters.email.value + '&ascending=' + vm.filters.ascending.value + '&descending=' + vm.filters.descending.value + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.getSellers(dataToSend).then(function (response) {
        vm.getSellersActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.sellers = response.data.sellers;

        if (vm.sellers.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.sellers.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.sellers.pop();
        } else {
          vm.nextPage = false;
        }
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getSellers();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getSellers();
      }
    },
    optionSelected: function optionSelected(data) {
      var vm = this;

      if (data.action == 'edit') {
        vm.formUpdate.fields.id.value = data.element.id;
        vm.formUpdate.fields.firstname.value = data.element.firstname;
        vm.formUpdate.fields.lastname.value = data.element.lastname;
        vm.formUpdate.fields.username.value = data.element.username;
        vm.formUpdate.fields.email.value = data.element.email;
        vm.formUpdate.fields.password.value = '';
        vm.formUpdate.fields.delegation.fakeValue = data.element.delegation ? data.element.delegation.name : '';
        vm.formUpdate.fields.delegation.value = data.element.delegation ? data.element.delegation.objectId : '';
        vm.formUpdate.fields.sellerType.fakeValue = data.element.sellerType ? data.element.sellerType.name : '';
        vm.formUpdate.fields.sellerType.value = data.element.sellerType ? data.element.sellerType.objectId : '';
        vm.formUpdate.fields.active.value = !!data.element.active;
        vm.formUpdate.fields.active.fakeValue = data.element.active ? vm.$t('private.sellers.list.fields.active_options.yes') : vm.$t('private.sellers.list.fields.active_options.no');
        vm.formUpdate.fields.multiType.value = !!data.element.multi_type;
        vm.formUpdate.fields.multiType.fakeValue = data.element.multi_type ? vm.$t('private.sellers.list.fields.active_options.yes') : vm.$t('private.sellers.list.fields.active_options.no');
        vm.formUpdate.fields.permissions.value = data.element.permissions ? data.element.permissions : vm.formCreate.fields.permissions.value;

        vm.displayUpdateSeller = true;
      } else if (data.action == 'delete') {
        vm.deleteSeller(data.element);
      }
    },
    formCreateSubmit: function formCreateSubmit() {
      var vm = this;

      if (vm.formCreate.active) {
        return;
      }

      vm.formCreate.active = true;

      vm.$root.$emit('validate', [vm.formCreate.fields, function (response) {
        if (!response.success) {
          vm.formCreate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          firstname: vm.formCreate.fields.firstname.value,
          lastname: vm.formCreate.fields.lastname.value,
          username: vm.formCreate.fields.username.value,
          email: vm.formCreate.fields.email.value,
          password: vm.formCreate.fields.password.value,
          delegation: vm.formCreate.fields.delegation.value,
          sellerType: vm.formCreate.fields.sellerType.value,
          active: vm.formCreate.fields.active.value,
          multiType: vm.formCreate.fields.multiType.value,
          permissions: vm.formCreate.fields.permissions.value
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.createSeller(dataToSend).then(function (response) {
          vm.formCreate.active = false;

          if (response.status != 200) {
            var _message2 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message2);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code == 101) {
              var _message3 = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message3);

              return;
            }

            if (response.data.error.code == 202) {
              var _message4 = {
                message: [vm.$t('errors.custom.017')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message4);

              return;
            }

            if (response.data.error.code == 203) {
              var _message5 = {
                message: [vm.$t('errors.custom.009')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message5);

              return;
            }

            return;
          }

          var message = {
            message: [vm.$t('private.sellers.list.create_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getSellers();

          vm.displayCreateSeller = false;

          vm.formCreate.fields.firstname.value = '';
          vm.formCreate.fields.lastname.value = '';
          vm.formCreate.fields.username.value = '';
          vm.formCreate.fields.email.value = '';
          vm.formCreate.fields.password.value = '';
          vm.formCreate.fields.delegation.fakeValue = '';
          vm.formCreate.fields.delegation.value = '';
          vm.formCreate.fields.sellerType.fakeValue = '';
          vm.formCreate.fields.sellerType.value = '';
          vm.formCreate.fields.active.value = '';
          vm.formCreate.fields.active.fakeValue = '';
          vm.formCreate.fields.multiType.value = '';
          vm.formCreate.fields.multiType.fakeValue = '';

          for (var i in vm.formCreate.fields.permissions.value) {
            vm.formCreate.fields.permissions.value[i] = false;
          }
        });
      }]);
    },
    formUpdateSubmit: function formUpdateSubmit() {
      var vm = this;

      if (vm.formUpdate.active) {
        return;
      }

      vm.formUpdate.active = true;

      vm.$root.$emit('validate', [vm.formUpdate.fields, function (response) {
        if (!response.success) {
          vm.formUpdate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          id: vm.formUpdate.fields.id.value,
          firstname: vm.formUpdate.fields.firstname.value,
          lastname: vm.formUpdate.fields.lastname.value,
          username: vm.formUpdate.fields.username.value,
          email: vm.formUpdate.fields.email.value,
          password: vm.formUpdate.fields.password.value,
          delegation: vm.formUpdate.fields.delegation.value,
          sellerType: vm.formUpdate.fields.sellerType.value,
          active: vm.formUpdate.fields.active.value,
          multiType: vm.formUpdate.fields.multiType.value,
          permissions: vm.formUpdate.fields.permissions.value
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.updateSeller(dataToSend).then(function (response) {
          vm.formUpdate.active = false;

          if (response.status != 200) {
            var _message6 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message6);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code == 101) {
              var _message7 = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message7);
            }

            if (response.data.error.code == 202 || response.data.error.code == '017') {
              var _message8 = {
                message: [vm.$t('errors.custom.017')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message8);

              return;
            }

            if (response.data.error.code == 203 || response.data.error.code == '009') {
              var _message9 = {
                message: [vm.$t('errors.custom.009')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message9);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.sellers.list.update_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getSellers();

          vm.displayUpdateSeller = false;

          vm.formUpdate.fields.id.value = '';
          vm.formUpdate.fields.firstname.value = '';
          vm.formUpdate.fields.lastname.value = '';
          vm.formUpdate.fields.username.value = '';
          vm.formUpdate.fields.email.value = '';
          vm.formUpdate.fields.password.value = '';
          vm.formUpdate.fields.delegation.fakeValue = '';
          vm.formUpdate.fields.delegation.value = '';
          vm.formUpdate.fields.sellerType.fakeValue = '';
          vm.formUpdate.fields.sellerType.value = '';
          vm.formUpdate.fields.active.value = '';
          vm.formUpdate.fields.active.fakeValue = '';
          vm.formUpdate.fields.multiType.value = '';
          vm.formUpdate.fields.multiType.fakeValue = '';

          for (var i in vm.formUpdate.fields.permissions.value) {
            vm.formUpdate.fields.permissions.value[i] = false;
          }
        });
      }]);
    },
    deleteSeller: function deleteSeller(element) {
      var vm = this;

      var questionModal = {
        title: this.$t('private.sellers.list.question_modal.title'),
        question: this.$t('private.sellers.list.question_modal.question')
      };

      vm.$root.$emit('question-modal', [questionModal, function (response) {
        if (response) {
          var dataToSend = '/?id=' + element.id;

          __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.deleteSeller(dataToSend).then(function (response) {
            vm.formUpdate.active = false;

            if (response.status != 200) {
              var _message10 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message10);

              return;
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                var _message11 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };

                vm.$root.$emit('showMessage', _message11);
              }

              return;
            }

            var message = {
              message: [vm.$t('private.sellers.list.delete_success')],
              type: 'success'
            };

            vm.$root.$emit('showMessage', message);

            vm.getSellers();
          });
        }
      }]);
    },
    getDelegations: function getDelegations() {
      var vm = this;

      vm.getDelegationsActive = true;

      var dataToSend = '';

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].delegations.getDelegations(dataToSend).then(function (response) {
        vm.getDelegationsActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message12 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message12);

          return;
        }

        var delegations = response.data.delegations;

        delegations = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(delegations, function (delegation) {
          return {
            fakeValue: delegation.name,
            value: delegation.id
          };
        });

        vm.formCreate.fields.delegation.options = delegations;
        vm.formUpdate.fields.delegation.options = delegations;
      });
    },
    getSellersTypes: function getSellersTypes() {
      var vm = this;

      vm.getSellersTypesActive = true;

      var dataToSend = '';

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellersTypes.getSellersTypes(dataToSend).then(function (response) {
        vm.getSellersTypesActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message13 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message13);

          return;
        }

        var sellersTypes = response.data.sellersTypes;

        sellersTypes = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sellersTypes, function (sellerType) {
          return {
            fakeValue: sellerType.name,
            value: sellerType.id
          };
        });

        vm.formCreate.fields.sellerType.options = sellersTypes;
        vm.formUpdate.fields.sellerType.options = sellersTypes;
      });
    },
    exportUsers: function exportUsers() {
      var vm = this;

      var dataToSend = {
        timeZone: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()
      };

      if (vm.exportUsersActive) {
        var message = {
          message: [vm.$t('private.clients.list.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      vm.exportUsersActive = true;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.exportUsers(dataToSend).then(function (response) {
        vm.exportUsersActive = false;

        if (response.status != 200) {
          var _message14 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message14);

          return;
        }

        var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var fileURL = URL.createObjectURL(file);

        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'users.xlsx');
      });
    },
    resetDataMigrateUsersWindow: function resetDataMigrateUsersWindow() {
      var vm = this;

      vm.migrateUsersWindow.sellersToCreated = [];
      vm.migrateUsersWindow.sellersWithErrors = [];
      vm.migrateUsersWindow.fields.csv.value = {};
      vm.migrateUsersWindow.fields.csv.fileReady = false;
    },
    migrateUsersSubmit: function migrateUsersSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateUsersWindow.fields.separator.value,
        csv: vm.migrateUsersWindow.fields.csv.value.data
      };

      vm.migrateUsersWindow.migrateCSVFileActive = true;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.migrateCSVFile(dataToSend).then(function (response) {
        vm.migrateUsersWindow.migrateCSVFileActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message15 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message15);

          return;
        }

        vm.migrateUsersWindow.sellersToCreated = response.data.sellersToCreated;
        vm.migrateUsersWindow.sellersWithErrors = response.data.sellersWithErrors;
      });
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_file_file__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getSellers();

    vm.getDelegations();

    vm.getSellersTypes();
  }
});

/***/ }),

/***/ "57QQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.active)?_c('aside',{staticClass:"private-aside slide-in"},[_c('ul',[_c('router-link',{attrs:{"to":_vm.routes.sellersList.path}},[_c('li',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("VE4s"),"alt":""}})])]),_c('li',{staticClass:"sections-container"},[_c('ul',[(_vm.sessionUser.permissions.sellers)?_c('li',{on:{"click":function($event){_vm.smallDevice ? _vm.active = false : ''}}},[_c('router-link',{staticClass:"section",class:{ 'active' : _vm.$route.name == _vm.routes.sellersList.name || _vm.$route.name == _vm.routes.sellersDelegations.name || _vm.$route.name == _vm.routes.sellersTypes.name },attrs:{"to":_vm.routes.sellersList.path}},[_c('i',{staticClass:"fa fa-users"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.sellers")))])])],1):_vm._e(),(_vm.sessionUser.permissions.clients)?_c('li',{on:{"click":function($event){_vm.smallDevice ? _vm.active = false : ''}}},[_c('router-link',{staticClass:"section",class:{ 'active' : _vm.$route.name == _vm.routes.clientsList.name },attrs:{"to":_vm.routes.clientsList.path}},[_c('i',{staticClass:"fa fa-user-plus"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.clients")))])])],1):_vm._e(),(_vm.sessionUser.permissions.clientsRecords)?_c('li',{on:{"click":function($event){_vm.smallDevice ? _vm.active = false : ''}}},[_c('router-link',{staticClass:"section",class:{ 'active' : _vm.$route.name === _vm.routes.clientsRecordsList.name },attrs:{"to":_vm.routes.clientsRecordsList.path}},[_c('i',{staticClass:"fa fa-address-card-o"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.clients_records")))])])],1):_vm._e(),(_vm.sessionUser.permissions.contracts)?_c('li',{on:{"click":function($event){_vm.smallDevice ? _vm.active = false : ''}}},[_c('router-link',{staticClass:"section",class:{ 'active' : _vm.$route.name === _vm.routes.contractsList.name || _vm.$route.name === _vm.routes.contractsSDA.name },attrs:{"to":_vm.routes.contractsList.path}},[_c('i',{staticClass:"fa fa-pencil-square-o"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.contracts")))])])],1):_vm._e(),(_vm.sessionUser.permissions.reports)?_c('li',{on:{"click":function($event){_vm.smallDevice ? _vm.active = false : ''}}},[_c('router-link',{staticClass:"section",class:{ 'active' : [_vm.routes.reportsMasterData.name, _vm.routes.reportsSDA.name, _vm.routes.reportsPotential.name, _vm.routes.reportsCCI.name, _vm.routes.reportsEducation.name].includes(_vm.$route.name)},attrs:{"to":_vm.sessionUser.permissions.masterData ? _vm.routes.reportsMasterData.path : _vm.routes.reportsSDA.path}},[_c('i',{staticClass:"fa fa-line-chart"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.reports")))])])],1):_vm._e(),(_vm.sessionUser.permissions.contracts)?_c('li',{on:{"click":function($event){_vm.smallDevice ? _vm.active = false : ''}}},[_c('router-link',{staticClass:"section",class:{ 'active' : [_vm.routes.historyContracts.name, _vm.routes.historyContractsSDA.name].includes(_vm.$route.name) },attrs:{"to":_vm.routes.historyContracts.path}},[_c('i',{staticClass:"fa fa-history"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.history")))])])],1):_vm._e()])]),_c('li',{staticClass:"hidden-button visible-xs",on:{"click":function($event){_vm.active = false}}},[_c('i',{staticClass:"fa fa-angle-double-left"})])],1),_c('ul',{staticClass:"logout"},[_c('li',{staticClass:"sections-container"},[_c('ul',[_c('li',{staticClass:"section",on:{"click":_vm.logout}},[_c('i',{staticClass:"fa fa-sign-out"}),_c('span',[_vm._v(_vm._s(_vm.$t("private.aside.logout")))])])])])])]):_vm._e(),(_vm.active)?_c('div',{staticClass:"back-screen visible-xs",on:{"click":function($event){_vm.active = false}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "58h1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"create-seller-type",on:{"click":function($event){_vm.displayCreateSellerType ? _vm.displayCreateSellerType = false : _vm.displayCreateSellerType = true}}},[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.create_seller_type")))]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('text-field',{attrs:{"data":_vm.filters.name},on:{"changeData":function($event){_vm.filters.name.value = $event; _vm.filters.skip.value = 0; _vm.getSellersTypes();}}}),_c('select-field',{attrs:{"data":_vm.filters.ascending},on:{"changeData":function($event){_vm.filters.ascending.value = $event; _vm.filters.skip.value = 0; _vm.getSellersTypes();}}}),_c('select-field',{attrs:{"data":_vm.filters.descending},on:{"changeData":function($event){_vm.filters.descending.value = $event; _vm.filters.skip.value = 0; _vm.getSellersTypes();}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getSellersTypes();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.sellersTypes.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.sellersTypes.length > 0)?_c('div',[_c('div',{staticClass:"list"},_vm._l((_vm.sellersTypes),function(sellerType,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item names"},[_vm._v(_vm._s(sellerType.name))])]),_c('menu-more-options',{attrs:{"element":sellerType,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)}))]):_vm._e(),(_vm.sellersTypes.length == 0 && !_vm.getSellersTypesActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.no_results")))]):_vm._e(),(_vm.getSellersTypesActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])]),(_vm.displayCreateSellerType)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.sellers_types_create"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayCreateSellerType = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formCreate.fields.name},on:{"changeData":function($event){_vm.formCreate.fields.name.value = $event}}},[_c('input',{attrs:{"type":"submit","hidden":"hidden"}})]),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.formCreate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.create_button")))]):_vm._e(),(_vm.formCreate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])],1)])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayCreateSellerType = false}}})]):_vm._e(),(_vm.displayUpdateSellerType)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.sellers_types_update"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayUpdateSellerType = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formUpdateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.name},on:{"changeData":function($event){_vm.formUpdate.fields.name.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formUpdateSubmit}},[(!_vm.formUpdate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.sellers_types.update_button")))]):_vm._e(),(_vm.formUpdate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayUpdateSellerType = false}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "59qL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{style:(_vm.data.style),attrs:{"id":_vm.data.id}},[_c('div',{staticClass:"field-container",style:(_vm.data.style)},[_c('div',{staticClass:"check-list-inline"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox","disabled":_vm.data.disabled},domProps:{"checked":_vm.field.value},on:{"click":_vm.field.value,"change":function($event){_vm.changeData()}}}),(_vm.data.name)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e()])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5sUg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/* harmony default export */ __webpack_exports__["a"] = ({
	submit: function submit(data) {

		var config = {
			scrollTop: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(data.selector).offset().top - 300 + 'px'
		};

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(data.target).animate(config);

		return;
	}
});

/***/ }),

/***/ "6X1G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{style:(_vm.data.style)},[(_vm.data.title)?_c('div',{staticClass:"field-container-title"},[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_c('div',{staticClass:"field-container",style:(_vm.data.style)},[((_vm.data.type != 'number' && _vm.field.value != '') || (_vm.data.type == 'number' && (_vm.field.value != '' || _vm.field.value === 0 )))?_c('div',{staticClass:"field-title fade-in"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),(_vm.data.type == 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"}],staticClass:"text-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"text","id":_vm.data.id,"placeholder":_vm.data.name,"maxlength":_vm.data.filters ? _vm.data.filters.maxLength : '',"disabled":_vm.data.disabled},domProps:{"value":(_vm.field.value)},on:{"click":function($event){_vm.data.error = false},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "value", $event.target.value)},_vm.changeData]}}):_vm._e(),(_vm.data.type == 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"}],staticClass:"text-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"password","id":_vm.data.id,"placeholder":_vm.data.name,"maxlength":_vm.data.filters ? _vm.data.filters.maxLength : '',"disabled":_vm.data.disabled},domProps:{"value":(_vm.field.value)},on:{"click":function($event){_vm.data.error = false},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "value", $event.target.value)},_vm.changeData]}}):_vm._e(),(_vm.data.type == 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"}],staticClass:"text-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"email","id":_vm.data.id,"placeholder":_vm.data.name,"maxlength":_vm.data.filters ? _vm.data.filters.maxLength : '',"disabled":_vm.data.disabled},domProps:{"value":(_vm.field.value)},on:{"click":function($event){_vm.data.error = false},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "value", $event.target.value)},_vm.changeData]}}):_vm._e(),(_vm.data.type == 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"}],staticClass:"text-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"number","id":_vm.data.id,"placeholder":_vm.data.name,"maxlength":_vm.data.filters ? _vm.data.filters.maxLength : '',"disabled":_vm.data.disabled},domProps:{"value":(_vm.field.value)},on:{"click":function($event){_vm.data.error = false},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "value", $event.target.value)},_vm.changeData]}}):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6YFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("d+At");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dbbdc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("8P8J");
function injectStyle (ssrContext) {
  __webpack_require__("tSXQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34dbbdc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dbbdc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6mGs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_file_file__ = __webpack_require__("6YFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_date_date__ = __webpack_require__("D507");















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'clients-list',
  data: function data() {
    return {
      clients: [],
      menuOptions: [{
        iconClass: 'fa fa-chain',
        name: this.$t('private.clients.list.menu_more_options.associate_account'),
        action: 'associateAccount'
      }, {
        iconClass: 'fa fa-list',
        name: this.$t('private.clients.list.menu_more_options.see_associated_accounts'),
        action: 'seeAssociatedAccounts'
      }, {
        iconClass: 'fa fa-pencil',
        name: this.$t('private.clients.list.menu_more_options.edit_client'),
        action: 'edit'
      }, {
        iconClass: 'fa fa-trash',
        name: this.$t('private.clients.list.menu_more_options.delete_client'),
        action: 'delete'
      }],
      filters: {
        cif: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.clients.list.filters.cif'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 100,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        clientCode: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.clients.list.filters.client_code'),
          type: 'text',
          error: false,
          filters: {
            maxLength: 8
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        // email : {
        // 	id      : _.uniqueId('field_'),
        // 	display : true,
        // 	value   : '',
        // 	name    : this.$t('private.clients.list.filters.email'),
        // 	type    : 'email',
        // 	error   : false,
        // 	filters : {
        // 		type      : 'string',
        // 		minLength : 2,
        // 		maxLength : 100,
        // 		required  : true
        // 	}
        // },
        legalName: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.clients.list.fields.legal_name'),
          type: 'text',
          error: false,
          filters: {
            type: 'string',
            minLength: 2,
            maxLength: 40,
            required: true
          },
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        ascending: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.clients.list.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.clients.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.cif'),
            value: 'cif'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.client_code'),
            value: 'clientCode'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.clients.list.filters.sort_options.created_at'),
          value: 'createdAt',
          name: this.$t('private.clients.list.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.clients.list.filters.sort_options.created_at'),
            value: 'createdAt'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.cif'),
            value: 'cif'
          }, {
            fakeValue: this.$t('private.clients.list.filters.sort_options.client_code'),
            value: 'clientCode'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.clients.list.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.clients.list.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.clients.list.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.clients.list.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.clients.list.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.clients.list.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      getClientsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayAssociateAccount: false,
      formAssociateAccount: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          client: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.client'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          legalName: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.legal_name'),
            type: 'text',
            disabled: true,
            error: false,
            filters: {}
          },
          cif: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.cif'),
            type: 'text',
            disabled: true,
            error: false,
            filters: {}
          },
          email: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.associate_account_modal.fields.email'),
            type: 'email',
            disabled: true,
            error: false,
            filters: {}
          }
        },
        active: false
      },
      getSearchClientsForAssociated: false,
      formCreate: {
        fields: {
          seller: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.seller'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          cfia: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cfia'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 15
            }
          },
          cif: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cif'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 15,
              required: true
            }
          },
          clientCode: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.client_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 8,
              maxLength: 10,
              required: true
            }
          },
          email: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email',
              minLength: 7,
              maxLength: 100,
              required: true
            }
          },
          employeesQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.employees_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number',
              required: true
            }
          },
          loungesQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.lounges_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number',
              required: true
            }
          },
          legalName: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.legal_name'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 40,
              required: true
            }
          },
          address: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.address'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          city: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.city'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          province: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.province'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          postal_code: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.postal_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 8,
              required: false
            }
          },
          // dischargeDate : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	fakeValue : '',
          // 	value     : '',
          // 	name      : this.$t('private.clients.list.fields.discharge_date'),
          // 	error     : false,
          // 	active    : false,
          // 	filters   : {
          // 		type      : 'date',
          // 		required  : true
          // 	}
          // },
          // status : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	fakeValue : this.$t('private.clients.list.fields.status_options.active'),
          // 	value     : true,
          // 	name      : this.$t('private.clients.list.fields.status'),
          // 	error     : false,
          // 	active    : false,
          // 	options : [{
          // 		fakeValue : this.$t('private.clients.list.fields.status_options.active'),
          // 		value : true
          // 	},{
          // 		fakeValue : this.$t('private.clients.list.fields.status_options.inactive'),
          // 		value : false
          // 	}],
          // 	filters : {
          // 		type      : 'boolean',
          // 		required  : true
          // 	}
          // },
          // recruitingLR : {
          // 	id        : _.uniqueId('field_'),
          // 	display   : true,
          // 	fakeValue : '',
          // 	value     : '',
          // 	name      : this.$t('private.clients.list.fields.recruiting_lr'),
          // 	error     : false,
          // 	active    : false,
          // 	options : [{
          // 		fakeValue : this.$t('private.clients.list.fields.recruiting_lr_options.yes'),
          // 		value : true
          // 	},{
          // 		fakeValue : this.$t('private.clients.list.fields.recruiting_lr_options.no'),
          // 		value : false
          // 	}],
          // 	filters : {
          // 		type      : 'boolean',
          // 		required  : true
          // 	}
          // },
          mktNews: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          emailInvoices: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.email_invoices'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
            // conditions : {
            // 	id        : _.uniqueId('field_'),
            // 	display   : true,
            // 	name      : this.$t('private.clients.list.fields.conditions'),
            // 	error     : false,
            // 	value     : {
            // 		imageConditions : false
            // 	},
            // 	options   : {
            // 		imageConditions : {
            // 			name : this.$t('private.clients.list.fields.conditions_options.image_conditions')
            // 		}
            // 	},
            // 	filters   : {
            // 		type : 'manyOptions',
            // 		enum : ['imageConditions']
            // 	}
            // }
          } },
        active: false
      },
      displayCreateClient: false,
      formUpdate: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          seller: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.seller'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          cfia: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cfia'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 15
            }
          },
          cif: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cif'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 15,
              required: true
            }
          },
          clientCode: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.client_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 8,
              maxLength: 10,
              required: true
            }
          },
          email: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.email'),
            type: 'email',
            error: false,
            filters: {
              type: 'email'
              // minLength : 7,
              // maxLength : 100,
              // required  : true
            }
          },
          employeesQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.employees_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
              // required  : true
            }
          },
          loungesQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.lounges_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
              // required  : true
            }
          },
          legalName: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.legal_name'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 2,
              maxLength: 40,
              required: true
            }
          },
          phone: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.phone'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          cellphone: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.cellphone'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          address: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.address'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          city: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.city'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 15
            }
          },
          province: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.province'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              required: false
            }
          },
          postal_code: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.postal_code'),
            type: 'text',
            error: false,
            filters: {
              type: 'string',
              minLength: 7,
              maxLength: 8,
              required: false
            }
          },
          web: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.web'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          ownerName: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.owner_name'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          headquarters: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.headquarters'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
              // minLength : 2,
              // maxLength : 40
            }
          },
          onlineShop: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.online_shop'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.online_shop_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.online_shop_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          resaleShop: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.resale_shop'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.resale_shop_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.resale_shop_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          dischargeDate: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.discharge_date'),
            error: false,
            active: false,
            filters: {
              type: 'date',
              required: true
            }
          },
          status: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.status'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.status_options.active'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.status_options.inactive'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          recruitingLR: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.recruiting_lr'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.recruiting_lr_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.recruiting_lr_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean'
              // required  : true
            }
          },
          mktNews: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          emailInvoices: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.email_invoices'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.email_invoices_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          haveSalon: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.clients.list.fields.have_salon'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.fields.have_salon_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.clients.list.fields.have_salon_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          nioxinPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.nioxin_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          sebastianPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.sebastian_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          spPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.sp_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          systemECPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.system_ec_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          wellaPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.wella_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          wellaRealPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.wella_real_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          totalContractedPastQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.clients.list.fields.total_contracted_past_quantity'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          conditions: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            name: this.$t('private.clients.list.fields.conditions'),
            error: false,
            value: {
              imageConditions: false
            },
            options: {
              imageConditions: {
                name: this.$t('private.clients.list.fields.conditions_options.image_conditions')
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['imageConditions']
            }
          }
        },
        active: false
      },
      displayUpdateClient: false,
      getSellersActive: false,
      displaySeeAssociatedAccounts: false,
      associatedAccountsWindow: {
        display: false,
        client: {},
        associatedAccounts: [],
        menuOptions: [{
          iconClass: 'fa fa-trash',
          name: this.$t('private.clients.list.associated_accounts_modal.menu_more_options.delete_association'),
          action: 'deleteAssociation'
        }]
      },
      importClientsWindow: {
        display: false,
        validateCSVFileActive: false,
        importClientsActive: false,
        clientsToCreate: [],
        clientsToUpdate: [],
        clientsWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 3.5,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        },
        selectedClientsToUpdate: [],
        allChecksUpdate: [],
        activateAllCheckboxUpdate: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          error: false,
          value: {
            active: false
          },
          options: {
            active: {}
          },
          filters: {
            type: 'manyOptions'
          }
        },
        selectedClientsToCreate: [],
        allChecksCreate: [],
        activateAllCheckboxCreate: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          error: false,
          value: {
            active: false
          },
          options: {
            active: {}
          },
          filters: {
            type: 'manyOptions'
          }
        }
      },
      migrateClientsWindow: {
        display: false,
        migrateCSVFileActive: false,
        clientsToCreated: [],
        clientsWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      migrateAssociatedAccountsWindow: {
        display: false,
        migrateCSVFileActive: false,
        associateccountCreated: [],
        associateccountWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      exportClientsActive: false,
      getSearchSellers: false,
      displayFoo: false
    };
  },

  methods: {
    filterSubmit: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.debounce(function () {
      var vm = this;

      vm.getClients();
    }, 1000),
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    getClients: function getClients() {
      var vm = this;

      vm.clients = [];
      vm.getClientsActive = true;

      var dataToSend = '/?cif=' + vm.filters.cif.value + '&clientCode=' + vm.filters.clientCode.value +
      // '&email='      + vm.filters.email.value       +
      '&legalName=' + vm.filters.legalName.value + '&ascending=' + vm.filters.ascending.value + '&descending=' + vm.filters.descending.value + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {
        vm.getClientsActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.clients = response.data.clients;

        if (vm.clients.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.clients.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.clients.pop();
        } else {
          vm.nextPage = false;
        }
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getClients();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getClients();
      }
    },
    optionSelected: function optionSelected(data) {
      var vm = this;

      if (data.action == 'associateAccount') {
        vm.formAssociateAccount.fields.id.value = data.element.id;
        vm.formAssociateAccount.fields.client.value = '';
        vm.formAssociateAccount.fields.legalName.value = '';
        vm.formAssociateAccount.fields.cif.value = '';
        vm.formAssociateAccount.fields.email.value = '';

        vm.searchClientsForAssociated('');

        vm.displayAssociateAccount = true;
      } else if (data.action == 'seeAssociatedAccounts') {
        if (data.element.associatedAccounts.length == 0) {
          var message = {
            message: [vm.$t('private.clients.list.not_have_associated_accounts')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        vm.associatedAccountsWindow.display = true;
        vm.associatedAccountsWindow.client = data.element;
        vm.associatedAccountsWindow.associatedAccounts = data.element.associatedAccounts;
      } else if (data.action == 'deleteAssociation') {
        vm.deleteAssociationAccount(data.element);
      } else if (data.action == 'edit') {
        vm.formUpdate.fields.id.value = data.element.id;
        vm.formUpdate.fields.seller.fakeValue = data.element.seller ? data.element.seller.fullname + ' ( ' + data.element.seller.username + ' )' : '';
        vm.formUpdate.fields.seller.value = data.element.seller ? data.element.seller.objectId : '';
        vm.formUpdate.fields.cfia.value = data.element.cfia ? data.element.cfia : '';
        vm.formUpdate.fields.cif.value = data.element.cif ? data.element.cif : '';
        vm.formUpdate.fields.address.value = data.element.address ? data.element.address : '';
        vm.formUpdate.fields.city.value = data.element.town ? data.element.town : '';
        vm.formUpdate.fields.province.value = data.element.province ? data.element.province : '';
        vm.formUpdate.fields.postal_code.value = data.element.zipcode ? data.element.zipcode : '';
        vm.formUpdate.fields.clientCode.value = data.element.clientCode ? data.element.clientCode : '';
        vm.formUpdate.fields.email.value = data.element.email ? data.element.email : '';
        vm.formUpdate.fields.employeesQuantity.value = data.element.employeesQuantity ? data.element.employeesQuantity : 0;
        vm.formUpdate.fields.loungesQuantity.value = data.element.loungesQuantity ? data.element.loungesQuantity : 0;
        vm.formUpdate.fields.legalName.value = data.element.legalName ? data.element.legalName : '';
        vm.formUpdate.fields.phone.value = data.element.phone ? data.element.phone : '';
        vm.formUpdate.fields.cellphone.value = data.element.cellphone ? data.element.cellphone : '';
        vm.formUpdate.fields.web.value = data.element.web ? data.element.web : '';
        vm.formUpdate.fields.ownerName.value = data.element.ownerName ? data.element.ownerName : '';
        vm.formUpdate.fields.headquarters.value = data.element.headquarters ? data.element.headquarters : '';
        vm.formUpdate.fields.onlineShop.fakeValue = data.element.onlineShop ? vm.$t('private.clients.list.fields.online_shop_options.yes') : vm.$t('private.clients.list.fields.online_shop_options.no');
        vm.formUpdate.fields.onlineShop.value = !!data.element.onlineShop;
        vm.formUpdate.fields.resaleShop.fakeValue = data.element.resaleShop ? vm.$t('private.clients.list.fields.resale_shop_options.yes') : vm.$t('private.clients.list.fields.resale_shop_options.no');
        vm.formUpdate.fields.resaleShop.value = !!data.element.resaleShop;
        vm.formUpdate.fields.haveSalon.fakeValue = data.element.haveSalon ? vm.$t('private.clients.list.fields.have_salon_options.yes') : vm.$t('private.clients.list.fields.have_salon_options.no');
        vm.formUpdate.fields.haveSalon.value = !!data.element.haveSalon;
        vm.formUpdate.fields.nioxinPastQuantity.value = data.element.nioxinPastQuantity ? data.element.nioxinPastQuantity : 0;
        vm.formUpdate.fields.sebastianPastQuantity.value = data.element.sebastianPastQuantity ? data.element.sebastianPastQuantity : 0;
        vm.formUpdate.fields.spPastQuantity.value = data.element.spPastQuantity ? data.element.spPastQuantity : 0;
        vm.formUpdate.fields.systemECPastQuantity.value = data.element.systemECPastQuantity ? data.element.systemECPastQuantity : 0;
        vm.formUpdate.fields.wellaPastQuantity.value = data.element.wellaPastQuantity ? data.element.wellaPastQuantity : 0;
        vm.formUpdate.fields.wellaRealPastQuantity.value = data.element.wellaRealPastQuantity ? data.element.wellaRealPastQuantity : 0;
        vm.formUpdate.fields.totalContractedPastQuantity.value = data.element.totalContractedPastQuantity ? data.element.totalContractedPastQuantity : 0;
        vm.formUpdate.fields.dischargeDate.fakeValue = data.element.dischargeDate ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(data.element.dischargeDate.iso).format('DD-MM-YYYY') : '';
        vm.formUpdate.fields.dischargeDate.value = data.element.dischargeDate ? data.element.dischargeDate.iso : '';
        vm.formUpdate.fields.status.fakeValue = data.element.status ? vm.$t('private.clients.list.fields.status_options.active') : vm.$t('private.clients.list.fields.status_options.inactive');
        vm.formUpdate.fields.status.value = !!data.element.status;
        vm.formUpdate.fields.recruitingLR.fakeValue = data.element.recruitingLR ? vm.$t('private.clients.list.fields.recruiting_lr_options.yes') : vm.$t('private.clients.list.fields.recruiting_lr_options.no');
        vm.formUpdate.fields.recruitingLR.value = !!data.element.recruitingLR;
        vm.formUpdate.fields.mktNews.fakeValue = data.element.mktNews ? vm.$t('private.clients.list.fields.mkt_news_options.yes') : vm.$t('private.clients.list.fields.mkt_news_options.no');
        vm.formUpdate.fields.mktNews.value = !!data.element.mktNews;
        vm.formUpdate.fields.emailInvoices.fakeValue = data.element.emailInvoices ? vm.$t('private.clients.list.fields.email_invoices_options.yes') : vm.$t('private.clients.list.fields.email_invoices_options.no');
        vm.formUpdate.fields.emailInvoices.value = !!data.element.emailInvoices;
        vm.formUpdate.fields.conditions.value.imageConditions = !!data.element.imageConditions;

        vm.displayUpdateClient = true;
      } else if (data.action == 'delete') {
        vm.deleteClient(data.element);
      }
    },
    searchClientsForAssociated: function searchClientsForAssociated(data) {
      var vm = this;

      vm.getSearchClientsForAssociated = true;

      var dataToSend = '?clientCode=' + data;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {
        vm.getSearchClientsForAssociated = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message2 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        var clients = response.data.clients;

        clients = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(clients, function (client) {
          return {
            fakeValue: client.legalName + ' (' + client.clientCode + ')',
            value: client
          };
        });

        vm.formAssociateAccount.fields.client.options = clients;
      });
    },
    clientForAssociatedSelected: function clientForAssociatedSelected(data) {
      var vm = this;

      vm.formAssociateAccount.fields.client.value = data.id;
      vm.formAssociateAccount.fields.legalName.value = data.legalName;
      vm.formAssociateAccount.fields.cif.value = data.cif;
      vm.formAssociateAccount.fields.email.value = data.email;
    },
    formAssociateAccountSubmit: function formAssociateAccountSubmit() {
      var vm = this;

      if (vm.formAssociateAccount.active) {
        return;
      }

      vm.formAssociateAccount.active = true;

      vm.$root.$emit('validate', [vm.formAssociateAccount.fields, function (response) {
        if (!response.success) {
          vm.formAssociateAccount.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          id: vm.formAssociateAccount.fields.id.value,
          accountToAssociate: vm.formAssociateAccount.fields.client.value
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.associateAccount(dataToSend).then(function (response) {
          vm.formAssociateAccount.active = false;

          if (response.status != 200) {
            var _message3 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message3);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code == 101) {
              var _message4 = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message4);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.clients.list.associate_account_modal.success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getClients();

          vm.displayAssociateAccount = false;

          vm.formAssociateAccount.fields.client.value = '';
          vm.formAssociateAccount.fields.legalName.value = '';
          vm.formAssociateAccount.fields.cif.value = '';
          vm.formAssociateAccount.fields.email.value = '';
        });
      }]);
    },
    deleteAssociationAccount: function deleteAssociationAccount(element) {
      var vm = this;

      var questionModal = {
        title: this.$t('private.clients.list.associated_accounts_modal.question_modal.title'),
        question: this.$t('private.clients.list.associated_accounts_modal.question_modal.question')
      };

      vm.$root.$emit('question-modal', [questionModal, function (response) {
        if (response) {
          var dataToSend = '?clientId=' + vm.associatedAccountsWindow.client.id + '&associatedAccountId=' + element.objectId;

          __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.deleteAssociationAccount(dataToSend).then(function (response) {
            vm.formUpdate.active = false;

            if (response.status != 200) {
              var _message5 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message5);

              return;
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                var _message6 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };

                vm.$root.$emit('showMessage', _message6);
              }

              return;
            }

            var message = {
              message: [vm.$t('private.clients.list.associated_accounts_modal.delete_success')],
              type: 'success'
            };

            vm.$root.$emit('showMessage', message);

            vm.associatedAccountsWindow.display = false;

            vm.getClients();
          });
        }
      }]);
    },
    formCreateSubmit: function formCreateSubmit() {
      var vm = this;

      if (vm.formCreate.active) {
        return;
      }

      vm.formCreate.active = true;

      vm.$root.$emit('validate', [vm.formCreate.fields, function (response) {
        if (!response.success) {
          vm.formCreate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          seller: vm.formCreate.fields.seller.value,
          cfia: vm.formCreate.fields.cfia.value,
          cif: vm.formCreate.fields.cif.value,
          clientCode: vm.formCreate.fields.clientCode.value,
          legalName: vm.formCreate.fields.legalName.value,
          dischargeDate: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().toDate(),
          email: vm.formCreate.fields.email.value,
          employeesQuantity: vm.formCreate.fields.employeesQuantity.value,
          loungesQuantity: vm.formCreate.fields.loungesQuantity.value,
          // dischargeDate     : moment(vm.formCreate.fields.dischargeDate.value).endOf('').toDate(),
          // status            : vm.formCreate.fields.status.value,
          // recruitingLR      : vm.formCreate.fields.recruitingLR.value,
          address: vm.formCreate.fields.address.value,
          town: vm.formCreate.fields.city.value,
          province: vm.formCreate.fields.province.value,
          zipcode: vm.formCreate.fields.postal_code.value,
          mktNews: vm.formCreate.fields.mktNews.value,
          emailInvoices: vm.formCreate.fields.emailInvoices.value
          // imageConditions   : vm.formCreate.fields.conditions.value.imageConditions
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.createClient(dataToSend).then(function (response) {
          vm.formCreate.active = false;

          if (response.status != 200) {
            var _message7 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message7);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code == '002') {
              vm.formCreate.fields.clientCode.error = true;

              var _message8 = {
                message: [vm.$t('errors.custom.002')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message8);
            }

            if (response.data.error.code == '007') {
              vm.formCreate.fields.cif.error = true;

              var _message9 = {
                message: [vm.$t('errors.custom.007')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message9);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.clients.list.create_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getClients();

          vm.displayCreateClient = false;

          vm.formCreate.fields.seller.value = '';
          vm.formCreate.fields.cif.value = '';
          vm.formCreate.fields.clientCode.value = '';
          vm.formCreate.fields.legalName.value = '';
          vm.formCreate.fields.address.value = '';
          vm.formCreate.fields.city.value = '';
          vm.formCreate.fields.province.value = '';
          vm.formCreate.fields.postal_code.value = '';
          // vm.formCreate.fields.dischargeDate.value              = ''
          // vm.formCreate.fields.email.value                      = ''
          // vm.formCreate.fields.employeesQuantity.value          = ''
          // vm.formCreate.fields.loungesQuantity.value            = ''
          // vm.formCreate.fields.dischargeDate.value              = ''
          // vm.formCreate.fields.status.value                     = ''
          // vm.formCreate.fields.recruitingLR.value               = ''
          vm.formCreate.fields.mktNews.value = '';
          vm.formCreate.fields.emailInvoices.value = '';
          // vm.formCreate.fields.conditions.value.imageConditions = false
        });
      }]);
    },
    formUpdateSubmit: function formUpdateSubmit() {
      var vm = this;

      if (vm.formUpdate.active) {
        return;
      }

      vm.formUpdate.active = true;

      vm.$root.$emit('validate', [vm.formUpdate.fields, function (response) {
        if (!response.success) {
          vm.formUpdate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          id: vm.formUpdate.fields.id.value,
          seller: vm.formUpdate.fields.seller.value,
          cfia: vm.formUpdate.fields.cfia.value,
          cif: vm.formUpdate.fields.cif.value,
          clientCode: vm.formUpdate.fields.clientCode.value,
          email: vm.formUpdate.fields.email.value,
          employeesQuantity: vm.formUpdate.fields.employeesQuantity.value,
          loungesQuantity: vm.formUpdate.fields.loungesQuantity.value,
          legalName: vm.formUpdate.fields.legalName.value,
          phone: vm.formUpdate.fields.phone.value,
          cellphone: vm.formUpdate.fields.cellphone.value,
          web: vm.formUpdate.fields.web.value,
          address: vm.formUpdate.fields.address.value,
          town: vm.formUpdate.fields.city.value,
          province: vm.formUpdate.fields.province.value,
          zipcode: vm.formUpdate.fields.postal_code.value,
          ownerName: vm.formUpdate.fields.ownerName.value,
          headquarters: vm.formUpdate.fields.headquarters.value,
          onlineShop: vm.formUpdate.fields.onlineShop.value,
          resaleShop: vm.formUpdate.fields.resaleShop.value,
          haveSalon: vm.formUpdate.fields.haveSalon.value,
          nioxinPastQuantity: vm.formUpdate.fields.nioxinPastQuantity.value,
          sebastianPastQuantity: vm.formUpdate.fields.sebastianPastQuantity.value,
          spPastQuantity: vm.formUpdate.fields.spPastQuantity.value,
          systemECPastQuantity: vm.formUpdate.fields.systemECPastQuantity.value,
          wellaPastQuantity: vm.formUpdate.fields.wellaPastQuantity.value,
          wellaRealPastQuantity: vm.formUpdate.fields.wellaRealPastQuantity.value,
          totalContractedPastQuantity: vm.formUpdate.fields.totalContractedPastQuantity.value,
          dischargeDate: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.formUpdate.fields.dischargeDate.value).endOf('day').toDate(),
          status: vm.formUpdate.fields.status.value,
          // recruitingLR                : vm.formUpdate.fields.recruitingLR.value,
          mktNews: vm.formUpdate.fields.mktNews.value,
          emailInvoices: vm.formUpdate.fields.emailInvoices.value,
          imageConditions: vm.formUpdate.fields.conditions.value.imageConditions
        };

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.updateClient(dataToSend).then(function (response) {
          vm.formUpdate.active = false;

          if (response.status != 200) {
            var _message10 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message10);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code == '002') {
              vm.formUpdate.fields.clientCode.error = true;

              var _message11 = {
                message: [vm.$t('errors.custom.002')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message11);
            }

            if (response.data.error.code == '007') {
              vm.formCreate.fields.cif.error = true;

              var _message12 = {
                message: [vm.$t('errors.custom.007')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message12);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.clients.list.update_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getClients();

          vm.displayUpdateClient = false;

          vm.formUpdate.fields.id.value = '';
          vm.formUpdate.fields.seller.value = '';
          vm.formUpdate.fields.cfia.value = '';
          vm.formUpdate.fields.cif.value = '';
          vm.formUpdate.fields.address.value = '';
          vm.formUpdate.fields.city.value = '';
          vm.formUpdate.fields.province.value = '';
          vm.formUpdate.fields.postal_code.value = '';
          vm.formUpdate.fields.clientCode.value = '';
          vm.formUpdate.fields.email.value = '';
          vm.formUpdate.fields.employeesQuantity.value = '';
          vm.formUpdate.fields.loungesQuantity.value = '';
          vm.formUpdate.fields.legalName.value = '';
          vm.formUpdate.fields.dischargeDate.value = '';
          vm.formUpdate.fields.status.value = '';
          vm.formUpdate.fields.recruitingLR.value = '';
          vm.formUpdate.fields.mktNews.value = '';
          vm.formUpdate.fields.emailInvoices.value = '';
          vm.formUpdate.fields.conditions.value.imageConditions = false;
        });
      }]);
    },
    deleteClient: function deleteClient(element) {
      var vm = this;

      var questionModal = {
        title: this.$t('private.clients.list.question_modal.title'),
        question: this.$t('private.clients.list.question_modal.question')
      };

      vm.$root.$emit('question-modal', [questionModal, function (response) {
        if (response) {
          var dataToSend = '/?id=' + element.id;

          __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.deleteClient(dataToSend).then(function (response) {
            vm.formUpdate.active = false;

            if (response.status != 200) {
              var _message13 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message13);

              return;
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                var _message14 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };

                vm.$root.$emit('showMessage', _message14);
              }

              return;
            }

            var message = {
              message: [vm.$t('private.clients.list.delete_success')],
              type: 'success'
            };

            vm.$root.$emit('showMessage', message);

            vm.getClients();
          });
        }
      }]);
    },
    searchSellers: function searchSellers(data) {
      var vm = this;

      vm.getSellersActive = true;

      var dataToSend = '?descending=createdAt&fullname=' + data;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].sellers.getSellers(dataToSend).then(function (response) {
        vm.getSellersActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message15 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message15);

          return;
        }

        var sellers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(response.data.sellers, 'username');

        sellers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sellers, function (seller) {
          return {
            fakeValue: seller.fullname + ' ( ' + seller.username + ' )',
            value: seller.id
          };
        });

        vm.formCreate.fields.seller.options = sellers;
        vm.formUpdate.fields.seller.options = sellers;
      });
    },
    sellerSelected: function sellerSelected(data) {
      var vm = this;

      vm.formCreate.fields.seller.value = data;
      vm.formUpdate.fields.seller.value = data;
    },
    displayDataToTooltip: function displayDataToTooltip(client) {
      var clientsRows = '';

      for (var i = 0; i < client.associatedAccounts.length; i++) {
        clientsRows = clientsRows + '<div>' + client.associatedAccounts[i].legalName + ' (' + client.associatedAccounts[i].clientCode + ')</div>';
      }

      return clientsRows;
    },
    validateCSVFile: function validateCSVFile() {
      var vm = this;

      vm.$root.$emit('validate', [vm.importClientsWindow.fields, function (response) {
        console.log(vm.importClientsWindow.fields);

        if (!response.success) {
          vm.formCreate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          separator: vm.importClientsWindow.fields.separator.value,
          csv: vm.importClientsWindow.fields.csv.value.data
        };

        vm.importClientsWindow.validateCSVFileActive = true;

        __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.validateCSVFile(dataToSend).then(function (response) {
          vm.importClientsWindow.validateCSVFileActive = false;

          if (response.status != 200) {
            var message = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', message);

            return;
          }

          if (!response.data.success) {
            var _message16 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message16);

            return;
          }

          vm.importClientsWindow.clientsToCreate = response.data.clientsToCreate;
          vm.importClientsWindow.clientsToUpdate = response.data.clientsToUpdate;
          vm.importClientsWindow.clientsWithErrors = response.data.clientsWithErrors;

          vm.importClientsWindow.allChecksUpdate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(vm.importClientsWindow.clientsToUpdate, function (client) {
            var field = {
              id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
              display: true,
              error: false,
              value: {},
              options: {},
              filters: {
                type: 'manyOptions'
              }
            };

            field.value[client.clientCode] = false;

            field.options[client.clientCode] = {};

            return field;
          });

          vm.importClientsWindow.allChecksCreate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(vm.importClientsWindow.clientsToCreate, function (client) {
            var field = {
              id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
              display: true,
              error: false,
              value: {},
              options: {},
              filters: {
                type: 'manyOptions'
              }
            };

            field.value[client.clientCode] = false;

            field.options[client.clientCode] = {};

            return field;
          });
        });
      }]);
    },
    importClientsSelected: function importClientsSelected() {
      var vm = this;

      var clientsToUpdate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(vm.importClientsWindow.selectedClientsToUpdate, function (element) {
        if (!element) {
          return false;
        }

        var key = '';

        for (var i in element) {
          key = i;
        }

        return element[key];
      });

      clientsToUpdate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(clientsToUpdate, function (element) {
        var key = '';

        for (var i in element) {
          key = i;
        }

        return key;
      });

      clientsToUpdate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(clientsToUpdate, function (clientCode) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(vm.importClientsWindow.clientsToUpdate, { clientCode: clientCode });
      });

      var clientsToCreate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(vm.importClientsWindow.selectedClientsToCreate, function (element) {
        if (!element) {
          return false;
        }

        var key = '';

        for (var i in element) {
          key = i;
        }

        return element[key];
      });

      clientsToCreate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(clientsToCreate, function (element) {
        var key = '';

        for (var i in element) {
          key = i;
        }

        return key;
      });

      clientsToCreate = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(clientsToCreate, function (clientCode) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(vm.importClientsWindow.clientsToCreate, { clientCode: clientCode });
      });

      if (clientsToUpdate.length == 0 && clientsToCreate.length == 0) {
        var message = {
          message: [vm.$t('private.clients.list.import_clients_modal.no_data_to_import')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var dataToSend = {
        clientsToUpdate: clientsToUpdate,
        clientsToCreate: clientsToCreate
      };

      vm.importClientsWindow.importClientsActive = true;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.importClients(dataToSend).then(function (response) {
        vm.importClientsWindow.importClientsActive = false;

        if (response.status != 200) {
          var _message17 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message17);

          return;
        }

        if (!response.data.success) {
          var _message18 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message18);

          return;
        }

        vm.getClients();

        vm.importClientsWindow.display = false;

        var message = {
          message: [vm.$t('private.clients.list.import_clients_modal.import_success')],
          type: 'success'
        };

        vm.$root.$emit('showMessage', message);

        vm.resetDataImportClientsWindow();
      });
    },
    activateAllCheckboxToggleUpdate: function activateAllCheckboxToggleUpdate() {
      var vm = this;

      vm.importClientsWindow.selectedClientsToUpdate = [];

      if (vm.importClientsWindow.activateAllCheckboxUpdate.value.active) {
        for (var i = 0; i < vm.importClientsWindow.allChecksUpdate.length; i++) {
          for (var j in vm.importClientsWindow.allChecksUpdate[i].value) {
            vm.importClientsWindow.allChecksUpdate[i].value[j] = true;
          }
        }
      } else {
        for (var _i = 0; _i < vm.importClientsWindow.allChecksUpdate.length; _i++) {
          for (var _j in vm.importClientsWindow.allChecksUpdate[_i].value) {
            vm.importClientsWindow.allChecksUpdate[_i].value[_j] = false;
          }
        }
      }
    },
    activateAllCheckboxToggleCreate: function activateAllCheckboxToggleCreate() {
      var vm = this;

      vm.importClientsWindow.selectedClientsToCreate = [];

      if (vm.importClientsWindow.activateAllCheckboxCreate.value.active) {
        for (var i = 0; i < vm.importClientsWindow.allChecksCreate.length; i++) {
          for (var j in vm.importClientsWindow.allChecksCreate[i].value) {
            vm.importClientsWindow.allChecksCreate[i].value[j] = true;
          }
        }
      } else {
        for (var _i2 = 0; _i2 < vm.importClientsWindow.allChecksCreate.length; _i2++) {
          for (var _j2 in vm.importClientsWindow.allChecksCreate[_i2].value) {
            vm.importClientsWindow.allChecksCreate[_i2].value[_j2] = false;
          }
        }
      }
    },
    resetDataImportClientsWindow: function resetDataImportClientsWindow() {
      var vm = this;

      vm.importClientsWindow.clientsToCreate = [];
      vm.importClientsWindow.clientsToUpdate = [];
      vm.importClientsWindow.clientsWithErrors = [];
      vm.importClientsWindow.fields.csv.value = {};
      vm.importClientsWindow.fields.csv.fileReady = false;
      vm.importClientsWindow.selectedClientsToUpdate = [];
      vm.importClientsWindow.allChecksUpdate = [];
      vm.importClientsWindow.activateAllCheckboxUpdate.value.active = false;
      vm.importClientsWindow.selectedClientsToCreate = [];
      vm.importClientsWindow.allChecksCreate = [];
      vm.importClientsWindow.activateAllCheckboxCreate.value.active = false;
    },
    exportClients: function exportClients() {
      var vm = this;

      var dataToSend = {
        timeZone: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()
      };

      if (vm.exportClientsActive) {
        var message = {
          message: [vm.$t('private.clients.list.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      vm.exportClientsActive = true;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.exportClients(dataToSend).then(function (response) {
        vm.exportClientsActive = false;

        if (response.status != 200) {
          var _message19 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message19);

          return;
        }

        var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var fileURL = URL.createObjectURL(file);

        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'clients.xlsx');
      });
    },
    parseDate: function parseDate(date) {
      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(date).format('DD-MM-YYYY');
    },
    resetDataMigrateClientsWindow: function resetDataMigrateClientsWindow() {
      var vm = this;

      vm.migrateClientsWindow.clientsToCreated = [];
      vm.migrateClientsWindow.clientsWithErrors = [];
      vm.migrateClientsWindow.fields.csv.value = {};
      vm.migrateClientsWindow.fields.csv.fileReady = false;
    },
    migrateClientsSubmit: function migrateClientsSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateClientsWindow.fields.separator.value,
        csv: vm.migrateClientsWindow.fields.csv.value.data
      };

      vm.migrateClientsWindow.migrateCSVFileActive = true;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.migrateCSVFile('/api/clients/migrate', dataToSend).then(function (response) {
        vm.migrateClientsWindow.migrateCSVFileActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message20 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message20);

          return;
        }

        vm.migrateClientsWindow.clientsToCreated = response.data.clientsToCreated;
        vm.migrateClientsWindow.clientsWithErrors = response.data.clientsWithErrors;
      });
    },
    resetDataMigrateAssociatedAccountsWindow: function resetDataMigrateAssociatedAccountsWindow() {
      var vm = this;

      vm.migrateAssociatedAccountsWindow.associateccountCreated = [];
      vm.migrateAssociatedAccountsWindow.associateccountWithErrors = [];
      vm.migrateAssociatedAccountsWindow.fields.csv.value = {};
      vm.migrateAssociatedAccountsWindow.fields.csv.fileReady = false;
    },
    migrateAssociatedAccountsSubmit: function migrateAssociatedAccountsSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateAssociatedAccountsWindow.fields.separator.value,
        csv: vm.migrateAssociatedAccountsWindow.fields.csv.value.data
      };

      vm.migrateAssociatedAccountsWindow.migrateCSVFileActive = true;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.migrateCSVFile('/api/clients/associatedAccounts/migrate', dataToSend).then(function (response) {
        vm.migrateAssociatedAccountsWindow.migrateCSVFileActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message21 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message21);

          return;
        }

        vm.migrateAssociatedAccountsWindow.associateccountCreated = response.data.associateccountCreated;
        vm.migrateAssociatedAccountsWindow.associateccountWithErrors = response.data.associateccountWithErrors;
      });
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_search_search__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_checkbox_checkbox__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_file_file__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_date_date__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getClients();

    vm.searchSellers('');
  }
});

/***/ }),

/***/ "6mzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_textarea_textarea__ = __webpack_require__("0MCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_fields_file_file__ = __webpack_require__("6YFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_fields_date_date__ = __webpack_require__("D507");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_general_fields_sort_sort__ = __webpack_require__("H0Q9");


















var Parse = __webpack_require__("ZVky");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contracts-zips',
  data: function data() {
    return {
      zips: [],
      menuOptions: [{
        iconClass: 'fa fa-pencil',
        name: this.$t('private.contracts.zips.menu_more_options.edit_contract'),
        action: 'edit'
      }, {
        iconClass: 'fa fa-archive',
        name: this.$t('private.contracts.zips.menu_more_options.archive_contract'),
        action: 'archive'
      }],
      filters: {
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.contracts.zips.filters.limit_options.10'),
          value: 50,
          name: this.$t('private.contracts.zips.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        state: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.state'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.zips.filters.state_options.green'),
            value: 0
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.red'),
            value: 1
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.yellow'),
            value: 2
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.black'),
            value: 3
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.state_options.purple'),
            value: 4
          }],
          style: {
            width: '100px',
            marginTop: '0px'
          }
        },
        hidden: { // ESTO SE HACE POR QUE AL PARECER HAY UN BUG EN LOS FILTROS DENTRO DE LA TABLA Y ESTO LO SOLUCIONA
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.zips.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.contracts.zips.filters.exported_options.no'),
            value: false
          }],
          style: {
            display: 'none'
          }
        },
        since: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.since'),
          error: false,
          active: false,
          style: {
            width: '110px',
            marginTop: '3px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.zips.filters.until'),
          error: false,
          active: false,
          style: {
            width: '110px'
          }
        },
        skip: {
          value: 0
        }
      },
      getZipsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayFoo: false,
      totalZips: 0,
      exportZipPDFsWindow: {
        sessionId: null,
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.zips.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.list.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          contract: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: 'PDFs',
            error: false,
            active: false,
            options: [{
              value: 'Contract',
              fakeValue: 'Contracto'
            }, {
              value: 'SDA',
              fakeValue: 'SDA'
            }],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0,
          download: 0
        }
      }
    };
  },
  methods: {
    filterSubmit: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
      var vm = this;

      vm.getZips();
    }, 1000),
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    actionSort: function actionSort(event, col) {
      var vm = this;

      vm.filters.ascending.value = '';
      vm.filters.descending.value = '';

      if (event.sort_default) vm.filters.descending.value = 'appCreationDate';

      if (event.sort_asc) vm.filters.ascending.value = col;

      if (event.sort_desc) vm.filters.descending.value = col;

      vm.getZips();
    },
    getZips: function getZips() {
      var vm = this;

      vm.getZipsActive = true;
      vm.totalZips = 0;
      vm.zips = [];

      var dataToSend = {
        limit: vm.filters.limit.value + 1,
        skip: vm.filters.skip.value
        // state  : vm.filters.state.value,
        // since  : vm.filters.since.value,
        // until  : vm.filters.until.value
      };

      __WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].contractsZips.getZips(dataToSend).then(function (response) {
        vm.getZipsActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.totalZips = response.data.count;
        vm.zips = response.data.results;

        if (vm.zips.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.zips.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.zips.pop();
        } else {
          vm.nextPage = false;
        }
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getZips();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getZips();
      }
    },
    exportZipPDFs: function exportZipPDFs() {
      var vm = this;

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        var message = {
          message: [vm.$t('private.contracts.zips.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var year = vm.exportZipPDFsWindow.fields.year.value;
      var month = vm.exportZipPDFsWindow.fields.month.value;

      var since = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().tz(__WEBPACK_IMPORTED_MODULE_4__config_env___default.a.timeZone).year(year).month(month - 1).startOf('month');
      var until = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().tz(__WEBPACK_IMPORTED_MODULE_4__config_env___default.a.timeZone).year(year).month(month - 1).endOf('month');

      vm.exportZipPDFsWindow.sessionId = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 20);
      vm.exportZipPDFsWindow.fields.month.disabled = true;
      vm.exportZipPDFsWindow.fields.year.disabled = true;
      vm.exportZipPDFsWindow.downloadZipPDFsActive = true;

      console.log('since', since.toDate());
      console.log('until', until.toDate());

      var dataToSend = {
        since: since.format(),
        until: until.format(),
        timeZone: __WEBPACK_IMPORTED_MODULE_4__config_env___default.a.timeZone,
        sessionId: vm.exportZipPDFsWindow.sessionId,
        contract: vm.exportZipPDFsWindow.fields.contract.value,
        month: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(since.format('MMMM')),
        year: year
      };

      __WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].contractsZips.createZip(dataToSend).then(function (response) {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
        vm.exportZipPDFsWindow.fields.month.disabled = false;
        vm.exportZipPDFsWindow.fields.year.disabled = false;

        if (response.status == 202) {
          var _message2 = {
            message: [vm.$t('errors.custom.011')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        if (response.status != 200) {
          var _message3 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message3);

          return;
        }

        if (!response.data.success) {
          if (response.data.error.code == 101) {
            var _message5 = {
              message: [vm.$t('errors.parse.101')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message5);

            return;
          }

          if (response.data.error.code == 325) {
            var _message6 = {
              message: [vm.$t('errors.custom.016')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message6);

            return;
          }

          var _message4 = {
            message: [vm.$t('errors.custom.011')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message4);

          return;
        }

        var message = {
          message: [vm.$t('private.contracts.zips.create_success')],
          type: 'success'
        };

        vm.$root.$emit('showMessage', message);

        vm.exportZipPDFsWindow.display = false;
        vm.resetForm();
        setTimeout(vm.getZips, 3000);
      });
    },
    generateMoths: function generateMoths() {
      var vm = this;

      var lang = navigator.language || navigator.userLanguage;

      __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.locale(lang);

      var year = vm.exportZipPDFsWindow.fields.year.value;

      var dateNow = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()();
      var dateSelectedYear = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(year);
      var monthNow = 12;

      if (dateNow.year() === dateSelectedYear.year()) monthNow = dateSelectedYear.month() + 1;

      vm.exportZipPDFsWindow.fields.month.options = [];
      vm.exportZipPDFsWindow.fields.month.disabled = true;

      for (var i = 0; i < monthNow; ++i) {
        vm.exportZipPDFsWindow.fields.month.options.push({
          fakeValue: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().month(i).format('MMMM')),
          value: i + 1
        });
      }

      vm.exportZipPDFsWindow.fields.month.value = '';
      vm.exportZipPDFsWindow.fields.month.fakeValue = '';
      vm.exportZipPDFsWindow.fields.month.disabled = false;
    },
    resetForm: function resetForm() {
      var vm = this;

      vm.exportZipPDFsWindow.fields.year.value = '';
      vm.exportZipPDFsWindow.fields.month.value = '';
      vm.exportZipPDFsWindow.fields.month.disabled = false;
      vm.exportZipPDFsWindow.fields.year.disabled = false;
      vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
    },
    generateSlug: function generateSlug(name, toUpperCase, replaceSpaceBy) {
      var _name = toUpperCase ? __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.deburr(name).toUpperCase() : __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.deburr(name).toLowerCase();

      return _name.replace(/\s+/g, replaceSpaceBy || '').toString();
    },
    getAgreement: function getAgreement(contract, key) {
      var agreements = [];

      if (contract[key + '1']) agreements.push(contract[key + '1']);
      if (contract[key + '2']) agreements.push(contract[key + '2']);
      if (contract[key + '3']) agreements.push(contract[key + '3']);

      return agreements.join(' - ');
    },
    parseDate: function parseDate(date, format) {
      date = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(date, 'iso') ? date.iso : date;

      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(new Date(date)).format(format);
    },
    validateExpire: function validateExpire(date) {
      date = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(date, 'iso') ? date.iso : date;

      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isAfter(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(date));
    },
    deleteZip: function deleteZip(element) {
      var vm = this;

      var questionModal = {
        title: this.$t('private.contracts.zips.question_modal.title'),
        question: this.$t('private.contracts.zips.question_modal.question')
      };

      vm.$root.$emit('question-modal', [questionModal, function (response) {
        if (response) {
          __WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].contractsZips.deleteZip(element.objectId).then(function (response) {
            vm.getZips();

            if (response.status != 200) {
              var _message7 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message7);

              return;
            }

            if (!response.data.success) {
              if (response.data.error.code == 101) {
                var _message8 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };

                vm.$root.$emit('showMessage', _message8);
              }

              if (response.data.error.code == 404) {
                var _message9 = {
                  message: [vm.$t('errors.custom.404')],
                  type: 'error'
                };

                vm.$root.$emit('showMessage', _message9);
              }

              return;
            }

            var message = {
              message: [vm.$t('private.contracts.zips.delete_success')],
              type: 'success'
            };

            vm.$root.$emit('showMessage', message);
          });
        }
      }]);
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_6__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_text_text__["a" /* default */],
    TextareaField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_textarea_textarea__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_select_select__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_search_search__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_checkbox_checkbox__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_12__components_general_fields_file_file__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_13__components_general_fields_date_date__["a" /* default */],
    SortField: __WEBPACK_IMPORTED_MODULE_14__components_general_fields_sort_sort__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getZips();

    for (var i = 2017; i <= __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(); i++) {
      vm.exportZipPDFsWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      });
    }
  },
  mounted: function mounted() {
    var vm = this;

    var queryProgress = new Parse.Query('FilesZips');

    var subscriptionProgress = queryProgress.subscribe();

    subscriptionProgress.on('open', function () {});

    subscriptionProgress.on('create', function (event) {
      var isPartitioned = event.get('isPartitioned');
      if (isPartitioned) {
        setTimeout(vm.getZips, 3000);
      }
    });

    subscriptionProgress.on('update', function (event) {
      // let sessionId   = event.get('sessionId');

      // if(vm.exportZipPDFsWindow.sessionId !== sessionId) return;

      var state = event.get('state');
      var count = event.get('count');
      var valueMax = event.get('valueMax');

      console.log('event', event.id);
      console.log('count', count);
      console.log('valueMax', valueMax);

      vm.exportZipPDFsWindow.progress.display = true;
      vm.exportZipPDFsWindow.progress.value = count;
      vm.exportZipPDFsWindow.progress.valueMax = valueMax;

      for (var i = 0; i < vm.zips.length; i++) {
        if (vm.zips[i].objectId == event.id) {
          vm.zips[i].count = count;
          vm.zips[i].state = state;
        }
      }

      var porcentaje = Math.floor(count / valueMax * 100);

      if (count > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + event.id).text(porcentaje + '%');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + event.id).attr('aria-valuenow', porcentaje);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + event.id).css('width', porcentaje + '%');
      }

      if (state === 'downloadable') {
        // subscriptionProgress.unsubscribe();
        setTimeout(vm.getZips, 3000);
      }
    });
  }
});

/***/ }),

/***/ "6r2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("wWPP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312b6686_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("FciK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_312b6686_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "711T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("r0Rk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a7a3de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("z9Du");
function injectStyle (ssrContext) {
  __webpack_require__("CTTP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43a7a3de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43a7a3de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7G/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	getClients: function getClients(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	createClient: function createClient(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	updateClient: function updateClient(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	deleteClient: function deleteClient(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().delete(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	associateAccount: function associateAccount(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients/associatedAccounts';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	deleteAssociationAccount: function deleteAssociationAccount(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients/associatedAccounts' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().delete(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	validateCSVFile: function validateCSVFile(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients/import/validation';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	importClients: function importClients(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients/import';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportClients: function exportClients(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/clients/export';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	migrateCSVFile: function migrateCSVFile(router, data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + router;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "88qS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("1tYJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2d95cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("thIQ");
function injectStyle (ssrContext) {
  __webpack_require__("r9eF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c2d95cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2d95cd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8P8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{style:(_vm.data.style),attrs:{"id":_vm.data.id}},[(!_vm.fileReady)?_c('div',{staticClass:"field-container",on:{"click":_vm.selectFile}},[_c('div',{staticClass:"body"},[_c('i',{staticClass:"icon-file",class:{'fa fa-file-pdf-o' : _vm.data.pdf, 'fa fa-file-excel-o' : _vm.data.xlsx, 'fa fa-file-excel-o' : _vm.data.xls, 'fa fa-file-excel-o' : _vm.data.csv}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.data.name))])])]):_vm._e(),(_vm.fileReady)?_c('div',{staticClass:"field-container file-ready"},[_c('div',{staticClass:"body"},[_c('i',{staticClass:"icon-file",class:{'fa fa-file-pdf-o' : _vm.data.pdf, 'fa fa-file-excel-o' : _vm.data.xlsx, 'fa fa-file-excel-o' : _vm.data.xls, 'fa fa-file-excel-o' : _vm.data.csv}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.fileName))]),(!_vm.data.disabled)?_c('i',{staticClass:"fa fa-times icon-remove round-icon first-color",on:{"click":_vm.removeFile}}):_vm._e()])]):_vm._e(),_c('input',{ref:"fileInput",attrs:{"type":"file","hidden":"hidden"},on:{"change":_vm.changeData}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9+XV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'clients',
	data: function data() {
		return {
			routes: __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */]
		};
	},

	methods: {},
	components: {},
	created: function created() {}
});

/***/ }),

/***/ "94g/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_env__);





/* harmony default export */ __webpack_exports__["a"] = ({
	createContract: function createContract(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/sda';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	getSDAs: function getSDAs(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/sda' + data;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	migrateCSVFile: function migrateCSVFile(router, data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + router;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	sendMailDigitalSignature: function sendMailDigitalSignature(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/sda/digital-signature/send-mail';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data);
	},
	exportZipPDFs: function exportZipPDFs(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/sda/exportZipPDFs';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	getExportZipPDFs: function getExportZipPDFs(archiveId) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/sda/exportZipPDFs/' + archiveId;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url, {
			responseType: 'arraybuffer',
			onDownloadProgress: function onDownloadProgress(progressEvent) {

				if (progressEvent.loaded > 0 && progressEvent.total > 0) {

					var percentCompleted = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_download').text(percentCompleted + '%');
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_download').attr("aria-valuenow", percentCompleted);
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_download').css("width", percentCompleted + "%");
				}
			}
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "98sC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in private-container-view"},[_c('div',{staticClass:"header-sections"},[_c('ul',{staticClass:"items-container"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.sellersList.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.sellers.header.sellers_list")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.sellersList.name}})])]),_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.sellersDelegations.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-street-view icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.sellers.header.sellers_delegations")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.sellersDelegations.name}})])]),_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.sellersTypes.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-id-card-o icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.sellers.header.sellers_types")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.sellersTypes.name}})])])],1)]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AYyO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("+UxX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d0de78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("58h1");
function injectStyle (ssrContext) {
  __webpack_require__("u/mm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-62d0de78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62d0de78_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AbTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
  getSDAsInfo: function getSDAsInfo(data) {

    var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sdasInfo' + data;

    return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
  },
  migrateCSVFile: function migrateCSVFile(data) {

    var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sdasInfo/migrate';

    return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
  }
});

/***/ }),

/***/ "AixB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Amvz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "As1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




var Parse = __webpack_require__("ZVky");
Parse.initialize(__WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.appId);
Parse.serverURL = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'contracts',
	data: function data() {
		return {
			routes: __WEBPACK_IMPORTED_MODULE_0__router_routes__["a" /* default */]
		};
	},

	methods: {},
	components: {},
	created: function created() {}
});

/***/ }),

/***/ "Au4d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BHBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("XUWW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79286742_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("i7XN");
function injectStyle (ssrContext) {
  __webpack_require__("+e7V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79286742"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79286742_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BYMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("vOza");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078d019e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("mcRC");
function injectStyle (ssrContext) {
  __webpack_require__("usps")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-078d019e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078d019e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BsCo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in private-container-view"},[_c('div',{staticClass:"header-sections"},[_c('ul',{staticClass:"items-container"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.clientsRecordsList.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.clients_records.header.clients_records_list")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.clientsRecordsList.name}})])])],1)]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "By3l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more-options"},[_c('i',{staticClass:"fa fa-ellipsis-v round-icon first-color icon",on:{"click":function($event){_vm.active = true}}}),_c('div',{staticClass:"container-menu-more-options"},[(_vm.active)?_c('ul',{staticClass:"menu-more-options fade-in",class:{'top' : _vm.topClass, 'left' : _vm.side == 'left', 'right' : _vm.side == 'right' }},_vm._l((_vm.options),function(option){return _c('li',{on:{"click":function($event){_vm.optionSelected(option)}}},[_c('i',{class:option.iconClass}),_c('span',[_vm._v(_vm._s(option.name))])])})):_vm._e(),(_vm.active)?_c('div',{staticClass:"menu-more-options-back-screen",on:{"click":function($event){_vm.active = false}}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CTTP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D507":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("KZG4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527dc05e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("Nr+5");
function injectStyle (ssrContext) {
  __webpack_require__("c87X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-527dc05e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527dc05e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DUzc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dcil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("1d/x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac02b44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("yeTg");
function injectStyle (ssrContext) {
  __webpack_require__("Jlyh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ac02b44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ac02b44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dzmf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FFFn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FciK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FqCv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G7Rn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("PgVB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4a57c80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("By3l");
function injectStyle (ssrContext) {
  __webpack_require__("zxDY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4a57c80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4a57c80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G9O9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("pbmc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612e755b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("HsW0");
function injectStyle (ssrContext) {
  __webpack_require__("FFFn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-612e755b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612e755b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GSUq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Go9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"create-delegation",on:{"click":function($event){_vm.displayCreateDelegation ? _vm.displayCreateDelegation = false : _vm.displayCreateDelegation = true}}},[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.create_delegation")))]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('text-field',{attrs:{"data":_vm.filters.name},on:{"changeData":function($event){_vm.filters.name.value = $event; _vm.filters.skip.value = 0; _vm.getDelegations();}}}),_c('select-field',{attrs:{"data":_vm.filters.ascending},on:{"changeData":function($event){_vm.filters.ascending.value = $event; _vm.filters.skip.value = 0; _vm.getDelegations();}}}),_c('select-field',{attrs:{"data":_vm.filters.descending},on:{"changeData":function($event){_vm.filters.descending.value = $event; _vm.filters.skip.value = 0; _vm.getDelegations();}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getDelegations();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.delegations.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.delegations.length > 0)?_c('div',[_c('div',{staticClass:"list"},_vm._l((_vm.delegations),function(delegation,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item names"},[_vm._v(_vm._s(delegation.name))])]),_c('menu-more-options',{attrs:{"element":delegation,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)}))]):_vm._e(),(_vm.delegations.length == 0 && !_vm.getDelegationsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.no_results")))]):_vm._e(),(_vm.getDelegationsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])]),(_vm.displayCreateDelegation)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.sellers_delegations_create"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayCreateDelegation = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formCreate.fields.name},on:{"changeData":function($event){_vm.formCreate.fields.name.value = $event}}},[_c('input',{attrs:{"type":"submit","hidden":"hidden"}})]),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.formCreate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.create_button")))]):_vm._e(),(_vm.formCreate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])],1)])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayCreateDelegation = false}}})]):_vm._e(),(_vm.displayUpdateDelegation)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.sellers_delegations_update"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayUpdateDelegation = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formUpdateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.name},on:{"changeData":function($event){_vm.formUpdate.fields.name.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formUpdateSubmit}},[(!_vm.formUpdate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.delegations.update_button")))]):_vm._e(),(_vm.formUpdate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayUpdateDelegation = false}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H0Q9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("L297");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4517765e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("lcrp");
function injectStyle (ssrContext) {
  __webpack_require__("+8JA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4517765e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4517765e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HDgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("48iy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efaae084_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("6X1G");
function injectStyle (ssrContext) {
  __webpack_require__("b5iG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-efaae084"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efaae084_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("0EFW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HgCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_date_date__ = __webpack_require__("D507");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_file_file__ = __webpack_require__("6YFI");














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'history-sda',
  data: function data() {
    return {
      SDAsInfo: [],
      menuOptions: [{
        iconClass: 'fa fa-archive',
        name: this.$t('private.history.sda.menu_more_options.archive_contract'),
        action: 'archive'
      }],
      filters: {
        since: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        exported: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.sda.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
            value: 'all'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.only_exported'),
            value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.not_exported'),
            value: 'not_exported'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.limit_options.50'),
          value: 50,
          name: this.$t('private.reports.sda.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: 10,
            value: 10
          }, {
            fakeValue: 25,
            value: 25
          }, {
            fakeValue: 50,
            value: 50
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        seller: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.client_code'),
          type: 'text',
          error: false,
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      getSDAsInfoActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayFoo: false
    };
  },

  methods: {
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    getSDAsInfo: function getSDAsInfo() {
      var vm = this;

      vm.getSDAsInfoActive = true;
      vm.SDAsInfo = [];

      var exported = vm.filters.exported.value === 'all' ? '' : vm.filters.exported.value === 'only_exported';

      var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
      var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

      var dataToSend = {
        className: 'SDAsInfoHistory',
        limit: vm.filters.limit.value + 1,
        skip: vm.filters.skip.value,
        descending: 'lastDateSDA',
        since: since,
        until: until,
        exported: exported,
        seller: vm.filters.seller.value,
        delegation: vm.filters.delegation.value,
        clientCode: vm.filters.clientCode.value,
        legalName: vm.filters.legalName.value
      };

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].contractsHistory.getContractsSDAHistory(dataToSend).then(function (response) {
        vm.getSDAsInfoActive = false;

        if (!response.data.success) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        vm.SDAsInfo = response.data.contracts;
        vm.totalContracts = response.data.countContracts;

        if (vm.SDAsInfo.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.SDAsInfo.length > vm.filters.limit.value) {
          vm.nextPage = true;
          vm.SDAsInfo.pop();
        } else {
          vm.nextPage = false;
        }
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value !== 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getSDAsInfo();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getSDAsInfo();
      }
    },
    searchClients: function searchClients(data) {
      var vm = this;

      vm.getSearchClients = true;

      var dataToSend = '?clientCode=' + data;

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {
        vm.getSearchClients = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        var clients = response.data.clients;

        clients = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(clients, function (client) {
          return {
            fakeValue: client.legalName + ' (' + client.clientCode + ')',
            value: client
          };
        });

        vm.createContractWindow.form.fields.client.options = clients;
      });
    },
    optionSelected: function optionSelected(data) {
      var vm = this;

      if (data.action === 'delete') {
        vm.archiveContract(data.element);
      }
    },
    parseDate: function parseDate(date) {
      var _date = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(date, 'iso') ? date.iso : date;

      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_date).format('DD-MM-YYYY');
    },
    getDelegations: function getDelegations() {
      var vm = this;

      vm.getDelegationsActive = true;

      var dataToSend = '/?descending=createdAt';

      __WEBPACK_IMPORTED_MODULE_3__api_api__["a" /* default */].delegations.getDelegations(dataToSend).then(function (response) {
        vm.getDelegationsActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message2 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        var delegations = response.data.delegations;

        delegations = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(delegations, function (delegation) {
          return {
            fakeValue: delegation.name,
            value: delegation.id
          };
        });

        vm.filters.delegation.options = delegations;
      });
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_checkbox_checkbox__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_date_date__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_search_search__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_file_file__["a" /* default */]
  },
  created: function created() {
    var vm = this;
    vm.getDelegations();
    vm.getSDAsInfo();
  },
  mounted: function mounted() {
    var vm = this;
  }
});

/***/ }),

/***/ "HrW+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HsW0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v(_vm._s(_vm.$t("public.login.title")))]),_c('div',{staticClass:"window-modal"},[_vm._m(0),_c('div',{staticClass:"body"},[_c('div',{staticClass:"row justify-content-sm-center"},[_c('div',{staticClass:"col-sm-8"},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.formSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.form.fields.username},on:{"changeData":function($event){_vm.form.fields.username.value = $event}}}),_c('text-field',{attrs:{"data":_vm.form.fields.password},on:{"changeData":function($event){_vm.form.fields.password.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formSubmit}},[(!_vm.form.active)?_c('span',[_vm._v(_vm._s(_vm.$t("public.login.login_button")))]):_vm._e(),(_vm.form.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("VE4s")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I7qb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_urijs__ = __webpack_require__("hBlz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_urijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_urijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_tradeTermsConfig_json__ = __webpack_require__("c59E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_tradeTermsConfig_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__config_tradeTermsConfig_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_fields_textarea_textarea__ = __webpack_require__("0MCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_general_fields_inputcheck_checkbox__ = __webpack_require__("yQYn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_general_fields_file_file__ = __webpack_require__("6YFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_general_fields_date_date__ = __webpack_require__("D507");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_general_fields_sort_sort__ = __webpack_require__("H0Q9");






















var Parse = __webpack_require__("ZVky");
var subscriptionProgress = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contracts-list',
  data: function data() {
    return {
      contracts: [],
      tablesDiscounts: {},
      menuOptions: [{
        iconClass: 'fa fa-pencil',
        name: this.$t('private.contracts.list.menu_more_options.edit_contract'),
        action: 'edit'
      }, {
        iconClass: 'fa fa-archive',
        name: this.$t('private.contracts.list.menu_more_options.archive_contract'),
        action: 'archive'
      }],
      filters: {
        ascending: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.contracts.list.filters.sort_options.created_at'),
          value: 'appCreationDate',
          name: this.$t('private.contracts.list.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.contracts.list.filters.limit_options.50'),
          value: 50,
          name: this.$t('private.contracts.list.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.contracts.list.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.contracts.list.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.contracts.list.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        state: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.state'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.state_options.green'),
            value: 0
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.red'),
            value: 1
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.yellow'),
            value: 2
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.black'),
            value: 3
          }, {
            fakeValue: this.$t('private.contracts.list.filters.state_options.purple'),
            value: 4
          }],
          style: {
            width: '100px',
            marginTop: '0px'
          }
        },
        exported: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.master_data.filters.exported_options.all'),
            value: ''
          }, {
            fakeValue: this.$t('private.contracts.list.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.contracts.list.filters.exported_options.no'),
            value: false
          }],
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        contractMode: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.contractMode'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.contractMode_1'),
            value: -1
          }, {
            fakeValue: this.$t('private.contracts.list.filters.contractMode_2'),
            value: 2
          }],
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        hidden: { // ESTO SE HACE POR QUE AL PARECER HAY UN BUG EN LOS FILTROS DENTRO DE LA TABLA Y ESTO LO SOLUCIONA
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.contracts.list.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.contracts.list.filters.exported_options.no'),
            value: false
          }],
          style: {
            display: 'none'
          }
        },
        since: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.since'),
          error: false,
          active: false,
          style: {
            width: '110px',
            marginTop: '3px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.until'),
          error: false,
          active: false,
          style: {
            width: '110px'
          }
        },
        seller: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.client_code'),
          type: 'text',
          error: false,
          filters: {
            maxLength: 8
          },
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      getContractsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      getSearchClients: false,
      formCreate: {
        fields: {
          client: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.client'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          state: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.state'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.state_options.green'),
              value: 0
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.red'),
              value: 1
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.yellow'),
              value: 2
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.black'),
              value: 3
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.purple'),
              value: 4
            }],
            filters: {
              type: 'number',
              required: true
            }
          },
          appCreationDate: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.app_creation_cate'),
            error: false,
            filters: {
              type: 'date'
            }
          },
          associateAccounts: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: false,
            name: this.$t('private.contracts.list.fields.associate_accounts'),
            disabled: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          },
          brands: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            inline: true,
            error: false,
            value: {
              // premium: false,
              // prestige: false,
              dso: false,
              iso: false,
              opi: false
            },
            options: {
              // premium: {
              //   name: this.$t('private.contracts.list.fields.premium'),
              //   disabled: false,
              //   value: false
              // },
              // prestige: {
              //   name: this.$t('private.contracts.list.fields.prestige'),
              //   disabled: false,
              //   value: false
              // },
              dso: {
                name: this.$t('private.contracts.list.fields.dso'),
                disabled: false,
                value: false
              },
              iso: {
                name: this.$t('private.contracts.list.fields.iso'),
                disabled: false,
                value: false
              },
              opi: {
                name: this.$t('private.contracts.list.fields.opi'),
                disabled: false,
                value: false
              }

            },
            filters: {
              type: 'manyOptions',
              enum: [
              // 'premium',
              // 'prestige',
              'dso', 'iso', 'opi'],
              required: true
            }
          },
          // premiumDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_date'),
          //   error: false,
          //   filters: {
          //     type: 'date'
          //   }
          // },
          // premiumSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_salon'),
          //   error: false,
          //   active: false,
          //   options: [{
          //     fakeValue: this.$t('private.contracts.list.fields.premium_salon'),
          //     value: ''
          //   }],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // premiumSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: -1,
          //   name: this.$t('private.contracts.list.fields.premium_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.premium_Brands'),
          //   error: false,
          //   value: {
          //     breandWELLA: false,
          //     breandIOXIN: false,
          //     breandSP: false
          //   },
          //   options: {
          //     breandWELLA: {
          //       name: this.$t('private.contracts.list.fields.BRAND_WELLA'),
          //       value: 1
          //     },
          //     breandIOXIN: {
          //       name: this.$t('private.contracts.list.fields.BRAND_NIOXIN'),
          //       value: 3
          //     },
          //     breandSP: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP'),
          //       value: 2
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions',
          //     enum: ['breandWELLA', 'breandIOXIN', 'breandSP'],
          //     required: true
          //   }
          // },
          // premiumMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_MTKG'),
          //   error: false,
          //   active: false,
          //   options: [],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // premiumMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   disabled: false,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_MTKG_Subtype'),
          //   error: false,
          //   type: 'text',
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumMTKGSubtypeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: false,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype_Brands'),
          //   error: false,
          //   value: {
          //     breandWELLA: false,
          //     breandIOXIN: false,
          //     breandSP: false
          //   },
          //   options: {},
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          // premiumATS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_ATS_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPTS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_PTS_1'),
          //   type: 'text',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_section_1'),
          //   type: 'text',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number',
          //     required: false
          //   }
          // },
          // premiumVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_education_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_potential'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_rappel_frequency'),
          //   type: 'string',
          //   error: false,
          //   options: [],
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_date'),
          //   error: false,
          //   active: false,
          //   filters: {
          //     type: 'date'
          //   }
          // },
          // prestigeSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.premium_salon'),
          //   error: false,
          //   active: false,
          //   options: [{
          //     fakeValue: this.$t('private.contracts.list.fields.premium_salon'),
          //     value: ''
          //   }],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // prestigeSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: -1,
          //   name: this.$t('private.contracts.list.fields.prestige_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeATS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_ATS'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePTS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_PTS'),
          //   type: 'text',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.prestige_Brands'),
          //   error: false,
          //   value: {
          //     // brandSEBASTIAN: false,
          //     brandSP_DIAMOND: false,
          //     brandSASSOON: false
          //   },
          //   options: {
          //     // brandSEBASTIAN: {
          //     //   name: this.$t('private.contracts.list.fields.BRAND_SEBASTIAN'),
          //     //   value: 6
          //     // },
          //     brandSP_DIAMOND: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
          //       value: 4,
          // 	  disabled: true
          //     },
          //     brandSASSOON: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
          //       value: 5,
          // 	  disabled: true
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions',
          //     enum: [
          //        // 'brandSEBASTIAN',
          //        'brandSP_DIAMOND',
          //        'brandSASSOON'
          //     ],
          //     required: true
          //   }
          // },
          // prestigeMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG'),
          //   error: false,
          //   active: false,
          // disabled: true,
          //   options: [{
          //     fakeValue: this.$t('private.contracts.list.fields.prestige_MTKG'),
          //     value: ''
          //   }],
          //   filters: {
          //     type: 'string',
          //     required: false
          //   }
          // },
          // prestigeMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype'),
          //   type: 'text',
          //   error: false,
          //  disabled: true,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeMTKGSubtypeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: false,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype_Brands'),
          //   error: false,
          //   value: {
          //     brandSEBASTIAN: false,
          //     brandSP_DIAMOND: false,
          //     brandSASSOON: false
          //   },
          //   options: {},
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          // prestigeSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_section_1'),
          //   type: 'text',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeEducation: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_education'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_potential'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_frequency'),
          //   type: 'text',
          //   error: false,
          // disabled: true,
          //   options: [],
          //   filters: {
          //     type: 'string'
          //   }
          // },
          dsoDate: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.dso_date'),
            error: false,
            active: false,
            filters: {
              type: 'date'
            }
          },
          dsoSalon: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.dso_salon'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.dso_salon'),
              value: ''
            }],
            filters: {
              type: 'string',
              required: false
            }
          },
          dsoSalonValue: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: -1,
            name: this.$t('private.contracts.list.fields.dso_salon_value'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoPTS: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_PTS'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'string'
            }
          },
          dsoBrands: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            name: this.$t('private.contracts.list.fields.add_Brands'),
            error: false,
            value: {
              brandSP_DIAMOND: false,
              brandSASSOON: false
            },
            options: {
              brandSP_DIAMOND: {
                name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
                value: 4,
                disabled: true
              },
              brandSASSOON: {
                name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
                value: 5,
                disabled: true
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['brandSP_DIAMOND', 'brandSASSOON'],
              required: true
            }
          },
          dsoMTKG: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.dso_MTKG'),
            error: false,
            active: false,
            disabled: true,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.dso_MTKG_options.wella_app'),
              value: this.$t('private.contracts.list.fields.dso_MTKG_options.wella_app')
            }, {
              fakeValue: this.$t('private.contracts.list.fields.dso_MTKG_options.congreso'),
              value: this.$t('private.contracts.list.fields.dso_MTKG_options.congreso')
            }, {
              fakeValue: this.$t('private.contracts.list.fields.dso_MTKG_options.evento_sebastian'),
              value: this.$t('private.contracts.list.fields.dso_MTKG_options.evento_sebastian')
            }],
            filters: {
              type: 'string',
              required: false
            }
          },
          dsoMTKGSubtype: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_MTKG_Subtype'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'string'
            }
          },
          dsoSection: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_section'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'string'
            }
          },
          dsoRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          briogeoRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.briogeo_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoDiscount: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_discount'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoRappelMarketing: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_rappel_marketing'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoEducation: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_education'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoPotential: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_potential'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          dsoRappelFrequency: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_rappel_frequency'),
            type: 'text',
            error: false,
            disabled: true,
            options: [{
              fakeValue: this.$t('utils.frequency.quarterly'),
              value: this.$t('utils.frequency.quarterly')
            }, {
              fakeValue: this.$t('utils.frequency.biannual'),
              value: this.$t('utils.frequency.biannual')
            }, {
              fakeValue: this.$t('utils.frequency.annual'),
              value: this.$t('utils.frequency.annual')
            }],
            filters: {
              type: 'string'
            }
          },
          hasPrestigeCondition: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            name: '',
            inline: true,
            error: false,
            disabled: false,
            value: {
              FY2223: false
            },
            options: {
              FY2223: {
                name: this.$t('private.contracts.list.fields.has_prestige_condition_FY2223'),
                disabled: false
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['FY2223']
            }
          },
          wellaQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_quantity'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          wellaDiscount: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_discount'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          wellaVolumeRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_volume_rappel'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          // sebManRappel: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_rappel'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // sebManDiscount: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_discount'),
          //   type: 'number',
          //   error: false,
          //   disabled: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          rappelMKTG: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          rappelMKTGManual: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg_manual'),
            type: 'text',
            error: false,
            disabled: false,
            filters: {
              type: 'string'
            }
          },
          opiQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_quantity'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          opiDiscount: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_discount'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          opiRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_rappel'),
            type: 'number',
            error: false,
            disabled: false,
            filters: {
              type: 'number'
            }
          },
          observations: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.observations'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          prorated: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.prorated'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.prorated_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.contracts.list.fields.prorated_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          proratedMonth: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.prorated_month'),
            type: 'number',
            error: false,
            disabled: true,
            options: [{
              fakeValue: 1,
              value: 1
            }, {
              fakeValue: 2,
              value: 2
            }, {
              fakeValue: 3,
              value: 3
            }, {
              fakeValue: 4,
              value: 4
            }, {
              fakeValue: 5,
              value: 5
            }, {
              fakeValue: 6,
              value: 6
            }, {
              fakeValue: 7,
              value: 7
            }, {
              fakeValue: 8,
              value: 8
            }, {
              fakeValue: 9,
              value: 9
            }, {
              fakeValue: 10,
              value: 10
            }, {
              fakeValue: 11,
              value: 11
            }, {
              fakeValue: 12,
              value: 12
            }],
            filters: {
              type: 'number',
              required: false
            }
          },
          mktNews: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          pdf: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.contracts.list.fields.pdf'),
            pdf: true,
            readAsDataURL: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 30,
              formatsAllowed: ['pdf'],
              required: true
            }
          }
        },
        active: false
      },
      displayCreateContract: false,
      formUpdate: {
        fields: {
          id: {
            value: '',
            filters: {
              type: 'string',
              required: true
            }
          },
          client: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.client'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            }
          },
          clientCode: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            type: 'text',
            name: this.$t('private.contracts.list.fields.client'),
            error: false,
            active: false,
            disabled: true,
            options: [],
            filters: {
              type: 'string'
            }
          },
          state: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.state'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.state_options.green'),
              value: 0
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.red'),
              value: 1
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.yellow'),
              value: 2
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.black'),
              value: 3
            }, {
              fakeValue: this.$t('private.contracts.list.fields.state_options.purple'),
              value: 4
            }],
            filters: {
              type: 'number',
              required: true
            }
          },
          associateAccounts: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: false,
            name: this.$t('private.contracts.list.fields.associate_accounts'),
            disabled: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          },
          // prestigeDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.prestige_date'),
          //   disabled: true,
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeATS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_ATS'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePTS: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_PTS'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_MTKG_Subtype'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_salon'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeEvent: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   error: false,
          //   name: this.$t('private.contracts.list.fields.prestige_event'),
          //   value: false,
          //   disabled: true,
          //   filters: {
          //     type: 'boolean',
          //     required: false
          //   }
          // },
          // prestigeSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_section_1'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeSection2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_section_2'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeSection3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_section_3'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeRappel3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelMarketing3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_marketing_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeVariableDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_variable_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeEducation: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_education'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigePotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_potential'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // prestigeRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.prestige_rappel_frequency'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // prestigeBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.prestige_Brands_view'),
          //   error: false,
          //   value: {
          //     // 6: false,
          //     4: false,
          //     5: false
          //   },
          //   options: {
          //     // 6: {
          //     //   name: this.$t('private.contracts.list.fields.BRAND_SEBASTIAN'),
          //     //   disabled: true
          //     // },
          //     4: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
          //       disabled: true
          //     },
          //     5: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
          //       disabled: true
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          // premiumDate: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   type: 'text',
          //   name: this.$t('private.contracts.list.fields.premium_date'),
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumMTKG: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_MTKG'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumMTKGSubtype: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_MTKG_Subtype'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSalon: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_salon'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSalonValue: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_salon_value'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumATS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_ATS_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumATS2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_ATS_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumATS3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_ATS_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPTS1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: false,
          //   name: this.$t('private.contracts.list.fields.premium_PTS_1'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumPTS2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: false,
          //   name: this.$t('private.contracts.list.fields.premium_PTS_2'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumPTS3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: false,
          //   name: this.$t('private.contracts.list.fields.premium_PTS_3'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumEvent: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   error: false,
          //   name: this.$t('private.contracts.list.fields.premium_event'),
          //   value: false,
          //   disabled: true,
          //   filters: {
          //     type: 'boolean',
          //     required: false
          //   }
          // },
          // premiumSection1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_section_1'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSection2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_section_2'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumSection3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_section_3'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumRappel1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappel2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappel3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelMarketing3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_marketing_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumVariableDiscount1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumVariableDiscount2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumVariableDiscount3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_variable_discount_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation1: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_education_1'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation2: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_education_2'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumEducation3: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_education_3'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumPotential: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_potential'),
          //   type: 'number',
          //   error: false,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // premiumRappelFrequency: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   fakeValue: '',
          //   value: '',
          //   disabled: true,
          //   name: this.$t('private.contracts.list.fields.premium_rappel_frequency'),
          //   type: 'text',
          //   error: false,
          //   filters: {
          //     type: 'string'
          //   }
          // },
          // premiumBrands: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   name: this.$t('private.contracts.list.fields.premium_Brands_view'),
          //   error: false,
          //   value: {
          //     1: false,
          //     3: false,
          //     2: false
          //   },
          //   options: {
          //     1: {
          //       name: this.$t('private.contracts.list.fields.BRAND_WELLA'),
          //       disabled: true
          //     },
          //     3: {
          //       name: this.$t('private.contracts.list.fields.BRAND_NIOXIN'),
          //       disabled: true
          //     },
          //     2: {
          //       name: this.$t('private.contracts.list.fields.BRAND_SP'),
          //       disabled: true
          //     }
          //   },
          //   filters: {
          //     type: 'manyOptions'
          //   }
          // },
          dsoDate: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.dso_date'),
            disabled: true,
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoPTS: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_PTS'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoMTKG: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_MTKG'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoMTKGSubtype: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_MTKG_Subtype'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoSalon: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_salon'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoSalonValue: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_salon_value'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoSection: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_section'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_rappel'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          briogeoRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.briogeo_rappel'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoDiscount: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_discount'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoRappelMarketing: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_rappel_marketing'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoEducation: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_education'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoPotential: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_potential'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          },
          dsoRappelFrequency: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.dso_rappel_frequency'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          dsoBrands: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            name: this.$t('private.contracts.list.fields.view_brands'),
            error: false,
            value: {
              4: false,
              5: false
            },
            options: {
              4: {
                name: this.$t('private.contracts.list.fields.BRAND_SP_DIAMOND'),
                disabled: true
              },
              5: {
                name: this.$t('private.contracts.list.fields.BRAND_SASSOON'),
                disabled: true
              }
            },
            filters: {
              type: 'manyOptions'
            }
          },
          hasPrestigeCondition: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            name: '',
            inline: true,
            error: false,
            value: {
              FY2223: false
            },
            options: {
              FY2223: {
                name: this.$t('private.contracts.list.fields.has_prestige_condition_FY2223'),
                disabled: true
              }
            },
            filters: {
              type: 'manyOptions',
              enum: ['FY2223']
            }
          },
          wellaQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_quantity'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          wellaDiscount: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_discount'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          wellaVolumeRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.wella_volume_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          // sebManRappel: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_rappel'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          // sebManDiscount: {
          //   id: _.uniqueId('field_'),
          //   display: true,
          //   value: '',
          //   name: this.$t('private.contracts.list.fields.seb_man_discount'),
          //   type: 'number',
          //   error: false,
          //   disabled: true,
          //   filters: {
          //     type: 'number'
          //   }
          // },
          rappelMKTG: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          rappelMKTGManual: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.rappel_mktg_manual'),
            type: 'text',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          observations: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.observations'),
            type: 'text',
            error: false,
            filters: {
              type: 'string'
            }
          },
          mktNews: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.mkt_news'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.yes'),
              value: true
            }, {
              fakeValue: this.$t('private.contracts.list.fields.mkt_news_options.no'),
              value: false
            }],
            filters: {
              type: 'boolean',
              required: true
            }
          },
          pdf: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            disabled: true,
            value: {},
            name: this.$t('private.contracts.list.fields.pdf'),
            pdf: true,
            readAsDataURL: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 30,
              formatsAllowed: ['pdf']
              // required       : true
            }
          },
          opiQuantity: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_quantity'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          opiDiscount: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_discount'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          opiRappel: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            name: this.$t('private.contracts.list.fields.opi_rappel'),
            type: 'number',
            error: false,
            disabled: true,
            filters: {
              type: 'number'
            }
          },
          prorated: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.contracts.list.fields.prorated'),
            error: false,
            type: 'text',
            disabled: true,
            filters: {
              type: 'string',
              required: false
            }
          },
          proratedMonth: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: '',
            disabled: true,
            name: this.$t('private.contracts.list.fields.prorated_month'),
            type: 'number',
            error: false,
            filters: {
              type: 'number'
            }
          }
        },
        active: false
      },
      displayUpdateContract: false,
      getClientsActive: false,
      getDelegationsActive: false,
      exportContractsActive: false,
      migrateContractsWindow: {
        display: false,
        migrateCSVFileActive: false,
        contractsToCreated: [],
        contractsToUpdate: [],
        contractsWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      displayFoo: false,
      totalContracts: 0,
      exportZipPDFsWindow: {
        sessionId: null,
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.list.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.list.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0,
          download: 0
        }
      }
    };
  },

  methods: {
    getParseConfig: function getParseConfig() {
      var vm = this;

      function parseTablesDiscounts(tablesDiscounts) {
        vm.tablesDiscounts = tablesDiscounts;
        // vm.tablesDiscounts.dso.premium.forEach((premium) => {
        //   vm.formCreate.fields.premiumSalon.options.push({
        // 	  fakeValue: premium.tipo,
        // 	  value: premium.tipo
        //   })
        // })
        // vm.tablesDiscounts.dso.prestige.forEach((prestige) => {
        //   vm.formCreate.fields.prestigeSalon.options.push({
        // 	  fakeValue: prestige.tipo,
        // 	  value: prestige.tipo
        //   })
        // })
        vm.tablesDiscounts.DSO.tipoClientes.forEach(function (typeClient) {
          vm.formCreate.fields.dsoSalon.options.push({
            fakeValue: typeClient.tipo,
            value: typeClient.tipo
          });
        });
      }

      function getTablesDiscounts(tablesDiscountsFile) {
        var uriOrigin = new __WEBPACK_IMPORTED_MODULE_5_urijs___default.a(tablesDiscountsFile._url);
        var pathname = uriOrigin.pathname();
        var url = '' + __WEBPACK_IMPORTED_MODULE_6__config_env___default.a.api.baseUrl + pathname;
        fetch(url).then(function (response) {
          return response.json();
        }).then(parseTablesDiscounts).catch(function (err) {
          console.error(err);
          parseTablesDiscounts(__WEBPACK_IMPORTED_MODULE_7__config_tradeTermsConfig_json___default.a);
        });
      }

      Parse.Config.get().then(function (config) {
        var tablesDiscountsFile = config.get('tablesDiscounts');
        if (tablesDiscountsFile) {
          getTablesDiscounts(tablesDiscountsFile);
        } else {
          parseTablesDiscounts(__WEBPACK_IMPORTED_MODULE_7__config_tradeTermsConfig_json___default.a);
        }
      }, function (error) {
        console.log('getParseConfig > Error');
        console.error(error);
      });
    },
    parseBrands: function parseBrands(brands) {
      var _bransd = {
        1: 'Wella',
        2: 'SP',
        3: 'Nioxin',
        4: 'SSP',
        5: 'Sassoon',
        6: 'Sebastian'
      };

      var parseBransObjs = [];

      if (brands && brands.length > 0) {
        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(brands, function (value) {
          parseBransObjs.push(_bransd[value]);
        });

        return parseBransObjs.map(function (k) {
          return k;
        }).join(', ');
      } else {
        return '';
      }
    },

    filterSubmit: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.debounce(function () {
      var vm = this;

      vm.getContracts();
    }, 1000),
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    actionSort: function actionSort(event, col) {
      var vm = this;

      vm.filters.ascending.value = '';
      vm.filters.descending.value = '';

      if (event.sort_default) vm.filters.descending.value = 'appCreationDate';

      if (event.sort_asc) vm.filters.ascending.value = col;

      if (event.sort_desc) vm.filters.descending.value = col;

      vm.getContracts();
    },
    actionSelectedBrands: function actionSelectedBrands(event) {
      var vm = this;

      var brands = vm.formCreate.fields.brands;

      // vm.formCreate.fields.premiumSalon.filters.required = brands.value['premium']
      // vm.formCreate.fields.prestigeSalon.filters.required = brands.value['prestige']
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = false
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = false
      vm.formCreate.fields.dsoSalon.filters.required = brands.value['dso'];

      if (brands.value['dso']) {
        // brands.options['premium'].value = brands.value['premium']
        // brands.options['prestige'].value = brands.value['prestige']
        brands.options['dso'].value = brands.value['dso'];
        brands.options['iso'].disabled = true;
        brands.options['opi'].disabled = true;
      } else if (brands.value['iso']) {
        brands.options['iso'].value = brands.value['iso'];
        // brands.options['premium'].disabled = true
        // brands.options['prestige'].disabled = true
        brands.options['dso'].disabled = true;
        brands.options['opi'].disabled = true;
      } else if (brands.value['opi']) {
        brands.options['opi'].value = brands.value['opi'];
        // brands.options['premium'].disabled = true
        // brands.options['prestige'].disabled = true
        brands.options['dso'].disabled = true;
        brands.options['iso'].disabled = true;
      } else {
        // brands.options['premium'].value = false
        // brands.options['prestige'].value = false
        brands.options['dso'].value = false;
        brands.options['iso'].value = false;
        brands.options['opi'].value = false;
        // brands.options['premium'].disabled = false
        // brands.options['prestige'].disabled = false
        brands.options['dso'].disabled = false;
        brands.options['iso'].disabled = false;
        brands.options['opi'].disabled = false;
      }
    },

    // actionSelectPremiumSalon (event) {
    //   let vm = this
    //
    //   let client = _.find(vm.formCreate.fields.client.options, (client) => {
    //     return client.value.objectId === vm.formCreate.fields.client.value
    //   })
    //
    //   if (!client && vm.formCreate.fields.premiumSalon.value !== '') {
    //     let message = {
    //       message: [vm.$t('errors.custom.012')],
    //       type: 'error'
    //     }
    //
    //     vm.$root.$emit('showMessage', message)
    //
    //     vm.formCreate.fields.premiumSalon.value = ''
    //     vm.formCreate.fields.premiumSalon.fakeValue = ''
    //     vm.formCreate.fields.premiumMTKG.value = ''
    //     vm.formCreate.fields.premiumMTKG.fakeValue = ''
    //     vm.formCreate.fields.premiumMTKGSubtype.value = ''
    //
    //     // this.$refs['premiumSalon'].field.value = vm.formCreate.fields.premiumSalon.value
    //     // this.$refs['premiumSalon'].field.fakeValue = vm.formCreate.fields.premiumSalon.fakeValue
    //     // this.$refs['premiumMTKG'].field.value = vm.formCreate.fields.premiumMTKG.value
    //     // this.$refs['premiumMTKG'].field.fakeValue = vm.formCreate.fields.premiumMTKG.fakeValue
    //     // this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    //
    //     return
    //   }
    //
    //   // vm.formCreate.fields.premiumSalonValue.value = -1
    //   // vm.formCreate.fields.premiumSection1.value = ''
    //   // vm.formCreate.fields.premiumDiscount1.value = ''
    //   // vm.formCreate.fields.premiumVariableDiscount1.value = ''
    //   // vm.formCreate.fields.premiumRappel1.value = ''
    //   // vm.formCreate.fields.premiumRappelMarketing1.value = ''
    //   // vm.formCreate.fields.premiumATS1.value = ''
    //   // vm.formCreate.fields.premiumPTS1.value = ''
    //   // vm.formCreate.fields.premiumEducation1.value = ''
    //   // vm.formCreate.fields.premiumPotential.value = ''
    //   // vm.formCreate.fields.premiumMTKG.filters.required = false
    //   // vm.formCreate.fields.premiumMTKGSubtype.value = ''
    //
    //   const premium = vm.tablesDiscounts.dso.premium.find((item) => item.tipo === vm.formCreate.fields.premiumSalon.value)
    //
    //   if (premium) {
    //     const index = 0
    //     const premiumPotential = 4000
    //     vm.formCreate.fields.premiumSalonValue.value = index
    //     vm.formCreate.fields.premiumSection1.value = `${premium.tramos[index].tramo} €`
    //     vm.formCreate.fields.premiumDiscount1.value = premium.tramos[index].descuento
    //     vm.formCreate.fields.premiumVariableDiscount1.value = premium.tramos[index].descuentoVariable
    //     vm.formCreate.fields.premiumRappel1.value = premium.tramos[index].rappel
    //     vm.formCreate.fields.premiumRappelMarketing1.value = premium.tramos[index].rappelMarketing
    //     vm.formCreate.fields.premiumATS1.value = premium.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.premiumEducation1.value = premium.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.premiumPotential.value = premiumPotential * client.value.employeesQuantity
    //     vm.formCreate.fields.premiumMTKG.filters.required = true
    //     const premiumMTKGOpts = []
    //     const premiumRappelFrequencyOpts = []
    //     premium.rappel.forEach((rappel) => {
    //       premiumRappelFrequencyOpts.push({
    //         fakeValue: rappel,
    //         value: rappel
    //       })
    //     })
    //     premium.marketing.forEach((marketing) => {
    //       premiumMTKGOpts.push(Object.assign(marketing, {
    //         fakeValue: marketing.nombre,
    //         value: marketing.nombre
    //       }))
    //     })
    //     vm.formCreate.fields.premiumRappelFrequency.options = premiumRappelFrequencyOpts
    //     vm.formCreate.fields.premiumMTKG.options = premiumMTKGOpts
    //   }
    //
    //   this.$refs['premiumSection1'].field.value = vm.formCreate.fields.premiumSection1.value
    //   this.$refs['premiumDiscount1'].field.value = vm.formCreate.fields.premiumDiscount1.value
    //   this.$refs['premiumVariableDiscount1'].field.value = vm.formCreate.fields.premiumVariableDiscount1.value
    //   this.$refs['premiumRappel1'].field.value = vm.formCreate.fields.premiumRappel1.value
    //   this.$refs['premiumRappelMarketing1'].field.value = vm.formCreate.fields.premiumRappelMarketing1.value
    //   this.$refs['premiumATS1'].field.value = vm.formCreate.fields.premiumATS1.value
    //   this.$refs['premiumPTS1'].field.value = vm.formCreate.fields.premiumPTS1.value
    //   this.$refs['premiumEducation1'].field.value = vm.formCreate.fields.premiumEducation1.value
    //   this.$refs['premiumPotential'].field.value = vm.formCreate.fields.premiumPotential.value
    //   this.$refs['premiumPotential'].field.value = vm.formCreate.fields.premiumPotential.value
    //   this.$refs['premiumMTKG'].field.value = vm.formCreate.fields.premiumMTKG.value
    //   this.$refs['premiumMTKG'].field.fakeValue = vm.formCreate.fields.premiumMTKG.fakeValue
    //   this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    // },
    // actionSelectPremiumMTKG (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.premiumSalon.value === '') {
    //     vm.formCreate.fields.premiumMTKGSubtype.value = ''
    //     this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    //     return
    //   }
    //
    //   let premiumMTKGSubtype = ''
    //   const marketing = vm.formCreate.fields.premiumMTKG.options.find((item) => item.value === event)
    //
    //   if (marketing) {
    //     if (marketing.congreso) {
    //       premiumMTKGSubtype = `Congreso: ${marketing.congreso}€`
    //     } else {
    //       premiumMTKGSubtype = `Pts app ${marketing.ptsApp ? marketing.ptsApp : ''}`
    //     }
    //   }
    //
    //   vm.formCreate.fields.premiumPTS1.value = marketing && marketing.ptsApp ? marketing.ptsApp : ''
    //   vm.formCreate.fields.premiumEducation1.value = marketing && ('congreso' in marketing) ? marketing.congreso : vm.formCreate.fields.premiumEducation1.value
    //   vm.formCreate.fields.premiumMTKGSubtype.value = premiumMTKGSubtype
    //
    //   this.$refs['premiumATS1'].field.value = vm.formCreate.fields.premiumATS1.value
    //   this.$refs['premiumPTS1'].field.value = vm.formCreate.fields.premiumPTS1.value
    //   this.$refs['premiumEducation1'].field.value = vm.formCreate.fields.premiumEducation1.value
    //   this.$refs['premiumMTKGSubtype'].field.value = vm.formCreate.fields.premiumMTKGSubtype.value
    // },
    // validateSelectPremiumMTKGSubtypeBrands () {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.premiumSalon.value === '') return
    //
    //   let brands = vm.formCreate.fields.premiumMTKGSubtypeBrands
    //   let selected = []
    //   let notSelected = []
    //
    //   _.each(brands.value, (value, key) => {
    //     if (value) selected.push(key)
    //     else notSelected.push(key)
    //   })
    //
    //   try {
    //     if (selected.length > 0 && selected.length === 2) {
    //       _.each(notSelected, (key) => {
    //         if (brands.options[key]) brands.options[key].disabled = true
    //       })
    //     } else {
    //       _.each(brands.options, (x) => {
    //         x.disabled = false
    //       })
    //     }
    //   } catch (error) {
    //     console.log('Error', error)
    //   }
    // },
    // actionSelectPremiumBrands (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.premiumSalon.value === '') return
    //
    //   if (vm.formCreate.fields.premiumMTKG.value === this.$t('private.contracts.list.fields.MTKG_options.materiales_MKT')) {
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.value = {}
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.display = false
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.options = {}
    //     vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = false
    //
    //     let premiumBrands = {}
    //
    //     _.each(vm.formCreate.fields.premiumBrands.value, (value, key) => {
    //       if (value) {
    //         premiumBrands[key] = {
    //           name: vm.formCreate.fields.premiumBrands.options[key].name,
    //           value: vm.formCreate.fields.premiumBrands.options[key].value,
    //           disabled: false
    //         }
    //       }
    //     })
    //
    //     if (_.size(premiumBrands) > 0) {
    //       vm.formCreate.fields.premiumMTKGSubtypeBrands.options = premiumBrands
    //       vm.formCreate.fields.premiumMTKGSubtypeBrands.display = true
    //       vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = true
    //     } else {
    //       let message = {
    //         message: [vm.$t('errors.custom.010').replace('{brand}', 'Premium')],
    //         type: 'error'
    //       }
    //
    //       vm.$root.$emit('showMessage', message)
    //     }
    //   }
    // },
    // actionSelectPrestigeSalon (event) {
    //   let vm = this
    //
    //   let client = _.find(vm.formCreate.fields.client.options, (client) => {
    //     return client.value.objectId === vm.formCreate.fields.client.value
    //   })
    //
    //   if (!client && vm.formCreate.fields.prestigeSalon.value !== '') {
    //     let message = {
    //       message: [vm.$t('errors.custom.012')],
    //       type: 'error'
    //     }
    //
    //     vm.$root.$emit('showMessage', message)
    //
    //     vm.formCreate.fields.prestigeSalon.value = ''
    //     vm.formCreate.fields.prestigeSalon.fakeValue = ''
    //     this.$refs['prestigeSalon'].field.value = vm.formCreate.fields.prestigeSalon.value
    //     this.$refs['prestigeSalon'].field.fakeValue = vm.formCreate.fields.prestigeSalon.fakeValue
    //     vm.resetFieldPrestige()
    //     vm.enabledFieldPrestige(false)
    //     return
    //   }
    //
    //   vm.resetFieldPrestige()
    //   vm.enabledFieldPrestige(event !== '')
    //   vm.formCreate.fields.prestigeSalonValue.value = -1
    //   vm.formCreate.fields.prestigeMTKG.filters.required = false
    //   const prestige = vm.tablesDiscounts.dso.prestige.find((item) => item.tipo === vm.formCreate.fields.prestigeSalon.value)
    //   if (prestige) {
    //     const index = 0
    //     const prestigePotential = 7000
    //     vm.formCreate.fields.prestigeSalonValue.value = index
    //     vm.formCreate.fields.prestigeSection1.value = `${prestige.tramos[index].tramo} €`
    //     vm.formCreate.fields.prestigeDiscount1.value = prestige.tramos[index].descuento
    //     // vm.formCreate.fields.prestigeVariableDiscount1.value = prestige.tramos[index].descuentoVariable
    //     vm.formCreate.fields.prestigeRappel1.value = prestige.tramos[index].rappel
    //     vm.formCreate.fields.prestigeRappelMarketing1.value = prestige.tramos[index].rappelMarketing
    //     // vm.formCreate.fields.prestigeATS.value = prestige.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.prestigeEducation.value = prestige.tramos[index].atsEducacionValorado
    //     vm.formCreate.fields.prestigePotential.value = prestigePotential * client.value.employeesQuantity
    //     vm.formCreate.fields.prestigeMTKG.filters.required = true
    //     const prestigeMTKGOpts = []
    //     const prestigeRappelFrequencyOpts = []
    //     prestige.rappel.forEach((rappel) => {
    //       prestigeRappelFrequencyOpts.push({
    //         fakeValue: rappel,
    //         value: rappel
    //       })
    //     })
    //     prestige.marketing.forEach((marketing) => {
    //       prestigeMTKGOpts.push(Object.assign(marketing, {
    //         fakeValue: marketing.nombre,
    //         value: marketing.nombre
    //       }))
    //     })
    //     vm.formCreate.fields.prestigeRappelFrequency.options = prestigeRappelFrequencyOpts
    //     vm.formCreate.fields.prestigeMTKG.options = prestigeMTKGOpts
    //   }
    //
    //   this.$refs['prestigeSection1'].field.value = vm.formCreate.fields.prestigeSection1.value
    //   this.$refs['prestigeDiscount1'].field.value = vm.formCreate.fields.prestigeDiscount1.value
    //   // this.$refs['prestigeVariableDiscount1'].field.value = vm.formCreate.fields.prestigeVariableDiscount1.value
    //   this.$refs['prestigeRappel1'].field.value = vm.formCreate.fields.prestigeRappel1.value
    //   this.$refs['prestigeRappelMarketing1'].field.value = vm.formCreate.fields.prestigeRappelMarketing1.value
    //   // this.$refs['prestigeATS'].field.value = vm.formCreate.fields.prestigeATS.value
    //   this.$refs['prestigePTS'].field.value = vm.formCreate.fields.prestigePTS.value
    //   this.$refs['prestigeEducation'].field.value = vm.formCreate.fields.prestigeEducation.value
    //   this.$refs['prestigePotential'].field.value = vm.formCreate.fields.prestigePotential.value
    //   this.$refs['prestigeMTKG'].field.value = vm.formCreate.fields.prestigeMTKG.value
    //   this.$refs['prestigeMTKG'].field.fakeValue = vm.formCreate.fields.prestigeMTKG.fakeValue
    //   this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    // },
    // enabledFieldPrestige (enabled) {
    //   let vm = this
    //
    //   vm.formCreate.fields.prestigeSalonValue.disabled = !enabled
    //     // vm.formCreate.fields.prestigeATS.disabled = !enabled
    //   vm.formCreate.fields.prestigeBrands.options.brandSP_DIAMOND.disabled = !enabled
    //   vm.formCreate.fields.prestigeBrands.options.brandSASSOON.disabled = !enabled
    //   vm.formCreate.fields.prestigeMTKG.disabled = !enabled
    //   vm.formCreate.fields.prestigeMTKGSubtype.disabled = !enabled
    //   vm.formCreate.fields.prestigePTS.disabled = !enabled
    //   vm.formCreate.fields.prestigeSection1.disabled = !enabled
    //   vm.formCreate.fields.prestigeRappel1.disabled = !enabled
    //   vm.formCreate.fields.prestigeDiscount1.disabled = !enabled
    //   // vm.formCreate.fields.prestigeVariableDiscount1.disabled = !enabled
    //  vm.formCreate.fields.prestigeRappelMarketing1.disabled = !enabled
    //   vm.formCreate.fields.prestigeEducation.disabled = !enabled
    //   vm.formCreate.fields.prestigePotential.disabled = !enabled
    //   vm.formCreate.fields.prestigeRappelFrequency.disabled = !enabled
    // },
    // resetFieldPrestige () {
    //   let vm = this
    //
    //     // vm.formCreate.fields.prestigeATS.value = ''
    //  vm.formCreate.fields.prestigeBrands.value = {
    // 	 // brandSEBASTIAN: false,
    // 	 brandSP_DIAMOND: false,
    // 	 brandSASSOON: false
    //  }
    //   vm.formCreate.fields.prestigeMTKG.value = ''
    //  vm.formCreate.fields.prestigeMTKG.fakeValue = ''
    //   vm.formCreate.fields.prestigeMTKGSubtype.value = ''
    //   vm.formCreate.fields.prestigePTS.value = ''
    //   vm.formCreate.fields.prestigeSection1.value = ''
    //   vm.formCreate.fields.prestigeRappel1.value = ''
    //   vm.formCreate.fields.prestigeDiscount1.value = ''
    //   // vm.formCreate.fields.prestigeVariableDiscount1.value = ''
    // vm.formCreate.fields.prestigeRappelMarketing1.value = ''
    //   vm.formCreate.fields.prestigeEducation.value = ''
    //   vm.formCreate.fields.prestigePotential.value = ''
    //   vm.formCreate.fields.prestigeRappelFrequency.value = ''
    //   vm.formCreate.fields.prestigeRappelFrequency.fakeValue = ''
    //   vm.formCreate.fields.hasPrestigeCondition.value = {
    //     FY2223: false
    //   }
    //
    //   this.$refs['prestigeMTKG'].field.value = vm.formCreate.fields.prestigeMTKG.value
    //   this.$refs['prestigeMTKG'].field.fakeValue = vm.formCreate.fields.prestigeMTKG.fakeValue
    //   this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    //   this.$refs['prestigeRappelFrequency'].field.value = vm.formCreate.fields.prestigeRappelFrequency.value
    //   this.$refs['prestigeRappelFrequency'].field.fakeValue = vm.formCreate.fields.prestigeRappelFrequency.fakeValue
    // },
    // actionSelectPrestigeMTKG (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.prestigeSalon.value === '') {
    //     vm.formCreate.fields.prestigeEvent.value = false
    //     vm.formCreate.fields.prestigeMTKGSubtype.value = ''
    //     this.$refs['prestigeEvent'].field.value = vm.formCreate.fields.prestigeEvent.value
    //     this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    //     return
    //   }
    //
    //   let prestigeMTKGSubtype = ''
    //   const marketing = vm.formCreate.fields.prestigeMTKG.options.find((item) => item.value === event)
    //
    //   if (marketing) {
    //     if (marketing.congreso) {
    //       prestigeMTKGSubtype = `Congreso: ${marketing.congreso}€`
    //     } else {
    //       prestigeMTKGSubtype = `Pts app ${marketing.ptsApp ? marketing.ptsApp : ''}`
    //     }
    //   }
    //
    // 	// let prestigeSalon = this.generateSlug(vm.formCreate.fields.prestigeSalon.value, true, '_')
    // 	// const marketingList = sections.prestigeSalon[prestigeSalon].marketing
    // 	// let prestigeEvent = false
    // 	// let marketing
    // 	// let prestigeMTKGSubtype = ''
    // 	// switch (vm.formCreate.fields.prestigeMTKG.value) {
    // 	//   case 'Wella APP':
    // 	//     vm.formCreate.fields.prestigeATS.value = ''
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `Pts app ${marketing && marketing.ptsApp ? marketing.ptsApp : ''}`
    // 	//     prestigeEvent = false
    // 	//     break
    // 	//   case '€ Congreso':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeEvent = false
    // 	//     prestigeMTKGSubtype = marketing && marketing.congreso ? `Congreso € ${marketing.congreso}` : ''
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Evento Sebastian + Wella APP':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `n/a`
    // 	//     prestigeEvent = true
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Evento Sebastian + € Congreso':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = marketing && marketing.congreso ? `Congreso € ${marketing.congreso}` : ''
    // 	//     prestigeEvent = true
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Rappel MKT':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `n/a`
    // 	//     prestigeEvent = false
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   case 'Evento Sebastian + Rappel MKT':
    // 	//     marketing = marketingList.find(el => el.nombre === vm.formCreate.fields.prestigeMTKG.value)
    // 	//     prestigeMTKGSubtype = `n/a`
    // 	//     prestigeEvent = true
    // 	//     vm.formCreate.fields.prestigeATS.value = sections.prestigeSalon[prestigeSalon].prestigeATS
    // 	//     break
    // 	//   default:
    // 	//     marketing = null
    // 	//     prestigeEvent = false
    // 	//     prestigeMTKGSubtype = ''
    // 	// }
    //
    //   vm.formCreate.fields.prestigePTS.value = marketing && marketing.ptsApp ? marketing.ptsApp : ''
    //   vm.formCreate.fields.prestigeEducation.value = marketing && ('congreso' in marketing) ? marketing.congreso : vm.formCreate.fields.prestigeEducation.value
    //   vm.formCreate.fields.prestigeMTKGSubtype.value = prestigeMTKGSubtype
    //
    //   // this.$refs['prestigeATS'].field.value = vm.formCreate.fields.prestigeATS.value
    //   this.$refs['prestigePTS'].field.value = vm.formCreate.fields.prestigePTS.value
    //   this.$refs['prestigeEducation'].field.value = vm.formCreate.fields.prestigeEducation.value
    //   this.$refs['prestigeMTKGSubtype'].field.value = vm.formCreate.fields.prestigeMTKGSubtype.value
    // },
    // validateSelectPrestigeMTKGSubtypeBrands () {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.prestigeSalon.value === '') return
    //
    //   let brands = vm.formCreate.fields.prestigeMTKGSubtypeBrands
    //   let selected = []
    //   let notSelected = []
    //
    //   _.each(brands.value, (value, key) => {
    //     if (value) selected.push(key)
    //     else notSelected.push(key)
    //   })
    //
    //   try {
    //     if (selected.length > 0 && selected.length === 2) {
    //       _.each(notSelected, (key) => {
    //         if (brands.options[key]) brands.options[key].disabled = true
    //       })
    //     } else {
    //       _.each(brands.options, (x) => {
    //         x.disabled = false
    //       })
    //     }
    //   } catch (error) {
    //     console.log('Error', error)
    //   }
    // },
    // actionSelectPrestigeBrands (event) {
    //   let vm = this
    //
    //   if (vm.formCreate.fields.prestigeSalon.value === '') return
    //
    //   if (vm.formCreate.fields.prestigeMTKG.value === this.$t('private.contracts.list.fields.MTKG_options.materiales_MKT')) {
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.value = {}
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.display = false
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.options = {}
    //     vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = false
    //
    //     let prestigeBrands = {}
    //
    //     _.each(vm.formCreate.fields.prestigeBrands.value, (value, key) => {
    //       if (value) {
    //         prestigeBrands[key] = {
    //           name: vm.formCreate.fields.prestigeBrands.options[key].name,
    //           value: vm.formCreate.fields.prestigeBrands.options[key].value,
    //           disabled: false
    //         }
    //       }
    //     })
    //
    //     if (_.size(prestigeBrands) > 0) {
    //       vm.formCreate.fields.prestigeMTKGSubtypeBrands.options = prestigeBrands
    //       vm.formCreate.fields.prestigeMTKGSubtypeBrands.display = true
    //       vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = true
    //     } else {
    //       let message = {
    //         message: [vm.$t('errors.custom.010').replace('{brand}', 'Prestige')],
    //         type: 'error'
    //       }
    //
    //       vm.$root.$emit('showMessage', message)
    //     }
    //   }
    // },
    actionSelectDSOSalon: function actionSelectDSOSalon(event) {
      var vm = this;

      var client = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(vm.formCreate.fields.client.options, function (client) {
        return client.value.objectId === vm.formCreate.fields.client.value;
      });

      if (!client && vm.formCreate.fields.dsoSalon.value !== '') {
        var message = {
          message: [vm.$t('errors.custom.012')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);
        vm.formCreate.fields.dsoSalon.value = '';
        vm.formCreate.fields.dsoSalon.fakeValue = '';
        this.$refs['dsoSalon'].field.value = vm.formCreate.fields.dsoSalon.value;
        this.$refs['dsoSalon'].field.fakeValue = vm.formCreate.fields.dsoSalon.fakeValue;
        vm.resetFieldDSO();
        vm.enabledFieldDSO(false);
        return;
      }

      vm.resetFieldDSO();
      vm.enabledFieldDSO(event !== '');
      vm.formCreate.fields.dsoSalonValue.value = -1;
      vm.formCreate.fields.dsoMTKG.filters.required = false;
      var dso = vm.tablesDiscounts.DSO.tipoClientes.find(function (item) {
        return item.tipo === vm.formCreate.fields.dsoSalon.value;
      });
      if (dso) {
        var index = 0;
        var dsoPotential = 7000;
        vm.formCreate.fields.dsoSalonValue.value = index;
        vm.formCreate.fields.dsoSection.value = dso.tramos[index].tramo;
        vm.formCreate.fields.dsoDiscount.value = dso.tramos[index].descuento;
        vm.formCreate.fields.dsoRappel.value = dso.tramos[index].rappel;
        vm.formCreate.fields.briogeoRappel.value = dso.tramos[index].rappelBriogeo;
        vm.formCreate.fields.dsoEducation.value = dso.tramos[index].atsEducacionValorado;
        vm.formCreate.fields.dsoPotential.value = dsoPotential * client.value.employeesQuantity;
        vm.formCreate.fields.dsoMTKG.filters.required = true;
        var dsoMTKGOpts = [];
        var dsoRappelFrequencyOpts = [];
        dso.rappel.forEach(function (rappel) {
          dsoRappelFrequencyOpts.push({
            fakeValue: rappel,
            value: rappel
          });
        });
        dso.marketing.forEach(function (marketing) {
          dsoMTKGOpts.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(marketing, {
            fakeValue: marketing.nombre,
            value: marketing.nombre
          }));
        });
        vm.formCreate.fields.dsoRappelFrequency.options = dsoRappelFrequencyOpts;
        vm.formCreate.fields.dsoMTKG.options = dsoMTKGOpts;
      }

      // - dsoSection
      this.$refs['dsoSection'].field.value = vm.formCreate.fields.dsoSection.value;
      this.$refs['dsoDiscount'].field.value = vm.formCreate.fields.dsoDiscount.value;
      this.$refs['dsoRappel'].field.value = vm.formCreate.fields.dsoRappel.value;
      this.$refs['briogeoRappel'].field.value = vm.formCreate.fields.briogeoRappel.value;
      this.$refs['dsoPTS'].field.value = vm.formCreate.fields.dsoPTS.value;
      this.$refs['dsoEducation'].field.value = vm.formCreate.fields.dsoEducation.value;
      this.$refs['dsoPotential'].field.value = vm.formCreate.fields.dsoPotential.value;
      this.$refs['dsoMTKG'].field.value = vm.formCreate.fields.dsoMTKG.value;
      this.$refs['dsoMTKG'].field.fakeValue = vm.formCreate.fields.dsoMTKG.fakeValue;
      this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value;
    },
    enabledFieldDSO: function enabledFieldDSO(enabled) {
      var vm = this;

      vm.formCreate.fields.dsoSalonValue.disabled = !enabled;
      vm.formCreate.fields.dsoSection.disabled = !enabled;
      vm.formCreate.fields.dsoDiscount.disabled = !enabled;
      vm.formCreate.fields.dsoRappelMarketing.disabled = !enabled;
      vm.formCreate.fields.dsoRappel.disabled = !enabled;
      vm.formCreate.fields.briogeoRappel.disabled = !enabled;
      vm.formCreate.fields.dsoPTS.disabled = !enabled;
      vm.formCreate.fields.dsoEducation.disabled = !enabled;
      vm.formCreate.fields.dsoPotential.disabled = !enabled;
      vm.formCreate.fields.dsoMTKG.disabled = !enabled;
      vm.formCreate.fields.dsoMTKGSubtype.disabled = !enabled;
      vm.formCreate.fields.dsoRappelFrequency.disabled = !enabled;
      vm.formCreate.fields.dsoBrands.options.brandSP_DIAMOND.disabled = !enabled;
      vm.formCreate.fields.dsoBrands.options.brandSASSOON.disabled = !enabled;
    },
    resetFieldDSO: function resetFieldDSO() {
      var vm = this;

      vm.formCreate.fields.dsoSection.value = '';
      vm.formCreate.fields.dsoDiscount.value = '';
      vm.formCreate.fields.dsoRappelMarketing.value = '';
      vm.formCreate.fields.dsoRappel.value = '';
      vm.formCreate.fields.briogeoRappel.value = '';
      vm.formCreate.fields.dsoPTS.value = '';
      vm.formCreate.fields.dsoEducation.value = '';
      vm.formCreate.fields.dsoPotential.value = '';
      vm.formCreate.fields.dsoMTKG.value = '';
      vm.formCreate.fields.dsoMTKG.fakeValue = '';
      vm.formCreate.fields.dsoMTKGSubtype.value = '';
      vm.formCreate.fields.dsoRappelFrequency.value = '';
      vm.formCreate.fields.dsoRappelFrequency.fakeValue = '';
      vm.formCreate.fields.dsoBrands.value = {
        brandSP_DIAMOND: false,
        brandSASSOON: false
      };
      vm.formCreate.fields.hasPrestigeCondition.value = {
        FY2223: false
      };

      this.$refs['dsoMTKG'].field.value = vm.formCreate.fields.dsoMTKG.value;
      this.$refs['dsoMTKG'].field.fakeValue = vm.formCreate.fields.dsoMTKG.fakeValue;
      this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value;
      this.$refs['dsoRappelFrequency'].field.value = vm.formCreate.fields.dsoRappelFrequency.value;
      this.$refs['dsoRappelFrequency'].field.fakeValue = vm.formCreate.fields.dsoRappelFrequency.fakeValue;
    },
    actionSelectDSOMTKG: function actionSelectDSOMTKG(event) {
      var vm = this;

      if (vm.formCreate.fields.dsoSalon.value === '') {
        vm.formCreate.fields.dsoMTKGSubtype.value = '';
        this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value;
        return;
      }

      var dsoMTKGSubtype = '';
      var marketing = vm.formCreate.fields.dsoMTKG.options.find(function (item) {
        return item.value === event;
      });

      if (marketing) {
        if (marketing.congreso) {
          dsoMTKGSubtype = 'Congreso ' + marketing.congreso + '\u20AC';
        } else {
          dsoMTKGSubtype = 'Pts app ' + (marketing.ptsApp ? marketing.ptsApp : '');
        }
      }

      vm.formCreate.fields.dsoPTS.value = marketing && marketing.ptsApp ? marketing.ptsApp : '';
      vm.formCreate.fields.dsoEducation.value = marketing && 'congreso' in marketing ? marketing.congreso : vm.formCreate.fields.dsoEducation.value;
      vm.formCreate.fields.dsoMTKGSubtype.value = dsoMTKGSubtype;
      this.$refs['dsoPTS'].field.value = vm.formCreate.fields.dsoPTS.value;
      this.$refs['dsoEducation'].field.value = vm.formCreate.fields.dsoEducation.value;
      this.$refs['dsoMTKGSubtype'].field.value = vm.formCreate.fields.dsoMTKGSubtype.value;
    },
    validateProrated: function validateProrated() {
      var vm = this;

      vm.formCreate.fields.proratedMonth.error = false;
      vm.formCreate.fields.proratedMonth.filters.required = false;
      vm.formCreate.fields.proratedMonth.disabled = true;

      if (vm.formCreate.fields.prorated.value === vm.formCreate.fields.prorated.options[0].value) {
        vm.formCreate.fields.proratedMonth.filters.required = true;
        vm.formCreate.fields.proratedMonth.disabled = false;
      }
      this.$refs['proratedMonth'].field.value = vm.formCreate.fields.proratedMonth.value;
      this.$refs['proratedMonth'].field.fakeValue = vm.formCreate.fields.proratedMonth.fakeValue;
    },
    onChangeOpiQuantity: function onChangeOpiQuantity(value) {
      var vm = this;

      var opi1 = vm.tablesDiscounts.OPI[0];
      var opi2 = vm.tablesDiscounts.OPI[1];

      vm.formCreate.fields.opiDiscount.value = '';
      vm.formCreate.fields.opiRappel.value = '';

      if (value > 0) {
        vm.formCreate.fields.opiDiscount.value = value < opi2.limite ? opi1.descuento : opi2.descuento;
        vm.formCreate.fields.opiRappel.value = value < opi2.limite ? opi1.rappel : opi2.rappel;
      }

      this.$refs['opiDiscount'].field.value = vm.formCreate.fields.opiDiscount.value;
      this.$refs['opiRappel'].field.value = vm.formCreate.fields.opiRappel.value;
    },
    onChangeIsoQuantity: function onChangeIsoQuantity(value) {
      var vm = this;
      vm.formCreate.fields.wellaDiscount.value = '';
      vm.formCreate.fields.wellaVolumeRappel.value = '';
      vm.formCreate.fields.rappelMKTG.value = '';
      // vm.formCreate.fields.sebManDiscount.value = ''
      // vm.formCreate.fields.sebManRappel.value = ''

      var option = vm.findOptionInList(vm.tablesDiscounts.ISO, value);
      // const option = vm.tablesDiscounts.ISO.reduce((prev, item) => {
      //  if (value >= item.limite) {
      // 	 return item
      //  }
      //  return prev
      // }, null)

      if (value > 0 && option) {
        vm.formCreate.fields.wellaDiscount.value = option.descuentoWella;
        vm.formCreate.fields.wellaVolumeRappel.value = option.rappelWella;
        vm.formCreate.fields.rappelMKTG.value = option.trade;
        // vm.formCreate.fields.sebManDiscount.value = option.descuentoNioxin
        // vm.formCreate.fields.sebManRappel.value = option.rappelNioxin
      }

      this.$refs['wellaDiscount'].field.value = vm.formCreate.fields.wellaDiscount.value;
      this.$refs['wellaVolumeRappel'].field.value = vm.formCreate.fields.wellaVolumeRappel.value;
      this.$refs['rappelMKTG'].field.value = vm.formCreate.fields.rappelMKTG.value;
    },
    onChangeWellaTradeManual: function onChangeWellaTradeManual(value) {
      var vm = this;
      if (value > 0) {
        vm.formCreate.fields.rappelMKTG.value = '';
      } else {
        var option = vm.findOptionInList(vm.tablesDiscounts.ISO, vm.formCreate.fields.wellaQuantity.value);
        // const option = vm.tablesDiscounts.iso.find((item) => vm.formCreate.fields.wellaQuantity.value >= item.limite)
        if (option) vm.formCreate.fields.rappelMKTG.value = option.trade;
      }

      this.$refs['rappelMKTG'].field.value = vm.formCreate.fields.rappelMKTG.value;
    },
    findOptionInList: function findOptionInList(list, value) {
      return list.reduce(function (prev, item) {
        if (value >= item.limite) {
          return item;
        }
        return prev;
      }, null);
    },
    getTotalContracts: function getTotalContracts() {
      var vm = this;

      vm.getTotalContractsActive = true;

      var dataToSend = '';

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.getTotalContracts(dataToSend).then(function (response) {
        vm.getTotalContractsActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.totalContracts = response.data.totalContracts;
      });
    },
    getContracts: function getContracts() {
      var vm = this;

      vm.getContractsActive = true;
      vm.contracts = [];

      var dataToSend = '/?ascending=' + vm.filters.ascending.value + '&descending=' + vm.filters.descending.value + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value + '&state=' + vm.filters.state.value + '&exported=' + vm.filters.exported.value + '&contractMode=' + vm.filters.contractMode.value + '&since=' + vm.filters.since.value + '&until=' + vm.filters.until.value + '&seller=' + vm.filters.seller.value + '&delegation=' + vm.filters.delegation.value + '&clientCode=' + vm.filters.clientCode.value + '&legalName=' + vm.filters.legalName.value;

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.getContracts(dataToSend).then(function (response) {
        vm.getContractsActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message2 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        vm.contracts = response.data.contracts;

        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(vm.contracts, function (x) {
          if (x.pdf) {
            var uri_org = new __WEBPACK_IMPORTED_MODULE_5_urijs___default.a(x.pdf.url),
                pathname = uri_org.pathname();

            x.pdf.url = __WEBPACK_IMPORTED_MODULE_6__config_env___default.a.api.baseUrl + pathname;
          }

          // let prestigeSalonValue = x.prestigeSalonValue ? x.prestigeSalonValue * 1 : 0
          // let premiumSalonValue = x.premiumSalonValue ? x.premiumSalonValue * 1 : 0
          // x.sumSalonValue = prestigeSalonValue

          // let premiumDiscount1 = x.premiumDiscount1 ? x.premiumDiscount1 * 1 : 0
          // let premiumVariableDiscount1 = x.premiumVariableDiscount1 ? x.premiumVariableDiscount1 * 1 : 0
          // x.premiumDiscountTotal = premiumDiscount1 + premiumVariableDiscount1

          // let prestigeDiscount1 = x.prestigeDiscount1 ? x.prestigeDiscount1 * 1 : 0
          // let prestigeVariableDiscount1 = x.prestigeVariableDiscount1 ? x.prestigeVariableDiscount1 * 1 : 0
          // x.prestigeDiscountTotal = prestigeDiscount1 + prestigeVariableDiscount1
          //  x.prestigeDiscountTotal = prestigeDiscount1
        });

        if (vm.contracts.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.contracts.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.contracts.pop();
        } else {
          vm.nextPage = false;
        }
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value !== 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getContracts();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getContracts();
      }
    },
    optionSelected: function optionSelected(data) {
      var vm = this;

      if (data.action === 'edit') {
        var stateFakeValue = data.element.state === 0 ? this.$t('private.contracts.list.fields.state_options.green') : data.element.state === 1 ? this.$t('private.contracts.list.fields.state_options.red') : data.element.state === 2 ? this.$t('private.contracts.list.fields.state_options.yellow') : data.element.state === 3 ? this.$t('private.contracts.list.fields.state_options.black') : data.element.state === 4 ? this.$t('private.contracts.list.fields.state_options.purple') : '';

        if (data.element.client) {
          vm.formUpdate.fields.client.value = data.element.client.id;
          vm.formUpdate.fields.clientCode.value = data.element.client.clientCode;
        }

        if (data.element.client && data.element.client.associatedAccounts && data.element.client.associatedAccounts.length > 0) {
          var value = {};
          var options = {};

          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.element.client.associatedAccounts, function (associatedAccount) {
            value[associatedAccount.clientCode] = data.element.associatedAccount1 === associatedAccount.clientCode ? true : data.element.associatedAccount2 === associatedAccount.clientCode ? true : data.element.associatedAccount3 === associatedAccount.clientCode;

            options[associatedAccount.clientCode] = {
              name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
              disabled: true
            };
          });

          vm.formUpdate.fields.associateAccounts.value = value;
          vm.formUpdate.fields.associateAccounts.options = options;
          vm.formUpdate.fields.associateAccounts.display = true;
        }

        var mktNewsFakeValue = data.element.prorated === true ? this.$t('private.contracts.list.fields.mkt_news_options.yes') : data.element.prorated === false ? this.$t('private.contracts.list.fields.mkt_news_options.no') : '';

        var proratedFakeValue = data.element.prorated === true ? this.$t('private.contracts.list.fields.prorated_options.yes') : data.element.prorated === false ? this.$t('private.contracts.list.fields.prorated_options.no') : '';

        vm.formUpdate.fields.id.value = data.element.id;
        vm.formUpdate.fields.state.fakeValue = stateFakeValue;
        vm.formUpdate.fields.state.value = data.element.state;
        // vm.formUpdate.fields.prestigeDate.value = data.element.prestigeDate ? this.parseDate(data.element.prestigeDate) : ''
        // vm.formUpdate.fields.prestigeATS.value = data.element.prestigeATS ? data.element.prestigeATS : 0
        // vm.formUpdate.fields.prestigePTS.value = data.element.prestigePTS ? data.element.prestigePTS : ''
        // vm.formUpdate.fields.prestigeMTKG.value = data.element.prestigeMTKG ? data.element.prestigeMTKG : ''
        // vm.formUpdate.fields.prestigeMTKGSubtype.value = data.element.prestigeMTKGSubtype ? data.element.prestigeMTKGSubtype : ''
        // vm.formUpdate.fields.prestigeSalon.value = data.element.prestigeSalon ? data.element.prestigeSalon : ''
        // vm.formUpdate.fields.prestigeSalonValue.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0
        // vm.formUpdate.fields.prestigeSection1.value = data.element.prestigeSection1 ? data.element.prestigeSection1 : '0'
        // vm.formUpdate.fields.prestigeRappel1.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0
        // vm.formUpdate.fields.prestigeRappelMarketing1.value = data.element.prestigeRappelMarketing1 ? data.element.prestigeRappelMarketing1 : 0
        // vm.formUpdate.fields.prestigeDiscount1.value = data.element.prestigeDiscount1 ? data.element.prestigeDiscount1 : 0
        // vm.formUpdate.fields.prestigeVariableDiscount1.value = data.element.prestigeVariableDiscount1 ? data.element.prestigeVariableDiscount1 : 0
        // vm.formUpdate.fields.prestigePotential.value = data.element.prestigePotential ? data.element.prestigePotential : 0
        // vm.formUpdate.fields.prestigeEducation.value = data.element.prestigeEducation ? data.element.prestigeEducation : 0
        // vm.formUpdate.fields.prestigeRappelFrequency.value = vm.formUpdate.fields.prestigeSalon.value && data.element.prestigeRappelFrequency ? data.element.prestigeRappelFrequency : vm.formUpdate.fields.prestigeSalon.value ? 'anual' : ''
        // vm.formUpdate.fields.premiumDate.value = data.element.premiumDate ? this.parseDate(data.element.premiumDate.iso) : ''
        // vm.formUpdate.fields.premiumMTKG.value = data.element.premiumMTKG ? data.element.premiumMTKG : ''
        // vm.formUpdate.fields.premiumMTKGSubtype.value = data.element.premiumMTKGSubtype ? data.element.premiumMTKGSubtype : ''
        // vm.formUpdate.fields.premiumSalon.value = data.element.premiumSalon ? data.element.premiumSalon : ''
        // vm.formUpdate.fields.premiumSalonValue.value = data.element.premiumRappel1 ? data.element.premiumRappel1 : 0
        // vm.formUpdate.fields.premiumATS1.value = data.element.premiumATS ? data.element.premiumATS : 0
        // vm.formUpdate.fields.premiumSection1.value = data.element.premiumSection1 ? data.element.premiumSection1 : '0'
        // vm.formUpdate.fields.premiumRappel1.value = data.element.premiumRappel1 ? data.element.premiumRappel1 : 0
        // vm.formUpdate.fields.premiumRappelMarketing1.value = data.element.premiumRappelMarketing1 ? data.element.premiumRappelMarketing1 : 0
        // vm.formUpdate.fields.premiumDiscount1.value = data.element.premiumDiscount1 ? data.element.premiumDiscount1 : 0
        // vm.formUpdate.fields.premiumVariableDiscount1.value = data.element.premiumVariableDiscount1 ? data.element.premiumVariableDiscount1 : 0
        // vm.formUpdate.fields.premiumEducation1.value = data.element.premiumEducation ? data.element.premiumEducation : 0
        // vm.formUpdate.fields.premiumPotential.value = data.element.premiumPotential ? data.element.premiumPotential : 0
        // vm.formUpdate.fields.premiumRappelFrequency.value = vm.formUpdate.fields.premiumSalon.value && data.element.premiumRappelFrequency ? data.element.premiumRappelFrequency : vm.formUpdate.fields.premiumSalon.value ? 'anual' : ''
        vm.formUpdate.fields.dsoDate.value = data.element.dsoDate ? this.parseDate(data.element.dsoDate) : '';
        vm.formUpdate.fields.dsoPTS.value = data.element.dsoPTS ? data.element.dsoPTS : '';
        vm.formUpdate.fields.dsoMTKG.value = data.element.dsoMTKG ? data.element.dsoMTKG : '';
        vm.formUpdate.fields.dsoMTKGSubtype.value = data.element.dsoMTKGSubtype ? data.element.dsoMTKGSubtype : '';
        vm.formUpdate.fields.dsoSalon.value = data.element.dsoSalon ? data.element.dsoSalon : '';
        vm.formUpdate.fields.dsoSalonValue.value = data.element.dsoRappel ? data.element.dsoRappel : 0;
        vm.formUpdate.fields.dsoSection.value = data.element.dsoSection ? data.element.dsoSection : '0';
        vm.formUpdate.fields.dsoRappel.value = data.element.dsoRappel ? data.element.dsoRappel : 0;
        vm.formUpdate.fields.briogeoRappel.value = data.element.briogeoRappel ? data.element.briogeoRappel : 0;
        vm.formUpdate.fields.dsoRappelMarketing.value = data.element.dsoRappelMarketing ? data.element.dsoRappelMarketing : 0;
        vm.formUpdate.fields.dsoDiscount.value = data.element.dsoDiscount ? data.element.dsoDiscount : 0;
        vm.formUpdate.fields.dsoPotential.value = data.element.dsoPotential ? data.element.dsoPotential : 0;
        vm.formUpdate.fields.dsoEducation.value = data.element.dsoEducation ? data.element.dsoEducation : 0;
        vm.formUpdate.fields.dsoRappelFrequency.value = vm.formUpdate.fields.dsoSalon.value && data.element.dsoRappelFrequency ? data.element.dsoRappelFrequency : vm.formUpdate.fields.dsoSalon.value ? 'anual' : '';
        vm.formUpdate.fields.hasPrestigeCondition.value.FY2223 = !!data.element.hasPrestigeConditionFY2223;
        vm.formUpdate.fields.wellaQuantity.value = data.element.wellaQuantity ? data.element.wellaQuantity : 0;
        vm.formUpdate.fields.wellaDiscount.value = data.element.wellaDiscount ? data.element.wellaDiscount : 0;
        vm.formUpdate.fields.wellaVolumeRappel.value = data.element.wellaVolumeRappel ? data.element.wellaVolumeRappel : 0;
        // vm.formUpdate.fields.sebManRappel.value = data.element.sebManRappel ? data.element.sebManRappel : 0
        // vm.formUpdate.fields.sebManDiscount.value = data.element.sebManDiscount ? data.element.sebManDiscount : 0
        vm.formUpdate.fields.rappelMKTG.value = data.element.rappelMKTG ? data.element.rappelMKTG : 0;
        vm.formUpdate.fields.rappelMKTGManual.value = data.element.rappelMKTGManual ? data.element.rappelMKTGManual : '';
        vm.formUpdate.fields.observations.value = data.element.observations ? data.element.observations : '';
        vm.formUpdate.fields.mktNews.fakeValue = mktNewsFakeValue;
        vm.formUpdate.fields.mktNews.value = !!data.element.mktNews;
        vm.formUpdate.fields.opiQuantity.value = data.element.opiQuantity ? data.element.opiQuantity : 0;
        vm.formUpdate.fields.opiDiscount.value = data.element.opiDiscount ? data.element.opiDiscount : 0;
        vm.formUpdate.fields.opiRappel.value = data.element.opiRappel ? data.element.opiRappel : 0;
        vm.formUpdate.fields.prorated.value = proratedFakeValue;
        vm.formUpdate.fields.proratedMonth.value = data.element.proratedMonth ? data.element.proratedMonth : '';

        if (data.element.pdf) {
          vm.formUpdate.fields.pdf.fileReady = true;
          vm.formUpdate.fields.pdf.value.data = data.element.pdf;
          vm.formUpdate.fields.pdf.value.format = 'pdf';
          vm.formUpdate.fields.pdf.value.size = 0;
        }

        // _.map(data.element.premiumBrands, (brand) => {
        //   vm.formUpdate.fields.premiumBrands.value[brand] = true
        // })
        // _.map(data.element.prestigeBrands, (brand) => {
        //   vm.formUpdate.fields.prestigeBrands.value[brand] = true
        // })

        __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.element.dsoBrands, function (brand) {
          vm.formUpdate.fields.dsoBrands.value[brand] = true;
        });

        vm.displayUpdateContract = true;
      } else if (data.action === 'archive') {
        vm.archiveContract(data.element);
      }
    },
    searchClients: function searchClients(data) {
      var vm = this;

      vm.getSearchClients = true;

      var dataToSend = '?clientCode=' + data;

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {
        vm.getSearchClients = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message3 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message3);

          return;
        }

        var clients = response.data.clients;

        clients = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(clients, function (client) {
          return {
            fakeValue: client.legalName + ' (' + client.clientCode + ')',
            value: client
          };
        });

        vm.formCreate.fields.client.options = clients;
        vm.formUpdate.fields.client.options = clients;
      });
    },
    clientSelected: function clientSelected(data) {
      var vm = this;

      vm.formCreate.fields.client.value = data.id;
      vm.formUpdate.fields.client.value = data.id;

      if (data.associatedAccounts.length === 0) {
        return;
      }

      var value = {};
      var options = {};

      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(data.associatedAccounts, function (associatedAccount) {
        value[associatedAccount.clientCode] = true;

        options[associatedAccount.clientCode] = {
          name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
          disabled: true
        };
      });

      vm.formCreate.fields.associateAccounts.value = value;
      vm.formCreate.fields.associateAccounts.options = options;
      vm.formCreate.fields.associateAccounts.display = true;
      vm.formUpdate.fields.associateAccounts.value = value;
      vm.formUpdate.fields.associateAccounts.options = options;
      vm.formUpdate.fields.associateAccounts.display = true;
    },
    resetForm: function resetForm() {
      var vm = this;

      vm.formCreate.fields.client.value = '';
      vm.formCreate.fields.state.value = '';
      vm.formCreate.fields.appCreationDate.value = '';
      vm.formCreate.fields.associateAccounts.value = {};
      vm.formCreate.fields.associateAccounts.options = [];
      // vm.formCreate.fields.premiumDate.value = ''
      // vm.formCreate.fields.premiumBrands.value = ''
      // vm.formCreate.fields.premiumMTKG.value = ''
      // vm.formCreate.fields.premiumMTKG.filters.required = false
      // vm.formCreate.fields.premiumMTKGSubtype.filters.required = false
      // vm.formCreate.fields.premiumMTKGSubtype.value = ''
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.value = ''
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.display = false
      // vm.formCreate.fields.premiumMTKGSubtypeBrands.filters.required = false
      // vm.formCreate.fields.premiumSalon.value = ''
      // vm.formCreate.fields.premiumSalon.filters.required = false
      // vm.formCreate.fields.premiumSalonValue.value = -1
      // vm.formCreate.fields.premiumATS1.value = ''
      // vm.formCreate.fields.premiumPTS1.value = ''
      // vm.formCreate.fields.premiumSection1.value = ''
      // vm.formCreate.fields.premiumRappel1.value = ''
      // vm.formCreate.fields.premiumRappelMarketing1.value = ''
      // vm.formCreate.fields.premiumDiscount1.value = ''
      // vm.formCreate.fields.premiumVariableDiscount1.value = ''
      // vm.formCreate.fields.premiumEducation1.value = ''
      // vm.formCreate.fields.premiumPotential.value = ''
      // vm.formCreate.fields.premiumRappelFrequency.value = ''
      // vm.formCreate.fields.prestigeDate.value = ''
      // vm.formCreate.fields.prestigeATS.value = ''
      // vm.formCreate.fields.prestigePTS.value = ''
      // vm.formCreate.fields.prestigeMTKG.value = ''
      // vm.formCreate.fields.prestigeMTKG.filters.required = false
      // vm.formCreate.fields.prestigeBrands.value = ''
      // vm.formCreate.fields.prestigeMTKGSubtype.value = ''
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.value = ''
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.display = false
      // vm.formCreate.fields.prestigeMTKGSubtypeBrands.filters.required = false
      // vm.formCreate.fields.prestigeSalon.value = ''
      // vm.formCreate.fields.prestigeSalon.filters.required = false
      // vm.formCreate.fields.prestigeSalonValue.value = -1
      // vm.formCreate.fields.prestigeSection1.value = ''
      // vm.formCreate.fields.prestigeRappel1.value = ''
      // vm.formCreate.fields.prestigeRappelMarketing1.value = ''
      // vm.formCreate.fields.prestigeDiscount1.value = ''
      // vm.formCreate.fields.prestigeVariableDiscount1.value = ''
      // vm.formCreate.fields.prestigeEducation.value = ''
      // vm.formCreate.fields.prestigePotential.value = ''
      // vm.formCreate.fields.prestigeRappelFrequency.value = ''
      vm.formCreate.fields.dsoDate.value = '';
      vm.formCreate.fields.dsoPTS.value = '';
      vm.formCreate.fields.dsoMTKG.value = '';
      vm.formCreate.fields.dsoMTKG.filters.required = false;
      vm.formCreate.fields.dsoBrands.value = '';
      vm.formCreate.fields.dsoMTKGSubtype.value = '';
      vm.formCreate.fields.dsoSalon.value = '';
      vm.formCreate.fields.dsoSalon.filters.required = false;
      vm.formCreate.fields.dsoSalonValue.value = -1;
      vm.formCreate.fields.dsoSection.value = '';
      vm.formCreate.fields.dsoRappel.value = '';
      vm.formCreate.fields.briogeoRappel.value = '';
      vm.formCreate.fields.dsoRappelMarketing.value = '';
      vm.formCreate.fields.dsoDiscount.value = '';
      vm.formCreate.fields.dsoEducation.value = '';
      vm.formCreate.fields.dsoPotential.value = '';
      vm.formCreate.fields.dsoRappelFrequency.value = '';
      vm.formCreate.fields.hasPrestigeCondition.value.FY2223 = false;
      vm.formCreate.fields.wellaQuantity.value = '';
      vm.formCreate.fields.wellaDiscount.value = '';
      vm.formCreate.fields.wellaVolumeRappel.value = '';
      // vm.formCreate.fields.sebManRappel.value = ''
      // vm.formCreate.fields.sebManDiscount.value = ''
      vm.formCreate.fields.rappelMKTG.value = '';
      vm.formCreate.fields.rappelMKTGManual.value = '';
      vm.formCreate.fields.opiQuantity.value = '';
      vm.formCreate.fields.opiDiscount.value = '';
      vm.formCreate.fields.opiRappel.value = '';
      vm.formCreate.fields.observations.value = '';
      // vm.formCreate.fields.brands.value.premium = false
      vm.formCreate.fields.brands.value.dso = false;
      vm.formCreate.fields.brands.value.iso = false;
      vm.formCreate.fields.brands.value.opi = false;
      // vm.formCreate.fields.brands.options.premium.value = false
      // vm.formCreate.fields.brands.options.prestige.value = false
      vm.formCreate.fields.brands.options.dso.value = false;
      vm.formCreate.fields.brands.options.iso.value = false;
      vm.formCreate.fields.brands.options.opi.value = false;
      // vm.formCreate.fields.brands.options.premium.disabled = false
      // vm.formCreate.fields.brands.options.prestige.disabled = false
      vm.formCreate.fields.brands.options.dso.disabled = false;
      vm.formCreate.fields.brands.options.iso.disabled = false;
      vm.formCreate.fields.brands.options.opi.disabled = false;
      vm.exportZipPDFsWindow.fields.year.value = '';
      vm.exportZipPDFsWindow.fields.month.value = '';
      vm.formCreate.fields.prorated.value = '';
      vm.formCreate.fields.proratedMonth.value = '';
      vm.formCreate.fields.proratedMonth.disabled = true;
      vm.formCreate.fields.proratedMonth.filters.required = false;
      vm.formCreate.fields.opiQuantity.disabled = false;
      vm.formCreate.fields.opiDiscount.disabled = false;
      vm.formCreate.fields.opiRappel.disabled = false;

      __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.keys(vm.formCreate.fields), function (key) {
        vm.formCreate.fields[key].error = false;
      });
    },
    formCreateSubmit: function formCreateSubmit() {
      var vm = this;

      if (vm.formCreate.active) {
        return;
      }

      vm.formCreate.active = true;

      vm.$root.$emit('validate', [vm.formCreate.fields, function (response) {
        if (!response.success) {
          vm.formCreate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_9__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        if (!__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.some(vm.formCreate.fields.brands.value)) {
          vm.formCreate.active = false;

          var message = {
            message: [vm.$t('errors.custom.013')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (vm.formCreate.fields.brands.value.iso && vm.formCreate.fields.wellaQuantity.value === '' && vm.formCreate.fields.wellaDiscount.value === '' && vm.formCreate.fields.wellaVolumeRappel.value === '' &&
        // vm.formCreate.fields.sebManRappel.value === '' &&
        // vm.formCreate.fields.sebManDiscount.value === '' &&
        vm.formCreate.fields.rappelMKTG.value === '' && vm.formCreate.fields.rappelMKTGManual.value === '') {
          vm.formCreate.active = false;

          var _message4 = {
            message: [vm.$t('errors.custom.014')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message4);

          return;
        }

        if (vm.formCreate.fields.brands.value.opi && vm.formCreate.fields.opiQuantity.value === '' && vm.formCreate.fields.opiRappel.value === '') {
          vm.formCreate.active = false;

          var _message5 = {
            message: [vm.$t('errors.custom.014')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message5);

          return;
        }

        var appCreationDate = vm.formCreate.fields.appCreationDate.value ? __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(vm.formCreate.fields.appCreationDate.value).toDate() : __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().toDate();

        var dataToSend = {
          appCreationDate: appCreationDate,
          client: vm.formCreate.fields.client.value,
          state: vm.formCreate.fields.state.value,
          observations: vm.formCreate.fields.observations.value,
          pdf: vm.formCreate.fields.pdf.value,
          prorated: vm.formCreate.fields.prorated.value,
          proratedMonth: vm.formCreate.fields.proratedMonth.value

          // if (vm.formCreate.fields.brands.value.premium) {
          //   dataToSend['premiumDate'] = vm.formCreate.fields.premiumSalon.value ? appCreationDate : undefined
          //   dataToSend['premiumMTKG'] = vm.formCreate.fields.premiumMTKG.value
          //   dataToSend['premiumMTKGSubtype'] = vm.formCreate.fields.premiumMTKGSubtype.value
          //   dataToSend['premiumSalon'] = vm.formCreate.fields.premiumSalon.value
          //   dataToSend['premiumSalonValue'] = vm.formCreate.fields.premiumSalonValue.value
          //   dataToSend['premiumATS'] = vm.formCreate.fields.premiumATS1.value
          //   dataToSend['premiumPTS'] = vm.formCreate.fields.premiumPTS1.value
          //   dataToSend['premiumSection1'] = vm.formCreate.fields.premiumSection1.value
          //   dataToSend['premiumRappel1'] = vm.formCreate.fields.premiumRappel1.value
          //   dataToSend['premiumRappelMarketing1'] = vm.formCreate.fields.premiumRappelMarketing1.value
          //   dataToSend['premiumDiscount1'] = vm.formCreate.fields.premiumDiscount1.value
          //   dataToSend['premiumVariableDiscount1'] = vm.formCreate.fields.premiumVariableDiscount1.value
          //   dataToSend['premiumEducation'] = vm.formCreate.fields.premiumEducation1.value
          //   dataToSend['premiumPotential'] = vm.formCreate.fields.premiumPotential.value
          //   dataToSend['premiumRappelFrequency'] = vm.formCreate.fields.premiumRappelFrequency.value
          //   dataToSend['premiumBrands'] = []
          //
          //   _.each(vm.formCreate.fields.premiumBrands.value, (value, key) => {
          //     if (value) dataToSend.premiumBrands.push(vm.formCreate.fields.premiumBrands.options[key].value)
          //   })
          //
          //   dataToSend['prestigeSalonValue'] = vm.formCreate.fields.prestigeSalon.value || -1
          // }

          // if (vm.formCreate.fields.brands.value.prestige) {
          //   dataToSend['prestigeSalon'] = vm.formCreate.fields.prestigeSalon.value
          //   dataToSend['prestigeDate'] = vm.formCreate.fields.prestigeSalon.value ? appCreationDate : undefined
          //   dataToSend['prestigeSalonValue'] = vm.formCreate.fields.prestigeSalonValue.value
          //   // dataToSend['prestigeATS'] = vm.formCreate.fields.prestigeATS.value
          //   dataToSend['prestigeBrands'] = []
          //   dataToSend['prestigeMTKG'] = vm.formCreate.fields.prestigeMTKG.value
          //   dataToSend['prestigeMTKGSubtype'] = vm.formCreate.fields.prestigeMTKGSubtype.value
          //   dataToSend['prestigePTS'] = vm.formCreate.fields.prestigePTS.value
          //   dataToSend['prestigeSection1'] = vm.formCreate.fields.prestigeSection1.value
          //   dataToSend['prestigeRappel1'] = vm.formCreate.fields.prestigeRappel1.value
          //   dataToSend['prestigeDiscount1'] = vm.formCreate.fields.prestigeDiscount1.value
          //   // dataToSend['prestigeVariableDiscount1'] = vm.formCreate.fields.prestigeVariableDiscount1.value
          //   dataToSend['prestigeRappelMarketing1'] = vm.formCreate.fields.prestigeRappelMarketing1.value
          //   dataToSend['prestigeEducation'] = vm.formCreate.fields.prestigeEducation.value
          //   dataToSend['prestigePotential'] = vm.formCreate.fields.prestigePotential.value
          //   dataToSend['prestigeRappelFrequency'] = vm.formCreate.fields.prestigeRappelFrequency.value
          //   dataToSend['hasPrestigeConditionFY2223'] = vm.formCreate.fields.hasPrestigeCondition.value.FY2223
          //
          //   _.each(vm.formCreate.fields.prestigeBrands.value, (value, key) => {
          //     if (value) dataToSend.prestigeBrands.push(vm.formCreate.fields.prestigeBrands.options[key].value)
          //   })
          //
          //   // dataToSend['premiumSalonValue'] = vm.formCreate.fields.premiumSalonValue.value || -1
          // }

        };if (vm.formCreate.fields.brands.value.dso) {
          dataToSend['dsoSalon'] = vm.formCreate.fields.dsoSalon.value;
          dataToSend['dsoDate'] = vm.formCreate.fields.dsoSalon.value ? appCreationDate : undefined;
          dataToSend['dsoSalonValue'] = vm.formCreate.fields.dsoSalonValue.value;
          dataToSend['dsoBrands'] = [];
          dataToSend['dsoMTKG'] = vm.formCreate.fields.dsoMTKG.value;
          dataToSend['dsoMTKGSubtype'] = vm.formCreate.fields.dsoMTKGSubtype.value;
          dataToSend['dsoPTS'] = vm.formCreate.fields.dsoPTS.value;
          dataToSend['dsoSection'] = vm.formCreate.fields.dsoSection.value;
          dataToSend['dsoRappel'] = vm.formCreate.fields.dsoRappel.value;
          dataToSend['briogeoRappel'] = vm.formCreate.fields.briogeoRappel.value;
          dataToSend['dsoDiscount'] = vm.formCreate.fields.dsoDiscount.value;
          dataToSend['dsoRappelMarketing'] = vm.formCreate.fields.dsoRappelMarketing.value;
          dataToSend['dsoEducation'] = vm.formCreate.fields.dsoEducation.value;
          dataToSend['dsoPotential'] = vm.formCreate.fields.dsoPotential.value;
          dataToSend['dsoRappelFrequency'] = vm.formCreate.fields.dsoRappelFrequency.value;
          dataToSend['hasPrestigeConditionFY2223'] = vm.formCreate.fields.hasPrestigeCondition.value.FY2223;

          __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.each(vm.formCreate.fields.dsoBrands.value, function (value, key) {
            if (value) dataToSend.dsoBrands.push(vm.formCreate.fields.dsoBrands.options[key].value);
          });
        }

        if (vm.formCreate.fields.brands.value.iso) {
          dataToSend['wellaQuantity'] = vm.formCreate.fields.wellaQuantity.value;
          dataToSend['wellaDiscount'] = vm.formCreate.fields.wellaDiscount.value;
          dataToSend['wellaVolumeRappel'] = vm.formCreate.fields.wellaVolumeRappel.value;
          // dataToSend['sebManRappel'] = vm.formCreate.fields.sebManRappel.value
          // dataToSend['sebManDiscount'] = vm.formCreate.fields.sebManDiscount.value
          dataToSend['rappelMKTG'] = vm.formCreate.fields.rappelMKTG.value;
          dataToSend['rappelMKTGManual'] = vm.formCreate.fields.rappelMKTGManual.value;
        }

        if (vm.formCreate.fields.brands.value.opi) {
          dataToSend['opiQuantity'] = vm.formCreate.fields.opiQuantity.value;
          dataToSend['opiDiscount'] = vm.formCreate.fields.opiDiscount.value;
          dataToSend['opiRappel'] = vm.formCreate.fields.opiRappel.value;
        }

        var loop = 1;

        for (var i in vm.formCreate.fields.associateAccounts.value) {
          if (vm.formCreate.fields.associateAccounts.value[i]) {
            dataToSend['associatedAccount' + loop] = i;

            loop++;
          }
        }

        __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.createContract(dataToSend).then(function (response) {
          vm.formCreate.active = false;

          if (response.status !== 200) {
            var _message6 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message6);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code === 101) {
              var _message7 = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message7);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.contracts.list.create_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getContracts();

          vm.resetForm();

          vm.getTotalContracts();

          vm.displayCreateContract = false;
        });
      }]);
    },
    formUpdateSubmit: function formUpdateSubmit() {
      var vm = this;

      if (vm.formUpdate.active) {
        return;
      }

      vm.formUpdate.active = true;

      vm.$root.$emit('validate', [vm.formUpdate.fields, function (response) {
        if (!response.success) {
          vm.formUpdate.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_9__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          id: vm.formUpdate.fields.id.value,
          client: vm.formUpdate.fields.client.value,
          state: vm.formUpdate.fields.state.value,
          wellaQuantity: vm.formUpdate.fields.wellaQuantity.value,
          wellaDiscount: vm.formUpdate.fields.wellaDiscount.value,
          wellaVolumeRappel: vm.formUpdate.fields.wellaVolumeRappel.value,
          // sebManRappel: vm.formUpdate.fields.sebManRappel.value,
          // sebManDiscount: vm.formUpdate.fields.sebManDiscount.value,
          rappelMKTG: vm.formUpdate.fields.rappelMKTG.value,
          rappelMKTGManual: vm.formUpdate.fields.rappelMKTGManual.value,
          // wellaTotalRappel: vm.formUpdate.fields.wellaTotalRappel.value,
          // wellaPotential: vm.formUpdate.fields.wellaPotential.value,
          // rappelAntecipado: vm.formUpdate.fields.rappelAntecipado.value,

          // nioxinQuantity        : vm.formUpdate.fields.nioxinQuantity.value,
          // nioxinSupport         : vm.formUpdate.fields.nioxinSupport.value,
          // spQuantity            : vm.formUpdate.fields.spQuantity.value,
          // spSupport             : vm.formUpdate.fields.spSupport.value,
          // systemECQuantity      : vm.formUpdate.fields.systemECQuantity.value,
          // systemECSupport       : vm.formUpdate.fields.systemECSupport.value,
          // sebastianQuantity     : vm.formUpdate.fields.sebastianQuantity.value,
          // sebastianSupport      : vm.formUpdate.fields.sebastianSupport.value,
          // sebastianBrandRappel  : vm.formUpdate.fields.sebastianBrandRappel.value,
          // sebastianGrowthRappel : vm.formUpdate.fields.sebastianGrowthRappel.value,
          // sebastianTotalRappel  : vm.formUpdate.fields.sebastianTotalRappel.value,
          // nioxinPotential       : vm.formUpdate.fields.nioxinPotential.value,
          // spPotential           : vm.formUpdate.fields.spPotential.value,
          // systemECPotential     : vm.formUpdate.fields.systemECPotential.value,
          // sebastianPotential    : vm.formUpdate.fields.sebastianPotential.value,
          // training              : vm.formUpdate.fields.training.value,
          observations: vm.formUpdate.fields.observations.value,
          mktNews: vm.formUpdate.fields.mktNews.value
        };

        if (__WEBPACK_IMPORTED_MODULE_2_lodash___default.a.has(vm.formUpdate.fields.pdf.value, 'data') && !vm.formUpdate.fields.pdf.value.data.url) {
          dataToSend.pdf = vm.formUpdate.fields.pdf.value;
        }

        var loop = 1;

        for (var i in vm.formUpdate.fields.associateAccounts.value) {
          if (vm.formUpdate.fields.associateAccounts.value[i]) {
            dataToSend['associatedAccount' + loop] = i;

            loop++;
          }
        }

        __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.updateContract(dataToSend).then(function (response) {
          vm.formUpdate.active = false;

          if (response.status !== 200) {
            var _message8 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message8);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code === 101) {
              var _message9 = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message9);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.contracts.list.update_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getContracts();

          vm.displayUpdateContract = false;
        });
      }]);
    },
    archiveContract: function archiveContract(element) {
      var vm = this;

      var questionModal = {
        title: this.$t('private.contracts.list.question_modal.title'),
        question: this.$t('private.contracts.list.question_modal.question')
      };

      vm.$root.$emit('question-modal', [questionModal, function (response) {
        if (response) {
          __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.archiveContract(element.id).then(function (response) {
            vm.formUpdate.active = false;

            if (response.status !== 200) {
              var _message10 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message10);

              return;
            }

            if (!response.data.success) {
              if (response.data.error.code === 101) {
                var _message11 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };

                vm.$root.$emit('showMessage', _message11);
              }

              return;
            }

            var message = {
              message: [vm.$t('private.contracts.list.archive_success')],
              type: 'success'
            };

            vm.$root.$emit('showMessage', message);

            vm.getContracts();
          });
        }
      }]);
    },
    exportContracts: function exportContracts() {
      var vm = this;

      if (vm.exportContractsActive) {
        var message = {
          message: [vm.$t('private.contracts.list.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      vm.exportContractsActive = true;

      var dataToSend = {
        timeZone: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess()
      };

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.exportContracts(dataToSend).then(function (response) {
        vm.exportContractsActive = false;

        if (response.status !== 200) {
          var _message12 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message12);

          return;
        }

        var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var fileURL = URL.createObjectURL(file);

        __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(file, 'contracts.xlsx');

        vm.getContracts();
      });
    },
    getDelegations: function getDelegations() {
      var vm = this;

      vm.getDelegationsActive = true;

      var dataToSend = '/?descending=createdAt';

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].delegations.getDelegations(dataToSend).then(function (response) {
        vm.getDelegationsActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message13 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message13);

          return;
        }

        var delegations = response.data.delegations;

        delegations = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(delegations, function (delegation) {
          return {
            fakeValue: delegation.name,
            value: delegation.id
          };
        });

        vm.filters.delegation.options = delegations;
      });
    },
    parseDate: function parseDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(date).format('DD-MM-YYYY');
    },
    resetDataMigrateContractsWindow: function resetDataMigrateContractsWindow() {
      var vm = this;

      vm.migrateContractsWindow.contractsToCreated = [];
      vm.migrateContractsWindow.contractsWithErrors = [];
      vm.migrateContractsWindow.fields.csv.value = {};
      vm.migrateContractsWindow.fields.csv.fileReady = false;
    },
    migrateContractsSubmit: function migrateContractsSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateContractsWindow.fields.separator.value,
        csv: vm.migrateContractsWindow.fields.csv.value.data
      };

      vm.migrateContractsWindow.migrateCSVFileActive = true;

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.migrateCSVFile(dataToSend).then(function (response) {
        vm.migrateContractsWindow.migrateCSVFileActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message14 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message14);

          return;
        }

        vm.migrateContractsWindow.contractsToCreated = response.data.contractsToCreated;
        vm.migrateContractsWindow.contractsWithErrors = response.data.contractsWithErrors;

        console.log(vm.migrateContractsWindow.contractsToCreated);
      });
    },
    generateSlug: function generateSlug(name, toUpperCase, replaceSpaceBy) {
      var _name = toUpperCase ? __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deburr(name).toUpperCase() : __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.deburr(name).toLowerCase();

      return _name.replace(/\s+/g, replaceSpaceBy || '').toString();
    },
    getAgreement: function getAgreement(contract, key) {
      var agreements = [];

      if (contract[key + '1']) agreements.push(contract[key + '1']);
      if (contract[key + '2']) agreements.push(contract[key + '2']);
      if (contract[key + '3']) agreements.push(contract[key + '3']);

      if (agreements.length > 0) {
        return agreements.join(' - ');
      }
      return contract['' + key];
    },
    concatValues: function concatValues(items_1, items_2, items_3) {
      var values = [];
      if (items_1) values.push(items_1);
      if (items_2) values.push(items_2);
      if (items_3) values.push(items_3);

      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(values).join('/');
    },
    handleSendMailDigitalSignature: function handleSendMailDigitalSignature(element) {
      var vm = this;

      if (element.isSendMailDigitalSignature) {
        return;
      }

      element.isSendMailDigitalSignature = true;

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.sendMailDigitalSignature({ id: element.id }).then(function (response) {
        element.isSendMailDigitalSignature = false;

        if (response.status !== 200) {
          var _message15 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message15);

          return;
        }

        if (!response.data.success) {
          var _message16 = void 0;
          if ('message' in response.data) {
            _message16 = {
              message: [response.data.message],
              type: 'error'
            };
          } else {
            if ('error' in response.data) {
              if (response.data.error.code === 101) {
                _message16 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };
              } else {
                _message16 = {
                  message: [vm.$t('errors.parse.001')],
                  type: 'error'
                };
              }
            }
          }

          vm.$root.$emit('showMessage', _message16);

          return;
        }

        var message = {
          message: [vm.$t('private.contracts.list.send_mail_success')],
          type: 'success'
        };

        vm.$root.$emit('showMessage', message);
      }).catch(function (error) {
        console.log('sendMailDigitalSignature > error');
        console.log(error);
        var message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);
      });
    },
    handleSendMailAutoRenew: function handleSendMailAutoRenew(element) {
      var vm = this;

      if (element.isSendMailAutoRenew) {
        return;
      }

      element.isSendMailAutoRenew = true;

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.sendMailAutoRenew({ id: element.id }).then(function (response) {
        element.isSendMailAutoRenew = false;

        if (response.status !== 200) {
          var _message17 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message17);

          return;
        }

        if (!response.data.success) {
          var _message18 = void 0;
          if ('message' in response.data) {
            _message18 = {
              message: [response.data.message],
              type: 'error'
            };
          } else {
            if ('error' in response.data) {
              if (response.data.error.code === 101) {
                _message18 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };
              } else {
                _message18 = {
                  message: [vm.$t('errors.parse.001')],
                  type: 'error'
                };
              }
            }
          }

          vm.$root.$emit('showMessage', _message18);

          return;
        }

        var message = {
          message: [vm.$t('private.contracts.list.send_mail_success')],
          type: 'success'
        };

        vm.$root.$emit('showMessage', message);
      }).catch(function (error) {
        console.log('sendMailAutoRenew > error');
        console.log(error);
        var message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);
      });
    },
    handleSendMailNewPackages: function handleSendMailNewPackages(element) {
      var vm = this;

      if (element.isSendMailNewPackages) {
        return;
      }

      element.isSendMailNewPackages = true;

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.sendMailNewPackages({ id: element.id }).then(function (response) {
        element.isSendMailNewPackages = false;

        if (response.status !== 200) {
          var _message19 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message19);

          return;
        }

        if (!response.data.success) {
          var _message20 = void 0;
          if ('message' in response.data) {
            _message20 = {
              message: [response.data.message],
              type: 'error'
            };
          } else {
            if ('error' in response.data) {
              if (response.data.error.code === 101) {
                _message20 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };
              } else {
                _message20 = {
                  message: [vm.$t('errors.parse.001')],
                  type: 'error'
                };
              }
            }
          }

          vm.$root.$emit('showMessage', _message20);

          return;
        }

        var message = {
          message: [vm.$t('private.contracts.list.send_mail_success')],
          type: 'success'
        };

        vm.$root.$emit('showMessage', message);
      }).catch(function (error) {
        console.log('sendMailNewPackages > error');
        console.log(error);
        var message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);
      });
    },
    exportZipPDFs: function exportZipPDFs() {
      var vm = this;

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        var message = {
          message: [vm.$t('private.contracts.list.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var year = vm.exportZipPDFsWindow.fields.year.value;
      var month = vm.exportZipPDFsWindow.fields.month.value;

      var since = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year(year).month(month - 1).startOf('month').valueOf();
      var until = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year(year).month(month - 1).endOf('month').valueOf();

      vm.exportZipPDFsWindow.sessionId = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 20);
      vm.exportZipPDFsWindow.fields.month.disabled = true;
      vm.exportZipPDFsWindow.fields.year.disabled = true;
      vm.exportZipPDFsWindow.downloadZipPDFsActive = true;

      console.log('since', __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(since).toDate());
      console.log('until', __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()(until).toDate());

      var dataToSend = {
        since: since,
        until: until,
        timeZone: __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.tz.guess(),
        sessionId: vm.exportZipPDFsWindow.sessionId
      };

      __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.exportZipPDFs(dataToSend).then(function (response) {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
        vm.exportZipPDFsWindow.fields.month.disabled = false;
        vm.exportZipPDFsWindow.fields.year.disabled = false;

        if (response.status === 202) {
          var _message21 = {
            message: [vm.$t('errors.custom.011')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message21);

          return;
        }

        if (response.status !== 200) {
          var _message22 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message22);

          return;
        }

        if (!response.data.success) {
          if (response.data.error.code === 101) {
            var _message24 = {
              message: [vm.$t('errors.parse.101')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message24);

            return;
          }

          var _message23 = {
            message: [vm.$t('errors.custom.011')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message23);

          return;
        }

        vm.exportZipPDFsWindow.downloadZipPDFsActive = true;
        vm.exportZipPDFsWindow.fields.month.disabled = true;
        vm.exportZipPDFsWindow.fields.year.disabled = true;
      });
    },
    generateMoths: function generateMoths() {
      var vm = this;

      var lang = navigator.language || navigator.userLanguage;

      __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default.a.locale(lang);

      var year = vm.exportZipPDFsWindow.fields.year.value;

      console.log(year);

      var dateNow = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()();
      var dateSelectedYear = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year(year);
      var monthNow = 12;

      if (dateNow.year() === dateSelectedYear.year()) monthNow = dateSelectedYear.month() + 1;

      vm.exportZipPDFsWindow.fields.month.options = [];
      vm.exportZipPDFsWindow.fields.month.disabled = true;

      for (var i = 0; i < monthNow; ++i) {
        vm.exportZipPDFsWindow.fields.month.options.push({
          fakeValue: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().month(i).format('MMMM')),
          value: i + 1
        });
      }

      vm.exportZipPDFsWindow.fields.month.value = '';
      vm.exportZipPDFsWindow.fields.month.fakeValue = '';
      vm.exportZipPDFsWindow.fields.month.disabled = false;
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_10__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_text_text__["a" /* default */],
    TextareaField: __WEBPACK_IMPORTED_MODULE_12__components_general_fields_textarea_textarea__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_13__components_general_fields_select_select__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_14__components_general_fields_search_search__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_15__components_general_fields_checkbox_checkbox__["a" /* default */],
    InputCheck: __WEBPACK_IMPORTED_MODULE_16__components_general_fields_inputcheck_checkbox__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_17__components_general_fields_file_file__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_18__components_general_fields_date_date__["a" /* default */],
    SortField: __WEBPACK_IMPORTED_MODULE_19__components_general_fields_sort_sort__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getParseConfig();

    vm.getContracts();

    vm.getTotalContracts();

    vm.searchClients('');

    vm.getDelegations();

    for (var i = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year() - 2; i <= __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year(); i++) {
      vm.exportZipPDFsWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      });
    }
  },
  mounted: function mounted() {
    var vm = this;

    var queryProgress = new Parse.Query('Progress');

    subscriptionProgress = queryProgress.subscribe();

    subscriptionProgress.on('open', function () {
      console.log(new Date().toString(), 'subscriptionProgress opened');
    });

    subscriptionProgress.on('create', function (event) {
      vm.exportZipPDFsWindow.progress.display = true;
      vm.exportZipPDFsWindow.progress.valueMax = event.get('valueMax');
    });

    subscriptionProgress.on('update', function (event) {
      var sessionId = event.get('sessionId');

      if (vm.exportZipPDFsWindow.sessionId !== sessionId) return;

      var status = event.get('status');
      var count = event.get('count');
      var valueMax = event.get('valueMax');

      vm.exportZipPDFsWindow.progress.display = true;
      vm.exportZipPDFsWindow.progress.value = count;
      vm.exportZipPDFsWindow.progress.valueMax = valueMax;

      var porcentaje = Math.floor(count / valueMax * 100);

      if (count > 0) {
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#progress_id_export_zippdf').text(porcentaje + '%');
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#progress_id_export_zippdf').attr('aria-valuenow', porcentaje);
        __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#progress_id_export_zippdf').css('width', porcentaje + '%');
      }

      if (status === 'error') {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
        vm.exportZipPDFsWindow.progress.display = false;
        vm.exportZipPDFsWindow.fields.month.disabled = false;
        vm.exportZipPDFsWindow.fields.year.disabled = false;
        vm.exportZipPDFsWindow.display = false;

        var message = {
          message: [vm.$t('errors.custom.001')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      if (status === 'finalized') {
        // subscriptionProgress.unsubscribe();

        var archive_id = event.get('archive_id');

        if (archive_id) {
          __WEBPACK_IMPORTED_MODULE_8__api_api__["a" /* default */].contracts.getExportZipPDFs(archive_id).then(function (response) {
            vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
            vm.exportZipPDFsWindow.fields.month.disabled = false;
            vm.exportZipPDFsWindow.fields.year.disabled = false;

            if (response.status !== 200) {
              vm.exportZipPDFsWindow.progress.display = false;

              var _message25 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message25);

              return;
            }

            var month = vm.exportZipPDFsWindow.fields.month.value;
            var year = vm.exportZipPDFsWindow.fields.year.value;

            var since = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year(year).month(month - 1).startOf('month').valueOf();
            var until = __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default()().year(year).month(month - 1).endOf('month').valueOf();

            var file = new Blob([response.data], { type: 'octet/stream' });
            var fileURL = URL.createObjectURL(file);

            __WEBPACK_IMPORTED_MODULE_3_file_saver___default.a.saveAs(file, 'pdfs_' + since + '_' + until + '.zip');

            setTimeout(function () {
              vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
              vm.exportZipPDFsWindow.progress.display = false;
              vm.exportZipPDFsWindow.fields.month.disabled = false;
              vm.exportZipPDFsWindow.fields.year.disabled = false;
              vm.exportZipPDFsWindow.display = false;
            }, 3000);
          });
        }
      }
    });

    subscriptionProgress.on('error', function (error) {
      console.log('on Error');
      console.log(error);
      vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
      vm.exportZipPDFsWindow.fields.month.disabled = false;
      vm.exportZipPDFsWindow.fields.year.disabled = false;
      vm.exportZipPDFsWindow.progress.display = false;
      vm.exportZipPDFsWindow.display = false;
    });
  }
});

/***/ }),

/***/ "IjAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




var Parse = __webpack_require__("ZVky");
Parse.initialize(__WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.appId);
Parse.serverURL = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl;

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'contracts',
	data: function data() {
		return {
			routes: __WEBPACK_IMPORTED_MODULE_0__router_routes__["a" /* default */]
		};
	},

	methods: {},
	components: {},
	created: function created() {}
});

/***/ }),

/***/ "IqKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locales_i18n__ = __webpack_require__("0Wv9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_http_http__ = __webpack_require__("Ysl6");







/* harmony default export */ __webpack_exports__["a"] = ({
	data: null,
	logout: function logout() {

		var headerToDelete = {
			key: 'x-parse-session-token'
		};

		__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].authentication.logout().then(function (response) {

			__WEBPACK_IMPORTED_MODULE_4__components_general_http_http__["a" /* default */].deleteHeader(headerToDelete);
			localStorage.removeItem('sessionToken');
			localStorage.removeItem('sessionUser');

			window.location.href = __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */].login.path;

			return;
		});
	},
	fetchSession: function fetchSession() {

		var vm = this;

		return __WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].authentication.session().then(function (response) {

			if (response.status != 200) {

				var message = {
					message: [__WEBPACK_IMPORTED_MODULE_3__locales_i18n__["a" /* default */].t('errors.custom.001')],
					type: 'error'
				};

				vm.$root.$emit('showMessage', message);

				return {
					success: false
				};
			}

			if (!response.data.success) {

				var _message = {
					message: [__WEBPACK_IMPORTED_MODULE_3__locales_i18n__["a" /* default */].t('errors.custom.001')],
					type: 'error'
				};

				vm.$root.$emit('showMessage', _message);

				return {
					success: false
				};
			}

			vm.data = response.data.session;

			delete vm.data.sessionToken;

			return {
				success: true
			};
		});
	}
});

/***/ }),

/***/ "J6A/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.history.sda.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('date-field',{attrs:{"data":_vm.filters.since},on:{"changeData":function($event){_vm.filters.since.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}}),_c('date-field',{attrs:{"data":_vm.filters.until},on:{"changeData":function($event){_vm.filters.until.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}}),_c('select-field',{attrs:{"data":_vm.filters.exported},on:{"changeData":function($event){_vm.filters.exported.value = $event; _vm.getSDAsInfo(); _vm.filters.skip.value = 0;}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value !== 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.SDAsInfo.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.SDAsInfo.length > 0)?_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.SDAsInfo),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])])])})):_vm._e(),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.exported")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.client")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.seller")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.delegation")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.normal_sda_pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.system_ec_sda_pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sebastian_sda_pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_wedo_pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_sp")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_sp_internet")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_sp_men")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_sebastian")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_system_ec")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_sebastian_internet")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_ghd")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_wedo")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sp_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sp_internet_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sp_men_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sp_system_ec_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sebastian_internet_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_ghd")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_wedo_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sebastian_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sda_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.normal_sda_virtual_signed")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.sebastian_sda_virtual_signed")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.system_ec_sda_virtual_signed")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.sda.table.wedo_sda_virtual_signed")))])])]),_c('tbody',[(_vm.activateFilters)?_c('tr',[_c('td'),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.clientCode},on:{"changeData":function($event){_vm.filters.clientCode.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.legalName},on:{"changeData":function($event){_vm.filters.legalName.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.seller},on:{"changeData":function($event){_vm.filters.seller.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.delegation},on:{"changeData":function($event){_vm.filters.delegation.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{attrs:{"colspan":"14"}})]):_vm._e(),_vm._l((_vm.SDAsInfo),function(SDAInfo,index){return _c('tr',{class:{ selected : SDAInfo.rowSelected },on:{"click":function($event){_vm.rowClicked(SDAInfo, SDAInfo.rowSelected ? false : true)}}},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.exported ? _vm.$t("private.history.sda.table.exported_options.yes") : _vm.$t("private.history.sda.table.exported_options.no")))]),_c('td',[_vm._v(_vm._s(SDAInfo.clientCode))]),_c('td',[_vm._v(_vm._s(SDAInfo.clientName))]),_c('td',[_vm._v(_vm._s(SDAInfo.sellerEmail ? SDAInfo.sellerEmail : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.delegationName ? SDAInfo.delegationName : ''))]),_c('td',{staticClass:"text-center"},[(SDAInfo.normalSDAPdf)?_c('a',{attrs:{"href":SDAInfo.normalSDAPdf ? SDAInfo.normalSDAPdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e(),(SDAInfo.hasNormalSDA && !SDAInfo.normalSDAPdf)?_c('div',[_c('i',{staticClass:"fa fa-times-rectangle",staticStyle:{"font-size":"25px","margin-top":"5px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',{staticClass:"text-center"},[(SDAInfo.systemECSDAPdf)?_c('a',{attrs:{"href":SDAInfo.systemECSDAPdf ? SDAInfo.systemECSDAPdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e(),(SDAInfo.hasSystemECSDA && !SDAInfo.systemECSDAPdf)?_c('div',[_c('i',{staticClass:"fa fa-times-rectangle",staticStyle:{"font-size":"25px","margin-top":"5px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',{staticClass:"text-center"},[(SDAInfo.sebastianSDAPdf)?_c('a',{attrs:{"href":SDAInfo.sebastianSDAPdf ? SDAInfo.sebastianSDAPdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e(),(SDAInfo.hasSebastianSDA && !SDAInfo.sebastianSDAPdf)?_c('div',[_c('i',{staticClass:"fa fa-times-rectangle",staticStyle:{"font-size":"25px","margin-top":"5px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',{staticClass:"text-center"},[(SDAInfo.wedoSDAPdf)?_c('a',{attrs:{"href":SDAInfo.wedoSDAPdf ? SDAInfo.wedoSDAPdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e(),(SDAInfo.hasWedoSDA && !SDAInfo.wedoSDAPdf)?_c('div',[_c('i',{staticClass:"fa fa-times-rectangle",staticStyle:{"font-size":"25px","margin-top":"5px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sdaSp ? _vm.$t("private.history.sda.table.sda_sp_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sdaSpInternet ? _vm.$t("private.history.sda.table.sda_sp_internet_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sdaSpMen ? _vm.$t("private.history.sda.table.sda_sp_men_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasSebastianSDA && SDAInfo.sdaSebastian ? _vm.$t("private.history.sda.table.sda_sebastian_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasSystemECSDA && SDAInfo.sdaSystemEC ? _vm.$t("private.history.sda.table.sda_system_ec_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sdaSebastianInternet ? _vm.$t("private.history.sda.table.sda_sebastian_internet_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sdaGHD ? _vm.$t("private.history.sda.table.sda_ghd_options.ok") : ''))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.hasWedoSDA && SDAInfo.sdaWedo ? _vm.$t("private.history.sda.table.sda_wedo_options.ok") : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.spDate ? _vm.parseDate( SDAInfo.spDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.spInternetDate ? _vm.parseDate( SDAInfo.spInternetDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.spMenDate ? _vm.parseDate( SDAInfo.spMenDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasSystemECSDA && SDAInfo.systemECDate ? _vm.parseDate( SDAInfo.systemECDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sebastianInternetDate ? _vm.parseDate( SDAInfo.sebastianInternetDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasNormalSDA && SDAInfo.sdaGHDDate ? _vm.parseDate( SDAInfo.sdaGHDDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasWedoSDA && SDAInfo.sdaWedoDate ? _vm.parseDate( SDAInfo.sdaWedoDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.hasSebastianSDA && SDAInfo.sebastianDate ? _vm.parseDate( SDAInfo.sebastianDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.lastDateSDA ? _vm.parseDate( SDAInfo.lastDateSDA ) : ''))]),_c('td',[(SDAInfo.hasNormalSDA)?_c('div',[(SDAInfo.sdaGHD && !SDAInfo.normalSDAVirtualSignApproved && SDAInfo.normalSDAVirtualSigned)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.no")))]):_vm._e(),(SDAInfo.normalSDAVirtualSignApproved)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.yes")))]):_vm._e()]):_vm._e()]),_c('td',[(SDAInfo.hasSebastianSDA)?_c('div',[(SDAInfo.sdaSebastian && !SDAInfo.sebastianSDAVirtualSignApproved && SDAInfo.sebastianSDAVirtualSigned)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.no")))]):_vm._e(),(SDAInfo.sebastianSDAVirtualSignApproved)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.yes")))]):_vm._e()]):_vm._e()]),_c('td',[(SDAInfo.hasSystemECSDA)?_c('div',[(SDAInfo.sdaSystemEC && !SDAInfo.systemECSDAVirtualSignApproved && SDAInfo.systemECSDAVirtualSigned)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.no")))]):_vm._e(),(SDAInfo.systemECSDAVirtualSignApproved)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.yes")))]):_vm._e()]):_vm._e()]),_c('td',[(SDAInfo.hasWedoSDA)?_c('div',[(SDAInfo.sdaWedo && !SDAInfo.wedoSDAVirtualSignApproved && SDAInfo.wedoSDAVirtualSigned)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.no")))]):_vm._e(),(SDAInfo.wedoSDAVirtualSignApproved)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.yes")))]):_vm._e()]):_vm._e()])])})],2)])]),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.SDAsInfo.length === 0 && !_vm.getSDAsInfoActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.history.sda.no_results")))]):_vm._e(),(_vm.getSDAsInfoActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J8Yx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"create-seller",on:{"click":function($event){_vm.displayCreateSeller ? _vm.displayCreateSeller = false : _vm.displayCreateSeller = true}}},[_vm._v(_vm._s(_vm.$t("private.sellers.list.create_seller")))]),_c('div',{staticClass:"export-seller",on:{"click":function($event){_vm.exportUsers()}}},[(!_vm.exportUsersActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.export_users")))]):_vm._e(),(_vm.exportUsersActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportUsersActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.sellers.list.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('text-field',{attrs:{"data":_vm.filters.fullname},on:{"changeData":function($event){_vm.filters.fullname.value = $event; _vm.filters.skip.value = 0; _vm.getSellers();}}}),_c('text-field',{attrs:{"data":_vm.filters.username},on:{"changeData":function($event){_vm.filters.username.value = $event; _vm.filters.skip.value = 0; _vm.getSellers();}}}),_c('text-field',{attrs:{"data":_vm.filters.email},on:{"changeData":function($event){_vm.filters.email.value = $event; _vm.filters.skip.value = 0; _vm.getSellers();}}}),_c('select-field',{attrs:{"data":_vm.filters.ascending},on:{"changeData":function($event){_vm.filters.ascending.value = $event; _vm.filters.skip.value = 0; _vm.getSellers();}}}),_c('select-field',{attrs:{"data":_vm.filters.descending},on:{"changeData":function($event){_vm.filters.descending.value = $event; _vm.filters.skip.value = 0; _vm.getSellers();}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getSellers();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.sellers.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.sellers.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.sellers),function(seller,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[(seller.firstname && seller.lastname)?_c('li',{staticClass:"item names"},[_vm._v(_vm._s(seller.firstname + ' ' +seller.lastname))]):_vm._e(),_c('li',{staticClass:"item email"},[_vm._v(_vm._s(seller.email))]),_c('li',{staticClass:"item username"},[_vm._v(_vm._s(seller.username))])]),_c('menu-more-options',{attrs:{"element":seller,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)})),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th'),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.firstname")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.lastname")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.username")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.email")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.delegation")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.type")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.active")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.multi_type")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.last_access")))])])]),_c('tbody',_vm._l((_vm.sellers),function(seller,index){return _c('tr',{class:{ selected : seller.rowSelected },on:{"click":function($event){_vm.rowClicked(seller, seller.rowSelected ? false : true)}}},[_c('td',{staticClass:"options"},[_c('menu-more-options',{attrs:{"element":seller,"side":'right',"options":_vm.menuOptions,"topClass":index > _vm.filters.limit.value - 5 ? true : false},on:{"optionSelected":_vm.optionSelected}})],1),_c('td',[_vm._v(_vm._s(seller.firstname))]),_c('td',[_vm._v(_vm._s(seller.lastname))]),_c('td',[_vm._v(_vm._s(seller.username))]),_c('td',[_vm._v(_vm._s(seller.email))]),_c('td',[_vm._v(_vm._s(seller.delegation ? seller.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(seller.sellerType ? seller.sellerType.name : ''))]),_c('td',[_vm._v(_vm._s(seller.active ? _vm.$t("private.sellers.list.table.active_yes") : _vm.$t("private.sellers.list.table.active_no")))]),_c('td',[_vm._v(_vm._s(seller.multi_type ? _vm.$t("private.sellers.list.table.active_yes") : _vm.$t("private.sellers.list.table.active_no")))]),_c('td',[_vm._v(_vm._s(seller.lastAccess))])])}))])])]):_vm._e(),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.sellers.length == 0 && !_vm.getSellersActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.no_results")))]):_vm._e(),(_vm.getSellersActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])]),(_vm.displayCreateSeller)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.sellers_list_create"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayCreateSeller = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formCreate.fields.firstname},on:{"changeData":function($event){_vm.formCreate.fields.firstname.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.lastname},on:{"changeData":function($event){_vm.formCreate.fields.lastname.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.username},on:{"changeData":function($event){_vm.formCreate.fields.username.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.email},on:{"changeData":function($event){_vm.formCreate.fields.email.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.password},on:{"changeData":function($event){_vm.formCreate.fields.password.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.delegation},on:{"changeData":function($event){_vm.formCreate.fields.delegation.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.sellerType},on:{"changeData":function($event){_vm.formCreate.fields.sellerType.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.active},on:{"changeData":function($event){_vm.formCreate.fields.active.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.multiType},on:{"changeData":function($event){_vm.formCreate.fields.multiType.value = $event}}}),_c('checkbox-field',{attrs:{"data":_vm.formCreate.fields.permissions},on:{"changeData":function($event){_vm.formCreate.fields.permissions.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.formCreate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.create_button")))]):_vm._e(),(_vm.formCreate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayCreateSeller = false}}})]):_vm._e(),(_vm.displayUpdateSeller)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.sellers.list.sellers_update"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayUpdateSeller = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formUpdateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.firstname},on:{"changeData":function($event){_vm.formUpdate.fields.firstname.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.lastname},on:{"changeData":function($event){_vm.formUpdate.fields.lastname.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.username},on:{"changeData":function($event){_vm.formUpdate.fields.username.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.email},on:{"changeData":function($event){_vm.formUpdate.fields.email.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.password},on:{"changeData":function($event){_vm.formUpdate.fields.password.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.delegation},on:{"changeData":function($event){_vm.formUpdate.fields.delegation.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.sellerType},on:{"changeData":function($event){_vm.formUpdate.fields.sellerType.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.active},on:{"changeData":function($event){_vm.formUpdate.fields.active.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.multiType},on:{"changeData":function($event){_vm.formUpdate.fields.multiType.value = $event}}}),_c('checkbox-field',{attrs:{"data":_vm.formUpdate.fields.permissions},on:{"changeData":function($event){_vm.formUpdate.fields.permissions.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formUpdateSubmit}},[(!_vm.formUpdate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.update_button")))]):_vm._e(),(_vm.formUpdate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayUpdateSeller = false}}})]):_vm._e(),(_vm.migrateUsersWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in"},[_c('div',{staticClass:"header"},[_vm._v("Migrar Usuarios - CSV"),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.migrateUsersWindow.display = false; _vm.resetDataMigrateUsersWindow ()}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.migrateUsersWindow.fields.csv},on:{"changeData":function($event){_vm.migrateUsersWindow.fields.csv.value = $event;}}})],1),_c('div',{staticClass:"col-md-6"},[(_vm.migrateUsersWindow.fields.csv.value.data)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.migrateUsersSubmit()}}},[(!_vm.migrateUsersWindow.migrateCSVFileActive)?_c('span',[_vm._v("Enviar CSV")]):_vm._e(),(_vm.migrateUsersWindow.migrateCSVFileActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e()]),(_vm.migrateUsersWindow.migrateCSVFileActive)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.please_wait")))])]):_vm._e()]),(!_vm.migrateUsersWindow.migrateCSVFileActive && (_vm.migrateUsersWindow.sellersToCreated.length > 0 || _vm.migrateUsersWindow.sellersWithErrors.length > 0))?_c('div',[_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Usuarios Migrados ' + _vm.migrateUsersWindow.sellersToCreated.length))]),_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Usuarios con errores ' + _vm.migrateUsersWindow.sellersWithErrors.length))])]),_c('hr'),(_vm.migrateUsersWindow.sellersWithErrors.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v("Datos con Error")]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_vm._m(0),_c('tbody',_vm._l((_vm.migrateUsersWindow.sellersWithErrors),function(seller,index){return _c('tr',[_c('td',[_vm._v(_vm._s(seller.seller ? seller.seller.username : seller.username))]),_c('td',[_vm._v(_vm._s(seller.error.field ? seller.error.field : ''))]),_c('td',[_vm._v(_vm._s(seller.error.value ? seller.error.value : ''))]),_c('td',[_vm._v(_vm._s(seller.error.message ? seller.error.message : ''))])])}))])]):_vm._e()]):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.migrateUsersWindow.display = false; _vm.resetDataMigrateUsersWindow()}}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Usuario")]),_c('th',[_vm._v("Campo")]),_c('th',[_vm._v("Valor")]),_c('th',[_vm._v("Descripción")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("k0Yb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("vkIy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jlyh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jm3/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KWv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  login: {
    path: '/',
    name: 'public.login'
  },
  private: {
    path: '',
    name: 'private'
  },
  sellers: {
    path: '/Sellers',
    name: 'private.sellers'
  },
  sellersList: {
    path: '/Sellers/List',
    name: 'private.sellers.list'
  },
  sellersDelegations: {
    path: '/Sellers/Delegations',
    name: 'private.sellers.delegations'
  },
  sellersTypes: {
    path: '/Sellers/Types',
    name: 'private.sellers.types'
  },
  clientsRecords: {
    path: '/ClientsRecords',
    name: 'private.clients_records'
  },
  clientsRecordsList: {
    path: '/ClientsRecords/List',
    name: 'private.clients_records.list'
  },
  clients: {
    path: '/Clients',
    name: 'private.clients'
  },
  clientsList: {
    path: '/Clients/List',
    name: 'private.clients.list'
  },
  contracts: {
    path: '/Contracts',
    name: 'private.contracts'
  },
  contractsList: {
    path: '/Contracts/List',
    name: 'private.contracts.list'
  },
  contractsSDA: {
    path: '/Contracts/SDA',
    name: 'private.contracts.sda'
  },
  contractsZips: {
    path: '/Contracts/zips',
    name: 'private.contracts.zips'
  },
  reports: {
    path: '/Reports',
    name: 'private.reports'
  },
  reportsMasterData: {
    path: '/Reports/MasterData',
    name: 'private.reports.master_data'
  },
  reportsSDA: {
    path: '/Reports/SDA',
    name: 'private.reports.sda'
  },
  reportsPotential: {
    path: '/Reports/Potential',
    name: 'private.reports.potential'
  },
  reportsCCI: {
    path: '/Reports/CCI',
    name: 'private.reports.cci'
  },
  reportsEducation: {
    path: '/Reports/Education',
    name: 'private.reports.education'
  },
  history: {
    path: '/history',
    name: 'private.history'
  },
  historyContracts: {
    path: '/history/contracts',
    name: 'private.history.contracts'
  },
  historyContractsSDA: {
    path: '/history/SDA',
    name: 'private.history.sda'
  }
});

/***/ }),

/***/ "KZG4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar__ = __webpack_require__("olwm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'date-field',
	props: ['data'],
	data: function data() {
		return {
			field: {
				fakeValue: this.data.fakeValue,
				value: this.data.value
			},
			calendar: {
				active: false
			}
		};
	},

	methods: {
		createFullCalendar: function createFullCalendar() {

			var vm = this;
			vm.calendar.active = true;

			var calendarConfig = {
				header: {
					left: 'prevYear,prev',
					center: 'title',
					right: 'next,nextYear'
				},
				prev: 'left-single-arrow',
				next: 'right-single-arrow',
				prevYear: 'left-double-arrow',
				nextYear: 'right-double-arrow',
				monthNames: [this.$t('calendar.month_names.january'), this.$t('calendar.month_names.february'), this.$t('calendar.month_names.march'), this.$t('calendar.month_names.april'), this.$t('calendar.month_names.may'), this.$t('calendar.month_names.june'), this.$t('calendar.month_names.july'), this.$t('calendar.month_names.august'), this.$t('calendar.month_names.september'), this.$t('calendar.month_names.october'), this.$t('calendar.month_names.november'), this.$t('calendar.month_names.december')],
				dayNamesShort: [this.$t('calendar.day_names_short.sunday'), this.$t('calendar.day_names_short.monday'), this.$t('calendar.day_names_short.tuesday'), this.$t('calendar.day_names_short.wednesday'), this.$t('calendar.day_names_short.thursday'), this.$t('calendar.day_names_short.friday'), this.$t('calendar.day_names_short.saturday')],
				dayClick: function dayClick(date, jsEvent, view) {

					jsEvent.preventDefault();

					if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).hasClass('disabled')) {

						__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.calendar.active').removeClass('active');

						__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this).addClass('active');

						var dateSelected = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(date.format()).format('YYYY-MM-DD');

						vm.field.fakeValue = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(date.format()).format('DD-MM-YYYY');

						vm.field.value = dateSelected;

						vm.calendar.active = false;

						vm.$emit('changeData', dateSelected);
					}
				},
				viewRender: function viewRender(view) {

					//$('.calendar .fc-day.fc-past').addClass('disabled')
					//$('.calendar .fc-day-number.fc-past').addClass('disabled')

				}
			};

			setTimeout(function () {

				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.calendar').fullCalendar(calendarConfig);
			}, 100);
		}
	}
});

/***/ }),

/***/ "L297":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sort-field',
	props: ['data'],
	data: function data() {
		return {
			field: {
				id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('sort_'),
				sort_default: true,
				sort_asc: false,
				sort_desc: false
			}
		};
	},

	methods: {
		actionSort: function actionSort(event) {

			var vm = this;

			var target = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(event.target).closest('#contrats_tr');
			var iconIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(target.find('th').children('i'), 'id');

			__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(iconIds, function (id) {

				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + id).removeClass("fa-sort-asc");
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + id).removeClass("fa-sort-desc");
				__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#' + id).addClass("fa-sort");
			});

			if (vm.field.sort_default) {
				vm.field.sort_default = false;
				vm.field.sort_asc = true;
			} else if (vm.field.sort_asc) {
				vm.field.sort_asc = false;
				vm.field.sort_desc = true;
			} else if (vm.field.sort_desc) {
				vm.field.sort_desc = false;
				vm.field.sort_default = true;
			}

			this.$emit('changeData', this.field);
		}
	}
});

/***/ }),

/***/ "Lbey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("6mzL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_585c5f43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("4tvh");
function injectStyle (ssrContext) {
  __webpack_require__("lBs9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-585c5f43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_585c5f43_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LfxX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	exportMasterData: function exportMasterData(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/reports/export/masterData';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportSDA: function exportSDA(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/reports/export/sda';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportPotential: function exportPotential(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/reports/export/potential';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportCCI: function exportCCI(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/reports/export/cci';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportEducation: function exportEducation(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/reports/export/education';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "LvjE":
/***/ (function(module, exports) {

module.exports = {"version":"2018e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|012|-2le00 4i6N0","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|012342525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 XQp0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0 1HB0 FX0 1HB0 IL0 1HB0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0 IL0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1HB0 FX0 1Kp0 FX0 1HB0 IL0 1EN0 FX0 1HB0 FX0 1HB0 IL0 1EN0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le80 1XO3u 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BAu|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rb0 1ld0 14n0 1zd0 On0 1zd0 On0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Etc/GMT-0|GMT|0|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app_app__ = __webpack_require__("XoBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locales_i18n__ = __webpack_require__("0Wv9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_css__ = __webpack_require__("5W1q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fullcalendar_dist_fullcalendar_min_css__ = __webpack_require__("AixB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_fullcalendar_dist_fullcalendar_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_fullcalendar_dist_fullcalendar_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	template: '<App/>',
	store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */],
	components: { App: __WEBPACK_IMPORTED_MODULE_1__app_app__["a" /* default */] },
	router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
	i18n: __WEBPACK_IMPORTED_MODULE_4__locales_i18n__["a" /* default */]
});

/***/ }),

/***/ "Notx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("oMXj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195964d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("/Egf");
function injectStyle (ssrContext) {
  __webpack_require__("2OgN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-195964d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195964d6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nr+5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{style:(_vm.data.style)},[(_vm.data.title)?_c('div',{staticClass:"field-container-title"},[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_c('div',{staticClass:"field-container",style:(_vm.data.style)},[(_vm.field.value != '')?_c('div',{staticClass:"field-title fade-in"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.fakeValue),expression:"field.fakeValue"}],staticClass:"text-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"text","id":_vm.data.id,"placeholder":_vm.data.name,"disabled":_vm.data.disabled,"onfocus":"document.activeElement.blur()"},domProps:{"value":(_vm.field.fakeValue)},on:{"click":function($event){_vm.data.error = false; _vm.createFullCalendar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "fakeValue", $event.target.value)}}})]),(_vm.calendar.active)?_c('div',{staticClass:"calendar-container"},[_c('div',{staticClass:"calendar",attrs:{"id":"calendar"}}),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.calendar.active = false}}})]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ny1O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in private-container-view"},[_c('div',{staticClass:"header-sections"},[_c('ul',{staticClass:"items-container"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.clientsList.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.clients.header.clients_list")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.clientsList.name}})])])],1)]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OQyK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header_header__ = __webpack_require__("3SG2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aside_aside__ = __webpack_require__("TMrr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_general_question_modal_question_modal__ = __webpack_require__("Notx");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'private',
	data: function data() {
		return {};
	},

	methods: {},
	components: {
		PrivateHeader: __WEBPACK_IMPORTED_MODULE_0__header_header__["a" /* default */],
		PrivateAside: __WEBPACK_IMPORTED_MODULE_1__aside_aside__["a" /* default */],
		QuestionModal: __WEBPACK_IMPORTED_MODULE_2__components_general_question_modal_question_modal__["a" /* default */]
	}
});

/***/ }),

/***/ "OScl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__ = __webpack_require__("711T");










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sellers-delegations',
	data: function data() {
		return {
			delegations: [],
			menuOptions: [{
				iconClass: 'fa fa-pencil',
				name: this.$t('private.sellers.delegations.menu_more_options.edit_delegation'),
				action: 'edit'
			}, {
				iconClass: 'fa fa-trash',
				name: this.$t('private.sellers.delegations.menu_more_options.delete_delegation'),
				action: 'delete'
			}],
			filters: {
				name: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					value: '',
					name: this.$t('private.sellers.delegations.filters.name'),
					type: 'text',
					error: false,
					filters: {
						type: 'string',
						minLength: 2,
						maxLength: 100,
						required: true
					},
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				ascending: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.sellers.delegations.filters.sort_options.created_at'),
					value: 'createdAt',
					name: this.$t('private.sellers.delegations.filters.sort_ascending'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.sellers.delegations.filters.sort_options.created_at'),
						value: 'createdAt'
					}, {
						fakeValue: this.$t('private.sellers.delegations.filters.sort_options.name'),
						value: 'name'
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				descending: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.sellers.delegations.filters.sort_descending'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.sellers.delegations.filters.sort_options.created_at'),
						value: 'createdAt'
					}, {
						fakeValue: this.$t('private.sellers.delegations.filters.sort_options.name'),
						value: 'name'
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				limit: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.sellers.delegations.filters.limit_options.10'),
					value: 10,
					name: this.$t('private.sellers.delegations.filters.limit'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.sellers.delegations.filters.limit_options.10'),
						value: 10
					}, {
						fakeValue: this.$t('private.sellers.delegations.filters.limit_options.25'),
						value: 25
					}, {
						fakeValue: this.$t('private.sellers.delegations.filters.limit_options.50'),
						value: 50
					}, {
						fakeValue: this.$t('private.sellers.delegations.filters.limit_options.100'),
						value: 100
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				skip: {
					value: 0
				}
			},
			getDelegationsActive: false,
			activateFilters: false,
			haveData: false,
			nextPage: false,
			formCreate: {
				fields: {
					name: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.sellers.delegations.fields.name'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 100,
							required: true
						}
					}
				},
				active: false
			},
			displayCreateDelegation: false,
			formUpdate: {
				fields: {
					id: {
						value: '',
						filters: {
							type: 'string',
							required: true
						}
					},
					name: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.sellers.delegations.fields.name'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 100,
							required: true
						}
					}
				},
				active: false
			},
			displayUpdateDelegation: false
		};
	},

	methods: {
		getDelegations: function getDelegations() {

			var vm = this;

			vm.getDelegationsActive = true;
			vm.delegations = [];

			var dataToSend = '/?name=' + vm.filters.name.value + '&ascending=' + vm.filters.ascending.value + '&descending=' + vm.filters.ascending.value + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

			__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].delegations.getDelegations(dataToSend).then(function (response) {

				vm.getDelegationsActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message);

					return;
				}

				vm.delegations = response.data.delegations;

				if (vm.delegations.length > 0 && !vm.haveData) {

					vm.haveData = true;
				}

				if (vm.delegations.length > vm.filters.limit.value) {

					vm.nextPage = true;

					vm.delegations.pop();
				} else {

					vm.nextPage = false;
				}
			});
		},
		goToBackPage: function goToBackPage() {

			var vm = this;

			if (vm.filters.skip.value != 0) {

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

				vm.getDelegations();
			}
		},
		goToNextPage: function goToNextPage() {

			var vm = this;

			if (vm.nextPage) {

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

				vm.getDelegations();
			}
		},
		optionSelected: function optionSelected(data) {

			var vm = this;

			if (data.action == 'edit') {

				vm.formUpdate.fields.id.value = data.element.id;
				vm.formUpdate.fields.name.value = data.element.name;

				vm.displayUpdateDelegation = true;
			} else if (data.action == 'delete') {

				vm.deleteDelegation(data.element);
			}
		},
		formCreateSubmit: function formCreateSubmit() {

			var vm = this;

			if (vm.formCreate.active) {

				return;
			}

			vm.formCreate.active = true;

			vm.$root.$emit('validate', [vm.formCreate.fields, function (response) {

				if (!response.success) {

					vm.formCreate.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_3__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				var dataToSend = {
					name: vm.formCreate.fields.name.value
				};

				__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].delegations.createDelegation(dataToSend).then(function (response) {

					vm.formCreate.active = false;

					if (response.status != 200) {

						var _message2 = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', _message2);

						return;
					}

					if (!response.data.success) {

						if (response.data.error.code == 101) {

							var _message3 = {
								message: [vm.$t('errors.parse.101')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message3);
						}

						return;
					}

					var message = {
						message: [vm.$t('private.sellers.delegations.create_success')],
						type: 'success'
					};

					vm.$root.$emit('showMessage', message);

					vm.getDelegations();

					vm.displayCreateDelegation = false;

					vm.formCreate.fields.name.value = '';
				});
			}]);
		},
		formUpdateSubmit: function formUpdateSubmit() {

			var vm = this;

			if (vm.formUpdate.active) {

				return;
			}

			vm.formUpdate.active = true;

			vm.$root.$emit('validate', [vm.formUpdate.fields, function (response) {

				if (!response.success) {

					vm.formUpdate.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_3__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				var dataToSend = {
					id: vm.formUpdate.fields.id.value,
					name: vm.formUpdate.fields.name.value
				};

				__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].delegations.updateDelegation(dataToSend).then(function (response) {

					vm.formUpdate.active = false;

					if (response.status != 200) {

						var _message4 = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', _message4);

						return;
					}

					if (!response.data.success) {

						if (response.data.error.code == 101) {

							var _message5 = {
								message: [vm.$t('errors.parse.101')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message5);
						}

						return;
					}

					var message = {
						message: [vm.$t('private.sellers.delegations.update_success')],
						type: 'success'
					};

					vm.$root.$emit('showMessage', message);

					vm.displayUpdateDelegation = false;

					vm.getDelegations();

					vm.formUpdate.fields.name.value = '';
				});
			}]);
		},
		deleteDelegation: function deleteDelegation(element) {

			var vm = this;

			var questionModal = {
				title: this.$t('private.sellers.delegations.question_modal.title'),
				question: this.$t('private.sellers.delegations.question_modal.question')
			};

			vm.$root.$emit('question-modal', [questionModal, function (response) {

				if (response) {

					var dataToSend = '/?id=' + element.id;

					__WEBPACK_IMPORTED_MODULE_1__api_api__["a" /* default */].delegations.deleteDelegation(dataToSend).then(function (response) {

						vm.formUpdate.active = false;

						if (response.status != 200) {

							var _message6 = {
								message: [vm.$t('errors.custom.001')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message6);

							return;
						}

						if (!response.data.success) {

							if (response.data.error.code == 101) {

								var _message7 = {
									message: [vm.$t('errors.parse.101')],
									type: 'error'
								};

								vm.$root.$emit('showMessage', _message7);
							}

							return;
						}

						var message = {
							message: [vm.$t('private.sellers.delegations.delete_success')],
							type: 'success'
						};

						vm.$root.$emit('showMessage', message);

						vm.getDelegations();
					});
				}
			}]);
		}
	},
	components: {
		MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_4__components_general_menu_more_options_menu_more_options__["a" /* default */],
		TextField: __WEBPACK_IMPORTED_MODULE_5__components_general_fields_text_text__["a" /* default */],
		SelectField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_select_select__["a" /* default */]
	},
	created: function created() {

		var vm = this;

		vm.getDelegations();
	}
});

/***/ }),

/***/ "ObX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"export-data",on:{"click":function($event){_vm.exportData()}}},[(!_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.cci.export_data")))]):_vm._e(),(_vm.exportDataActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.cci.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.reports.cci.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.getclients(); _vm.filters.skip.value = 0;}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.clients.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.clients.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.clients),function(client,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(client.id))])])])})),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.cci.table.client_code")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.cci.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.cci.table.image_conditions")))])])]),_c('tbody',_vm._l((_vm.clients),function(client,index){return _c('tr',[_c('td',[_vm._v(_vm._s(client.clientCode))]),_c('td',[_vm._v(_vm._s(client.legalName))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(client.mktNews ? 'OK' : ''))])])}))])])]):_vm._e(),(_vm.clients.length == 0 && !_vm.getClientsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.reports.cci.no_results")))]):_vm._e(),(_vm.getClientsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OrUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("ykU3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cdfcdb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("98sC");
function injectStyle (ssrContext) {
  __webpack_require__("sssV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26cdfcdb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26cdfcdb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P0Y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('messenger'),_c('data-validator'),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P9l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__authentication__ = __webpack_require__("uLeh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sellers__ = __webpack_require__("cl9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__delegations__ = __webpack_require__("snNT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sellers_types__ = __webpack_require__("n0K1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clients__ = __webpack_require__("7zLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clients_records__ = __webpack_require__("eAmI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__contracts__ = __webpack_require__("tbHi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__contractsHistory__ = __webpack_require__("W4uV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__contractsZips__ = __webpack_require__("d2t4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sda__ = __webpack_require__("94g/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sdas_info__ = __webpack_require__("AbTt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reports__ = __webpack_require__("LfxX");













/* harmony default export */ __webpack_exports__["a"] = ({
	authentication: __WEBPACK_IMPORTED_MODULE_0__authentication__["a" /* default */],
	sellers: __WEBPACK_IMPORTED_MODULE_1__sellers__["a" /* default */],
	delegations: __WEBPACK_IMPORTED_MODULE_2__delegations__["a" /* default */],
	sellersTypes: __WEBPACK_IMPORTED_MODULE_3__sellers_types__["a" /* default */],
	clients: __WEBPACK_IMPORTED_MODULE_4__clients__["a" /* default */],
	clientsRecords: __WEBPACK_IMPORTED_MODULE_5__clients_records__["a" /* default */],
	contracts: __WEBPACK_IMPORTED_MODULE_6__contracts__["a" /* default */],
	contractsHistory: __WEBPACK_IMPORTED_MODULE_7__contractsHistory__["a" /* default */],
	contractsZips: __WEBPACK_IMPORTED_MODULE_8__contractsZips__["a" /* default */],
	SDAs: __WEBPACK_IMPORTED_MODULE_9__sda__["a" /* default */],
	SDAsInfo: __WEBPACK_IMPORTED_MODULE_10__sdas_info__["a" /* default */],
	reports: __WEBPACK_IMPORTED_MODULE_11__reports__["a" /* default */]
});

/***/ }),

/***/ "PgVB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'menu-more-options',
	props: ['element', 'options', 'topClass', 'side'],
	data: function data() {
		return {
			active: ''
		};
	},

	methods: {
		optionSelected: function optionSelected(option) {

			var vm = this;

			vm.active = false;

			var dataToSend = {
				element: vm.element,
				action: option.action
			};

			this.$emit('optionSelected', dataToSend);
		}
	}
});

/***/ }),

/***/ "PqU8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"export-data",on:{"click":function($event){_vm.exportData()}}},[(!_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.sda.export_data")))]):_vm._e(),(_vm.exportDataActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.reports.sda.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('date-field',{attrs:{"data":_vm.filters.since},on:{"changeData":function($event){_vm.filters.since.value = $event; _vm.getSDAsInfo()}}}),_c('date-field',{attrs:{"data":_vm.filters.until},on:{"changeData":function($event){_vm.filters.until.value = $event; _vm.getSDAsInfo()}}}),_c('select-field',{attrs:{"data":_vm.filters.exported},on:{"changeData":function($event){_vm.filters.exported.value = $event; _vm.getSDAsInfo(); _vm.filters.skip.value = 0;}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.getSDAsInfo(); _vm.filters.skip.value = 0;}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.SDAsInfo.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.SDAsInfo.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.SDAsInfo),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])])])})),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',[_c('checkbox-field',{attrs:{"data":_vm.activateAllCheckbox},on:{"changeData":function($event){_vm.activateAllCheckbox.value = $event; _vm.activateAllCheckboxToggle()}}})],1),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.exported")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.client")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.seller")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.delegation")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.sda_sebastian")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.table.sebastian_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sda_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sebastian_sda_pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sebastian_sda_virtual_signed")))])])]),_c('tbody',_vm._l((_vm.SDAsInfo),function(SDAInfo,index){return _c('tr',[_c('td',[_c('checkbox-field',{attrs:{"data":_vm.allChecks[index]},on:{"changeData":function($event){_vm.selectedSDAsInfo[index] = $event}}})],1),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.exported ? _vm.$t("private.reports.sda.table.exported_options.yes") : _vm.$t("private.reports.sda.table.exported_options.no")))]),_c('td',[_vm._v(_vm._s(SDAInfo.client ? SDAInfo.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.client ? SDAInfo.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(!SDAInfo.client ? '' : SDAInfo.client.seller ? SDAInfo.client.seller.username : ''))]),_c('td',[_vm._v(_vm._s(!SDAInfo.client ? '' : !SDAInfo.client.seller ? '' : !SDAInfo.client.seller.delegation ? '' : SDAInfo.client.seller.delegation.name))]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.sebastianSDA && SDAInfo.sdaSebastian ? _vm.$t("private.contracts.sda.table.sda_sebastian_options.ok") : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.sebastianSDA && SDAInfo.sebastianDate ? _vm.parseDate( SDAInfo.sebastianDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.lastDateSDA ? _vm.parseDate( SDAInfo.lastDateSDA ) : ''))]),_c('td',{staticClass:"text-center"},[(SDAInfo.sebastianSDA && SDAInfo.sebastianSDA.pdf)?_c('a',{attrs:{"href":SDAInfo.sebastianSDA.pdf ? SDAInfo.sebastianSDA.pdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',[(SDAInfo.sebastianSDA && SDAInfo.sebastianSDA.virtualSigned && SDAInfo.sebastianSDA.sdaSebastian)?_c('div',[_c('span',[_vm._v(_vm._s(SDAInfo.sebastianSDA && SDAInfo.sebastianSDA.virtualSignApproved ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))])]):_vm._e()])])}))])])]):_vm._e(),(_vm.SDAsInfo.length == 0 && !_vm.getSDAsInfoActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.reports.sda.no_results")))]):_vm._e(),(_vm.getSDAsInfoActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q+H2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_date_date__ = __webpack_require__("D507");












/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reports-education',
	data: function data() {
		return {
			contracts: [],
			filters: {
				since: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.reports.master_data.filters.since'),
					error: false,
					active: false,
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				until: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.reports.master_data.filters.until'),
					error: false,
					active: false,
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				limit: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
					value: 10,
					name: this.$t('private.reports.master_data.filters.limit'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
						value: 10
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.25'),
						value: 25
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.50'),
						value: 50
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.100'),
						value: 100
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				skip: {
					value: 0
				}
			},
			groupings: {
				id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
				display: true,
				fakeValue: 'Ninguno',
				value: 0,
				name: this.$t('private.reports.master_data.groupings.name'),
				error: false,
				active: false,
				options: [{
					fakeValue: 'Ningúno',
					value: 0
				}, {
					fakeValue: this.$t('private.reports.master_data.groupings.codeClient'),
					value: 1
				}, {
					fakeValue: this.$t('private.reports.master_data.groupings.legal_name'),
					value: 2
				}, {
					fakeValue: this.$t('private.reports.master_data.groupings.seller'),
					value: 3
				}]
			},
			getContractsActive: false,
			activateFilters: false,
			haveData: false,
			nextPage: false,
			exportDataActive: false,
			groupingsActive: false,
			contractsGroupsByCodeClient: [],
			contractsGroupsByLegalName: [],
			contractsGroupsBySeller: []
		};
	},

	methods: {
		getContracts: function getContracts() {

			var vm = this;

			vm.getContractsActive = true;
			vm.contracts = [];

			var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
			var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

			var dataToSend = '/?state=' + 0 + '&descending=' + 'appCreationDate' + '&since=' + since + '&until=' + until + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

			__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].contracts.getContracts(dataToSend).then(function (response) {

				vm.getContractsActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message);

					return;
				}

				vm.contracts = response.data.contracts;

				if (vm.contracts.length > 0 && !vm.haveData) {

					vm.haveData = true;
				}

				if (vm.contracts.length > vm.filters.limit.value) {

					vm.nextPage = true;

					vm.contracts.pop();
				} else {

					vm.nextPage = false;
				}

				vm.activateGroupings();
			});
		},
		goToBackPage: function goToBackPage() {

			var vm = this;

			if (vm.filters.skip.value != 0) {

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

				vm.getContracts();
			}
		},
		goToNextPage: function goToNextPage() {

			var vm = this;

			if (vm.nextPage) {

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

				vm.getContracts();
			}
		},
		exportData: function exportData() {

			var vm = this;

			var dataToSend = {
				headers: [vm.$t("private.reports.education.table.state"), vm.$t("private.reports.education.table.client"), vm.$t("private.reports.education.table.legal_name"), vm.$t("private.reports.education.table.email"), vm.$t("private.reports.education.table.seller"), vm.$t("private.reports.education.table.delegation"), vm.$t("private.reports.education.table.associated_1"), vm.$t("private.reports.education.table.associated_2"), vm.$t("private.reports.education.table.associated_3"), vm.$t("private.reports.education.table.associated_4"), vm.$t("private.reports.education.table.associated_5"), vm.$t("private.reports.education.table.wella_quantity"), vm.$t("private.reports.education.table.wella_package"), vm.$t("private.reports.education.table.sp_quantity"), vm.$t("private.reports.education.table.sp_package"), vm.$t("private.reports.education.table.nioxin_quantity"), vm.$t("private.reports.education.table.nioxin_package"), vm.$t("private.reports.education.table.sebastian_quantity"), vm.$t("private.reports.education.table.sebastian_package"), vm.$t("private.reports.education.table.sassoon_quantity"), vm.$t("private.reports.education.table.sassoon_package"), vm.$t("private.reports.education.table.salons"), vm.$t("private.reports.education.table.mkt_news")],
				timeZone: __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()
			};
			vm.exportDataActive = true;
			__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].reports.exportEducation(dataToSend).then(function (response) {

				vm.getContractsActive = false;

				vm.exportDataActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
				var fileURL = URL.createObjectURL(file);

				__WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'education.xlsx');

				vm.getContracts();
			});
		},
		activateGroupings: function activateGroupings() {

			var vm = this;

			vm.groupingsActive = vm.groupings.value == 0 ? false : true;

			if (vm.groupings.value == 0) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['appCreationDate'], ['desc']);
			}

			if (vm.groupings.value == 1) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['client.clientCode', 'appCreationDate'], ['asc', 'desc']);
				vm.contractsGroupsByCodeClient = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(vm.contracts, 'client.clientCode');
			}

			if (vm.groupings.value == 2) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['client.legalName', 'appCreationDate'], ['asc', 'desc']);
				vm.contractsGroupsByLegalName = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(vm.contracts, 'client.legalName');
			}

			if (vm.groupings.value == 3) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['seller.username', 'appCreationDate'], ['asc', 'desc']);
				vm.contractsGroupsBySeller = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(vm.contracts, 'seller.username');
			}
		}
	},
	components: {
		MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__["a" /* default */],
		TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */],
		SelectField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__["a" /* default */],
		CheckboxField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__["a" /* default */],
		DateField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_date_date__["a" /* default */]
	},
	created: function created() {

		var vm = this;

		vm.getContracts();
	}
});

/***/ }),

/***/ "Q7O4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_date_date__ = __webpack_require__("D507");












/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reports-cci',
	data: function data() {
		return {
			clients: [],
			filters: {
				since: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.reports.master_data.filters.since'),
					error: false,
					active: false,
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				until: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.reports.master_data.filters.until'),
					error: false,
					active: false,
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				limit: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
					value: 10,
					name: this.$t('private.reports.master_data.filters.limit'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
						value: 10
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.25'),
						value: 25
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.50'),
						value: 50
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.100'),
						value: 100
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				skip: {
					value: 0
				}
			},
			getClientsActive: false,
			activateFilters: false,
			haveData: false,
			nextPage: false,
			exportDataActive: false
		};
	},

	methods: {
		getClients: function getClients() {

			var vm = this;

			vm.getClientsActive = true;
			vm.clients = [];

			var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
			var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

			var dataToSend = '/?descending=' + 'createdAt' + '&since=' + since + '&until=' + until + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

			__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {

				vm.getClientsActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message);

					return;
				}

				vm.clients = response.data.clients;

				if (vm.clients.length > 0 && !vm.haveData) {

					vm.haveData = true;
				}

				if (vm.clients.length > vm.filters.limit.value) {

					vm.nextPage = true;

					vm.clients.pop();
				} else {

					vm.nextPage = false;
				}
			});
		},
		goToBackPage: function goToBackPage() {

			var vm = this;

			if (vm.filters.skip.value != 0) {

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

				vm.getClients();
			}
		},
		goToNextPage: function goToNextPage() {

			var vm = this;

			if (vm.nextPage) {

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

				vm.getClients();
			}
		},
		exportData: function exportData() {

			var vm = this;

			var dataToSend = {
				headers: [vm.$t("private.reports.cci.table.client_code"), vm.$t("private.reports.cci.table.legal_name"), vm.$t("private.reports.cci.table.image_conditions")],
				timeZone: __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()
			};

			vm.exportDataActive = true;
			__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].reports.exportCCI(dataToSend).then(function (response) {

				vm.getClientsActive = false;
				vm.exportDataActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
				var fileURL = URL.createObjectURL(file);

				__WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'cci.xlsx');

				vm.getClients();
			});
		}
	},
	components: {
		MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__["a" /* default */],
		TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */],
		SelectField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__["a" /* default */],
		CheckboxField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__["a" /* default */],
		DateField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_date_date__["a" /* default */]
	},
	created: function created() {

		var vm = this;

		vm.getClients();
	}
});

/***/ }),

/***/ "QhW4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_urijs__ = __webpack_require__("hBlz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_urijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_urijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_date_date__ = __webpack_require__("D507");















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reports-sda',
  data: function data() {
    return {
      SDAsInfo: [],
      filters: {
        since: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        exported: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.sda.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.exported_options.all'), value: 'all'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.only_exported'), value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.not_exported'), value: 'not_exported'
          }],
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.limit_options.10'),
          value: 10,
          name: this.$t('private.reports.sda.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.limit_options.10'), value: 10
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.25'), value: 25
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.50'), value: 50
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.100'), value: 100
          }],
          style: {
            width: '230px', display: 'inline-block', margin: '0px 10px'
          }
        },
        skip: {
          value: 0
        }
      },
      selectedSDAsInfo: [],
      allChecks: [],
      getSDAsInfoActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      activateAllCheckbox: {
        id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
        display: true,
        error: false,
        value: {
          active: false
        },
        options: {
          active: {
            value: true
          }
        },
        filters: {
          type: 'manyOptions'
        }
      },
      exportDataActive: false
    };
  },

  methods: {
    getSDAsInfo: function getSDAsInfo() {
      var vm = this;

      vm.getSDAsInfoActive = true;
      vm.SDAsInfo = [];

      var exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported';

      var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
      var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

      var dataToSend = '/?state=' + 0 + '&descending=' + 'lastDateSDA' + '&since=' + since + '&until=' + until + '&exported=' + exported + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value + '&virtualSignApproved=false';

      __WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].SDAsInfo.getSDAsInfo(dataToSend).then(function (response) {
        vm.getSDAsInfoActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')], type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')], type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.SDAsInfo = response.data.SDAsInfo;

        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(vm.SDAsInfo, function (element) {
          if (element.normalSDA && element.normalSDA.pdf) {
            var uri_org = new __WEBPACK_IMPORTED_MODULE_3_urijs___default.a(element.normalSDA.pdf.url);
            var pathname = uri_org.pathname();

            element.normalSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_4__config_env___default.a.api.baseUrl + pathname;
          }

          if (element.wedoSDA && element.wedoSDA.pdf) {
            var _uri_org = new __WEBPACK_IMPORTED_MODULE_3_urijs___default.a(element.wedoSDA.pdf.url);
            var _pathname = _uri_org.pathname();

            element.wedoSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_4__config_env___default.a.api.baseUrl + _pathname;
          }

          if (element.systemECSDA && element.systemECSDA.pdf) {
            var _uri_org2 = new __WEBPACK_IMPORTED_MODULE_3_urijs___default.a(element.systemECSDA.pdf.url);
            var _pathname2 = _uri_org2.pathname();

            element.systemECSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_4__config_env___default.a.api.baseUrl + _pathname2;
          }

          if (element.sebastianSDA && element.sebastianSDA.pdf) {
            var _uri_org3 = new __WEBPACK_IMPORTED_MODULE_3_urijs___default.a(element.sebastianSDA.pdf.url);
            var _pathname3 = _uri_org3.pathname();

            element.sebastianSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_4__config_env___default.a.api.baseUrl + _pathname3;
          }
        });

        if (vm.SDAsInfo.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.SDAsInfo.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.SDAsInfo.pop();
        } else {
          vm.nextPage = false;
        }

        vm.allChecks = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(vm.SDAsInfo, function (SDA) {
          var field = {
            id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
            display: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          };

          field.value[SDA.objectId] = false;

          field.options[SDA.objectId] = {};

          return field;
        });
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getSDAsInfo();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getSDAsInfo();
      }
    },
    activateAllCheckboxToggle: function activateAllCheckboxToggle() {
      var vm = this;

      vm.selectedSDAsInfo = [];

      if (vm.activateAllCheckbox.value.active) {
        for (var i = 0; i < vm.allChecks.length; i++) {
          for (var j in vm.allChecks[i].value) {
            vm.allChecks[i].value[j] = true;
          }
        }
      } else {
        for (var _i = 0; _i < vm.allChecks.length; _i++) {
          for (var _j in vm.allChecks[_i].value) {
            vm.allChecks[_i].value[_j] = false;
          }
        }
      }
    },
    exportData: function exportData() {
      var vm = this;

      var SDAsInfoIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(vm.selectedSDAsInfo, function (element) {
        if (!element) {
          return false;
        }

        var key = '';

        for (var i in element) {
          key = i;
        }

        return element[key];
      });

      SDAsInfoIds = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(SDAsInfoIds, function (element) {
        var key = '';

        for (var i in element) {
          key = i;
        }

        return key;
      });

      if (SDAsInfoIds.length == 0) {
        var message = {
          message: [vm.$t('private.reports.sda.export.no_data')], type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var dataToSend = {
        headers: [vm.$t('private.reports.sda.table.exported'), vm.$t('private.reports.sda.table.client'), vm.$t('private.reports.sda.table.legal_name'), vm.$t('private.reports.sda.table.seller'), vm.$t('private.reports.sda.table.delegation'), // vm.$t("private.reports.sda.table.sda_sp"),
        // vm.$t("private.reports.sda.table.sda_sp_internet"),
        // vm.$t("private.reports.sda.table.sda_sp_men"),
        // vm.$t('private.reports.sda.table.sda_system_ec'),
        vm.$t('private.reports.sda.table.sda_sebastian'),
        // vm.$t("private.reports.sda.table.sda_sebastian_internet"),
        // vm.$t("private.reports.sda.table.sda_ghd"),
        // vm.$t("private.reports.sda.table.sda_wedo"),
        // vm.$t("private.reports.sda.table.sp_date"),
        // vm.$t("private.reports.sda.table.sp_internet_date"),
        // vm.$t("private.reports.sda.table.sp_men_date"),
        // vm.$t('private.reports.sda.table.sp_system_ec_date'),
        vm.$t('private.reports.sda.table.sebastian_date'),
        // vm.$t("private.reports.sda.table.sebastian_internet_date"),
        // vm.$t("private.reports.sda.table.sda_ghd_date"),
        // vm.$t("private.reports.sda.table.sda_wedo_date"),
        vm.$t('private.reports.sda.table.sda_date')],
        SDAsInfoIds: SDAsInfoIds,
        timeZone: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()
      };

      vm.exportDataActive = true;

      __WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].reports.exportSDA(dataToSend).then(function (response) {
        vm.getSDAsInfoActive = false;

        vm.exportDataActive = false;

        if (response.status != 200) {
          var _message2 = {
            message: [vm.$t('errors.custom.001')], type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        var fileURL = URL.createObjectURL(file);

        __WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'sda.xlsx');

        vm.getSDAsInfo();
      });
    },
    parseDate: function parseDate(date) {
      var _date = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.has(date, 'iso') ? date.iso : date;

      return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(_date).format('DD-MM-YYYY');
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_7__components_general_menu_more_options_menu_more_options__["a" /* default */], TextField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_text_text__["a" /* default */], SelectField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_select_select__["a" /* default */], CheckboxField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_checkbox_checkbox__["a" /* default */], DateField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_date_date__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getSDAsInfo();
  }
});

/***/ }),

/***/ "Rr4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'messenger',
	data: function data() {
		return {
			messages: []
		};
	},

	methods: {
		showMessage: function showMessage(data) {

			var vm = this;

			var message = {
				id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('message_'),
				content: data.message,
				type: data.type
			};

			setTimeout(function () {

				vm.deleteMessage(message.id);
			}, 20000);

			vm.messages.push(message);
		},
		deleteMessage: function deleteMessage(id) {

			var vm = this;

			for (var i = 0; i < vm.messages.length; i++) {

				if (vm.messages[i].id == id) {

					vm.messages.splice(i, 1);

					break;
				}
			}
		}
	},
	created: function created() {

		var vm = this;

		vm.$root.$on('showMessage', function (data) {

			vm.showMessage(data);
		});
	}
});

/***/ }),

/***/ "SngM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('select-field',{ref:"selectYears",attrs:{"data":_vm.selectYears},on:{"changeData":function($event){_vm.selectYears.value = $event;  _vm.getContracts();}}}),(_vm.haveData)?_c('div',{staticClass:"export-contract",on:{"click":function($event){_vm.exportContracts()}}},[(!_vm.exportContractsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.export_contracts")))]):_vm._e(),(_vm.exportContractsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportContractsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.please_wait")))]):_vm._e()]):_vm._e(),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.history.contracts.see_filters")))]):_vm._e()],1),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('select-field',{attrs:{"data":_vm.filters.ascending},on:{"changeData":function($event){_vm.filters.ascending.value = $event; _vm.filters.skip.value = 0; _vm.getContracts()}}}),_c('select-field',{attrs:{"data":_vm.filters.descending},on:{"changeData":function($event){_vm.filters.descending.value = $event; _vm.filters.skip.value = 0; _vm.getContracts()}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getContracts();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.contracts.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e(),_c('span',{staticStyle:{"margin-left":"30px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.totalContracts))])])]):_vm._e(),(_vm.contracts.length > 0)?_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.contracts),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])]),_c('menu-more-options',{attrs:{"element":contract,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)})):_vm._e(),_c('select-field',{attrs:{"data":_vm.filters.hidden},on:{"changeData":function($event){_vm.filters.hidden.value = $event; _vm.filters.skip.value = 0; _vm.getContracts()}}}),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"5"}}),_c('th',{attrs:{"colspan":"7"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.seller")))])]),_c('th',{attrs:{"colspan":"10"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.client")))])]),_c('th',{attrs:{"colspan":"5"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_1")))])]),_c('th',{attrs:{"colspan":"5"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_2")))])]),_c('th',{attrs:{"colspan":"5"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_3")))])]),_c('th',{attrs:{"colspan":"13"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella")))])]),_c('th',{attrs:{"colspan":"2"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.opi")))])]),_c('th',{attrs:{"colspan":"3"}}),_c('th',{attrs:{"colspan":"2"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.digital_signature")))])])]),_c('tr',{attrs:{"id":"contrats_tr"}},[_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.state")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'state')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.exported")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'exported')}}})],1),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.pdf")))]),_c('th',{staticClass:"header-column-observations"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.observations")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'observations')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.timestamp")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'appCreationDate')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.username")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerUsername')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.firstname")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerFirstname')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.lastname")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerLastname')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.email")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerEmail')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.active")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerActive')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.type")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerTypeName')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.sellers.list.table.delegation")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sellerDelegationName')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.client_code")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientCode')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.legal_name")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientLegalName')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.email")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientEmail')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.employees_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientEmployeesQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.lounges_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientLoungesQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.discharge_date")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientDischargeDate')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.status")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientStatus')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.recruiting_lr")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientRecruitingLR')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.mkt_news")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientMktNews')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.table.image_conditions")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'clientImageConditions')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_code")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedAccount1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_cif")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedCif1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_email")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedEmail1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_legal_name")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedLegalName1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_employees")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedEmployeesNumber1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_code")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedAccount2')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_cif")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedCif2')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_email")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedEmail2')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_legal_name")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedLegalName2')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_employees")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedEmployeesNumber2')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_code")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedAccount3')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_cif")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedCif3')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_email")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedEmail3')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_legal_name")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedLegalName3')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.associated_employees")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedEmployeesNumber3')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_support")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaSupport')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_discount")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaDiscount')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_brand_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaBrandRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_growth_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaGrowthRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_volume_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaVolumeRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_total_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaTotalRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.wella_potential")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaPotential')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.rappel_antecipado")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'rappelAntecipado')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.rappel_mktg")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'rappelMKTG')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.rappel_mktg_manual")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'rappelMKTGManual')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.seb_man_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sebManRappe1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.seb_man_discount")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'sebManDiscount')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.opi_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'opiQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.opi_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'opiRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.mkt_news")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'mktNews')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.mail_conditions")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'mailConditions')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.history.contracts.table.image_conditions")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'imageConditions')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.virtual_signed")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'virtualSigned')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.virtual_signApproved")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'virtualSignApproved')}}})],1)])]),_c('tbody',[(_vm.activateFilters)?_c('tr',[_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.state},on:{"changeData":function($event){_vm.filters.state.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.exported},on:{"changeData":function($event){_vm.filters.exported.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{attrs:{"colspan":"2"}}),_c('td',{staticClass:"filter-cell"},[_c('date-field',{attrs:{"data":_vm.filters.since},on:{"changeData":function($event){_vm.filters.since.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}}),_c('date-field',{attrs:{"data":_vm.filters.until},on:{"changeData":function($event){_vm.filters.until.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.seller},on:{"changeData":function($event){_vm.filters.seller.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{attrs:{"colspan":"5"}}),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.delegation},on:{"changeData":function($event){_vm.filters.delegation.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.clientCode},on:{"changeData":function($event){_vm.filters.clientCode.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.legalName},on:{"changeData":function($event){_vm.filters.legalName.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit()}}})],1),_c('td',{attrs:{"colspan":"50"}})]):_vm._e(),_vm._l((_vm.contracts),function(contract,index){return (_vm.haveData)?_c('tr',{class:{ selected : contract.rowSelected },on:{"click":function($event){_vm.rowClicked(contract, contract.rowSelected ? false : true)}}},[_c('td',{class:{'green' : contract.contractState == 0, 'red' : contract.contractState == 1, 'yellow' : contract.contractState == 2, 'black' : contract.contractState == 3, 'purple' : contract.contractState == 4  }},[_vm._v(_vm._s(contract.contractState == 0 ? _vm.$t("private.history.contracts.table.state_options.ok") : contract.contractState == 1 ? _vm.$t("private.history.contracts.table.state_options.no_ok") : contract.contractState == 2 ? _vm.$t("private.history.contracts.table.state_options.pendiente_ok") : contract.contractState == 3 ? _vm.$t("private.history.contracts.table.state_options.archive") : contract.contractState == 4 ? _vm.$t("private.history.contracts.table.state_options.retenido_asociado") : ''))]),_c('td',[_vm._v(_vm._s(contract.exported ? _vm.$t("private.history.contracts.table.exported_options.yes") : _vm.$t("private.history.contracts.table.exported_options.no")))]),_c('td',{staticClass:"text-center"},[(contract.pdf)?_c('a',{attrs:{"href":contract.pdf ? contract.pdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',[_vm._v(_vm._s(contract.observations))]),_c('td',[_vm._v(_vm._s(contract.appCreationDate ? _vm.parseDate( contract.appCreationDate ) : ''))]),_c('td',[_vm._v(_vm._s(contract.sellerUsername ? contract.sellerUsername : ''))]),_c('td',[_vm._v(_vm._s(contract.sellerFirstname ? contract.sellerFirstname : ''))]),_c('td',[_vm._v(_vm._s(contract.sellerLastname ? contract.sellerLastname : ''))]),_c('td',[_vm._v(_vm._s(contract.sellerEmail ? contract.sellerEmail : ''))]),_c('td',[_vm._v(_vm._s(contract.sellerActive ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.sellerTypeName ? contract.sellerTypeName : ''))]),_c('td',[_vm._v(_vm._s(contract.sellerDelegationName ? contract.sellerDelegationName : ''))]),_c('td',[_vm._v(_vm._s(contract.clientCode ? contract.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.clientLegalName ? contract.clientLegalName : ''))]),_c('td',[_vm._v(_vm._s(contract.clientEmail ? contract.clientEmail : ''))]),_c('td',[_vm._v(_vm._s(contract.clientEmployeesQuantity ? contract.clientEmployeesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.clientLoungesQuantity ? contract.clientLoungesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.clientDischargeDate ? _vm.parseDate( contract.clientDischargeDate.iso ) : ''))]),_c('td',[_vm._v(_vm._s(contract.clientStatus ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.clientRecruitingLR ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.clientMktNews ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.clientImageConditions ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount1 ? contract.associatedAccount1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedCif1 ? contract.associatedCif1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedEmail1 ? contract.associatedEmail1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedLegalName1 ? contract.associatedLegalName1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedEmployeesNumber1 ? contract.associatedEmployeesNumber1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount2 ? contract.associatedAccount2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedCif2 ? contract.associatedCif2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedEmail2 ? contract.associatedEmail2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedLegalName2 ? contract.associatedLegalName2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedEmployeesNumber2 ? contract.associatedEmployeesNumber2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount3 ? contract.associatedAccount3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedCif3 ? contract.associatedCif3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedEmail3 ? contract.associatedEmail3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedLegalName3 ? contract.associatedLegalName3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedEmployeesNumber3 ? contract.associatedEmployeesNumber3 : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaSupport))]),_c('td',[_vm._v(_vm._s(contract.wellaDiscount))]),_c('td',[_vm._v(_vm._s(contract.wellaBrandRappel))]),_c('td',[_vm._v(_vm._s(contract.wellaGrowthRappel))]),_c('td',[_vm._v(_vm._s(contract.wellaVolumeRappel))]),_c('td',[_vm._v(_vm._s(contract.wellaTotalRappel))]),_c('td',[_vm._v(_vm._s(contract.wellaPotential))]),_c('td',[_vm._v(_vm._s(contract.rappelAntecipado))]),_c('td',[_vm._v(_vm._s(contract.rappelMKTG))]),_c('td',[_vm._v(_vm._s(contract.rappelMKTGManual ? contract.rappelMKTGManual : ''))]),_c('td',[_vm._v(_vm._s(contract.sebManRappel))]),_c('td',[_vm._v(_vm._s(contract.sebManDiscount))]),_c('td',[_vm._v(_vm._s(contract.opiQuantity  ? contract.opiQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.opiRappel ? contract.opiRappel : ''))]),_c('td',[_vm._v(_vm._s(contract.mktNews ? _vm.$t("private.history.contracts.table.mkt_news_options.yes") : _vm.$t("private.history.contracts.table.mkt_news_options.no")))]),_c('td',[_vm._v(_vm._s(contract.mailConditions ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.imageConditions ? _vm.$t("utils.conditional.yes") : _vm.$t("utils.conditional.not")))]),_c('td',[_vm._v(_vm._s(contract.virtualSigned ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.virtualSigned && contract.virtualSignApproved ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))])]):_vm._e()})],2)])]),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.contracts.length === 0 && !_vm.getContractsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.history.contracts.no_results")))]):_vm._e(),(_vm.getContractsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TMrr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("WeJu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e3003a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("57QQ");
function injectStyle (ssrContext) {
  __webpack_require__("cdnz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79e3003a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e3003a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U0kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("538u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615c7cf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("J8Yx");
function injectStyle (ssrContext) {
  __webpack_require__("HrW+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-615c7cf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_615c7cf6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ULeU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UZfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'checkbox-field',
	props: ['data'],
	data: function data() {
		return {
			fields: {},
			foo: ''
		};
	},

	methods: {
		changeData: function changeData() {

			var vm = this;

			vm.$emit('changeData', vm.fields);
		}
	},
	watch: {
		data: {
			handler: function handler(newData, oldData) {

				var vm = this;

				for (var i in newData.value) {

					vm.fields[i] = newData.value[i];
				}

				if (vm.foo != '') {

					vm.foo = '';
				} else {

					vm.foo = '.';
				}

				vm.$emit('changeData', vm.fields);
			},

			deep: true
		}
	},
	created: function created() {

		var vm = this;

		for (var i in vm.data.value) {

			vm.fields[i] = vm.data.value[i];
		}
	}
});

/***/ }),

/***/ "Ujr2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("tvGf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc1ab25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("eQpL");
function injectStyle (ssrContext) {
  __webpack_require__("lvdl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2cc1ab25"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cc1ab25_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V2bL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api__ = __webpack_require__("P9l9");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'private-header',
	data: function data() {
		return {};
	},

	methods: {
		asideToggle: function asideToggle() {

			this.$root.$emit('asideToggle');
		}
	}
});

/***/ }),

/***/ "VE4s":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wella-logo.135db64.png";

/***/ }),

/***/ "VPVU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("OQyK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed63cb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("3YZe");
function injectStyle (ssrContext) {
  __webpack_require__("Jm3/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed63cb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VSAm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[(_vm.haveData)?_c('div',{staticClass:"export-clients",on:{"click":function($event){_vm.exportClientsRecords()}}},[(!_vm.exportClientsRecordsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients_records.list.export_clients_records")))]):_vm._e(),(_vm.exportClientsRecordsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportClientsRecordsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients_records.list.please_wait")))]):_vm._e()]):_vm._e(),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"row filters-container"},[_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.getClientsRecords(); _vm.filters.skip.value = 0;}}}),_c('select-field',{attrs:{"data":_vm.filters.state},on:{"changeData":function($event){_vm.filters.state.value = $event; _vm.getClientsRecords(); _vm.filters.skip.value = 0;}}}),_c('select-field',{attrs:{"data":_vm.filters.updated},on:{"changeData":function($event){_vm.filters.updated.value = $event; _vm.getClientsRecords(); _vm.filters.skip.value = 0;}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.clientsRecords.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.clientsRecords.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.clientsRecords),function(clientRecord,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item email"},[_vm._v(_vm._s(clientRecord.email))]),_c('li',{staticClass:"item client-code"},[_vm._v(_vm._s(clientRecord.clientCode))])]),_c('menu-more-options',{attrs:{"element":clientRecord,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)})),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th'),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.client_code")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.state")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.sales_area")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.activity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.update_client")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.cfia")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.associate_account_1")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.associate_account_2")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.associate_account_3")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.closing_days")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.email")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.mkt_news_2")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.dados_pessoais")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.delivery_time")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.resale_shop")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.online_shop")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.particular_address")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.particular_address_cp")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.particular_address_location")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_1")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_1_cp")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_1_localidade")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_2")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_2_cp")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_2_localidade")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.address_observations")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.nif")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.nioxin_support")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.mkt_news")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.employees_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.lounges_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.sebastian_support")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.headquarters")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.headquarters_cp")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.headquarters_location")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.sp_support")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.phone")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.cellphone")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.client_type")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.wella_support")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.owner_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.industry_code")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.customer_class")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.email_invoices_1")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.email_invoices_2")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.table.my_creation_date")))])])]),_c('tbody',_vm._l((_vm.clientsRecords),function(clientRecord,index){return _c('tr',{class:{ selected : clientRecord.rowSelected },on:{"click":function($event){_vm.rowClicked(clientRecord, clientRecord.rowSelected ? false : true)}}},[_c('td',{staticClass:"options"},[_c('menu-more-options',{attrs:{"element":clientRecord,"side":'right',"options":_vm.menuOptions,"topClass":index > _vm.filters.limit.value - 5 ? true : false},on:{"optionSelected":_vm.optionSelected}})],1),_c('td',[_vm._v(_vm._s(clientRecord.clientCode))]),_c('td',{class:{'green' : clientRecord.state == 1, 'red' : clientRecord.state == 2, 'yellow' : clientRecord.state == 3 }},[_vm._v(_vm._s(clientRecord.state == 1 ? _vm.$t("private.clients_records.list.table.state_options.ok") : clientRecord.state == 2 ? _vm.$t("private.clients_records.list.table.state_options.no_ok") : (clientRecord.state == 3 || clientRecord.state == undefined) ? _vm.$t("private.clients_records.list.table.state_options.pendiente_ok") : ''))]),_c('td',[_vm._v(_vm._s(clientRecord.salesArea))]),_c('td',[_vm._v(_vm._s(clientRecord.activity))]),_c('td',[_vm._v(_vm._s(clientRecord.updateClient ? _vm.$t("private.clients_records.list.table.update_client_options.yes") : _vm.$t("private.clients_records.list.table.update_client_options.no")))]),_c('td',[_vm._v(_vm._s(clientRecord.cfia))]),_c('td',[_vm._v(_vm._s(clientRecord.associatedAccount1))]),_c('td',[_vm._v(_vm._s(clientRecord.associatedAccount2))]),_c('td',[_vm._v(_vm._s(clientRecord.associatedAccount3))]),_c('td',[_vm._v(_vm._s(clientRecord.date ? _vm.parseDate( clientRecord.date.iso ) : ''))]),_c('td',[_vm._v(_vm._s(clientRecord.closingDays))]),_c('td',[_vm._v(_vm._s(clientRecord.email))]),_c('td',[_vm._v(_vm._s(clientRecord.mktNews2 ? _vm.$t("private.clients_records.list.table.email_invoices_options.yes") : _vm.$t("private.clients_records.list.table.email_invoices_options.no")))]),_c('td',[_vm._v(_vm._s(clientRecord.dadosPessoais ? _vm.$t("private.clients_records.list.table.email_invoices_options.yes") : _vm.$t("private.clients_records.list.table.email_invoices_options.no")))]),_c('td',[_vm._v(_vm._s(clientRecord.deliveryTime))]),_c('td',[_vm._v(_vm._s(clientRecord.resaleShop ? _vm.$t("private.clients_records.list.table.resale_shop_options.yes") : _vm.$t("private.clients_records.list.table.resale_shop_options.no")))]),_c('td',[_vm._v(_vm._s(clientRecord.onlineShop ? _vm.$t("private.clients_records.list.table.online_shop_options.yes") : _vm.$t("private.clients_records.list.table.online_shop_options.no")))]),_c('td',[_vm._v(_vm._s(clientRecord.particularAddress))]),_c('td',[_vm._v(_vm._s(clientRecord.particularAddressCP))]),_c('td',[_vm._v(_vm._s(clientRecord.particularAddressLocation))]),_c('td',[_vm._v(_vm._s(clientRecord.address1))]),_c('td',[_vm._v(_vm._s(clientRecord.address1CP))]),_c('td',[_vm._v(_vm._s(clientRecord.address1Location))]),_c('td',[_vm._v(_vm._s(clientRecord.address2))]),_c('td',[_vm._v(_vm._s(clientRecord.address2CP))]),_c('td',[_vm._v(_vm._s(clientRecord.address2Location))]),_c('td',[_vm._v(_vm._s(clientRecord.addressObservations))]),_c('td',[_vm._v(_vm._s(clientRecord.nif))]),_c('td',[_vm._v(_vm._s(clientRecord.nioxinSupport))]),_c('td',[_vm._v(_vm._s(clientRecord.mktNews ? _vm.$t("private.clients_records.list.table.mkt_news_yes") : _vm.$t("private.clients_records.list.table.mkt_news_no")))]),_c('td',[_vm._v(_vm._s(clientRecord.employeesQuantity))]),_c('td',[_vm._v(_vm._s(clientRecord.loungesQuantity))]),_c('td',[_vm._v(_vm._s(clientRecord.legalName))]),_c('td',[_vm._v(_vm._s(clientRecord.sebastianSupport))]),_c('td',[_vm._v(_vm._s(clientRecord.headquarters))]),_c('td',[_vm._v(_vm._s(clientRecord.headquartersCP))]),_c('td',[_vm._v(_vm._s(clientRecord.headquartersLocation))]),_c('td',[_vm._v(_vm._s(clientRecord.spSupport))]),_c('td',[_vm._v(_vm._s(clientRecord.phone))]),_c('td',[_vm._v(_vm._s(clientRecord.cellphone))]),_c('td',[_vm._v(_vm._s(clientRecord.clientType))]),_c('td',[_vm._v(_vm._s(clientRecord.wellaSupport))]),_c('td',[_vm._v(_vm._s(clientRecord.ownerName))]),_c('td',[_vm._v(_vm._s(clientRecord.industryCode ? clientRecord.industryCode : ''))]),_c('td',[_vm._v(_vm._s(clientRecord.customerClass ? clientRecord.customerClass : ''))]),_c('td',[_vm._v(_vm._s(clientRecord.emailInvoices1 ? clientRecord.emailInvoices1 : ''))]),_c('td',[_vm._v(_vm._s(clientRecord.emailInvoices2 ? clientRecord.emailInvoices2 : ''))]),_c('td',{staticClass:"text-center"},[(clientRecord.pdf)?_c('a',{attrs:{"href":clientRecord.pdf ? clientRecord.pdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',[_vm._v(_vm._s(clientRecord.createdAt ? _vm.parseDate( clientRecord.createdAt.iso ) : ''))])])}))])])]):_vm._e(),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.clientsRecords.length == 0 && !_vm.getClientsRecordsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.no_results")))]):_vm._e(),(_vm.getClientsRecordsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])]),(_vm.approveClientsRecordsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in",staticStyle:{"height":"300px"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients_records.list.approve_client_record_window.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.approveClientsRecordsWindow.display = false; _vm.approveClientsRecordsWindow.formApprove.active = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formApproveSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.approveClientsRecordsWindow.formApprove.fields.clientCode},on:{"changeData":function($event){_vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formApproveSubmit}},[(!_vm.approveClientsRecordsWindow.formApprove.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients_records.list.approve_client_record_window.search_button")))]):_vm._e(),(_vm.approveClientsRecordsWindow.formApprove.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.approveClientsRecordsWindow.display = false}}})]):_vm._e(),(_vm.displayCreateClient)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in",staticStyle:{"height":"80%"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.clients_list_create"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayCreateClient = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.formCreate.fields.seller},on:{"getData":function($event){_vm.searchSellers($event)},"optionSelected":function($event){_vm.sellerSelected($event)}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.cfia},on:{"changeData":function($event){_vm.formCreate.fields.cfia.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.cif},on:{"changeData":function($event){_vm.formCreate.fields.cif.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.clientCode},on:{"changeData":function($event){_vm.formCreate.fields.clientCode.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.email},on:{"changeData":function($event){_vm.formCreate.fields.email.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.employeesQuantity},on:{"changeData":function($event){_vm.formCreate.fields.employeesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.loungesQuantity},on:{"changeData":function($event){_vm.formCreate.fields.loungesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.legalName},on:{"changeData":function($event){_vm.formCreate.fields.legalName.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.mktNews},on:{"changeData":function($event){_vm.formCreate.fields.mktNews.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.formCreate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.create_button")))]):_vm._e(),(_vm.formCreate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayCreateClient = false}}})]):_vm._e(),(_vm.displayUpdateClient)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.clients_update"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayUpdateClient = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formUpdateSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.formUpdate.fields.seller},on:{"getData":function($event){_vm.searchSellers($event)},"optionSelected":function($event){_vm.sellerSelected($event)}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.cfia},on:{"changeData":function($event){_vm.formUpdate.fields.cfia.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.cif},on:{"changeData":function($event){_vm.formUpdate.fields.cif.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.clientCode},on:{"changeData":function($event){_vm.formUpdate.fields.clientCode.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.email},on:{"changeData":function($event){_vm.formUpdate.fields.email.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.employeesQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.employeesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.loungesQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.loungesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.legalName},on:{"changeData":function($event){_vm.formUpdate.fields.legalName.value = $event}}}),_c('date-field',{attrs:{"data":_vm.formUpdate.fields.dischargeDate},on:{"changeData":function($event){_vm.formUpdate.fields.dischargeDate.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.status},on:{"changeData":function($event){_vm.formUpdate.fields.status.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.recruitingLR},on:{"changeData":function($event){_vm.formUpdate.fields.recruitingLR.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.mktNews},on:{"changeData":function($event){_vm.formUpdate.fields.mktNews.value = $event}}}),_c('checkbox-field',{attrs:{"data":_vm.formUpdate.fields.conditions},on:{"changeData":function($event){_vm.formUpdate.fields.conditions.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formUpdateSubmit}},[(!_vm.formUpdate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.update_button")))]):_vm._e(),(_vm.formUpdate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayUpdateClient = false}}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W4uV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_env__);





/* harmony default export */ __webpack_exports__["a"] = ({
  getContractsHistory: function getContractsHistory(query) {
    var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/v2/history/contracts';

    if (query) {
      var esc = encodeURIComponent;
      var _query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (k) {
        return esc(k) + '=' + esc(query[k]);
      }).join('&');

      url += '?' + _query;
    }

    return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
  },
  exportContracts: function exportContracts(data) {
    var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/v2/history/contracts/export';

    return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data, {
      responseType: 'arraybuffer'
    }).then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
  },
  getContractsSDAHistory: function getContractsSDAHistory(query) {
    var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/v2/history/sda';

    if (query) {
      var esc = encodeURIComponent;
      var _query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (k) {
        return esc(k) + '=' + esc(query[k]);
      }).join('&');

      url += '?' + _query;
    }

    return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
  }
});

/***/ }),

/***/ "WI2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"export-data",on:{"click":function($event){_vm.exportData()}}},[(!_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.education.export_data")))]):_vm._e(),(_vm.exportDataActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.education.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.reports.education.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.getContracts(); _vm.filters.skip.value = 0;}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.contracts.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.contracts.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.contracts),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])])])})),_c('div',{staticClass:"table-container hidden-xs"},[_c('hr'),_c('div',{staticClass:"row filters-container"},[_c('div',{staticClass:"col-md-3"},[_c('select-field',{attrs:{"data":_vm.groupings},on:{"changeData":function($event){_vm.groupings.value = $event; _vm.activateGroupings(); _vm.filters.skip.value = 0;}}})],1)]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.state")))]),(_vm.groupings.value!=1)?_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.client")))]):_vm._e(),(_vm.groupings.value!=2)?_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.legal_name")))]):_vm._e(),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.email")))]),(_vm.groupings.value!=3)?_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.seller")))]):_vm._e(),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.delegation")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.associated_1")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.associated_2")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.associated_3")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.associated_4")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.associated_5")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.wella_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.wella_package")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.sp_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.sp_package")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.nioxin_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.nioxin_package")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.sebastian_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.sebastian_package")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.sassoon_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.sassoon_package")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.salons")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.education.table.mkt_news")))])])]),(!_vm.groupingsActive)?_c('tbody',_vm._l((_vm.contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.state == 0 ? _vm.$t("private.contracts.list.table.state_options.ok") : contract.state == 1 ? _vm.$t("private.contracts.list.table.state_options.no_ok") : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.email : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.delegation ? contract.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount1 ? contract.associatedAccount1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount2 ? contract.associatedAccount2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount3 ? contract.associatedAccount3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount4 ? contract.associatedAccount4 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount5 ? contract.associatedAccount5 : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaPackage))]),_c('td',[_vm._v(_vm._s(contract.spQuantity))]),_c('td',[_vm._v(_vm._s(contract.spPackage))]),_c('td',[_vm._v(_vm._s(contract.nioxinQuantity))]),_c('td',[_vm._v(_vm._s(contract.nioxinPackage))]),_c('td',[_vm._v(_vm._s(contract.sebastianQuantity))]),_c('td',[_vm._v(_vm._s(contract.sebastianPackage))]),_c('td',[_vm._v(_vm._s(contract.sassoonQuantity))]),_c('td',[_vm._v(_vm._s(contract.sassoonPackage))]),_c('td',[_vm._v(_vm._s(contract.salons))]),_c('td',[_vm._v(_vm._s(contract.mktNews))])])})):_vm._e(),_vm._l((_vm.contractsGroupsByCodeClient),function(contracts,index){return (_vm.groupingsActive && _vm.groupings.value==1)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"23"}},[_c('strong',[_vm._v(_vm._s(contracts[0].client ? 'Código cliente: '+ contracts[0].client.clientCode : ''))])])]),_vm._l((contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.state == 0 ? _vm.$t("private.contracts.list.table.state_options.ok") : contract.state == 1 ? _vm.$t("private.contracts.list.table.state_options.no_ok") : ''))]),(false)?_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]):_vm._e(),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.email : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.delegation ? contract.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount1 ? contract.associatedAccount1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount2 ? contract.associatedAccount2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount3 ? contract.associatedAccount3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount4 ? contract.associatedAccount4 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount5 ? contract.associatedAccount5 : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaPackage))]),_c('td',[_vm._v(_vm._s(contract.spQuantity))]),_c('td',[_vm._v(_vm._s(contract.spPackage))]),_c('td',[_vm._v(_vm._s(contract.nioxinQuantity))]),_c('td',[_vm._v(_vm._s(contract.nioxinPackage))]),_c('td',[_vm._v(_vm._s(contract.sebastianQuantity))]),_c('td',[_vm._v(_vm._s(contract.sebastianPackage))]),_c('td',[_vm._v(_vm._s(contract.sassoonQuantity))]),_c('td',[_vm._v(_vm._s(contract.sassoonPackage))]),_c('td',[_vm._v(_vm._s(contract.salons))]),_c('td',[_vm._v(_vm._s(contract.mktNews))])])}),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s('Total Código cliente ' + contracts[0].client.clientCode + ': ' + contracts.length))])]),_c('td',{attrs:{"colspan":"20"}})])],2):_vm._e()}),_vm._l((_vm.contractsGroupsByCodeClient),function(contracts,index){return (_vm.groupingsActive && _vm.groupings.value==2)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"23"}},[_c('strong',[_vm._v(_vm._s(contracts[0].client ? 'Razón social: ' + contracts[0].client.legalName : ''))])])]),_vm._l((contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.state == 0 ? _vm.$t("private.contracts.list.table.state_options.ok") : contract.state == 1 ? _vm.$t("private.contracts.list.table.state_options.no_ok") : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),(false)?_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]):_vm._e(),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.email : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.delegation ? contract.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount1 ? contract.associatedAccount1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount2 ? contract.associatedAccount2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount3 ? contract.associatedAccount3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount4 ? contract.associatedAccount4 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount5 ? contract.associatedAccount5 : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaPackage))]),_c('td',[_vm._v(_vm._s(contract.spQuantity))]),_c('td',[_vm._v(_vm._s(contract.spPackage))]),_c('td',[_vm._v(_vm._s(contract.nioxinQuantity))]),_c('td',[_vm._v(_vm._s(contract.nioxinPackage))]),_c('td',[_vm._v(_vm._s(contract.sebastianQuantity))]),_c('td',[_vm._v(_vm._s(contract.sebastianPackage))]),_c('td',[_vm._v(_vm._s(contract.sassoonQuantity))]),_c('td',[_vm._v(_vm._s(contract.sassoonPackage))]),_c('td',[_vm._v(_vm._s(contract.salons))]),_c('td',[_vm._v(_vm._s(contract.mktNews))])])}),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s('Total razón social ' + contracts[0].client.legalName + ': ' + contracts.length))])]),_c('td',{attrs:{"colspan":"20"}})])],2):_vm._e()}),_vm._l((_vm.contractsGroupsByCodeClient),function(contracts,index){return (_vm.groupingsActive && _vm.groupings.value==3)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"23"}},[_c('strong',[_vm._v(_vm._s(contracts[0].client ? 'Vendedor: '+ contracts[0].seller.username : ''))])])]),_vm._l((contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.state == 0 ? _vm.$t("private.contracts.list.table.state_options.ok") : contract.state == 1 ? _vm.$t("private.contracts.list.table.state_options.no_ok") : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.email : ''))]),(false)?_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]):_vm._e(),_c('td',[_vm._v(_vm._s(contract.delegation ? contract.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount1 ? contract.associatedAccount1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount2 ? contract.associatedAccount2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount3 ? contract.associatedAccount3 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount4 ? contract.associatedAccount4 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount5 ? contract.associatedAccount5 : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaPackage))]),_c('td',[_vm._v(_vm._s(contract.spQuantity))]),_c('td',[_vm._v(_vm._s(contract.spPackage))]),_c('td',[_vm._v(_vm._s(contract.nioxinQuantity))]),_c('td',[_vm._v(_vm._s(contract.nioxinPackage))]),_c('td',[_vm._v(_vm._s(contract.sebastianQuantity))]),_c('td',[_vm._v(_vm._s(contract.sebastianPackage))]),_c('td',[_vm._v(_vm._s(contract.sassoonQuantity))]),_c('td',[_vm._v(_vm._s(contract.sassoonPackage))]),_c('td',[_vm._v(_vm._s(contract.salons))]),_c('td',[_vm._v(_vm._s(contract.mktNews))])])}),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s('Total vendedor ' + contracts[0].seller.username +': ' + contracts.length))])]),_c('td',{attrs:{"colspan":"20"}})])],2):_vm._e()})],2)])]):_vm._e(),(_vm.contracts.length == 0 && !_vm.getContractsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.reports.education.no_results")))]):_vm._e(),(_vm.getContractsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WeJu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_general_session_session__ = __webpack_require__("IqKp");





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'private-aside',
  data: function data() {
    return {
      smallDevice: false,
      active: false,
      routes: __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */],
      sessionUser: {}
    };
  },

  methods: {
    firstDisplay: function firstDisplay() {

      if (!this.smallDevice) {

        this.active = true;
      }
    },
    logout: function logout() {

      __WEBPACK_IMPORTED_MODULE_2__components_general_session_session__["a" /* default */].logout();
    }
  },
  created: function created() {

    var vm = this;

    window.innerWidth <= 767 ? vm.smallDevice = true : vm.smallDevice = false;

    vm.firstDisplay();

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).resize(function () {

      if (window.innerWidth <= 767) {

        vm.smallDevice = true;

        if (vm.active) {

          vm.active = false;
        }
      } else {

        vm.smallDevice = false;

        if (!vm.active) {

          vm.active = true;
        }
      }
    });

    vm.$root.$on('asideToggle', function () {

      if (vm.active) {

        vm.active = false;
      } else {

        vm.active = true;
      }
    });

    vm.sessionUser = JSON.parse(localStorage.getItem('sessionUser'));
  }
});

/***/ }),

/***/ "XUWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_date_date__ = __webpack_require__("D507");












/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reports-potential',
	data: function data() {
		return {
			contracts: [],
			filters: {
				since: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.reports.master_data.filters.since'),
					error: false,
					active: false,
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				until: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.reports.master_data.filters.until'),
					error: false,
					active: false,
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				limit: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
					value: 10,
					name: this.$t('private.reports.master_data.filters.limit'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.10'),
						value: 10
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.25'),
						value: 25
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.50'),
						value: 50
					}, {
						fakeValue: this.$t('private.reports.master_data.filters.limit_options.100'),
						value: 100
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				skip: {
					value: 0
				}
			},
			groupings: {
				id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
				display: true,
				fakeValue: 'Ningúno',
				value: 0,
				name: this.$t('private.reports.master_data.groupings.name'),
				error: false,
				active: false,
				options: [{
					fakeValue: 'Ninguno',
					value: 0
				}, {
					fakeValue: this.$t('private.reports.master_data.groupings.codeClient'),
					value: 1
				}, {
					fakeValue: this.$t('private.reports.master_data.groupings.legal_name'),
					value: 2
				}, {
					fakeValue: this.$t('private.reports.master_data.groupings.seller'),
					value: 3
				}]
			},
			getContractsActive: false,
			activateFilters: false,
			haveData: false,
			nextPage: false,
			exportDataActive: false,
			groupingsActive: false,
			contractsGroupsByCodeClient: [],
			contractsGroupsByLegalName: [],
			contractsGroupsBySeller: []
		};
	},

	methods: {
		getContracts: function getContracts() {

			var vm = this;

			vm.getContractsActive = true;
			vm.contracts = [];

			var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
			var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

			var dataToSend = '/?state=' + 0 + '&descending=' + 'appCreationDate' + '&exported=' + true + '&since=' + since + '&until=' + until + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value;

			__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].contracts.getContracts(dataToSend).then(function (response) {

				vm.getContractsActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message);

					return;
				}

				vm.contracts = response.data.contracts;

				if (vm.contracts.length > 0 && !vm.haveData) {

					vm.haveData = true;
				}

				if (vm.contracts.length > vm.filters.limit.value) {

					vm.nextPage = true;

					vm.contracts.pop();
				} else {

					vm.nextPage = false;
				}

				vm.activateGroupings();
			});
		},
		goToBackPage: function goToBackPage() {

			var vm = this;

			if (vm.filters.skip.value != 0) {

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

				vm.getContracts();
			}
		},
		goToNextPage: function goToNextPage() {

			var vm = this;

			if (vm.nextPage) {

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

				vm.getContracts();
			}
		},
		exportData: function exportData() {

			var vm = this;

			var dataToSend = {
				headers: [vm.$t("private.reports.potential.table.client"), vm.$t("private.reports.potential.table.legal_name"), vm.$t("private.reports.potential.table.seller"), vm.$t("private.reports.potential.table.employees_quantity"), vm.$t("private.reports.potential.table.wella_potential"), vm.$t("private.reports.potential.table.nioxin_potential"), vm.$t("private.reports.potential.table.sp_potential"), vm.$t("private.reports.potential.table.sassoon_potential"), vm.$t("private.reports.potential.table.sebastian_potential"), vm.$t("private.reports.potential.table.sp_diamond_potential"), vm.$t("private.reports.potential.table.opi_potential")],
				timeZone: __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()
			};

			console.log('moment.tz.guess()', __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess());

			vm.exportDataActive = true;
			__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].reports.exportPotential(dataToSend).then(function (response) {

				vm.getContractsActive = false;

				vm.exportDataActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
				var fileURL = URL.createObjectURL(file);

				__WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'potential.xlsx');

				vm.getContracts();
			});
		},
		activateGroupings: function activateGroupings() {

			var vm = this;

			vm.groupingsActive = vm.groupings.value == 0 ? false : true;

			if (vm.groupings.value == 0) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['appCreationDate'], ['desc']);
			}

			if (vm.groupings.value == 1) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['client.clientCode', 'appCreationDate'], ['asc', 'desc']);
				vm.contractsGroupsByCodeClient = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(vm.contracts, 'client.clientCode');

				console.log('vm.contractsGroupsByCodeClient ', vm.contractsGroupsByCodeClient);
			}

			if (vm.groupings.value == 2) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['client.legalName', 'appCreationDate'], ['asc', 'desc']);
				vm.contractsGroupsByLegalName = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(vm.contracts, 'client.legalName');
			}

			if (vm.groupings.value == 3) {

				vm.contracts = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.orderBy(vm.contracts, ['seller.username', 'appCreationDate'], ['asc', 'desc']);
				vm.contractsGroupsBySeller = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.groupBy(vm.contracts, 'seller.username');
			}
		}
	},
	components: {
		MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__["a" /* default */],
		TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */],
		SelectField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_select_select__["a" /* default */],
		CheckboxField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_checkbox_checkbox__["a" /* default */],
		DateField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_date_date__["a" /* default */]
	},
	created: function created() {

		var vm = this;

		vm.getContracts();
	}
});

/***/ }),

/***/ "Xg7a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"create-client",on:{"click":function($event){_vm.displayCreateClient ? _vm.displayCreateClient = false : _vm.displayCreateClient = true}}},[_vm._v(_vm._s(_vm.$t("private.clients.list.create_client")))]),_c('div',{staticClass:"import-clients",on:{"click":function($event){_vm.importClientsWindow.display = true}}},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients")))]),_c('div',{staticClass:"export-clients",on:{"click":function($event){_vm.exportClients()}}},[(!_vm.exportClientsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.export_clients")))]):_vm._e(),(_vm.exportClientsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportClientsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.clients.list.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"row filters-container"},[_c('text-field',{attrs:{"data":_vm.filters.cif},on:{"changeData":function($event){_vm.filters.cif.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}}),_c('text-field',{attrs:{"data":_vm.filters.clientCode},on:{"changeData":function($event){_vm.filters.clientCode.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}}),_c('text-field',{attrs:{"data":_vm.filters.legalName},on:{"changeData":function($event){_vm.filters.legalName.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}}),_c('select-field',{attrs:{"data":_vm.filters.ascending},on:{"changeData":function($event){_vm.filters.ascending.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}}),_c('select-field',{attrs:{"data":_vm.filters.descending},on:{"changeData":function($event){_vm.filters.descending.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.clients.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.clients.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.clients),function(client,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item email"},[_vm._v(_vm._s(client.email))]),_c('li',{staticClass:"item client-code"},[_vm._v(_vm._s(client.clientCode))])]),_c('menu-more-options',{attrs:{"element":client,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)})),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th'),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.seller")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.associated_accounts")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.cif")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.cfia")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.address")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.city")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.province")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.postal_code")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.client_code")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.delegation")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.email")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.employees_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.lounges_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.phone")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.cellphone")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.web")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.headquarters")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.owner_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.online_shop")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.resale_shop")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.have_salon")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.nioxin_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.sebastian_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.sp_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.system_ec_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.wella_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.wella_real_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.total_contracted_past_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.discharge_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.status")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.mkt_news")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.email_invoices")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.clients.list.table.image_conditions")))])])]),_c('tbody',_vm._l((_vm.clients),function(client,index){return _c('tr',{class:{ selected : client.rowSelected },on:{"click":function($event){_vm.rowClicked(client, client.rowSelected ? false : true)}}},[_c('td',{staticClass:"options"},[_c('menu-more-options',{attrs:{"element":client,"side":'right',"options":_vm.menuOptions,"topClass":index > _vm.filters.limit.value - 5 ? true : false},on:{"optionSelected":_vm.optionSelected}})],1),_c('td',[_vm._v(_vm._s(client.seller ? client.seller.username : ''))]),_c('td',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.auto.html",value:(_vm.displayDataToTooltip(client)),expression:"displayDataToTooltip(client)",modifiers:{"hover":true,"auto":true,"html":true}}]},[_vm._v(_vm._s(client.associatedAccounts ? client.associatedAccounts.length : 0))]),_c('td',[_vm._v(_vm._s(client.cif))]),_c('td',[_vm._v(_vm._s(client.cfia))]),_c('td',[_vm._v(_vm._s(client.address))]),_c('td',[_vm._v(_vm._s(client.town))]),_c('td',[_vm._v(_vm._s(client.province))]),_c('td',[_vm._v(_vm._s(client.zipcode))]),_c('td',[_vm._v(_vm._s(client.clientCode))]),_c('td',[_vm._v(_vm._s(client.delegation ? client.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(client.email))]),_c('td',[_vm._v(_vm._s(client.employeesQuantity))]),_c('td',[_vm._v(_vm._s(client.loungesQuantity))]),_c('td',[_vm._v(_vm._s(client.legalName))]),_c('td',[_vm._v(_vm._s(client.phone))]),_c('td',[_vm._v(_vm._s(client.cellphone))]),_c('td',[_vm._v(_vm._s(client.web))]),_c('td',[_vm._v(_vm._s(client.headquarters))]),_c('td',[_vm._v(_vm._s(client.ownerName))]),_c('td',[_vm._v(_vm._s(client.onlineShop))]),_c('td',[_vm._v(_vm._s(client.resaleShop))]),_c('td',[_vm._v(_vm._s(client.haveSalon))]),_c('td',[_vm._v(_vm._s(client.nioxinPastQuantity))]),_c('td',[_vm._v(_vm._s(client.sebastianPastQuantity))]),_c('td',[_vm._v(_vm._s(client.spPastQuantity))]),_c('td',[_vm._v(_vm._s(client.systemECPastQuantity))]),_c('td',[_vm._v(_vm._s(client.wellaPastQuantity))]),_c('td',[_vm._v(_vm._s(client.wellaRealPastQuantity))]),_c('td',[_vm._v(_vm._s(client.totalContractedPastQuantity))]),_c('td',[_vm._v(_vm._s(client.dischargeDate ? _vm.parseDate( client.dischargeDate.iso ) : ''))]),_c('td',[_vm._v(_vm._s(client.status ? _vm.$t("private.clients.list.table.status_active") : _vm.$t("private.clients.list.table.status_inactive")))]),_c('td',[_vm._v(_vm._s(client.mktNews ? _vm.$t("private.clients.list.table.mkt_news_yes") : _vm.$t("private.clients.list.table.mkt_news_no")))]),_c('td',[_vm._v(_vm._s(client.emailInvoices ? _vm.$t("private.clients.list.table.email_invoices_yes") : _vm.$t("private.clients.list.table.email_invoices_no")))]),_c('td',[_vm._v(_vm._s(client.imageConditions ? _vm.$t("private.clients.list.table.image_conditions_yes") : _vm.$t("private.clients.list.table.image_conditions_no")))])])}))])])]):_vm._e(),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.clients.length == 0 && !_vm.getClientsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.clients.list.no_results")))]):_vm._e(),(_vm.getClientsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])]),(_vm.displayCreateClient)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in",staticStyle:{"height":"80%"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.clients_list_create"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayCreateClient = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.formCreate.fields.seller},on:{"getData":function($event){_vm.searchSellers($event)},"optionSelected":function($event){_vm.sellerSelected($event)}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.cfia},on:{"changeData":function($event){_vm.formCreate.fields.cfia.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.cif},on:{"changeData":function($event){_vm.formCreate.fields.cif.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.clientCode},on:{"changeData":function($event){_vm.formCreate.fields.clientCode.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.email},on:{"changeData":function($event){_vm.formCreate.fields.email.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.employeesQuantity},on:{"changeData":function($event){_vm.formCreate.fields.employeesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.loungesQuantity},on:{"changeData":function($event){_vm.formCreate.fields.loungesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.legalName},on:{"changeData":function($event){_vm.formCreate.fields.legalName.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.address},on:{"changeData":function($event){_vm.formCreate.fields.address.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.city},on:{"changeData":function($event){_vm.formCreate.fields.city.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.province},on:{"changeData":function($event){_vm.formCreate.fields.province.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formCreate.fields.postal_code},on:{"changeData":function($event){_vm.formCreate.fields.postal_code.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.mktNews},on:{"changeData":function($event){_vm.formCreate.fields.mktNews.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.emailInvoices},on:{"changeData":function($event){_vm.formCreate.fields.emailInvoices.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.formCreate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.create_button")))]):_vm._e(),(_vm.formCreate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayCreateClient = false}}})]):_vm._e(),(_vm.displayUpdateClient)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.clients_update"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayUpdateClient = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formUpdateSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.formUpdate.fields.seller},on:{"getData":function($event){_vm.searchSellers($event)},"optionSelected":function($event){_vm.sellerSelected($event)}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.cfia},on:{"changeData":function($event){_vm.formUpdate.fields.cfia.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.cif},on:{"changeData":function($event){_vm.formUpdate.fields.cif.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.address},on:{"changeData":function($event){_vm.formUpdate.fields.address.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.city},on:{"changeData":function($event){_vm.formUpdate.fields.city.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.province},on:{"changeData":function($event){_vm.formUpdate.fields.province.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.postal_code},on:{"changeData":function($event){_vm.formUpdate.fields.postal_code.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.clientCode},on:{"changeData":function($event){_vm.formUpdate.fields.clientCode.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.email},on:{"changeData":function($event){_vm.formUpdate.fields.email.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.employeesQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.employeesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.loungesQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.loungesQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.legalName},on:{"changeData":function($event){_vm.formUpdate.fields.legalName.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.phone},on:{"changeData":function($event){_vm.formUpdate.fields.phone.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.cellphone},on:{"changeData":function($event){_vm.formUpdate.fields.cellphone.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.web},on:{"changeData":function($event){_vm.formUpdate.fields.web.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.ownerName},on:{"changeData":function($event){_vm.formUpdate.fields.ownerName.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.headquarters},on:{"changeData":function($event){_vm.formUpdate.fields.headquarters.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.onlineShop},on:{"changeData":function($event){_vm.formUpdate.fields.onlineShop.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.resaleShop},on:{"changeData":function($event){_vm.formUpdate.fields.resaleShop.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.mktNews},on:{"changeData":function($event){_vm.formUpdate.fields.mktNews.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.emailInvoices},on:{"changeData":function($event){_vm.formUpdate.fields.emailInvoices.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.haveSalon},on:{"changeData":function($event){_vm.formUpdate.fields.haveSalon.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.status},on:{"changeData":function($event){_vm.formUpdate.fields.status.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.nioxinPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.nioxinPastQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.sebastianPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.sebastianPastQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.spPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.spPastQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.systemECPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.systemECPastQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.wellaPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.wellaPastQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.wellaRealPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.wellaRealPastQuantity.value = $event}}}),_c('text-field',{attrs:{"data":_vm.formUpdate.fields.totalContractedPastQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.totalContractedPastQuantity.value = $event}}}),_c('date-field',{attrs:{"data":_vm.formUpdate.fields.dischargeDate},on:{"changeData":function($event){_vm.formUpdate.fields.dischargeDate.value = $event}}}),_c('checkbox-field',{attrs:{"data":_vm.formUpdate.fields.conditions},on:{"changeData":function($event){_vm.formUpdate.fields.conditions.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formUpdateSubmit}},[(!_vm.formUpdate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.update_button")))]):_vm._e(),(_vm.formUpdate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayUpdateClient = false}}})]):_vm._e(),(_vm.displayAssociateAccount)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.associate_account_modal.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayAssociateAccount = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formAssociateAccountSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.formAssociateAccount.fields.client},on:{"getData":function($event){_vm.searchClientsForAssociated($event)},"optionSelected":function($event){_vm.clientForAssociatedSelected($event)}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}}),(_vm.formAssociateAccount.fields.legalName.value !== '')?_c('text-field',{attrs:{"data":_vm.formAssociateAccount.fields.legalName}}):_vm._e(),(_vm.formAssociateAccount.fields.cif.value !== '')?_c('text-field',{attrs:{"data":_vm.formAssociateAccount.fields.cif}}):_vm._e(),(_vm.formAssociateAccount.fields.email.value !== '')?_c('text-field',{attrs:{"data":_vm.formAssociateAccount.fields.email}}):_vm._e()],1),_c('div',{staticClass:"button",on:{"click":_vm.formAssociateAccountSubmit}},[(!_vm.formAssociateAccount.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.associate_account_modal.button")))]):_vm._e(),(_vm.formAssociateAccount.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayAssociateAccount = false}}})]):_vm._e(),(_vm.associatedAccountsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.associated_accounts_modal.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.associatedAccountsWindow.display = false}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"list"},_vm._l((_vm.associatedAccountsWindow.associatedAccounts),function(associatedAccount,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item email"},[_vm._v(_vm._s(associatedAccount.legalName))]),_c('li',{staticClass:"item email"},[_vm._v(_vm._s(associatedAccount.email))]),_c('li',{staticClass:"item client-code"},[_vm._v(_vm._s(associatedAccount.clientCode))])]),_c('menu-more-options',{attrs:{"element":associatedAccount,"side":'left',"options":_vm.associatedAccountsWindow.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)}))])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.associatedAccountsWindow.display = false}}})]):_vm._e(),(_vm.importClientsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.importClientsWindow.display = false; _vm.resetDataImportClientsWindow()}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-2"},[_c('select-field',{attrs:{"data":_vm.importClientsWindow.fields.separator},on:{"changeData":function($event){_vm.importClientsWindow.fields.separator.value = $event;}}})],1),_c('div',{staticClass:"col-md-5"},[_c('file-field',{attrs:{"data":_vm.importClientsWindow.fields.csv},on:{"changeData":function($event){_vm.importClientsWindow.fields.csv.value = $event; _vm.importClientsWindow.fields.csv.value.data ? _vm.validateCSVFile() : _vm.resetDataImportClientsWindow()}}})],1)]),(_vm.importClientsWindow.validateCSVFileActive)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.please_wait")))])]):_vm._e(),_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[(_vm.importClientsWindow.clientsToUpdate.length > 0 || _vm.importClientsWindow.clientsToCreate.length > 0)?_c('div',{staticClass:"button",on:{"click":_vm.importClientsSelected}},[(!_vm.importClientsWindow.importClientsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.import_clients")))]):_vm._e(),(_vm.importClientsWindow.importClientsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e()])]),(_vm.importClientsWindow.fields.csv.value.data && !_vm.importClientsWindow.validateCSVFileActive)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[(_vm.importClientsWindow.clientsToUpdate.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.clients_to_update")))]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"blue"},[_c('checkbox-field',{attrs:{"data":_vm.importClientsWindow.activateAllCheckboxUpdate},on:{"changeData":function($event){_vm.importClientsWindow.activateAllCheckboxUpdate.value = $event; _vm.activateAllCheckboxToggleUpdate()}}})],1),_c('th',{staticClass:"blue"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.seller")))]),_c('th',{staticClass:"blue"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.client_code")))]),_c('th',{staticClass:"blue"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.legal_name")))]),_c('th',{staticClass:"blue"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.cif")))])])]),_c('tbody',_vm._l((_vm.importClientsWindow.clientsToUpdate),function(client,index){return _c('tr',[_c('td',{staticClass:"blue"},[_c('checkbox-field',{attrs:{"data":_vm.importClientsWindow.allChecksUpdate[index]},on:{"changeData":function($event){_vm.importClientsWindow.selectedClientsToUpdate[index] = $event}}})],1),_c('td',{staticClass:"blue"},[_vm._v(_vm._s(client.sellerUsername))]),_c('td',{staticClass:"blue"},[_vm._v(_vm._s(client.clientCode))]),_c('td',{staticClass:"blue"},[_vm._v(_vm._s(client.clientLegalName))]),_c('td',{staticClass:"blue"},[_vm._v(_vm._s(client.clientCIF))])])}))])]):_vm._e(),(_vm.importClientsWindow.clientsToUpdate.length == 0)?_c('div',{staticClass:"no-table-data"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.no_clients_to_update")))]):_vm._e()]),_c('div',{staticClass:"col-md-4"},[(_vm.importClientsWindow.clientsToCreate.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.clients_to_create")))]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"green"},[_c('checkbox-field',{attrs:{"data":_vm.importClientsWindow.activateAllCheckboxCreate},on:{"changeData":function($event){_vm.importClientsWindow.activateAllCheckboxCreate.value = $event; _vm.activateAllCheckboxToggleCreate()}}})],1),_c('th',{staticClass:"green"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.seller")))]),_c('th',{staticClass:"green"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.client_code")))]),_c('th',{staticClass:"green"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.legal_name")))]),_c('th',{staticClass:"green"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.cif")))])])]),_c('tbody',_vm._l((_vm.importClientsWindow.clientsToCreate),function(client,index){return _c('tr',[_c('td',{staticClass:"green"},[_c('checkbox-field',{attrs:{"data":_vm.importClientsWindow.allChecksCreate[index]},on:{"changeData":function($event){_vm.importClientsWindow.selectedClientsToCreate[index] = $event}}})],1),_c('td',{staticClass:"green"},[_vm._v(_vm._s(client.sellerUsername))]),_c('td',{staticClass:"green"},[_vm._v(_vm._s(client.clientCode))]),_c('td',{staticClass:"green"},[_vm._v(_vm._s(client.clientLegalName))]),_c('td',{staticClass:"green"},[_vm._v(_vm._s(client.clientCIF))])])}))])]):_vm._e(),(_vm.importClientsWindow.clientsToCreate.length == 0)?_c('div',{staticClass:"no-table-data"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.no_clients_to_create")))]):_vm._e()]),_c('div',{staticClass:"col-md-4"},[(_vm.importClientsWindow.clientsWithErrors.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.clients_with_error")))]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.seller")))]),_c('th',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.client_code")))]),_c('th',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.legal_name")))]),_c('th',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.cif")))]),_c('th',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.table.observation")))])])]),_c('tbody',_vm._l((_vm.importClientsWindow.clientsWithErrors),function(client,index){return _c('tr',[_c('td',{staticClass:"red"},[_vm._v(_vm._s(client.sellerUsername))]),_c('td',{staticClass:"red"},[_vm._v(_vm._s(client.clientCode))]),_c('td',{staticClass:"red"},[_vm._v(_vm._s(client.clientLegalName))]),_c('td',{staticClass:"red"},[_vm._v(_vm._s(client.clientCIF))]),_c('td',{staticClass:"red"},[_vm._v(_vm._s(_vm.$t("errors.custom." + client.error.code )))])])}))])]):_vm._e(),(_vm.importClientsWindow.clientsWithErrors.length == 0)?_c('div',{staticClass:"no-table-data"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.no_clients_with_error")))]):_vm._e()])]):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.importClientsWindow.display = false; _vm.resetDataImportClientsWindow()}}})]):_vm._e(),(_vm.migrateClientsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in"},[_c('div',{staticClass:"header"},[_vm._v("Migrar Clientes - CSV"),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.migrateClientsWindow.display = false; _vm.resetDataMigrateClientsWindow ()}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.migrateClientsWindow.fields.csv},on:{"changeData":function($event){_vm.migrateClientsWindow.fields.csv.value = $event;}}})],1),_c('div',{staticClass:"col-md-6"},[(_vm.migrateClientsWindow.fields.csv.value.data)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.migrateClientsSubmit()}}},[(!_vm.migrateClientsWindow.migrateCSVFileActive)?_c('span',[_vm._v("Enviar CSV")]):_vm._e(),(_vm.migrateClientsWindow.migrateCSVFileActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e()]),(_vm.migrateClientsWindow.migrateCSVFileActive)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.please_wait")))])]):_vm._e()]),(!_vm.migrateClientsWindow.migrateCSVFileActive && (_vm.migrateClientsWindow.clientsToCreated.length > 0 || _vm.migrateClientsWindow.clientsWithErrors.length > 0))?_c('div',[_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Clientes Migrados ' + _vm.migrateClientsWindow.clientsToCreated.length))]),_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Clientes con errores ' + _vm.migrateClientsWindow.clientsWithErrors.length))])]),_c('hr'),(_vm.migrateClientsWindow.clientsWithErrors.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v("Datos con Error")]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_vm._m(0),_c('tbody',_vm._l((_vm.migrateClientsWindow.clientsWithErrors),function(client,index){return _c('tr',[_c('td',[_vm._v(_vm._s(client.client ? client.client.clientCode : client.clientCode))]),_c('td',[_vm._v(_vm._s(client.error.field ? client.error.field : ''))]),_c('td',[_vm._v(_vm._s(client.error.value ? client.error.value : ''))]),_c('td',[_vm._v(_vm._s(client.error.message ? client.error.message : ''))])])}))])]):_vm._e()]):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.migrateClientsWindow.display = false; _vm.resetDataMigrateClientsWindow()}}})]):_vm._e(),(_vm.migrateAssociatedAccountsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in"},[_c('div',{staticClass:"header"},[_vm._v("Migrar Asociados - CSV"),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.migrateAssociatedAccountsWindow.display = false; _vm.resetDataMigrateAssociatedAccountsWindow ()}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.migrateAssociatedAccountsWindow.fields.csv},on:{"changeData":function($event){_vm.migrateAssociatedAccountsWindow.fields.csv.value = $event;}}})],1),_c('div',{staticClass:"col-md-6"},[(_vm.migrateAssociatedAccountsWindow.fields.csv.value.data)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.migrateAssociatedAccountsSubmit()}}},[(!_vm.migrateAssociatedAccountsWindow.migrateCSVFileActive)?_c('span',[_vm._v("Enviar CSV")]):_vm._e(),(_vm.migrateAssociatedAccountsWindow.migrateCSVFileActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e()]),(_vm.migrateAssociatedAccountsWindow.migrateCSVFileActive)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.please_wait")))])]):_vm._e()]),(!_vm.migrateAssociatedAccountsWindow.migrateCSVFileActive && (_vm.migrateAssociatedAccountsWindow.associateccountCreated.length > 0 || _vm.migrateAssociatedAccountsWindow.associateccountWithErrors.length > 0))?_c('div',[_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Asociados Migrados ' + _vm.migrateAssociatedAccountsWindow.associateccountCreated.length))]),_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Asociados con errores ' + _vm.migrateAssociatedAccountsWindow.associateccountWithErrors.length))])]),_c('hr'),(_vm.migrateAssociatedAccountsWindow.associateccountWithErrors.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v("Datos con Error")]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_vm._m(1),_c('tbody',_vm._l((_vm.migrateAssociatedAccountsWindow.associateccountWithErrors),function(client,index){return _c('tr',[_c('td',[_vm._v(_vm._s(client.id ? client.id : ''))]),_c('td',[_vm._v(_vm._s(client.error.field ? client.error.field : ''))]),_c('td',[_vm._v(_vm._s(client.error.value ? client.error.value : ''))]),_c('td',[_vm._v(_vm._s(client.error.message ? client.error.message : ''))])])}))])]):_vm._e()]):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.migrateAssociatedAccountsWindow.display = false; _vm.resetDataMigrateAssociatedAccountsWindow()}}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Cliente")]),_c('th',[_vm._v("Campo")]),_c('th',[_vm._v("Valor")]),_c('th',[_vm._v("Descripción")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("ID")]),_c('th',[_vm._v("Campo")]),_c('th',[_vm._v("Valor")]),_c('th',[_vm._v("Descripción")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XoBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("mhRs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b2e8d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("P0Y2");
function injectStyle (ssrContext) {
  __webpack_require__("GSUq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b2e8d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XzJv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("Q7O4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf59375_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("ObX2");
function injectStyle (ssrContext) {
  __webpack_require__("fI9E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2bf59375"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bf59375_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YBiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messenger-container"},_vm._l((_vm.messages),function(message){return _c('div',{staticClass:"message fade-in-from-top"},[_c('ul',{staticClass:"sides-container"},[_c('li',{staticClass:"left-side"},[( message.type == 'success' )?_c('i',{staticClass:"fa fa-check-circle icon success"}):_vm._e(),( message.type == 'error' )?_c('i',{staticClass:"fa fa-exclamation-circle icon error"}):_vm._e()]),_c('li',{staticClass:"right-side"},[_c('i',{staticClass:"fa fa-times round-icon first-color close-icon",on:{"click":function($event){_vm.deleteMessage( message.id )}}}),_vm._l((message.content),function(content){return _c('ul',{staticClass:"message-content"},[_c('li',{staticClass:"text"},[_vm._v(_vm._s(content))])])})],2)])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_general_session_session__ = __webpack_require__("IqKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_public_login_login__ = __webpack_require__("G9O9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_private_private__ = __webpack_require__("VPVU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_private_sellers_sellers__ = __webpack_require__("OrUh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_private_sellers_list_list__ = __webpack_require__("U0kk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_private_sellers_delegations_delegations__ = __webpack_require__("wtYE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_private_sellers_sellers_types_sellers_types__ = __webpack_require__("AYyO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_private_clients_clients__ = __webpack_require__("gDXb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_private_clients_list_list__ = __webpack_require__("hOMo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_private_clients_records_clients_records__ = __webpack_require__("fcyh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_private_clients_records_list_list__ = __webpack_require__("gWmG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_private_contracts_contracts__ = __webpack_require__("0ZxF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_private_contracts_list_list__ = __webpack_require__("sGGH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_private_contracts_sda_sda__ = __webpack_require__("Ujr2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_private_contracts_zips_zips__ = __webpack_require__("Lbey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_private_reports_reports__ = __webpack_require__("BYMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_private_reports_master_data_master_data__ = __webpack_require__("88qS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_private_reports_sda_sda__ = __webpack_require__("q+vm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_private_reports_potential_potential__ = __webpack_require__("BHBU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_private_reports_cci_cci__ = __webpack_require__("XzJv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_private_reports_education_education__ = __webpack_require__("jrS6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_private_history_history__ = __webpack_require__("gwm3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_private_history_contracts_contracts__ = __webpack_require__("0PR0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_private_history_sda_sda__ = __webpack_require__("t5Gw");































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var RouterToExport = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].login.path,
    name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].login.name,
    component: __WEBPACK_IMPORTED_MODULE_5__components_public_login_login__["a" /* default */]
  }, {
    path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].private.path,
    name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].private.name,
    component: __WEBPACK_IMPORTED_MODULE_6__components_private_private__["a" /* default */],
    children: [{
      path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellers.path,
      name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellers.name,
      component: __WEBPACK_IMPORTED_MODULE_7__components_private_sellers_sellers__["a" /* default */],
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellersList.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellersList.name,
        component: __WEBPACK_IMPORTED_MODULE_8__components_private_sellers_list_list__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellersDelegations.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellersDelegations.name,
        component: __WEBPACK_IMPORTED_MODULE_9__components_private_sellers_delegations_delegations__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellersTypes.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].sellersTypes.name,
        component: __WEBPACK_IMPORTED_MODULE_10__components_private_sellers_sellers_types_sellers_types__["a" /* default */]
      }]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clients.path,
      name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clients.name,
      component: __WEBPACK_IMPORTED_MODULE_11__components_private_clients_clients__["a" /* default */],
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clientsList.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clientsList.name,
        component: __WEBPACK_IMPORTED_MODULE_12__components_private_clients_list_list__["a" /* default */]
      }]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clientsRecords.path,
      name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clientsRecords.name,
      component: __WEBPACK_IMPORTED_MODULE_13__components_private_clients_records_clients_records__["a" /* default */],
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clientsRecordsList.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].clientsRecordsList.name,
        component: __WEBPACK_IMPORTED_MODULE_14__components_private_clients_records_list_list__["a" /* default */]
      }]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contracts.path,
      name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contracts.name,
      component: __WEBPACK_IMPORTED_MODULE_15__components_private_contracts_contracts__["a" /* default */],
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contractsList.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contractsList.name,
        component: __WEBPACK_IMPORTED_MODULE_16__components_private_contracts_list_list__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contractsSDA.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contractsSDA.name,
        component: __WEBPACK_IMPORTED_MODULE_17__components_private_contracts_sda_sda__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contractsZips.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].contractsZips.name,
        component: __WEBPACK_IMPORTED_MODULE_18__components_private_contracts_zips_zips__["a" /* default */]
      }]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reports.path,
      name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reports.name,
      component: __WEBPACK_IMPORTED_MODULE_19__components_private_reports_reports__["a" /* default */],
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsMasterData.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsMasterData.name,
        component: __WEBPACK_IMPORTED_MODULE_20__components_private_reports_master_data_master_data__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsSDA.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsSDA.name,
        component: __WEBPACK_IMPORTED_MODULE_21__components_private_reports_sda_sda__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsPotential.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsPotential.name,
        component: __WEBPACK_IMPORTED_MODULE_22__components_private_reports_potential_potential__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsCCI.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsCCI.name,
        component: __WEBPACK_IMPORTED_MODULE_23__components_private_reports_cci_cci__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsEducation.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].reportsEducation.name,
        component: __WEBPACK_IMPORTED_MODULE_24__components_private_reports_education_education__["a" /* default */]
      }]
    }, {
      path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].history.path,
      name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].history.name,
      component: __WEBPACK_IMPORTED_MODULE_25__components_private_history_history__["a" /* default */],
      children: [{
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].historyContracts.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].historyContracts.name,
        component: __WEBPACK_IMPORTED_MODULE_26__components_private_history_contracts_contracts__["a" /* default */]
      }, {
        path: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].historyContractsSDA.path,
        name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].historyContractsSDA.name,
        component: __WEBPACK_IMPORTED_MODULE_27__components_private_history_sda_sda__["a" /* default */]
      }]
    }]
  }]
});

RouterToExport.beforeEach(function (to, from, next) {

  if (to.name.indexOf('private') != -1) {

    if (!localStorage.getItem('sessionToken')) {

      return next({ name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].login.name });
    }

    __WEBPACK_IMPORTED_MODULE_4__components_general_http_http__["a" /* default */].setHeader({ key: 'x-parse-session-token', value: localStorage.getItem('sessionToken') });

    return __WEBPACK_IMPORTED_MODULE_3__components_general_session_session__["a" /* default */].fetchSession().then(function (response) {

      if (!response.success) {

        return next({ name: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */].login.name });
      }

      return next();
    });
  }

  return next();
});

/* harmony default export */ __webpack_exports__["a"] = (RouterToExport);

/***/ }),

/***/ "Ysl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	headers: {
		// 'crossDomain': true,
		'X-Parse-Application-Id': __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.appId
		// 'Access-Control-Allow-Origin' : '*'
	},
	getHeaders: function getHeaders() {

		return this.headers;
	},
	setHeader: function setHeader(data) {

		this.headers[data.key] = data.value;
	},
	deleteHeader: function deleteHeader(data) {

		delete this.headers[data.key];
	},
	request: function request() {

		var headers = this.headers;

		return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
			headers: headers,
			timeout: 5000 * 60 * 100
		});
	}
});

/***/ }),

/***/ "Yu4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("UZfk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36356e7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("gKkB");
function injectStyle (ssrContext) {
  __webpack_require__("Dzmf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36356e7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36356e7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "b5iG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bFOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'textarea-field',
	props: ['data'],
	data: function data() {
		return {
			field: {
				value: this.data.value
			}
		};
	},

	methods: {
		changeData: function changeData(event) {

			this.$emit('changeData', event.target.value);
		}
	}
});

/***/ }),

/***/ "c59E":
/***/ (function(module, exports) {

module.exports = {"DSO":{"tipoClientes":[{"tipo":"Associate","tramoTotal":"3400-7399","rappel":["anual"],"tramos":[{"tramo":"3400","descuento":27,"rappel":0,"rappelBriogeo":0,"rappelMarketing":0,"ptsApp":"150","atsEducacionValorado":0}],"marketing":[{"nombre":"Wella APP","ptsApp":"150","congreso":0}]},{"tipo":"Prime","tramoTotal":"7400-19999","rappel":["anual","semestral"],"tramos":[{"tramo":"7400","descuento":30,"rappel":5,"rappelBriogeo":5,"rappelMarketing":0,"ptsApp":"10% escalão contratado","atsEducacionValorado":400}],"marketing":[{"nombre":"Wella APP","ptsApp":"10% escalão contratado","congreso":0},{"nombre":"€ Congresso","ptsApp":"0","congreso":400}]},{"tipo":"Select","tramoTotal":"20000-39999","rappel":["anual","semestral","trimestral"],"tramos":[{"tramo":"20000","descuento":35,"rappel":20,"rappelBriogeo":0,"rappelMarketing":5,"ptsApp":"10% escalão contratado","atsEducacionValorado":800}],"marketing":[{"nombre":"Wella APP","ptsApp":"10% escalão contratado","congreso":0},{"nombre":"€ Congresso","ptsApp":"0","congreso":800},{"nombre":"Rappel MKT","ptsApp":"","congreso":0}]},{"tipo":"Elite","tramoTotal":"40000-69999","rappel":["anual","semestral","trimestral"],"tramos":[{"tramo":"40000","descuento":37,"rappel":20,"rappelBriogeo":0,"rappelMarketing":10,"ptsApp":"10% escalão contratado","atsEducacionValorado":1300}],"marketing":[{"nombre":"Wella APP","ptsApp":"10% escalão contratado","congreso":0},{"nombre":"€ Congresso","ptsApp":"0","congreso":1300},{"nombre":"Rappel MKT","ptsApp":"","congreso":0}]},{"tipo":"Executive","tramoTotal":"70000","rappel":["anual","semestral","trimestral"],"tramos":[{"tramo":"70000","descuento":40,"rappel":20,"rappelBriogeo":0,"rappelMarketing":10,"ptsApp":"10% escalão contratado","atsEducacionValorado":1800}],"marketing":[{"nombre":"Wella APP","ptsApp":"10% escalão contratado","congreso":0},{"nombre":"€ Congresso","ptsApp":"0","congreso":1800},{"nombre":"Rappel MKT","ptsApp":"","congreso":0}]}]},"ISO":[{"tipo":"ISO_1","limite":6000,"desconto":30,"sebManDesconto":30,"rappelVolume":20,"sebManRappelVolume":20,"rappelMKTG":7},{"tipo":"ISO_2","limite":45000,"desconto":33,"sebManDesconto":33,"rappelVolume":24,"sebManRappelVolume":24,"rappelMKTG":8},{"tipo":"ISO_3","limite":110000,"desconto":34,"sebManDesconto":34,"rappelVolume":24,"sebManRappelVolume":24,"rappelMKTG":9},{"tipo":"ISO_4","limite":170000,"desconto":35,"sebManDesconto":35,"rappelVolume":24,"sebManRappelVolume":24,"rappelMKTG":10}],"OPI":[{"limite":8000,"descuento":27,"rappel":10},{"limite":16000,"descuento":30,"rappel":15}]}

/***/ }),

/***/ "c87X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cdnz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cl9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	getSellers: function getSellers(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellers' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	createSeller: function createSeller(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellers';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	updateSeller: function updateSeller(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellers';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	deleteSeller: function deleteSeller(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellers' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().delete(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportUsers: function exportUsers(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellers/export';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	migrateCSVFile: function migrateCSVFile(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellers/migrate';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "d+At":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_is_js__);



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'file-field',
	props: ['data'],
	data: function data() {
		return {
			fileReady: this.data.fileReady,
			fileName: this.data.fileReady ? '... ' + this.data.value.data.name.substring(this.data.value.data.name.length - 20, this.data.value.data.name.length) : ''
		};
	},

	methods: {
		selectFile: function selectFile() {

			var vm = this;

			vm.$refs.fileInput.click();
		},
		changeData: function changeData(event) {

			var vm = this;

			var files = event.target.files || event.dataTransfer.files;

			if (files[0]) {

				vm.fileName = files[0].name;

				var fileReader = new FileReader();

				if (vm.data.readAsDataURL) {

					fileReader.readAsDataURL(files[0]);
				} else if (vm.data.readAsText) {

					fileReader.readAsText(files[0]);
				}

				fileReader.onloadend = function (fileReaderEvent) {

					var data = {
						data: fileReaderEvent.target.result,
						format: files[0].type.substring(files[0].type.indexOf('/') + 1),
						size: files[0].size / 1000000
					};

					if (vm.data.filters.formatsAllowed && !__WEBPACK_IMPORTED_MODULE_1_is_js___default.a.inArray(data.format, vm.data.filters.formatsAllowed)) {

						var message = {
							message: [vm.$t('data_validator.file.format').replace('%formats%', vm.data.filters.formatsAllowed.join(', '))],
							type: 'error'
						};

						vm.$root.$emit('showMessage', message);

						return;
					}

					if (vm.data.filters.maxSize && data.size > vm.data.filters.maxSize) {

						var _message = {
							message: [vm.$t('data_validator.file.size').replace('%size%', vm.data.filters.maxSize)],
							type: 'error'
						};

						vm.$root.$emit('showMessage', _message);

						return;
					}

					vm.fileReady = true;

					if (vm.data.image) {

						var image = new Image();

						image.src = fileReaderEvent.target.result;

						image.onload = function () {

							data.height = this.height;
							data.width = this.width;

							vm.sendData(data);
						};
					} else {

						vm.sendData(data);
					}
				};
			}
		},
		removeFile: function removeFile() {

			var vm = this;

			vm.sendData({});

			setTimeout(function () {

				vm.fileReady = false;
			}, 100);
		},
		sendData: function sendData(data) {

			this.$emit('changeData', data);
		}
	}
});

/***/ }),

/***/ "d2t4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_env__);






/* harmony default export */ __webpack_exports__["a"] = ({
	createZip: function createZip(data) {

		var url = __WEBPACK_IMPORTED_MODULE_3__config_env___default.a.api.baseUrl + '/api/v1/files-zips';

		return __WEBPACK_IMPORTED_MODULE_2__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	getZips: function getZips(query) {

		var url = __WEBPACK_IMPORTED_MODULE_3__config_env___default.a.api.baseUrl + '/api/v1/files-zips';

		if (query) {

			var esc = encodeURIComponent;
			var _query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (k) {
				return esc(k) + '=' + esc(query[k]);
			}).join('&');

			url += '/?' + _query;
		}

		return __WEBPACK_IMPORTED_MODULE_2__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	deleteZip: function deleteZip(id) {

		var url = __WEBPACK_IMPORTED_MODULE_3__config_env___default.a.api.baseUrl + '/api/v1/files-zips/' + id;

		return __WEBPACK_IMPORTED_MODULE_2__components_general_http_http__["a" /* default */].request().delete(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "e17V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_env__);





/* harmony default export */ __webpack_exports__["a"] = ({
	getClientsRecords: function getClientsRecords(query) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/clientsRecords';

		if (query) {
			var esc = encodeURIComponent;
			var _query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (k) {
				return esc(k) + '=' + esc(query[k]);
			}).join('&');
			url += '?' + _query;
		}

		// let url = config.api.baseUrl + '/api/clientsRecords' + data

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	searchClient: function searchClient(query) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/clientsRecords/search-client';

		if (query) {
			var esc = encodeURIComponent;
			var _query = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).map(function (k) {
				return esc(k) + '=' + esc(query[k]);
			}).join('&');
			url += '?' + _query;
		}

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	approveClientsRecords: function approveClientsRecords(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/clientsRecords/approve';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	disapproveClientsRecords: function disapproveClientsRecords(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/clientsRecords/disapprove';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	exportClientsRecords: function exportClientsRecords(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/clientsRecords/export';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "eQpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"create-contract",on:{"click":function($event){_vm.createContractWindow.display = true}}},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.create_contract_sda")))]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('date-field',{attrs:{"data":_vm.filters.since},on:{"changeData":function($event){_vm.filters.since.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}}),_c('date-field',{attrs:{"data":_vm.filters.until},on:{"changeData":function($event){_vm.filters.until.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}}),_c('select-field',{attrs:{"data":_vm.filters.exported},on:{"changeData":function($event){_vm.filters.exported.value = $event; _vm.getSDAsInfo(); _vm.filters.skip.value = 0;}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.SDAsInfo.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.SDAsInfo.length > 0)?_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.SDAsInfo),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])])])})):_vm._e(),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.exported")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.client")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.seller")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.delegation")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sebastian_sda_pdf")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sda_sebastian")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sebastian_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sda_date")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.table.sebastian_sda_virtual_signed")))])])]),_c('tbody',[(_vm.activateFilters)?_c('tr',[_c('td'),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.clientCode},on:{"changeData":function($event){_vm.filters.clientCode.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.legalName},on:{"changeData":function($event){_vm.filters.legalName.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.seller},on:{"changeData":function($event){_vm.filters.seller.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.delegation},on:{"changeData":function($event){_vm.filters.delegation.value = $event; _vm.filters.skip.value = 0; _vm.getSDAsInfo();}}})],1),_c('td',{attrs:{"colspan":"14"}})]):_vm._e(),_vm._l((_vm.SDAsInfo),function(SDAInfo,index){return _c('tr',{class:{ selected : SDAInfo.rowSelected },on:{"click":function($event){_vm.rowClicked(SDAInfo, SDAInfo.rowSelected ? false : true)}}},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.exported ? _vm.$t("private.contracts.sda.table.exported_options.yes") : _vm.$t("private.contracts.sda.table.exported_options.no")))]),_c('td',[_vm._v(_vm._s(SDAInfo.client ? SDAInfo.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.client ? SDAInfo.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(!SDAInfo.client ? '' : SDAInfo.client.seller ? SDAInfo.client.seller.username : ''))]),_c('td',[_vm._v(_vm._s(!SDAInfo.client ? '' : !SDAInfo.client.seller ? '' : !SDAInfo.client.seller.delegation ? '' : SDAInfo.client.seller.delegation.name))]),_c('td',{staticClass:"text-center"},[(SDAInfo.sebastianSDA && SDAInfo.sebastianSDA.pdf)?_c('a',{attrs:{"href":SDAInfo.sebastianSDA.pdf ? SDAInfo.sebastianSDA.pdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e(),(SDAInfo.sebastianSDA && !SDAInfo.sebastianSDA.pdf)?_c('div',[_c('i',{staticClass:"fa fa-times-rectangle",staticStyle:{"font-size":"25px","margin-top":"5px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(SDAInfo.sebastianSDA && SDAInfo.sdaSebastian ? _vm.$t("private.contracts.sda.table.sda_sebastian_options.ok") : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.sebastianSDA && SDAInfo.sebastianDate ? _vm.parseDate( SDAInfo.sebastianDate ) : ''))]),_c('td',[_vm._v(_vm._s(SDAInfo.lastDateSDA ? _vm.parseDate( SDAInfo.lastDateSDA ) : ''))]),_c('td',[(SDAInfo.sebastianSDA)?_c('div',[(SDAInfo.sebastianSDA.sdaSebastian && !SDAInfo.sebastianSDA.virtualSignApproved && SDAInfo.sebastianSDA.virtualSigned)?_c('div',{staticClass:"send-mail",on:{"click":function($event){_vm.handleSendMailDigitalSignature(SDAInfo.sebastianSDA);}}},[_vm._v(_vm._s(_vm.$t("private.contracts.list.forward_email")))]):_vm._e(),(SDAInfo.sebastianSDA.virtualSignApproved)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.yes")))]):_vm._e()]):_vm._e()])])})],2)])]),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.SDAsInfo.length == 0 && !_vm.getSDAsInfoActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.no_results")))]):_vm._e(),(_vm.getSDAsInfoActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])]),(_vm.createContractWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.create_contract_window.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.createContractWindow.display = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.createContractWindow.form.fields.client},on:{"getData":function($event){_vm.searchClients($event)},"optionSelected":function($event){_vm.clientSelected($event)}}}),_c('date-field',{attrs:{"data":_vm.createContractWindow.form.fields.date},on:{"changeData":function($event){_vm.createContractWindow.form.fields.date.value = $event}}}),_c('checkbox-field',{attrs:{"data":_vm.createContractWindow.form.fields.sdaTypes},on:{"changeData":function($event){_vm.createContractWindow.form.fields.sdaTypes.value = $event; _vm.validateSdaTypes()}}}),_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.createContractWindow.form.fields.pdf},on:{"changeData":function($event){_vm.createContractWindow.form.fields.pdf.value = $event}}})],1)]),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.createContractWindow.form.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.sda.create_contract_window.create_button")))]):_vm._e(),(_vm.createContractWindow.form.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.createContractWindow.display = false}}})]):_vm._e(),(_vm.exportZipPDFsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in",staticStyle:{"height":"500px"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.contracts.sda.export_zip_pdfs_window.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.exportZipPDFsWindow.display = false;}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.year},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.year.value = $event; _vm.generateMoths()}}})],1),_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.month},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.month.value = $event;}}})],1)])]),(_vm.exportZipPDFsWindow.fields.year.value && _vm.exportZipPDFsWindow.fields.month.value != '' )?_c('div',{staticClass:"button",on:{"click":_vm.exportZipPDFs}},[(!_vm.exportZipPDFsWindow.downloadZipPDFsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.sda.export_zip_pdfs_window.download_button")))]):_vm._e(),(_vm.exportZipPDFsWindow.downloadZipPDFsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e(),(_vm.exportZipPDFsWindow.progress.display)?_c('div',{staticStyle:{"margin":"10px 100px"}},[_c('span',[_vm._v("Comprimiendo")]),_vm._m(0),_c('br'),_c('span',[_vm._v("Descargando")]),_vm._m(1)]):_vm._e()])]),_c('div',{staticClass:"back-screen"})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-info progress-bar-striped",staticStyle:{"width":"0%"},attrs:{"id":"progress_id_export_zippdf_sda","role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-success progress-bar-striped",staticStyle:{"width":"0%"},attrs:{"id":"progress_id_export_zippdf_download","role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fI9E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "fcyh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("tw+a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71c6b1ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("BsCo");
function injectStyle (ssrContext) {
  __webpack_require__("FqCv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71c6b1ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71c6b1ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fzU0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_urijs__ = __webpack_require__("hBlz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_urijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_urijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_fields_file_file__ = __webpack_require__("6YFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_fields_date_date__ = __webpack_require__("D507");

















/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'client-record-list',
	data: function data() {
		return {
			clients: [],
			menuOptions: [{
				iconClass: 'fa fa-check',
				name: this.$t('private.clients_records.list.menu_more_options.approve'),
				action: 'approve'
			}, {
				iconClass: 'fa fa-times',
				name: this.$t('private.clients_records.list.menu_more_options.disapprove'),
				action: 'disapprove'
			}],
			filters: {
				cif: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					value: '',
					name: this.$t('private.clients_records.list.filters.cif'),
					type: 'text',
					error: false,
					filters: {
						type: 'string',
						minLength: 2,
						maxLength: 100,
						required: true
					},
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				clientCode: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					value: '',
					name: this.$t('private.clients_records.list.filters.client_code'),
					type: 'text',
					error: false,
					filters: {
						type: 'string',
						minLength: 10,
						maxLength: 20,
						required: true
					},
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				// email : {
				// 	id      : _.uniqueId('field_'),
				// 	display : true,
				// 	value   : '',
				// 	name    : this.$t('private.clients_records.list.filters.email'),
				// 	type    : 'email',
				// 	error   : false,
				// 	filters : {
				// 		type      : 'string',
				// 		minLength : 2,
				// 		maxLength : 100,
				// 		required  : true
				// 	}
				// },
				legalName: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					value: '',
					name: this.$t('private.clients_records.list.fields.legal_name'),
					type: 'text',
					error: false,
					filters: {
						type: 'string',
						minLength: 2,
						maxLength: 40,
						required: true
					},
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				state: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.clients_records.list.filters.state_options.pendiente_ok'),
					value: '',
					name: this.$t('private.clients_records.list.filters.state'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.clients_records.list.filters.state_options.ok'),
						value: 1
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.state_options.no_ok'),
						value: 2
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.state_options.pendiente_ok'),
						value: ''
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				updated: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.clients_records.list.filters.updated'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.clients_records.list.filters.updated_options.yes'),
						value: true
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.updated_options.not'),
						value: false
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				ascending: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: '',
					value: '',
					name: this.$t('private.clients_records.list.filters.sort_ascending'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.clients_records.list.filters.sort_options.created_at'),
						value: 'createdAt'
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.sort_options.cif'),
						value: 'cif'
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.sort_options.client_code'),
						value: 'clientCode'
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				descending: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.clients_records.list.filters.sort_options.created_at'),
					value: 'createdAt',
					name: this.$t('private.clients_records.list.filters.sort_descending'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.clients_records.list.filters.sort_options.created_at'),
						value: 'createdAt'
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.sort_options.cif'),
						value: 'cif'
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.sort_options.client_code'),
						value: 'clientCode'
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				limit: {
					id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
					display: true,
					fakeValue: this.$t('private.clients_records.list.filters.limit_options.10'),
					value: 10,
					name: this.$t('private.clients_records.list.filters.limit'),
					error: false,
					active: false,
					options: [{
						fakeValue: this.$t('private.clients_records.list.filters.limit_options.10'),
						value: 10
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.limit_options.25'),
						value: 25
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.limit_options.50'),
						value: 50
					}, {
						fakeValue: this.$t('private.clients_records.list.filters.limit_options.100'),
						value: 100
					}],
					style: {
						width: '230px',
						display: 'inline-block',
						margin: '0px 10px'
					}
				},
				skip: {
					value: 0
				}
			},
			getClientsRecordsActive: false,
			activateFilters: false,
			haveData: false,
			nextPage: false,
			disapproveClientsRecords: {
				fields: {
					id: {
						value: '',
						filters: {
							type: 'string',
							required: true
						}
					}
				},
				active: false
			},
			exportClientsRecordsActive: false,
			approveClientsRecordsWindow: {
				display: false,
				clientRecord: {},
				formApprove: {
					fields: {
						clientCode: {
							id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
							display: true,
							value: '',
							name: this.$t('private.clients_records.list.fields.client_code'),
							type: 'text',
							error: false,
							filters: {
								type: 'string',
								minLength: 8,
								maxLength: 8,
								required: true
							}
						}
					},
					active: false
				}
			},
			formCreate: {
				fields: {
					seller: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.seller'),
						error: false,
						active: false,
						options: [],
						filters: {
							type: 'string',
							required: true
						}
					},
					cfia: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.cfia'),
						type: 'text',
						error: false,
						filters: {
							type: 'string'
						}
					},
					cif: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.cif'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 15,
							required: true
						}
					},
					clientCode: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.client_code'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 8,
							maxLength: 8,
							required: true
						}
					},
					email: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.email'),
						type: 'email',
						error: false,
						filters: {
							type: 'email',
							minLength: 7,
							maxLength: 100,
							required: true
						}
					},
					employeesQuantity: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.employees_quantity'),
						type: 'number',
						error: false,
						filters: {
							type: 'number',
							required: true
						}
					},
					loungesQuantity: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.lounges_quantity'),
						type: 'number',
						error: false,
						filters: {
							type: 'number',
							required: true
						}
					},
					legalName: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.legal_name'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 40,
							required: true
						}
					},
					// dischargeDate : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	fakeValue : '',
					// 	value     : '',
					// 	name      : this.$t('private.clients_records.list.fields.discharge_date'),
					// 	error     : false,
					// 	active    : false,
					// 	filters   : {
					// 		type      : 'date',
					// 		required  : true
					// 	}
					// },
					// status : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	fakeValue : this.$t('private.clients_records.list.fields.status_options.active'),
					// 	value     : true,
					// 	name      : this.$t('private.clients_records.list.fields.status'),
					// 	error     : false,
					// 	active    : false,
					// 	options : [{
					// 		fakeValue : this.$t('private.clients_records.list.fields.status_options.active'),
					// 		value : true
					// 	},{
					// 		fakeValue : this.$t('private.clients_records.list.fields.status_options.inactive'),
					// 		value : false
					// 	}],
					// 	filters : {
					// 		type      : 'boolean',
					// 		required  : true
					// 	}
					// },
					// recruitingLR : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	fakeValue : '',
					// 	value     : '',
					// 	name      : this.$t('private.clients_records.list.fields.recruiting_lr'),
					// 	error     : false,
					// 	active    : false,
					// 	options : [{
					// 		fakeValue : this.$t('private.clients_records.list.fields.recruiting_lr_options.yes'),
					// 		value : true
					// 	},{
					// 		fakeValue : this.$t('private.clients_records.list.fields.recruiting_lr_options.no'),
					// 		value : false
					// 	}],
					// 	filters : {
					// 		type      : 'boolean',
					// 		required  : true
					// 	}
					// },
					mktNews: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.mkt_news'),
						error: false,
						active: false,
						options: [{
							fakeValue: this.$t('private.clients_records.list.fields.mkt_news_options.yes'),
							value: true
						}, {
							fakeValue: this.$t('private.clients_records.list.fields.mkt_news_options.no'),
							value: false
						}],
						filters: {
							type: 'boolean',
							required: true
						}
					}
					// conditions : {
					// 	id        : _.uniqueId('field_'),
					// 	display   : true,
					// 	name      : this.$t('private.clients_records.list.fields.conditions'),
					// 	error     : false,
					// 	value     : {
					// 		imageConditions : false
					// 	},
					// 	options   : {
					// 		imageConditions : {
					// 			name : this.$t('private.clients_records.list.fields.conditions_options.image_conditions')
					// 		}
					// 	},
					// 	filters   : {
					// 		type : 'manyOptions',
					// 		enum : ['imageConditions']
					// 	}
					// }
				},
				active: false
			},
			displayCreateClient: false,
			formUpdate: {
				fields: {
					id: {
						value: '',
						filters: {
							type: 'string',
							required: true
						}
					},
					seller: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.seller'),
						error: false,
						active: false,
						options: [],
						filters: {
							type: 'string',
							required: true
						}
					},
					cfia: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.cfia'),
						type: 'text',
						error: false,
						filters: {
							type: 'string'
						}
					},
					cif: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.cif'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 15,
							required: true
						}
					},
					clientCode: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.client_code'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 8,
							maxLength: 8,
							required: true
						}
					},
					email: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.email'),
						type: 'email',
						error: false,
						filters: {
							type: 'email',
							minLength: 7,
							maxLength: 100
							// required  : true
						}
					},
					employeesQuantity: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.employees_quantity'),
						type: 'number',
						error: false,
						filters: {
							type: 'number'
							// required  : true
						}
					},
					loungesQuantity: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.lounges_quantity'),
						type: 'number',
						error: false,
						filters: {
							type: 'number'
							// required  : true
						}
					},
					legalName: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('private.clients_records.list.fields.legal_name'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 2,
							maxLength: 40,
							required: true
						}
					},
					dischargeDate: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.discharge_date'),
						error: false,
						active: false,
						filters: {
							type: 'date',
							required: true
						}
					},
					status: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.status'),
						error: false,
						active: false,
						options: [{
							fakeValue: this.$t('private.clients_records.list.fields.status_options.active'),
							value: true
						}, {
							fakeValue: this.$t('private.clients_records.list.fields.status_options.inactive'),
							value: false
						}],
						filters: {
							type: 'boolean',
							required: true
						}
					},
					recruitingLR: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.recruiting_lr'),
						error: false,
						active: false,
						options: [{
							fakeValue: this.$t('private.clients_records.list.fields.recruiting_lr_options.yes'),
							value: true
						}, {
							fakeValue: this.$t('private.clients_records.list.fields.recruiting_lr_options.no'),
							value: false
						}],
						filters: {
							type: 'boolean',
							required: true
						}
					},
					mktNews: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						fakeValue: '',
						value: '',
						name: this.$t('private.clients_records.list.fields.mkt_news'),
						error: false,
						active: false,
						options: [{
							fakeValue: this.$t('private.clients_records.list.fields.mkt_news_options.yes'),
							value: true
						}, {
							fakeValue: this.$t('private.clients_records.list.fields.mkt_news_options.no'),
							value: false
						}],
						filters: {
							type: 'boolean',
							required: true
						}
					},
					conditions: {
						id: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniqueId('field_'),
						display: true,
						name: this.$t('private.clients_records.list.fields.conditions'),
						error: false,
						value: {
							imageConditions: false
						},
						options: {
							imageConditions: {
								name: this.$t('private.clients_records.list.fields.conditions_options.image_conditions')
							}
						},
						filters: {
							type: 'manyOptions',
							enum: ['imageConditions']
						}
					}
				},
				active: false
			},
			displayUpdateClient: false,
			displayFoo: false
		};
	},

	methods: {
		rowClicked: function rowClicked(element, value) {

			element.rowSelected = value;

			this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
		},
		getClientsRecords: function getClientsRecords() {

			var vm = this;

			vm.clientsRecords = [];
			vm.getClientsRecordsActive = true;

			var dataToSend = {
				cif: vm.filters.cif.value ? vm.filters.cif.value : '',
				clientCode: vm.filters.clientCode.value ? vm.filters.clientCode.value : '',
				legalName: vm.filters.legalName.value ? vm.filters.legalName.value : '',
				state: vm.filters.state.value ? vm.filters.state.value : '',
				updateClient: vm.filters.updated.value ? vm.filters.updated.value : '',
				ascending: vm.filters.ascending.value ? vm.filters.ascending.value : '',
				descending: vm.filters.descending.value ? vm.filters.descending.value : '',
				limit: vm.filters.limit.value + 1,
				skip: vm.filters.skip.value
			};

			__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clientsRecords.getClientsRecords(dataToSend).then(function (response) {

				vm.getClientsRecordsActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message);

					return;
				}

				vm.clientsRecords = response.data.clientsRecords;

				if (vm.clientsRecords.length > 0 && !vm.haveData) {

					vm.haveData = true;
				}

				if (vm.clientsRecords.length > vm.filters.limit.value) {

					vm.nextPage = true;

					vm.clientsRecords.pop();
				} else {

					vm.nextPage = false;
				}

				__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.each(vm.clientsRecords, function (x) {

					if (x.pdf) {

						var uri_org = new __WEBPACK_IMPORTED_MODULE_3_urijs___default.a(x.pdf.url),
						    pathname = uri_org.pathname();

						x.pdf.url = __WEBPACK_IMPORTED_MODULE_4__config_env___default.a.api.baseUrl + pathname;
					}
				});
			});
		},
		goToBackPage: function goToBackPage() {

			var vm = this;

			if (vm.filters.skip.value != 0) {

				vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

				vm.getClientsRecords();
			}
		},
		goToNextPage: function goToNextPage() {

			var vm = this;

			if (vm.nextPage) {

				vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

				vm.getClientsRecords();
			}
		},
		optionSelected: function optionSelected(data) {

			var vm = this;

			if (data.action == 'approve') {

				vm.approveClientsRecordsWindow.clientRecord = data.element;
				vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = '';

				vm.approveClientsRecordsWindow.display = true;
			} else if (data.action == 'disapprove') {

				vm.disapproveSubmit(data.element);
			}
		},
		formApproveSubmit: function formApproveSubmit() {

			var vm = this;

			if (vm.approveClientsRecordsWindow.formApprove.active) {

				return;
			}

			vm.approveClientsRecordsWindow.formApprove.active = true;

			vm.$root.$emit('validate', [vm.approveClientsRecordsWindow.formApprove.fields, function (response) {

				if (!response.success) {

					vm.approveClientsRecordsWindow.formApprove.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_6__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				// let dataToSend = {
				// 	clientRecordId : vm.approveClientsRecordsWindow.clientRecord.objectId,
				// 	clientCode     : vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
				// }

				var dataToSend = '?clientCode=' + vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value;
				__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {

					if (response.status != 200) {

						var message = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', message);

						return;
					}

					if (!response.data.success) {

						vm.approveClientsRecordsWindow.formApprove.active = false;

						// if( response.data.error.code == '016' ){
						//
						// 	vm.formUpdate.fields.clientCode.error = true
						//
						// 	let message = {
						// 		message : [vm.$t('errors.custom.016')],
						// 		type    : 'error'
						// 	}
						//
						// 	vm.$root.$emit('showMessage', message)
						//
						// 	return
						//
						// }

						var _message2 = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', _message2);

						return;
					}

					if (response.data.client) {

						var client = response.data.client;

						vm.formUpdate.fields.id.value = client.id ? client.id : '';
						vm.formUpdate.fields.seller.fakeValue = client.seller ? client.seller.fullname + ' ( ' + client.seller.username + ' )' : '';
						vm.formUpdate.fields.seller.value = client.seller ? client.seller.objectId : '';
						vm.formUpdate.fields.cfia.value = client.cfia ? client.cfia : '';
						vm.formUpdate.fields.cif.value = client.cif ? client.cif : '';
						vm.formUpdate.fields.clientCode.value = client.clientCode ? client.clientCode : '';
						vm.formUpdate.fields.email.value = client.email ? client.email : '';
						vm.formUpdate.fields.employeesQuantity.value = client.employeesQuantity ? client.employeesQuantity : 0;
						vm.formUpdate.fields.loungesQuantity.value = client.loungesQuantity ? client.loungesQuantity : 0;
						vm.formUpdate.fields.legalName.value = client.legalName ? client.legalName : '';
						vm.formUpdate.fields.dischargeDate.fakeValue = client.dischargeDate ? __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(client.dischargeDate.iso).format('DD-MM-YYYY') : '';
						vm.formUpdate.fields.dischargeDate.value = client.dischargeDate ? client.dischargeDate.iso : '';
						vm.formUpdate.fields.status.fakeValue = client.status ? vm.$t('private.clients_records.list.fields.status_options.active') : vm.$t('private.clients_records.list.fields.status_options.inactive');
						vm.formUpdate.fields.status.value = client.status ? true : false;
						vm.formUpdate.fields.recruitingLR.fakeValue = client.recruitingLR ? vm.$t('private.clients_records.list.fields.recruiting_lr_options.yes') : vm.$t('private.clients_records.list.fields.recruiting_lr_options.no');
						vm.formUpdate.fields.recruitingLR.value = client.recruitingLR ? true : false;
						vm.formUpdate.fields.mktNews.fakeValue = client.mktNews ? vm.$t('private.clients_records.list.fields.mkt_news_options.yes') : vm.$t('private.clients_records.list.fields.mkt_news_options.no');
						vm.formUpdate.fields.mktNews.value = client.mktNews ? true : false;
						vm.formUpdate.fields.conditions.value.imageConditions = client.imageConditions ? true : false;

						vm.displayUpdateClient = true;
					} else {

						vm.formCreate.fields.cfia.value = vm.approveClientsRecordsWindow.clientRecord.cfia;
						vm.formCreate.fields.cif.value = vm.approveClientsRecordsWindow.clientRecord.nif;
						vm.formCreate.fields.clientCode.value = vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value;
						vm.formCreate.fields.email.value = vm.approveClientsRecordsWindow.clientRecord.email;
						vm.formCreate.fields.employeesQuantity.value = vm.approveClientsRecordsWindow.clientRecord.employeesQuantity;
						vm.formCreate.fields.loungesQuantity.value = vm.approveClientsRecordsWindow.clientRecord.loungesQuantity;
						vm.formCreate.fields.legalName.value = vm.approveClientsRecordsWindow.clientRecord.legalName;
						vm.formCreate.fields.mktNews.fakeValue = vm.approveClientsRecordsWindow.clientRecord.mktNews ? vm.$t('private.clients_records.list.fields.mkt_news_options.yes') : vm.$t('private.clients_records.list.fields.mkt_news_options.no');
						vm.formCreate.fields.mktNews.value = vm.approveClientsRecordsWindow.clientRecord.mktNews ? true : false;

						vm.displayCreateClient = true;
					}

					vm.approveClientsRecordsWindow.formApprove.active = false;
				});
			}]);
		},
		searchSellers: function searchSellers(data) {

			var vm = this;

			vm.getSellersActive = true;

			var dataToSend = '?descending=createdAt&fullname=' + data;

			__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].sellers.getSellers(dataToSend).then(function (response) {

				vm.getSellersActive = false;

				if (response.status != 200) {

					var message = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', message);

					return;
				}

				if (!response.data.success) {

					var _message3 = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message3);

					return;
				}

				var sellers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(response.data.sellers, 'username');

				sellers = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(sellers, function (seller) {

					return {
						fakeValue: seller.fullname + ' ( ' + seller.username + ' )',
						value: seller.id
					};
				});

				vm.formCreate.fields.seller.options = sellers;
				vm.formUpdate.fields.seller.options = sellers;
			});
		},
		sellerSelected: function sellerSelected(data) {

			var vm = this;

			vm.formCreate.fields.seller.value = data;
			vm.formUpdate.fields.seller.value = data;
		},
		formUpdateSubmit: function formUpdateSubmit() {

			var vm = this;

			if (vm.formUpdate.active) {

				return;
			}

			vm.formUpdate.active = true;

			vm.$root.$emit('validate', [vm.formUpdate.fields, function (response) {

				if (!response.success) {

					vm.formUpdate.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_6__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				var dataToSend = {
					id: vm.formUpdate.fields.id.value,
					seller: vm.formUpdate.fields.seller.value,
					cfia: vm.formUpdate.fields.cfia.value,
					cif: vm.formUpdate.fields.cif.value,
					clientCode: vm.formUpdate.fields.clientCode.value,
					email: vm.formUpdate.fields.email.value,
					employeesQuantity: vm.formUpdate.fields.employeesQuantity.value,
					loungesQuantity: vm.formUpdate.fields.loungesQuantity.value,
					legalName: vm.formUpdate.fields.legalName.value,
					dischargeDate: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(vm.formUpdate.fields.dischargeDate.value).endOf('day').toDate(),
					status: vm.formUpdate.fields.status.value,
					recruitingLR: vm.formUpdate.fields.recruitingLR.value,
					mktNews: vm.formUpdate.fields.mktNews.value,
					imageConditions: vm.formUpdate.fields.conditions.value.imageConditions
				};

				__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clients.updateClient(dataToSend).then(function (response) {

					if (response.status != 200) {

						var message = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', message);

						return;
					}

					if (!response.data.success) {

						if (response.data.error.code == '002') {

							vm.formUpdate.fields.clientCode.error = true;

							var _message4 = {
								message: [vm.$t('errors.custom.002')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message4);
						}

						if (response.data.error.code == '007') {

							vm.formUpdate.fields.cif.error = true;

							var _message5 = {
								message: [vm.$t('errors.custom.007')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message5);
						}

						return;
					}

					var dataToSend = {
						clientRecordId: vm.approveClientsRecordsWindow.clientRecord.objectId,
						clientCode: vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
					};

					__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clientsRecords.approveClientsRecords(dataToSend).then(function (response) {

						vm.formUpdate.active = false;

						vm.approveClientsRecordsWindow.formApprove.active = false;

						if (response.status != 200) {

							var _message6 = {
								message: [vm.$t('errors.custom.001')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message6);

							return;
						}

						if (!response.data.success) {

							if (response.data.error.code == '002') {

								vm.approveClientsRecordsWindow.formApprove.fields.clientCode.error = true;

								var _message7 = {
									message: [vm.$t('errors.custom.002')],
									type: 'error'
								};

								vm.$root.$emit('showMessage', _message7);
							}

							return;
						}

						var message = {
							message: [vm.$t('private.clients_records.list.approve_client_record_success')],
							type: 'success'
						};

						vm.$root.$emit('showMessage', message);

						vm.getClientsRecords();

						vm.approveClientsRecordsWindow.display = false;

						vm.approveClientsRecordsWindow.clientRecord = {};
						vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = '';

						vm.displayUpdateClient = false;

						vm.formUpdate.fields.id.value = '';
						vm.formUpdate.fields.seller.value = '';
						vm.formUpdate.fields.cfia.value = '';
						vm.formUpdate.fields.cif.value = '';
						vm.formUpdate.fields.clientCode.value = '';
						vm.formUpdate.fields.email.value = '';
						vm.formUpdate.fields.employeesQuantity.value = '';
						vm.formUpdate.fields.loungesQuantity.value = '';
						vm.formUpdate.fields.legalName.value = '';
						vm.formUpdate.fields.dischargeDate.value = '';
						vm.formUpdate.fields.status.value = '';
						vm.formUpdate.fields.recruitingLR.value = '';
						vm.formUpdate.fields.mktNews.value = '';
						vm.formUpdate.fields.conditions.value.imageConditions = false;
					});
				});
			}]);
		},
		formCreateSubmit: function formCreateSubmit() {

			var vm = this;

			if (vm.formCreate.active) {

				return;
			}

			vm.formCreate.active = true;

			vm.$root.$emit('validate', [vm.formCreate.fields, function (response) {

				if (!response.success) {

					vm.formCreate.active = false;

					response.type = 'error';

					response.field.error = true;

					var dataToScroll = {
						selector: '#' + response.field.id,
						target: 'html, body'
					};

					__WEBPACK_IMPORTED_MODULE_6__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

					vm.$root.$emit('showMessage', response);

					return;
				}

				var dataToSend = {
					seller: vm.formCreate.fields.seller.value,
					cfia: vm.formCreate.fields.cfia.value,
					cif: vm.formCreate.fields.cif.value,
					clientCode: vm.formCreate.fields.clientCode.value,
					legalName: vm.formCreate.fields.legalName.value,
					dischargeDate: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()().toDate(),
					email: vm.formCreate.fields.email.value,
					employeesQuantity: vm.formCreate.fields.employeesQuantity.value,
					loungesQuantity: vm.formCreate.fields.loungesQuantity.value,
					// dischargeDate     : moment(vm.formCreate.fields.dischargeDate.value).endOf('').toDate(),
					// status            : vm.formCreate.fields.status.value,
					// recruitingLR      : vm.formCreate.fields.recruitingLR.value,
					mktNews: vm.formCreate.fields.mktNews.value
					// imageConditions   : vm.formCreate.fields.conditions.value.imageConditions
				};

				__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clients.createClient(dataToSend).then(function (response) {

					if (response.status != 200) {

						var message = {
							message: [vm.$t('errors.custom.001')],
							type: 'error'
						};

						vm.$root.$emit('showMessage', message);

						return;
					}

					if (!response.data.success) {

						if (response.data.error.code == '002') {

							vm.formCreate.fields.clientCode.error = true;

							var _message8 = {
								message: [vm.$t('errors.custom.002')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message8);
						}

						if (response.data.error.code == '007') {

							vm.formCreate.fields.cif.error = true;

							var _message9 = {
								message: [vm.$t('errors.custom.007')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message9);
						}

						return;
					}

					var dataToSend = {
						clientRecordId: vm.approveClientsRecordsWindow.clientRecord.objectId,
						clientCode: vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value
					};

					__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clientsRecords.approveClientsRecords(dataToSend).then(function (response) {

						vm.formCreate.active = false;

						vm.approveClientsRecordsWindow.formApprove.active = false;

						if (response.status != 200) {

							var _message10 = {
								message: [vm.$t('errors.custom.001')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message10);

							return;
						}

						if (!response.data.success) {

							if (response.data.error.code == '002') {

								vm.approveClientsRecordsWindow.formApprove.fields.clientCode.error = true;

								var _message11 = {
									message: [vm.$t('errors.custom.002')],
									type: 'error'
								};

								vm.$root.$emit('showMessage', _message11);
							}

							return;
						}

						var message = {
							message: [vm.$t('private.clients_records.list.approve_client_record_success')],
							type: 'success'
						};

						vm.$root.$emit('showMessage', message);

						vm.getClientsRecords();

						vm.approveClientsRecordsWindow.display = false;

						vm.approveClientsRecordsWindow.clientRecord = {};
						vm.approveClientsRecordsWindow.formApprove.fields.clientCode.value = '';

						vm.displayCreateClient = false;

						vm.formCreate.fields.seller.value = '';
						vm.formCreate.fields.cif.value = '';
						vm.formCreate.fields.clientCode.value = '';
						vm.formCreate.fields.legalName.value = '';
						// vm.formCreate.fields.dischargeDate.value              = ''
						// vm.formCreate.fields.email.value                      = ''
						// vm.formCreate.fields.employeesQuantity.value          = ''
						// vm.formCreate.fields.loungesQuantity.value            = ''
						// vm.formCreate.fields.dischargeDate.value              = ''
						// vm.formCreate.fields.status.value                     = ''
						// vm.formCreate.fields.recruitingLR.value               = ''
						vm.formCreate.fields.mktNews.value = '';
						// vm.formCreate.fields.conditions.value.imageConditions = false
					});
				});
			}]);
		},
		disapproveSubmit: function disapproveSubmit(element) {

			var vm = this;

			var questionModal = {
				title: this.$t('private.clients_records.list.question_modal.title'),
				question: this.$t('private.clients_records.list.question_modal.question')
			};

			vm.$root.$emit('question-modal', [questionModal, function (response) {

				if (response) {

					var dataToSend = {
						id: element.objectId
					};

					__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clientsRecords.disapproveClientsRecords(dataToSend).then(function (response) {

						if (response.status != 200) {

							var _message12 = {
								message: [vm.$t('errors.custom.001')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message12);

							return;
						}

						if (!response.data.success) {

							if (response.data.error.code == 101) {

								var _message13 = {
									message: [vm.$t('errors.parse.101')],
									type: 'error'
								};

								vm.$root.$emit('showMessage', _message13);
							}

							return;
						}

						var message = {
							message: [vm.$t('private.clients_records.list.disapprove_success')],
							type: 'success'
						};

						vm.$root.$emit('showMessage', message);

						vm.getClientsRecords();
					});
				}
			}]);
		},
		exportClientsRecords: function exportClientsRecords() {

			var vm = this;

			var dataToSend = {
				timeZone: __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default.a.tz.guess()
			};

			if (vm.exportClientsRecordsActive) {

				var message = {
					message: [vm.$t('private.clients_records.list.please_wait')],
					type: 'error'
				};

				vm.$root.$emit('showMessage', message);

				return;
			}

			vm.exportClientsRecordsActive = true;

			__WEBPACK_IMPORTED_MODULE_5__api_api__["a" /* default */].clientsRecords.exportClientsRecords(dataToSend).then(function (response) {

				vm.exportClientsRecordsActive = false;

				if (response.status != 200) {

					var _message14 = {
						message: [vm.$t('errors.custom.001')],
						type: 'error'
					};

					vm.$root.$emit('showMessage', _message14);

					return;
				}

				var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
				var fileURL = URL.createObjectURL(file);

				__WEBPACK_IMPORTED_MODULE_1_file_saver___default.a.saveAs(file, 'clients_records.xlsx');
			});
		},
		parseDate: function parseDate(date) {

			return __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default()(date).format('DD-MM-YYYY');
		}
	},
	components: {
		MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_7__components_general_menu_more_options_menu_more_options__["a" /* default */],
		TextField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_text_text__["a" /* default */],
		SelectField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_select_select__["a" /* default */],
		SearchField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_search_search__["a" /* default */],
		CheckboxField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_checkbox_checkbox__["a" /* default */],
		FileField: __WEBPACK_IMPORTED_MODULE_12__components_general_fields_file_file__["a" /* default */],
		DateField: __WEBPACK_IMPORTED_MODULE_13__components_general_fields_date_date__["a" /* default */]
	},
	created: function created() {

		var vm = this;

		vm.getClientsRecords();

		vm.searchSellers('');
	}
});

/***/ }),

/***/ "gDXb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("9+XV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f96d57a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("Ny1O");
function injectStyle (ssrContext) {
  __webpack_require__("vEfO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f96d57a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f96d57a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gKkB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{style:(_vm.data.style),attrs:{"id":_vm.data.id}},[(_vm.data.name)?_c('div',{staticClass:"check-list-title"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),(!_vm.data.inline)?_c('ul',{staticClass:"check-list"},_vm._l((_vm.data.options),function(element,key){return _c('li',{staticClass:"checkbox-container"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox","disabled":element.disabled},domProps:{"checked":_vm.fields[key]},on:{"click":function($event){_vm.fields[key] ? _vm.fields[key] = false : _vm.fields[key] = true},"change":function($event){_vm.changeData()}}}),_c('span',{staticStyle:{"font-size":"0px"}},[_vm._v(_vm._s(_vm.foo))]),(element.name)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(element.name))]):_vm._e()])})):_vm._e(),(_vm.data.inline)?_c('div',_vm._l((_vm.data.options),function(element,key){return _c('div',{staticClass:"check-list-inline"},[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox","disabled":element.disabled},domProps:{"checked":_vm.fields[key]},on:{"click":function($event){_vm.fields[key] ? _vm.fields[key] = false : _vm.fields[key] = true},"change":function($event){_vm.changeData()}}}),(element.name)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(element.name))]):_vm._e()])})):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gMwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'input-check',
	props: ['data'],
	data: function data() {
		return {
			field: {
				value: this.data.value
			}
		};
	},

	methods: {
		changeData: function changeData() {

			var vm = this;

			vm.$emit('changeData', vm.field.value);
		}
	}
});

/***/ }),

/***/ "gWmG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("fzU0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e1ab9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("VSAm");
function injectStyle (ssrContext) {
  __webpack_require__("i+22")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64e1ab9f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64e1ab9f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gwm3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("IjAR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4e245b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("gwnn");
function injectStyle (ssrContext) {
  __webpack_require__("kjBa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a4e245b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a4e245b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gwnn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in private-container-view"},[_c('div',{staticClass:"header-sections"},[_c('ul',{staticClass:"items-container"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.historyContracts.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.contracts.header.contracts_history")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name === _vm.routes.historyContracts.name}})])]),_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.historyContractsSDA.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.contracts.header.contracts_sda")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name === _vm.routes.historyContractsSDA.name}})])])],1)]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hOMo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("6mGs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2634522a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("Xg7a");
function injectStyle (ssrContext) {
  __webpack_require__("ULeU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2634522a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2634522a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i+22":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i+3Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',[(_vm.data.title)?_c('div',{staticClass:"field-container-title"},[_vm._v(_vm._s(_vm.data.title))]):_vm._e(),_c('div',{staticClass:"field-container",style:(_vm.data.style)},[(_vm.field.value != '')?_c('div',{staticClass:"field-title fade-in"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.value),expression:"field.value"}],staticClass:"textarea-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"id":_vm.data.id,"placeholder":_vm.data.name,"maxlength":_vm.data.filters.maxLength,"disabled":_vm.data.disabled},domProps:{"value":(_vm.field.value)},on:{"click":function($event){_vm.data.error = false},"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "value", $event.target.value)},_vm.changeData]}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i7XN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"export-data",on:{"click":function($event){_vm.exportData()}}},[(!_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.potential.export_data")))]):_vm._e(),(_vm.exportDataActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.potential.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.reports.potential.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.getContracts(); _vm.filters.skip.value = 0;}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.contracts.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.contracts.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.contracts),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])])])})),_c('div',{staticClass:"table-container hidden-xs"},[_c('hr'),_c('div',{staticClass:"row filters-container"},[_c('div',{staticClass:"col-md-3"},[_c('select-field',{attrs:{"data":_vm.groupings},on:{"changeData":function($event){_vm.groupings.value = $event; _vm.activateGroupings(); _vm.filters.skip.value = 0;}}})],1)]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[(_vm.groupings.value!=1)?_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.client")))]):_vm._e(),(_vm.groupings.value!=2)?_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.legal_name")))]):_vm._e(),(_vm.groupings.value!=3)?_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.seller")))]):_vm._e(),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.employees_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.wella_potential")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.nioxin_potential")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.sp_potential")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.sassoon_potential")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.sebastian_potential")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.sp_diamond_potential")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.table.opi_potential")))])])]),(!_vm.groupingsActive)?_c('tbody',_vm._l((_vm.contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.client.employeesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaPotential))]),_c('td',[_vm._v(_vm._s(contract.nioxinPotential))]),_c('td',[_vm._v(_vm._s(contract.spPotential))]),_c('td',[_vm._v(_vm._s(contract.sassoonPotential))]),_c('td',[_vm._v(_vm._s(contract.sebastianPotential))]),_c('td',[_vm._v(_vm._s(contract.spDiamondPotential))]),_c('td',[_vm._v(_vm._s(contract.opiPotential))])])})):_vm._e(),_vm._l((_vm.contractsGroupsByCodeClient),function(contracts,index){return (_vm.groupingsActive && _vm.groupings.value==1)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"12"}},[_c('strong',[_vm._v(_vm._s(contracts[0].client ? 'Código cliente: ' + contracts[0].client.clientCode : ''))])])]),_vm._l((contracts),function(contract,index){return _c('tr',[(false)?_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]):_vm._e(),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.client.employeesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaPotential))]),_c('td',[_vm._v(_vm._s(contract.nioxinPotential))]),_c('td',[_vm._v(_vm._s(contract.spPotential))]),_c('td',[_vm._v(_vm._s(contract.sassoonPotential))]),_c('td',[_vm._v(_vm._s(contract.sebastianPotential))]),_c('td',[_vm._v(_vm._s(contract.spDiamondPotential))]),_c('td',[_vm._v(_vm._s(contract.opiPotential)+"\t")])])}),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s('Total Código cliente ' + contracts[0].client.clientCode + ': ' + contracts.length))])]),_c('td',{attrs:{"colspan":"10"}})])],2):_vm._e()}),_vm._l((_vm.contractsGroupsByLegalName),function(contracts,index){return (_vm.groupingsActive && _vm.groupings.value==2)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"12"}},[_c('strong',[_vm._v(_vm._s(contracts[0].client ? 'Razón social: ' + contracts[0].client.legalName : ''))])])]),_vm._l((contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),(false)?_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]):_vm._e(),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.client.employeesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaPotential))]),_c('td',[_vm._v(_vm._s(contract.nioxinPotential))]),_c('td',[_vm._v(_vm._s(contract.spPotential))]),_c('td',[_vm._v(_vm._s(contract.sassoonPotential))]),_c('td',[_vm._v(_vm._s(contract.sebastianPotential))]),_c('td',[_vm._v(_vm._s(contract.spDiamondPotential))]),_c('td',[_vm._v(_vm._s(contract.opiPotential)+"\t")])])}),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s('Total razón social ' + contracts[0].client.legalName + ': ' + contracts.length))])]),_c('td',{attrs:{"colspan":"10"}})])],2):_vm._e()}),_vm._l((_vm.contractsGroupsBySeller),function(contracts,index){return (_vm.groupingsActive && _vm.groupings.value==3)?_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"12"}},[_c('strong',[_vm._v(_vm._s(contracts[0].client ? 'Vendedor: '+ contracts[0].seller.username : ''))])])]),_vm._l((contracts),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),(false)?_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]):_vm._e(),_c('td',[_vm._v(_vm._s(contract.seller ? contract.client.employeesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaPotential))]),_c('td',[_vm._v(_vm._s(contract.nioxinPotential))]),_c('td',[_vm._v(_vm._s(contract.spPotential))]),_c('td',[_vm._v(_vm._s(contract.sassoonPotential))]),_c('td',[_vm._v(_vm._s(contract.sebastianPotential))]),_c('td',[_vm._v(_vm._s(contract.spDiamondPotential))]),_c('td',[_vm._v(_vm._s(contract.opiPotential)+"\t")])])}),_c('tr',[_c('td',{staticClass:"text-right",attrs:{"colspan":"5"}},[_c('strong',[_vm._v(_vm._s('Total vendedor ' + contracts[0].seller.username + ': ' + contracts.length)+"\t")])]),_c('td',{attrs:{"colspan":"10"}})])],2):_vm._e()})],2)])]):_vm._e(),(_vm.contracts.length == 0 && !_vm.getContractsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.reports.potential.no_results")))]):_vm._e(),(_vm.getContractsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8CV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _table, _table2, _table3;

/* harmony default export */ __webpack_exports__["a"] = ({
  'data_validator': {
    'required': 'El campo %name% no puede estar vacío',
    'min_length': 'El campo %name% debe tener como mínimo de caracteres %length%',
    'max_length': 'El campo %name% puede tener como máximo de caracteres %length%',
    'type': 'El campo %name% posee un formato incorrecto',
    'invalid_option': 'La opción seleccionada en el campo %name% es inválida',
    'numeric': {
      'smaller_than': 'El campo %name% debe ser menor a %number%',
      'greather_than': 'El campo %name% debe ser mayor a %number%'
    },
    'date': {
      'smaller_than': 'La fecha del campo %name% debe ser menor a la fecha de cierre',
      'greather_than': 'La fecha del campo %name% debe ser mayor a la fecha de inicio'
    },
    'file': {
      'format': 'El archivo que está tratando de subir posee un formato incorrecto (formatos permitidos %formats%)',
      'size': 'El archivo que está tratando de subir es muy pesado (peso máximo de %size% mb)'
    }
  },
  'calendar': {
    'month_names': {
      'january': 'ENE',
      'february': 'FEB',
      'march': 'MAR',
      'april': 'ABR',
      'may': 'MAY',
      'june': 'JUN',
      'july': 'JUL',
      'august': 'AGO',
      'september': 'SEP',
      'october': 'OCT',
      'november': 'NOV',
      'december': 'DIC'
    },
    'day_names_short': {
      'sunday': 'D',
      'monday': 'L',
      'tuesday': 'M',
      'wednesday': 'M',
      'thursday': 'J',
      'friday': 'V',
      'saturday': 'S'
    }
  },
  'errors': {
    'parse': {
      '101': 'El usuario o contraseña son incorrectos'
    },
    'custom': {
      '001': 'Ha ocurrido un error al enviar la petición, por favor te pedimos que intentes más tarde',
      '002': 'El código del cliente pertenece a otro cliente, porfavor ingresa otro código',
      '003': 'El usuario del vendedor no existe',
      '004': 'El campo del usuario del vendedor está vacío',
      '005': 'El campo del código del cliente está vacío',
      '006': 'Usted no posee los permisos suficientes para acceder',
      '007': 'El cif del cliente pertenece a otro cliente, porfavor ingresa otro cif'
    }
  },
  'views_names': {
    'public': {
      'login': 'Iniciar Sesión'
    },
    'private': {
      'sellers': {
        'list': 'Vendedores',
        'create': 'Vendedores',
        'delegations': 'Vendedores',
        'types': 'Vendedores'
      },
      'clients': {
        'list': 'Clientes'
      },
      'contracts': {
        'list': 'Contratos',
        'sda': 'Contratos'
      },
      'reports': {
        'master_data': 'Reportes',
        'sda': 'Reportes',
        'potential': 'Reportes',
        'cci': 'Reportes',
        'education': 'Reportes'
      }
    }
  },
  'public': {
    'login': {
      'title': 'Iniciar Sesión | Wella',
      'fields': {
        'username': 'usuario',
        'password': 'contraseña'
      },
      'login_button': 'Iniciar Sesión'
    }
  },
  'private': {
    'header': {
      'options': 'Opciones'
    },
    'aside': {
      'sellers': 'Vendedores',
      'clients': 'Clientes',
      'contracts': 'Contratos',
      'reports': 'Reportes',
      'logout': 'Salir'
    },
    'sellers': {
      'header': {
        'sellers_list': 'Listado',
        'sellers_delegations': 'Delegaciones',
        'sellers_types': 'Tipos'
      },
      'list': {
        'sellers_list': 'Listado de vendedores',
        'create_seller': 'Crear vendedor',
        'see_filters': 'Ver filtros',
        'export_users': 'Exportar vendedores',
        'please_wait': 'Por favor espera un momento',
        'filters': {
          'fullname': 'Nombre o apellido',
          'username': 'Nombre de usuario',
          'email': 'Correo electrónico',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'firstname': 'Nombres',
            'lastname': 'Apellidos'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'firstname': 'Nombres',
          'lastname': 'Apellidos',
          'username': 'Usuario',
          'email': 'Correo electrónico',
          'delegation': 'Delegación',
          'type': 'Tipo',
          'active': 'Activo',
          'active_yes': 'Si',
          'active_no': 'No',
          'last_access': 'Último acceso'
        },
        'menu_more_options': {
          'edit_seller': 'Editar vendedor',
          'delete_seller': 'Eliminar vendedor'
        },
        'sellers_list_create': 'Crear vendedor',
        'fields': {
          'firstname': 'nombres',
          'lastname': 'apellidos',
          'username': 'usuario',
          'email': 'correo electrónico',
          'password': 'contraseña',
          'delegation': 'Delegación',
          'seller_type': 'Tipo de vendendor',
          'active': 'Activo',
          'active_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'permissions': 'Permisos',
          'permissions_options': {
            'sellers': 'Vendedores',
            'clients': 'Clientes',
            'contracts': 'Contratos',
            'messages': 'Mensajes',
            'reports': 'Reportes',
            'master_data': '¿Es master data?'
          }
        },
        'create_button': 'Crear vendedor',
        'create_success': 'Vendedor creado con éxito',
        'sellers_update': 'Editar vendedor',
        'update_button': 'Editar vendedor',
        'update_success': 'Vendedor editado con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar este vendedor?'
        },
        'delete_success': 'Vendedor eliminado con éxito'
      },
      'delegations': {
        'sellers_delegations': 'Listado de delegaciones',
        'create_delegation': 'Crear delegación',
        'see_filters': 'Ver filtros',
        'filters': {
          'name': 'Nombre',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'name': 'Nombre'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'menu_more_options': {
          'edit_delegation': 'Editar delegación',
          'delete_delegation': 'Eliminar delegación'
        },
        'sellers_delegations_create': 'Crear delegación',
        'fields': {
          'name': 'nombre'
        },
        'create_button': 'Crear delegación',
        'create_success': 'Delegación creada con éxito',
        'sellers_delegations_update': 'Editar delegación',
        'update_button': 'Editar delegación',
        'update_success': 'Delegación editada con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar esta delegación?'
        },
        'delete_success': 'Delegación eliminada con éxito'
      },
      'sellers_types': {
        'sellers_types': 'Listado de tipos de vendedores',
        'create_seller_type': 'Crear tipo',
        'see_filters': 'Ver filtros',
        'filters': {
          'name': 'Nombre',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'name': 'Nombre'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'menu_more_options': {
          'edit_seller_type': 'Editar tipo',
          'delete_seller_type': 'Eliminar tipo'
        },
        'sellers_types_create': 'Crear tipo',
        'fields': {
          'name': 'nombre'
        },
        'create_button': 'Crear tipo',
        'create_success': 'Tipo de vendedor creado con éxito',
        'sellers_types_update': 'Editar tipo',
        'update_button': 'Editar tipo',
        'update_success': 'Tipo de vendedor editado con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar este tipo de vendedor?'
        },
        'delete_success': 'Tipo de vendedor eliminado con éxito'
      }
    },
    'clients': {
      'header': {
        'clients_list': 'Listado'
      },
      'list': {
        'clients_list': 'Listado de clientes',
        'create_client': 'Crear cliente',
        'import_clients': 'Importar clientes',
        'export_clients': 'Exportar clientes',
        'migrate_clients': 'Importar Migración',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'cif': 'CIF',
          'client_code': 'Código cliente',
          'email': 'Correo electrónico',
          'employees_quantity': 'Número de empleados',
          'lounges_quantity': 'Número de salones',
          'legal_name': 'Razón social',
          'discharge_date': 'Fecha alta',
          'status': 'Estado',
          'recruiting_lr': 'Contratación LR',
          'mkt_news': 'Novedades MKT',
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación',
            'cif': 'CIF',
            'client_code': 'Código cliente',
            'email': 'Correo electrónico',
            'employees': 'Empleados',
            'lounge': 'Salón',
            'legal_name': 'Razón social',
            'discharge_date': 'Fecha alta',
            'status': 'Estado',
            'recruiting_lr': 'Contratación LR',
            'mkt_news': 'Novedades MKT'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'associated_accounts': 'Cuentas asociadas',
          'seller': 'Vendedor',
          'cfia': 'CFIA',
          'cif': 'CIF',
          'client_code': 'Código cliente',
          'delegation': 'Delegación',
          'email': 'Correo electrónico',
          'employees_quantity': 'Número de empleados',
          'lounges_quantity': 'Número de salones',
          'legal_name': 'Razón social',
          'discharge_date': 'Fecha alta',
          'status': 'Estado',
          'status_active': 'Activo',
          'status_inactive': 'Inactivo',
          'recruiting_lr': 'Contratación LR',
          'recruiting_lr_yes': 'Si',
          'recruiting_lr_no': 'No',
          'mkt_news': 'Novedades MKT',
          'mkt_news_yes': 'Si',
          'mkt_news_no': 'No',
          'image_conditions': 'Condiciones imagen',
          'image_conditions_yes': 'Si',
          'image_conditions_no': 'No'
        },
        'not_have_associated_accounts': 'Este cliente no posee cuentas asociadas',
        'menu_more_options': {
          'associate_account': 'Asociar cuenta',
          'see_associated_accounts': 'Listar cuentas asociadas',
          'edit_client': 'Editar cliente',
          'delete_client': 'Eliminar cliente'
        },
        'associate_account_modal': {
          'title': 'Asociar cuenta',
          'fields': {
            'client': 'buscar cliente',
            'legal_name': 'razón social',
            'cif': 'CIF',
            'email': 'correo electrónico'
          },
          'button': 'Asociar cuenta',
          'success': 'Cuenta asociada con éxito'
        },
        'associated_accounts_modal': {
          'title': 'Cuentas asociadas',
          'menu_more_options': {
            'delete_association': 'Eliminar asociación'
          },
          'question_modal': {
            'title': 'Advertencia',
            'question': '¿Está seguro que desea eliminar esta asociación?'
          },
          'delete_success': 'Asociación eliminada con éxito'
        },
        'import_clients_modal': {
          'title': 'Importar clientes por CSV',
          'import_clients': 'Importar clientes',
          'fields': {
            'separator': 'Separador',
            'separator_options': {
              'coma': ',',
              'semicolon': ';',
              'pipe': '|'
            },
            'csv': 'Cargar documento CSV'
          },
          'please_wait': 'Porfavor espera un momento',
          'clients_to_update': 'Clientes a modificar',
          'clients_to_create': 'Clientes a agregar',
          'clients_with_error': 'Clientes con errores',
          'no_clients_to_update': 'No hay clientes a modificar',
          'no_clients_to_create': 'No hay clientes a agregar',
          'no_clients_with_error': 'No hay clientes con errores',
          'table': {
            'seller': 'Vendedor',
            'client_code': 'Código del cliente',
            'legal_name': 'Razón social',
            'cif': 'CIF',
            'observation': 'Observación'
          },
          'no_data_to_import': 'Debes escoger al menos algún cliente para modificar o agregar',
          'import_success': 'Clientes importados con éxito'
        },
        'clients_list_create': 'Crear cliente',
        'fields': {
          'seller': 'vendedor',
          'cfia': 'CFIA',
          'cif': 'CIF',
          'client_code': 'código cliente',
          'email': 'correo electrónico',
          'employees_quantity': 'número de empleados',
          'lounges_quantity': 'número de salones',
          'legal_name': 'razón social',
          'receive_communications': 'Recibir comunicaciones',
          'receive_communications_options': {
            'receive_communications': 'Recibir comunicaciones'
          },
          'discharge_date': 'fecha alta',
          'status': 'estado',
          'status_options': {
            'active': 'Activo',
            'inactive': 'Inactivo'
          },
          'recruiting_lr': 'contratación LR',
          'recruiting_lr_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'mkt_news': 'novedades MKT',
          'mkt_news_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'conditions': 'Condiciones',
          'conditions_options': {
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          }
        },
        'create_button': 'Crear cliente',
        'create_success': 'Cliente creado con éxito',
        'clients_update': 'Editar cliente',
        'update_button': 'Editar cliente',
        'update_success': 'Cliente editado con éxito',
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea eliminar este cliente?'
        },
        'delete_success': 'Cliente eliminado con éxito'
      }
    },
    'contracts': {
      'header': {
        'contracts_list': 'Contratos',
        'contracts_sda': 'SDA'
      },
      'list': {
        'contracts_list': 'Listado de contratos',
        'create_contract': 'Crear contrato',
        'export_contracts': 'Exportar contratos',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'since': 'Desde',
          'until': 'Hasta',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'client_code': 'Código del cliente',
          'legal_name': 'Razón social'
        },
        'no_results': 'No se encontraron resultados',
        'table': (_table = {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'No OK',
            'pendiente_ok': 'Pendiente',
            'archive': 'Archivado',
            'retenido_asociado': 'Retenido x Asociado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'timestamp': 'Marca de tiempo',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'associated_1': 'Asociado 1',
          'associated_2': 'Asociado 2',
          'associated_3': 'Asociado 3',
          'associated_4': 'Asociado 4',
          'associated_5': 'Asociado 5',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Descuento',
          'wella_rappel': 'Rappel',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'Descuento',
          'sp_rappel': 'Rappel',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Descuento',
          'sebastian_rappel': 'Rappel',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Descuento',
          'sassoon_rappel': 'Rappel',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Descuento',
          'sp_diamond_rappel': 'Rappel',
          'nioxin_quantity': 'Nioxin',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_summer_discount': 'Desc. Verano',
          'nioxin_discount': 'Descuento',
          'nioxin_rappel': 'Rappel',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Descuento',
          'opi_rappel': 'Rappel',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial Diamond',
          'opi_potential': 'Potencial Opi',
          'wella_variable_discount': 'Wella Descuento Variable',
          'kolleston_growth': 'Crecimiento Kolleston'
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'observations', 'Observaciones'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'comments', 'Comentarios'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'prorated', '¿Contrato prorrateado?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'prorated_options', {
          'yes': 'Si',
          'no': 'No'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'quarterly_rappel', '¿Rappel trimestral?'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'quarterly_rappel_options', {
          'yes': 'Si',
          'no': 'No'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'pdf', 'Ver PDF'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'mail_conditions', 'Condiciones correo'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'mail_conditions_options', {
          'yes': 'Si',
          'no': 'No'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'image_conditions', 'Condiciones imagen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table, 'image_conditions_options', {
          'yes': 'Si',
          'no': 'No'
        }), _table),
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea archivar este contrato?'
        },
        'contracts_list_create': 'Crear contrato',
        'client_not_have_relations': 'Este cliente no posee asociaciones',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial y descuentos',
        'observations': 'Observaciones',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'associate_accounts': 'Asociar cuentas',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Descuento',
          'wella_rappel': 'Rappel',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'Descuento',
          'sp_rappel': 'Rappel',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Descuento',
          'sebastian_rappel': 'Rappel',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Descuento',
          'sassoon_rappel': 'Rappel',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Descuento',
          'sp_diamond_rappel': 'Rappel',
          'nioxin_quantity': 'Nioxin',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_summer_discount': 'Desc. Verano',
          'nioxin_discount': 'Descuento',
          'nioxin_rappel': 'Rappel',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Descuento',
          'opi_rappel': 'Rappel',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial Diamond',
          'opi_potential': 'Potencial Opi',
          'wella_variable_discount': 'Wella Descuento Variable',
          'kolleston_growth': 'Crecimiento Kolleston',
          'wella_trade': 'Wella trade',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'pdf': 'Agregar archivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          }
        },
        'create_button': 'Crear contrato',
        'create_success': 'Contrato creado con éxito',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito'
      },
      'sda': {
        'sda_list': 'Contratos SDA',
        'create_contract_sda': 'Crear contrato SDA',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': (_table2 = {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'delegation': 'Delegación'
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'exported', 'Exportado'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'client', 'Cliente'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'legal_name', 'Razón social'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'delegation', 'Delegación'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sassoon', 'SDA Sassoon'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sassoon_options', {
          'ok': 'ok'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sebastian', 'SDA Sebastian'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sebastian_options', {
          'ok': 'ok'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sp', 'SDA System Professional'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sp_options', {
          'ok': 'ok'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sp_men', 'SDA SP Men'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sp_men_options', {
          'ok': 'ok'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sp_diamond', 'SDA SP Diamond'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_sp_diamond_options', {
          'ok': 'ok'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sassoon_date', 'Sassoon Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sebastian_date', 'Sebastian Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sp_date', 'System Professional Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sp_men_date', 'SP Men Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sp_diamond', 'SP Diamond Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_date', 'SDA Fecha Ult'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'normal_sda_pdf', 'SDA PDF'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'diamond_sda_pdf', 'SDA SP Diamond PDF'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table2, 'sda_link_pdf', 'Ver PDF'), _table2),
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'create_contract_window': {
          'title': 'Crear contrato SDA',
          'fields': {
            'client': 'Cliente',
            'sda_types': 'Tipos de SDA',
            'sda_types_options': {
              'sda_sp': 'SDA SP',
              'sda_sp_men': 'SDA SP Men',
              'sda_sp_diamond': 'SDA SP DIamond',
              'sda_sebastian': 'SDA Sebastian',
              'sda_sassoon': 'SDA Sassoon'
            },
            'date': 'Fecha',
            'pdf': 'Agregar archivo PDF',
            'pdf_sp_diamond': 'Agregar archivo PDF Sp Diamond'
          },
          'create_button': 'Crear contrato SDA',
          'create_success': 'Contrato SDA creado con éxito'
        },
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito'
      }
    },
    'reports': {
      'header': {
        'master_data': 'Master Data',
        'sda': 'SDA',
        'potential': 'Potencial',
        'cci': 'CCI',
        'education': 'Educación'
      },
      'master_data': {
        'master_data_list': 'Reporte Master Data',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'export': {
          'no_data': 'Debes seleccionar al menos un contrato'
        },
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'groupings': {
          'name': 'Agrupar por:',
          'codeClient': 'Código Cliente',
          'legal_name': 'Razón Social',
          'seller': 'Vendedor'
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'associated_accounts': 'Cuentas asociadas',
          'associated_1': 'Asociado 1',
          'associated_2': 'Asociado 2',
          'associated_3': 'Asociado 3',
          'associated_4': 'Asociado 4',
          'associated_5': 'Asociado 5',
          'wella_total_discount': 'Wella descuento total',
          'wella_discount': 'Descuento Wella',
          'nioxin_summer_discount': 'Desc. Verano Nioxin',
          'nioxin_discount': 'Descuento Nioxin',
          'sp_discount': 'Descuento System Proffesional',
          'sebastian_discount': 'Descuento Sebastian',
          'sassoon_discount': 'Descuento Sassoon',
          'sp_diamond_discount': 'Descuento SP Diamond',
          'wella_quantity': 'Wella cantidad',
          'sebastian_quantity': 'Sebastian cantidad',
          'nioxin_quantity': 'Nioxin cantidad',
          'sp_quantity': 'System cantidad',
          'sassoon_quantity': 'Sassoon cantidad',
          'sp_diamond_quantity': 'SP Diamond cantidad',
          'wella_rappel': 'Wella Rappel',
          'sp_rappel': 'System P Rappel',
          'nioxin_rappel': 'Nioxin Rappel',
          'sebastian_rappel': 'Sebastian Rappel',
          'sassoon_rappel': 'Sassoon Rappel',
          'sp_diamond_rappel': 'SP Diamond Rappel',
          'observations': 'Observaciones',
          'timestamp': 'Marca de tiempo',
          'opi_quantity': 'OPI cantidad',
          'opi_discount': 'OPI descuento',
          'opi_rappel': 'OPI Rappel'
        }
      },
      'sda': {
        'sda_list': 'Reporte SDA',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'export': {
          'no_data': 'Debes seleccionar al menos un SDA'
        },
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': (_table3 = {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'delegation': 'Delegación'
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'exported', 'Exportado'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'client', 'Cliente'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'legal_name', 'Razón social'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'delegation', 'Delegación'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_sassoon', 'SDA Sassoon'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_sebastian', 'SDA Sebastian'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_sp', 'SDA System Professional'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_sp_men', 'SDA SP Men'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_sp_diamond', 'SDA SP Diamond'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sassoon_date', 'Sassoon Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sebastian_date', 'Sebastian Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sp_date', 'System Professional Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sp_men_date', 'SP Men Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sp_diamond', 'SP Diamond Fecha'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_date', 'SDA Fecha Ult'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_pdf', 'Ver PDF SDA'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_sp_diamond_pdf', 'Ver PDF SDA SP Diamond'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'normal_sda_pdf', 'SDA PDF'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'diamond_sda_pdf', 'SDA SP Diamond PDF'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_table3, 'sda_link_pdf', 'Ver PDF'), _table3)
      },
      'potential': {
        'potential_list': 'Reporte Potencial',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'seller': 'Vendedor',
          'employees_quantity': 'Número de empleados',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial SP Diamond',
          'opi_potential': 'Potencial OPI'
        }
      },
      'cci': {
        'cci_list': 'Reporte CCI',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'client_code': 'Código cliente',
          'legal_name': 'Razón social',
          'image_conditions': 'Condiciones imagen'
        }
      },
      'education': {
        'education_list': 'Reporte Educación',
        'export_data': 'Exportar excel',
        'please_wait': 'Por favor espera un momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'since': 'desde',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar todos',
            'only_exported': 'Solo exportados',
            'not_exported': 'No exportados'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'No se encontraron resultados',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'No OK',
            'pendiente_ok': 'Pendiente',
            'archive': 'Archivado',
            'retenido_asociado': 'Retenido x Asociado'
          },
          'client': 'Cliente',
          'legal_name': 'Razón social',
          'email': 'Correo electrónico',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'associated_1': 'Asociado 1',
          'associated_2': 'Asociado 2',
          'associated_3': 'Asociado 3',
          'associated_4': 'Asociado 4',
          'associated_5': 'Asociado 5',
          'wella_quantity': 'Wella cantidad',
          'wella_package': 'Paquete Wella',
          'sp_quantity': 'System cantidad',
          'sp_package': 'Paquete System',
          'nioxin_quantity': 'Nioxin cantidad',
          'nioxin_package': 'Paquete Nioxin',
          'sebastian_quantity': 'Sebastian cantidad',
          'sebastian_package': 'Paquete Sebastian',
          'sassoon_quantity': 'Sassoon cantidad',
          'sassoon_package': 'Paquete Sassoon',
          'salons': 'Salones',
          'mkt_news': 'Novedades MKT'
        }
      }
    }
  }
});

/***/ }),

/***/ "jrS6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("Q+H2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d5ae01a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("WI2b");
function injectStyle (ssrContext) {
  __webpack_require__("oej/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d5ae01a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d5ae01a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k/Ja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_fields_textarea_textarea__ = __webpack_require__("0MCM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_file_file__ = __webpack_require__("6YFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_fields_date_date__ = __webpack_require__("D507");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_fields_sort_sort__ = __webpack_require__("H0Q9");

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'history-contracts',
  data: function data() {
    return {
      contracts: [],
      contractHistoryOptions: [],
      menuOptions: [{
        iconClass: 'fa fa-pencil',
        name: this.$t('private.history.contracts.menu_more_options.edit_contract'),
        action: 'edit'
      }, {
        iconClass: 'fa fa-archive',
        name: this.$t('private.history.contracts.menu_more_options.archive_contract'),
        action: 'archive'
      }],
      selectYears: {
        id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
        display: true,
        fakeValue: '',
        value: '',
        name: this.$t('private.history.contracts.selectYears'),
        error: false,
        active: false,
        options: [],
        style: {
          width: '230px',
          display: 'inline-block',
          margin: '0px 10px'
        }

      },
      filters: {
        ascending: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.sort_ascending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        descending: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.history.contracts.filters.sort_options.created_at'),
          value: 'appCreationDate',
          name: this.$t('private.history.contracts.filters.sort_descending'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.sort_options.created_at'),
            value: 'appCreationDate'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: 50,
          value: 50,
          name: this.$t('private.history.contracts.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: 10,
            value: 10
          }, {
            fakeValue: 25,
            value: 25
          }, {
            fakeValue: 50,
            value: 50
          }, {
            fakeValue: 100,
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        state: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.state'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.state_options.green'),
            value: 0
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.red'),
            value: 1
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.yellow'),
            value: 2
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.black'),
            value: 3
          }, {
            fakeValue: this.$t('private.history.contracts.filters.state_options.purple'),
            value: 4
          }],
          style: {
            width: '100px',
            marginTop: '0px'
          }
        },
        exported: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.history.contracts.filters.exported_options.no'),
            value: false
          }],
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        hidden: { // ESTO SE HACE POR QUE AL PARECER HAY UN BUG EN LOS FILTROS DENTRO DE LA TABLA Y ESTO LO SOLUCIONA
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.history.contracts.filters.exported_options.yes'),
            value: true
          }, {
            fakeValue: this.$t('private.history.contracts.filters.exported_options.no'),
            value: false
          }],
          style: {
            display: 'none'
          }
        },
        since: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.since'),
          error: false,
          active: false,
          style: {
            width: '110px',
            marginTop: '3px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.until'),
          error: false,
          active: false,
          style: {
            width: '110px'
          }
        },
        seller: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.history.contracts.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.client_code'),
          type: 'text',
          error: false,
          filters: {
            maxLength: 10
          },
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        clientLegalName: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.history.contracts.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      getContractsActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      getSearchClients: false,
      getClientsActive: false,
      getDelegationsActive: false,
      exportContractsActive: false,
      migrateContractsWindow: {
        display: false,
        migrateCSVFileActive: false,
        contractsToCreated: [],
        contractsToUpdate: [],
        contractsWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csv: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: this.$t('private.clients.list.import_clients_modal.fields.csv'),
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      displayFoo: false,
      totalContracts: 0,
      exportZipPDFsWindow: {
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.january'),
              value: '01'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.february'),
              value: '02'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.march'),
              value: '03'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.april'),
              value: '04'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.may'),
              value: '05'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.june'),
              value: '06'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.july'),
              value: '07'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.august'),
              value: '08'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.september'),
              value: '09'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.october'),
              value: '10'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.november'),
              value: '11'
            }, {
              fakeValue: this.$t('private.history.contracts.export_zip_pdfs_window.fields.month_options.december'),
              value: '12'
            }],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            name: this.$t('private.history.contracts.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        }
      },
      createHistoryWindow: {
        display: false,
        createHistoryActive: false,
        fields: {
          month: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: true,
            name: this.$t('private.history.contracts.create_history_window.fields.month'),
            error: false,
            active: false,
            options: [],
            // options : [{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.january'),
            //   value : '01'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.february'),
            //   value : '02'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.march'),
            //   value : '03'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.april'),
            //   value : '04'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.may'),
            //   value : '05'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.june'),
            //   value : '06'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.july'),
            //   value : '07'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.august'),
            //   value : '08'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.september'),
            //   value : '09'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.october'),
            //   value : '10'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.november'),
            //   value : '11'
            // },{
            //   fakeValue : this.$t('private.history.contracts.create_history_window.fields.month_options.december'),
            //   value : '12'
            // }],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.history.contracts.create_history_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0
        }
      }
    };
  },

  methods: {
    filterSubmit: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.debounce(function () {
      var vm = this;

      vm.getContracts();
    }, 1000),
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    actionSort: function actionSort(event, col) {
      var vm = this;

      vm.filters.ascending.value = '';
      vm.filters.descending.value = '';

      if (event.sort_default) vm.filters.descending.value = 'appCreationDate';

      if (event.sort_asc) vm.filters.ascending.value = col;

      if (event.sort_desc) vm.filters.descending.value = col;

      vm.getContracts();
    },
    optionsGetContractsHistory: function optionsGetContractsHistory() {
      var _this = this;

      var vm = this;

      vm.contractHistoryOptions = [];

      var dataToSend = {
        className: 'ContractHistory',
        descending: 'year'
      };

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].contractsHistory.getContractsHistory(dataToSend).then(function (response) {
        if (!response.data.success) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (response.data.contracts.length > 0) {
          vm.contractHistoryOptions = response.data.contracts;

          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(vm.contractHistoryOptions, function (element) {
            vm.selectYears.options.push({
              fakeValue: element.slugContract,
              value: element._id
            });
          });

          vm.selectYears.fakeValue = vm.contractHistoryOptions[0].slugContract;
          vm.selectYears.value = vm.contractHistoryOptions[0]._id;
          _this.$refs['selectYears'].field.value = vm.selectYears.value;
          _this.$refs['selectYears'].field.fakeValue = vm.selectYears.fakeValue;

          vm.getContracts();
        }
      });
    },
    getContracts: function getContracts() {
      var vm = this;

      vm.exportContractsActive = false;
      vm.contracts = [];

      var contractHistory = void 0;

      if (vm.selectYears.value) {
        contractHistory = vm.contractHistoryOptions.find(function (element) {
          return element._id === vm.selectYears.value;
        });
      } else {
        contractHistory = vm.contractHistoryOptions[0];
      }

      if (!contractHistory) return false;

      vm.totalContracts = 0;

      vm.getContractsActive = true;

      var dataToSend = {
        className: contractHistory.classNameContract,
        ascending: vm.filters.ascending.value,
        descending: vm.filters.descending.value,
        limit: vm.filters.limit.value + 1,
        skip: vm.filters.skip.value,
        contractState: vm.filters.state.value,
        exported: vm.filters.exported.value,
        since: vm.filters.since.value,
        until: vm.filters.until.value,
        sellerUsername: vm.filters.seller.value,
        clientCode: vm.filters.clientCode.value,
        clientLegalName: vm.filters.legalName.value
      };

      if (vm.filters.delegation.value) {
        var delegation = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(vm.filters.delegation.options, function (element) {
          return element.value == vm.filters.delegation.value;
        });

        dataToSend.sellerDelegationName = delegation.fakeValue;
      }

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].contractsHistory.getContractsHistory(dataToSend).then(function (response) {
        vm.getContractsActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.contracts = response.data.contracts;
        vm.totalContracts = response.data.countContracts || contractHistory.countContracts;

        if (vm.contracts.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.contracts.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.contracts.pop();
        } else {
          vm.nextPage = false;
        }

        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(vm.contracts, function (x) {
          var prestigeSalonValue = x.prestigeSalonValue ? x.prestigeSalonValue * 1 : 0;
          var premiumSalonValue = x.premiumSalonValue ? x.premiumSalonValue * 1 : 0;
          x.sumSalonValue = prestigeSalonValue + premiumSalonValue;

          var premiumDiscount1 = x.premiumDiscount1 ? x.premiumDiscount1 * 1 : 0;
          var premiumVariableDiscount1 = x.premiumVariableDiscount1 ? x.premiumVariableDiscount1 * 1 : 0;
          x.premiumDiscountTotal = premiumDiscount1 + premiumVariableDiscount1;

          var prestigeDiscount1 = x.prestigeDiscount1 ? x.prestigeDiscount1 * 1 : 0;
          var prestigeVariableDiscount1 = x.prestigeVariableDiscount1 ? x.prestigeVariableDiscount1 * 1 : 0;
          x.prestigeDiscountTotal = prestigeDiscount1 + prestigeVariableDiscount1;
        });
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getContracts();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getContracts();
      }
    },
    optionSelected: function optionSelected(data) {
      var vm = this;

      if (data.action == 'edit') {
        var stateFakeValue = data.element.state == 0 ? this.$t('private.history.contracts.fields.state_options.green') : data.element.state == 1 ? this.$t('private.history.contracts.fields.state_options.red') : data.element.state == 2 ? this.$t('private.history.contracts.fields.state_options.yellow') : data.element.state == 3 ? this.$t('private.history.contracts.fields.state_options.black') : data.element.state == 4 ? this.$t('private.history.contracts.fields.state_options.purple') : '';

        if (data.element.client) {
          vm.formUpdate.fields.client.value = data.element.client.id;
          vm.formUpdate.fields.clientCode.value = data.element.client.clientCode;
        }

        if (data.element.client && data.element.client.associatedAccounts && data.element.client.associatedAccounts.length > 0) {
          var value = {};
          var options = {};

          __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(data.element.client.associatedAccounts, function (associatedAccount) {
            value[associatedAccount.clientCode] = data.element.associatedAccount1 == associatedAccount.clientCode ? true : data.element.associatedAccount2 == associatedAccount.clientCode ? true : data.element.associatedAccount3 == associatedAccount.clientCode ? true : data.element.associatedAccount4 == associatedAccount.clientCode ? true : data.element.associatedAccount5 == associatedAccount.clientCode;

            options[associatedAccount.clientCode] = {
              name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
              cif: associatedAccount.cif,
              legalName: associatedAccount.legalName,
              email: associatedAccount.email,
              employeesQuantity: associatedAccount.employeesQuantity,
              disabled: true
            };
          });

          vm.formUpdate.fields.associateAccounts.value = value;
          vm.formUpdate.fields.associateAccounts.options = options;
          vm.formUpdate.fields.associateAccounts.display = true;
        }

        var proratedFakeValue = data.element.prorated == true ? this.$t('private.history.contracts.fields.prorated_options.yes') : data.element.prorated == false ? this.$t('private.history.contracts.fields.prorated_options.no') : '';

        vm.formUpdate.fields.id.value = data.element.id;
        vm.formUpdate.fields.state.fakeValue = stateFakeValue;
        vm.formUpdate.fields.state.value = data.element.state;
        vm.formUpdate.fields.prestigeDate.value = data.element.prestigeDate ? this.parseDate(data.element.prestigeDate.iso) : '';
        vm.formUpdate.fields.prestigeATS.value = data.element.prestigeATS ? data.element.prestigeATS : 0;
        vm.formUpdate.fields.prestigeMTKG.value = data.element.prestigeMTKG ? data.element.prestigeMTKG : '';
        vm.formUpdate.fields.prestigeSalon.value = data.element.prestigeSalon ? data.element.prestigeSalon : '';
        vm.formUpdate.fields.prestigeSalonValue.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0;
        vm.formUpdate.fields.prestigeRappel1.value = data.element.prestigeRappel1 ? data.element.prestigeRappel1 : 0;
        vm.formUpdate.fields.prestigeRappel2.value = data.element.prestigeRappel2 ? data.element.prestigeRappel2 : 0;
        vm.formUpdate.fields.prestigeSection1.value = data.element.prestigeSection1 ? data.element.prestigeSection1 : 0;
        vm.formUpdate.fields.prestigeSection2.value = data.element.prestigeSection2 ? data.element.prestigeSection2 : 0;
        vm.formUpdate.fields.prestigePotential.value = data.element.prestigePotential ? data.element.prestigePotential : 0;
        vm.formUpdate.fields.prestigeEducation.value = data.element.prestigeEducation ? data.element.prestigeEducation : 0;
        vm.formUpdate.fields.prestigeRappelFrequency.value = data.element.prestigeRappelFrequency ? data.element.prestigeRappelFrequency : '';
        vm.formUpdate.fields.prestigeDiscount1.value = data.element.prestigeDiscount1 ? data.element.prestigeDiscount1 : 0;
        vm.formUpdate.fields.prestigeDiscount2.value = data.element.prestigeDiscount2 ? data.element.prestigeDiscount2 : 0;
        vm.formUpdate.fields.prestigeVariableDiscount1.value = data.element.prestigeVariableDiscount1 ? data.element.prestigeVariableDiscount1 : 0;
        vm.formUpdate.fields.prestigeVariableDiscount2.value = data.element.prestigeVariableDiscount2 ? data.element.prestigeVariableDiscount2 : 0;
        vm.formUpdate.fields.premiumDate.value = data.element.premiumDate ? this.parseDate(data.element.premiumDate.iso) : '';
        vm.formUpdate.fields.premiumPotential.value = data.element.premiumPotential ? data.element.premiumPotential : 0;
        vm.formUpdate.fields.premiumRappelFrequency.value = data.element.premiumRappelFrequency ? data.element.premiumRappelFrequency : '';
        vm.formUpdate.fields.prorated.value = proratedFakeValue;
        vm.formUpdate.fields.proratedMonth.value = data.element.proratedMonth ? data.element.proratedMonth : '';
        vm.formUpdate.fields.manualDate.value = data.element.manualDate ? this.parseDate(data.element.manualDate.iso) : '';
        vm.formUpdate.fields.observations.value = data.element.observations ? data.element.observations : '';
        vm.formUpdate.fields.conditions.value.mailConditions = !!data.element.mailConditions;
        vm.formUpdate.fields.conditions.value.imageConditions = !!data.element.imageConditions;

        if (data.element.pdf) {
          vm.formUpdate.fields.pdf.fileReady = true;
          vm.formUpdate.fields.pdf.value.data = data.element.pdf;
          vm.formUpdate.fields.pdf.value.format = 'pdf';
          vm.formUpdate.fields.pdf.value.size = 0;
        }

        vm.displayUpdateContract = true;
      } else if (data.action == 'archive') {
        vm.archiveContract(data.element);
      }
    },
    searchClients: function searchClients(data) {
      var vm = this;

      vm.getSearchClients = true;

      var dataToSend = '?clientCode=' + data;

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {
        vm.getSearchClients = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message2 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        var clients = response.data.clients;

        clients = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(clients, function (client) {
          return {
            fakeValue: client.legalName + ' (' + client.clientCode + ')',
            value: client
          };
        });

        vm.formCreate.fields.client.options = clients;
        vm.formUpdate.fields.client.options = clients;
      });
    },
    clientSelected: function clientSelected(data) {
      var vm = this;

      vm.formCreate.fields.client.value = data.id;
      vm.formUpdate.fields.client.value = data.id;

      if (data.associatedAccounts.length == 0) {
        return;
      }

      var value = {};
      var options = {};

      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(data.associatedAccounts, function (associatedAccount) {
        value[associatedAccount.clientCode] = true;

        options[associatedAccount.clientCode] = {
          name: associatedAccount.legalName + ' (' + associatedAccount.clientCode + ')',
          cif: associatedAccount.cif,
          legalName: associatedAccount.legalName,
          email: associatedAccount.email,
          employeesQuantity: associatedAccount.employeesQuantity,
          disabled: true
        };
      });

      vm.formCreate.fields.associateAccounts.value = value;
      vm.formCreate.fields.associateAccounts.options = options;
      vm.formCreate.fields.associateAccounts.display = true;
      vm.formUpdate.fields.associateAccounts.value = value;
      vm.formUpdate.fields.associateAccounts.options = options;
      vm.formUpdate.fields.associateAccounts.display = true;
    },
    exportContracts: function exportContracts() {
      var vm = this;

      if (vm.exportContractsActive) {
        var message = {
          message: [vm.$t('private.history.contracts.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var contractHistory = void 0;

      if (vm.selectYears.value) {
        contractHistory = vm.contractHistoryOptions.find(function (element) {
          return element._id === vm.selectYears.value;
        });
      } else {
        contractHistory = vm.contractHistoryOptions[0];
      }

      if (!contractHistory) return false;

      vm.exportContractsActive = true;

      var dataToSend = {
        className: contractHistory.classNameContract,
        timeZone: __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess()
      };

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].contractsHistory.exportContracts(dataToSend).then(function (response) {
        vm.exportContractsActive = false;

        if (response.status !== 200) {
          var _message3 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message3);

          return;
        }

        var file = new Blob([response.data], { type: 'application/vnd.ms-excel' });
        // let fileURL = URL.createObjectURL(file)

        __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(file, 'historico_contrato.xlsx');

        vm.getContracts();
      });
    },
    getDelegations: function getDelegations() {
      var vm = this;

      vm.getDelegationsActive = true;

      var dataToSend = '/?descending=createdAt';

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].delegations.getDelegations(dataToSend).then(function (response) {
        vm.getDelegationsActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message4 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message4);

          return;
        }

        var delegations = response.data.delegations;

        delegations = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(delegations, function (delegation) {
          return {
            fakeValue: delegation.name,
            value: delegation.id
          };
        });

        vm.filters.delegation.options = delegations;
      });
    },
    parseDate: function parseDate(date) {
      var _date = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(date, 'iso') ? date.iso : date;

      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(_date).format('DD-MM-YYYY');
    },
    resetDataMigrateContractsWindow: function resetDataMigrateContractsWindow() {
      var vm = this;

      vm.migrateContractsWindow.contractsToCreated = [];
      vm.migrateContractsWindow.contractsWithErrors = [];
      vm.migrateContractsWindow.fields.csv.value = {};
      vm.migrateContractsWindow.fields.csv.fileReady = false;
    },
    migrateContractsSubmit: function migrateContractsSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateContractsWindow.fields.separator.value,
        csv: vm.migrateContractsWindow.fields.csv.value.data
      };

      vm.migrateContractsWindow.migrateCSVFileActive = true;

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].contracts.migrateCSVFile(dataToSend).then(function (response) {
        vm.migrateContractsWindow.migrateCSVFileActive = false;

        if (response.status !== 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message5 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message5);

          return;
        }

        vm.migrateContractsWindow.contractsToCreated = response.data.contractsToCreated;
        vm.migrateContractsWindow.contractsWithErrors = response.data.contractsWithErrors;

        console.log(vm.migrateContractsWindow.contractsToCreated);
      });
    },
    exportZipPDFs: function exportZipPDFs() {
      var vm = this;

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        var message = {
          message: [vm.$t('private.history.contracts.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var month = vm.exportZipPDFsWindow.fields.month.value;
      var year = vm.exportZipPDFsWindow.fields.year.value;

      if (!__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isAfter(year + '-' + month + '-' + __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(year + '-' + month).endOf('month').format('DD'), 'year') || !__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().isAfter(year + '-' + month + '-' + __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(year + '-' + month).endOf('month').format('DD'), 'month')) {
        var _message6 = {
          message: [vm.$t('errors.custom.008')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', _message6);

        return;
      }

      var since = year + '-' + month + '-01';
      var until = year + '-' + month + '-' + __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(year + '-' + month).endOf('month').format('DD');

      vm.exportZipPDFsWindow.downloadZipPDFsActive = true;

      var dataToSend = {
        since: since,
        until: until
      };

      __WEBPACK_IMPORTED_MODULE_4__api_api__["a" /* default */].contracts.exportZipPDFs(dataToSend).then(function (response) {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false;

        if (response.status !== 200) {
          var _message7 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message7);

          return;
        }

        var file = new Blob([response.data], { type: 'octet/stream' });
        // let fileURL = URL.createObjectURL(file)

        __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(file, 'pdfs_' + since + '_' + until + '.zip');

        vm.exportZipPDFsWindow.display = false;
      });
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_5__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */],
    TextareaField: __WEBPACK_IMPORTED_MODULE_7__components_general_fields_textarea_textarea__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_8__components_general_fields_select_select__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_search_search__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_checkbox_checkbox__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_file_file__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_12__components_general_fields_date_date__["a" /* default */],
    SortField: __WEBPACK_IMPORTED_MODULE_13__components_general_fields_sort_sort__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getDelegations();

    vm.optionsGetContractsHistory();

    for (var i = 2016; i <= __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(); i++) {
      vm.createHistoryWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      });
    }

    vm.sessionUser = JSON.parse(localStorage.getItem('sessionUser'));
  }
});

/***/ }),

/***/ "k0Yb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "kjBa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lBs9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lcrp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"field-sort fa",class:{ 'fa-sort': _vm.field.sort_default, 'fa-sort-asc': _vm.field.sort_asc, 'fa-sort-desc': _vm.field.sort_desc },attrs:{"id":_vm.field.id},on:{"click":function($event){_vm.actionSort($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lvdl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mcRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in private-container-view"},[_c('div',{staticClass:"header-sections"},[_c('ul',{staticClass:"items-container"},[(_vm.sessionUser.permissions.masterData)?_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.reportsMasterData.path}},[_c('li',{staticClass:"item"},[_c('span',{staticClass:"icon"},[_vm._v("1")]),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.reports.header.master_data")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.reportsMasterData.name}})])]):_vm._e(),(_vm.sessionUser.permissions.reports)?_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.reportsSDA.path}},[_c('li',{staticClass:"item"},[_c('span',{staticClass:"icon"},[_vm._v("2")]),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.reports.header.sda")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name == _vm.routes.reportsSDA.name}})])]):_vm._e()],1)]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mhRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_messenger_messenger__ = __webpack_require__("oT9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_general_data_validator_data_validator__ = __webpack_require__("6r2B");



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	components: {
		Messenger: __WEBPACK_IMPORTED_MODULE_0__components_general_messenger_messenger__["a" /* default */],
		DataValidator: __WEBPACK_IMPORTED_MODULE_1__components_general_data_validator_data_validator__["a" /* default */]
	}
});

/***/ }),

/***/ "n0K1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	getSellersTypes: function getSellersTypes(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellersTypes' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	createSellerType: function createSellerType(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellersTypes';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	updateSellerType: function updateSellerType(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellersTypes';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	deleteSellerType: function deleteSellerType(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/sellersTypes' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().delete(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "oMXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'question-modal',
	data: function data() {
		return {
			title: '',
			question: '',
			active: false
		};
	},

	methods: {
		optionSelected: function optionSelected(response) {

			var vm = this;

			vm.active = false;

			vm.cb(response);
		},
		cb: function cb() {}
	},
	created: function created() {

		var vm = this;

		vm.$root.$on('question-modal', function (data) {

			vm.active = true;
			vm.title = data[0].title;
			vm.question = data[0].question;

			vm.cb = data[1];
		});
	}
});

/***/ }),

/***/ "oT9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("Rr4E");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018b05fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("YBiZ");
function injectStyle (ssrContext) {
  __webpack_require__("e17V")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-018b05fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_018b05fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oej/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		sellers: {
			sellers: []
		}
	},
	getters: {},
	mutations: {
		fetchSellers: function fetchSellers(state, sellers) {

			state.sellers.sellers = sellers;
		},
		updateSeller: function updateSeller(state, seller) {

			state.sellers.sellers.find(function (element) {

				if (element.id == seller.id) {

					element = seller;
				}
			});
		}
	},
	actions: {
		fetchSellers: function fetchSellers(state, sellers) {

			state.sellers.sellers = sellers;
		}
	}
});

/***/ }),

/***/ "ooDe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p2M4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  'data_validator': {
    'required': 'O campo %name% não pode estar vazio',
    'min_length': 'O campo %name% deve ter um mínimo de caracteres %length%',
    'max_length': 'O campo %name% pode ter um máximo de caracteres %length%',
    'type': 'O campo %name% tem um formato incorreto',
    'invalid_option': 'A opção selecionada no campo %name% é inválida',
    'numeric': {
      'smaller_than': 'O campo %name% deve ser inferior a %number%',
      'greather_than': 'O campo %name% deve ser maior que %number%'
    },
    'date': {
      'smaller_than': 'A data no campo %name% deve ser inferior à data de encerramento',
      'greather_than': 'A data no campo %name% deve ser maior que a data de início'
    },
    'file': {
      'format': 'O arquivo que você está tentando enviar tem um formato incorreto (formatos permitidos %formatos%)',
      'size': 'O arquivo que você está tentando enviar é muito pesado (peso máximo de %size% mb)'
    }
  },
  'calendar': {
    'month_names': {
      'january': 'JAN',
      'february': 'FEV',
      'march': 'MAR',
      'april': 'ABR',
      'may': 'MAI',
      'june': 'JUN',
      'july': 'JUL',
      'august': 'AGO',
      'september': 'SET',
      'october': 'OUT',
      'november': 'NOV',
      'december': 'DEZ'
    },
    'day_names_short': {
      'sunday': 'D',
      'monday': '2f',
      'tuesday': '3f',
      'wednesday': '4f',
      'thursday': '5f',
      'friday': '6f',
      'saturday': 'S'
    }
  },
  'errors': {
    'parse': {
      '101': 'O usuário ou senha son incorretos'
    },
    'custom': {
      '001': 'Ocorreu um erro ao enviar o pedido, por favor, pedimos que tente depois',
      '002': 'O código do cliente pertence a outro cliente, insira outro código',
      '003': 'O usuário do vendedor não existe',
      '004': 'O campo do usuário do vendedor está vazio',
      '005': 'O campo de código do cliente está vazio',
      '006': 'Você não possui permissões suficientes para acessar',
      '007': 'CIF do cliente pertence a outro cliente, insira outro CIF',
      '008': 'A data selecionada é inválida, verifique',
      '009': 'O email inserido já está em uso',
      '010': 'Selecione pelo menos uma marca da {brand} antes de escolher os materiais do MTKG',
      '011': 'Não há PDF para exportar para o mês e ano indicados.',
      '012': 'Para esta ação, você deve primeiro selecionar o cliente',
      '013': 'Você deve selecionar pelo menos uma marca',
      '014': 'Deve indicar pelo menos um valor em uma das marcas',
      '015': 'Você deve indicar ano e mês para continuar com a operação',
      '016': 'Já existe um arquivo com este código de cliente',
      '017': 'O usuário inserido já está em uso'
    }
  },
  'views_names': {
    'public': {
      'login': 'Iniciar sessão'
    },
    'private': {
      'sellers': {
        'list': 'Vendedores',
        'create': 'Vendedores',
        'delegations': 'Vendedores',
        'types': 'Vendedores'
      },
      'clients': {
        'list': 'Clientes'
      },
      'clients_records': {
        'list': 'Ficha Cliente'
      },
      'contracts': {
        'list': 'Contratos',
        'sda': 'Contratos',
        'history': 'Histórico',
        'zips': 'Zips'
      },
      'reports': {
        'master_data': 'Relatórios',
        'sda': 'Relatórios',
        'potential': 'Relatórios',
        'cci': 'Relatórios',
        'education': 'Relatórios'
      },
      'history': {
        'contracts': 'Histórico - Contratos',
        'sda': 'Histórico - Contratos SDA'
      }
    }
  },
  'public': {
    'login': {
      'title': 'Iniciar sessão | Wella',
      'fields': {
        'username': 'usuário',
        'password': 'senha'
      },
      'login_button': 'Iniciar sessão'
    }
  },
  'private': {
    'header': {
      'options': 'Opções'
    },
    'aside': {
      'sellers': 'Vendedores',
      'clients': 'Clientes',
      'clients_records': 'Ficha Cliente',
      'contracts': 'Contratos',
      'reports': 'Relatórios',
      'history': 'Histórico',
      'logout': 'Sair'
    },
    'sellers': {
      'header': {
        'sellers_list': 'Listagem',
        'sellers_delegations': 'Delegações',
        'sellers_types': 'Tipos'
      },
      'list': {
        'sellers_list': 'Lista de vendedores',
        'create_seller': 'Criar vendedor',
        'see_filters': 'Veja filtros',
        'export_users': 'Exportadores',
        'please_wait': 'Aguarde um momento',
        'filters': {
          'fullname': 'Nome ou sobrenome',
          'username': 'Nome de usuário',
          'email': 'Correio eletrônico',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'firstname': 'Nomes',
            'lastname': 'Sobrenome'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'firstname': 'Nomes',
          'lastname': 'Sobrenome',
          'username': 'Usuário',
          'email': 'Correio eletrônico',
          'delegation': 'Delegação',
          'type': 'Tipo',
          'active': 'Ativo',
          'multi_type': 'Multimarca',
          'active_yes': 'Sim',
          'active_no': 'Não',
          'last_access': 'Último acesso'
        },
        'menu_more_options': {
          'edit_seller': 'Editar vendedor',
          'delete_seller': 'Remover vendedor'
        },
        'sellers_list_create': 'Criar vendedor',
        'fields': {
          'firstname': 'Nomes',
          'lastname': 'Sobrenome',
          'username': 'Usuário',
          'email': 'Correio eletrônico',
          'password': 'Senha',
          'delegation': 'Delegação',
          'seller_type': 'Tipo de vendendor',
          'active': 'Ativo',
          'multi_type': 'Multimarca',
          'active_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'permissions': 'Permissões',
          'permissions_options': {
            'sellers': 'Vendedores',
            'clients': 'Clientes',
            'clients_records': 'Ficha Cliente',
            'contracts': 'Contratos',
            'messages': 'Mensagens',
            'reports': 'Relatórios',
            'master_data': 'São dados mestres?'
          }
        },
        'create_button': 'Criar vendedor',
        'create_success': 'Vendedor criado com sucesso',
        'sellers_update': 'Editar vendedor',
        'update_button': 'Editar vendedor',
        'update_success': 'Vendedor com êxito editado',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esse vendedor?'
        },
        'delete_success': 'Vendedor removido com sucesso'
      },
      'delegations': {
        'sellers_delegations': 'Lista de delegações',
        'create_delegation': 'Criar delegação',
        'see_filters': 'Veja filtros',
        'filters': {
          'name': 'Nome',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'name': 'Nome'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'menu_more_options': {
          'edit_delegation': 'Editar delegação',
          'delete_delegation': 'Eliminar delegação'
        },
        'sellers_delegations_create': 'Criar delegação',
        'fields': {
          'name': 'nome'
        },
        'create_button': 'Criar delegação',
        'create_success': 'Delegação criada com sucesso',
        'sellers_delegations_update': 'Editar delegação',
        'update_button': 'Editar delegação',
        'update_success': 'Delegação editada com sucesso',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esta delegação?'
        },
        'delete_success': 'Delegação foi excluída com êxito'
      },
      'sellers_types': {
        'sellers_types': 'Lista de tipos de vendedores',
        'create_seller_type': 'Criar tipo',
        'see_filters': 'Veja filtros',
        'filters': {
          'name': 'Nome',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'name': 'Nome'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'menu_more_options': {
          'edit_seller_type': 'Editar tipo',
          'delete_seller_type': 'Excluir tipo'
        },
        'sellers_types_create': 'Criar tipo',
        'fields': {
          'name': 'nome'
        },
        'create_button': 'Criar tipo',
        'create_success': 'Tipo de vendedor criado com sucesso',
        'sellers_types_update': 'Editar tipo',
        'update_button': 'Editar tipo',
        'update_success': 'Tipo de vendedor com êxito editado',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esse tipo de vendedor?'
        },
        'delete_success': 'Tipo de vendedor removido com sucesso'
      }
    },
    'clients': {
      'header': {
        'clients_list': 'Listagem'
      },
      'list': {
        'clients_list': 'Lista de clientes',
        'create_client': 'Criar cliente',
        'import_clients': 'Importar clientes',
        'export_clients': 'Exportar clientes',
        'migrate_clients': 'Migração de Importações',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'cif': 'NIF',
          'client_code': 'Código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'discharge_date': 'Data alta',
          'status': 'Estado',
          'recruiting_lr': 'Contratação LR',
          'mkt_news': 'Condições de correio',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação',
            'cif': 'NIF',
            'client_code': 'Código do cliente',
            'email': 'Correio eletrônico',
            'employees': 'Empregados',
            'lounge': 'Salão',
            'legal_name': 'Razão social',
            'discharge_date': 'Data alta',
            'status': 'Estado',
            'recruiting_lr': 'Contratação LR',
            'mkt_news': 'Condições de correio'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'associated_accounts': 'Contas associadas',
          'seller': 'Vendedor',
          'cfia': 'CFIA',
          'address': 'Endereço',
          'city': 'Cidadde',
          'province': 'Província',
          'postal_code': 'Código Postal',
          'cif': 'NIF',
          'client_code': 'Código do cliente',
          'delegation': 'Delegação',
          'email': 'Correio eletrônico',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'phone': 'telefono',
          'cellphone': 'telemovel',
          'web': 'web',
          'headquarters': 'Sede social',
          'owner_name': 'Nome propietario',
          'online_shop': 'Loja online',
          'resale_shop': 'Loja revenda',
          'have_salon': 'Tem salão',
          'have_salon_yes': 'Sim',
          'have_salon_no': 'Ñao',
          'nioxin_past_quantity': 'Nioxin quantidade passada',
          'sebastian_past_quantity': 'Sebastian quantidade passada',
          'sp_past_quantity': 'SP quantidade passada',
          'system_ec_past_quantity': 'System EC quantidade passada',
          'wella_past_quantity': 'Wella quantidade passada',
          'wella_real_past_quantity': 'Wella quantidade passada real',
          'total_contracted_past_quantity': 'Valor total contratado na última',
          'discharge_date': 'Data alta',
          'status': 'Estado',
          'status_active': 'Ativo',
          'status_inactive': 'Inativo',
          'recruiting_lr': 'Contratação LR',
          'recruiting_lr_yes': 'Sim',
          'recruiting_lr_no': 'Ñao',
          'mkt_news': 'Condições de correio',
          'mkt_news_yes': 'Sim',
          'mkt_news_no': 'Ñao',
          'image_conditions': 'Condições de imagem',
          'image_conditions_yes': 'Sim',
          'image_conditions_no': 'Ñao',
          'email_invoices': 'Faturas email',
          'email_invoices_yes': 'Sim',
          'email_invoices_no': 'Ñao'
        },
        'not_have_associated_accounts': 'Este cliente não possui contas associadas',
        'menu_more_options': {
          'associate_account': 'Conta associada',
          'see_associated_accounts': 'Listar contas associadas',
          'edit_client': 'Editar cliente',
          'delete_client': 'Remover cliente'
        },
        'associate_account_modal': {
          'title': 'Conta associada',
          'fields': {
            'client': 'procure um cliente',
            'legal_name': 'razão social',
            'cif': 'NIF',
            'email': 'Correio eletrônico'
          },
          'button': 'Conta associada',
          'success': 'Conta associada ao sucesso'
        },
        'associated_accounts_modal': {
          'title': 'Contas associadas',
          'menu_more_options': {
            'delete_association': 'Remover associação'
          },
          'question_modal': {
            'title': 'Aviso',
            'question': 'Tem certeza de que deseja excluir esta associação?'
          },
          'delete_success': 'Associação eliminada com sucesso'
        },
        'import_clients_modal': {
          'title': 'Importar clientes por CSV',
          'import_clients': 'Importar clientes',
          'fields': {
            'separator': 'Separador',
            'separator_options': {
              'coma': ',',
              'semicolon': ';',
              'pipe': '|'
            },
            'csv': 'Carregar documento CSV'
          },
          'please_wait': 'Aguarde um momento',
          'clients_to_update': 'Clientes para modificar',
          'clients_to_create': 'Clientes para adicionar',
          'clients_with_error': 'Clientes com erros',
          'no_clients_to_update': 'Não há clientes a serem modificados',
          'no_clients_to_create': 'Nenhum cliente para adicionar',
          'no_clients_with_error': 'Nenhum cliente com erros',
          'table': {
            'seller': 'Vendedor',
            'client_code': 'Código do cliente',
            'legal_name': 'Razão social',
            'cif': 'NIF',
            'observation': 'Observação'
          },
          'no_data_to_import': 'Você deve escolher pelo menos um cliente para modificar ou adicionar',
          'import_success': 'Clientes importados com sucesso'
        },
        'clients_list_create': 'Criar cliente',
        'fields': {
          'client': 'buscar cliente',
          'seller': 'vendedor',
          'cfia': 'CFIA',
          'cif': 'NIF',
          'client_code': 'código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'número de empregados',
          'lounges_quantity': 'número de saloes',
          'legal_name': 'razão social',
          'phone': 'telefono',
          'cellphone': 'telemovel',
          'address': 'endereço',
          'city': 'cidadde',
          'province': 'província',
          'postal_code': 'código Postal',
          'web': 'web',
          'headquarters': 'Sede social',
          'owner_name': 'Nome propietario',
          'online_shop': 'Loja online',
          'online_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'resale_shop': 'Loja revenda',
          'resale_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'have_salon_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'have_salon': 'Tem salão',
          'have_salon_yes': 'Sim',
          'have_salon_no': 'Ñao',
          'nioxin_past_quantity': 'Nioxin quantidade passada',
          'sebastian_past_quantity': 'Sebastian quantidade passada',
          'sp_past_quantity': 'SP quantidade passada',
          'system_ec_past_quantity': 'System EC quantidade passada',
          'wella_past_quantity': 'Wella quantidade passada',
          'wella_real_past_quantity': 'Wella quantidade passada real',
          'total_contracted_past_quantity': 'Valor total contratado na última',
          'discharge_date': 'data alta',
          'status': 'estado',
          'status_options': {
            'active': 'Ativo',
            'inactive': 'Inativo'
          },
          'recruiting_lr': 'recrutamento LR',
          'recruiting_lr_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'conditions': 'Condições',
          'conditions_options': {
            'image_conditions': 'Dou o meu consentimento para que a sociedade possa capturar a minha imagem'
          },
          'email_invoices': 'Cliente deseja receber faturas via e-mail?',
          'email_invoices_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'create_button': 'Criar cliente',
        'create_success': 'Cliente criado com sucesso',
        'clients_update': 'Editar cliente',
        'update_button': 'Editar cliente',
        'update_success': 'Cliente editado com sucesso',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja excluir esse cliente?'
        },
        'delete_success': 'Cliente excluído com sucesso'
      }
    },
    'clients_records': {
      'header': {
        'clients_records_list': 'Listagem'
      },
      'list': {
        'clients_list': 'Lista de guias do cliente',
        'export_clients_records': 'Exportar arquivo do cliente',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'cif': 'NIF',
          'client_code': 'Código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'discharge_date': 'Data alta',
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente'
          },
          'updated': 'Atualizado',
          'updated_options': {
            'yes': 'Sim',
            'not': 'Ñao'
          },
          'recruiting_lr': 'Contratação LR',
          'mkt_news': 'Condições de correio',
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'pdf': 'Veja PDF',
          'sort_options': {
            'created_at': 'Data de criação',
            'cif': 'NIF',
            'client_code': 'Código do cliente',
            'email': 'Correio eletrônico',
            'employees': 'Empregados',
            'lounge': 'Salão',
            'legal_name': 'Razão social',
            'discharge_date': 'Data alta',
            'status': 'Estado',
            'recruiting_lr': 'Contratação LR',
            'mkt_news': 'Condições de correio'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'client_code': 'Código do cliente',
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente'
          },
          'sales_area': 'Area venda',
          'activity': 'Atividade',
          'update_client': 'Atualizar cliente',
          'update_client_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'cfia': 'CFIA',
          'associate_account_1': 'Conta associada 1',
          'associate_account_2': 'Conta associada 2',
          'associate_account_3': 'Conta associada 3',
          'date': 'Data',
          'closing_days': 'Dia encerramento',
          'email': 'Correio eletrônico',
          'email_invoices': 'Faturas email',
          'mkt_news_2': 'Dados Pessoais',
          'dados_pessoais': 'Imagen',
          'email_invoices_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'delivery_time': 'Horario entrega',
          'resale_shop': 'Loja revenda',
          'resale_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'online_shop': 'Loja online',
          'online_shop_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'particular_address': 'Morada particular',
          'particular_address_cp': 'Morada particular CP',
          'particular_address_location': 'Morada particular localidade',
          'address_1': 'Morada 1',
          'address_1_cp': 'Morada 1 CP',
          'address_1_localidade': 'Morada 1 localidade',
          'address_2': 'Morada 2',
          'address_2_cp': 'Morada 2 CP',
          'address_2_localidade': 'Morada 2 localidade',
          'address_observations': 'Morada observaciones',
          'nif': 'NIF',
          'nioxin_support': 'Nioxin apoio',
          'mkt_news': 'Condições de correio',
          'mkt_news_yes': 'Sim',
          'mkt_news_no': 'Ñao',
          'employees_quantity': 'Número de empregados',
          'lounges_quantity': 'Número de saloes',
          'legal_name': 'Razão social',
          'sebastian_support': 'Sebastian apoio',
          'headquarters': 'Sede social',
          'headquarters_cp': 'Sede social CP',
          'headquarters_location': 'Sede social localidade',
          'sp_support': 'SP apoio',
          'phone': 'Telefono',
          'cellphone': 'Telemovel',
          'client_type': 'Tipo cliente',
          'wella_support': 'Wella apoio',
          'owner_name': 'Nome propietario',
          'industry_code': ' Industry Code Details ',
          'customer_class': 'CUSTOMER CLASS ',
          'email_invoices_1': 'Email fatura 1',
          'email_invoices_2': 'Email fatura 2',
          'my_creation_date': 'Fecha creacion',
          'pdf': 'Veja PDF'
        },
        'not_have_associated_accounts': 'Este cliente não possui contas associadas',
        'menu_more_options': {
          'approve': 'aprova',
          'disapprove': 'desaprovar'
        },
        'associate_account_modal': {
          'title': 'Conta associada',
          'fields': {
            'client': 'procure um cliente',
            'legal_name': 'razão social',
            'cif': 'NIF',
            'email': 'Correio eletrônico'
          },
          'button': 'Conta associada',
          'success': 'Conta associada ao sucesso'
        },
        'associated_accounts_modal': {
          'title': 'Contas associadas',
          'menu_more_options': {
            'delete_association': 'Remover associação'
          },
          'question_modal': {
            'title': 'Aviso',
            'question': 'Tem certeza de que deseja excluir esta associação?'
          },
          'delete_success': 'Associação eliminada com sucesso'
        },
        'import_clients_modal': {
          'title': 'Importar clientes por CSV',
          'import_clients': 'Importar clientes',
          'fields': {
            'separator': 'Separador',
            'separator_options': {
              'coma': ',',
              'semicolon': ';',
              'pipe': '|'
            },
            'csv': 'Carregar documento CSV'
          },
          'please_wait': 'Aguarde um momento',
          'clients_to_update': 'Clientes para modificar',
          'clients_to_create': 'Clientes para adicionar',
          'clients_with_error': 'Clientes com erros',
          'no_clients_to_update': 'Não há clientes a serem modificados',
          'no_clients_to_create': 'Nenhum cliente para adicionar',
          'no_clients_with_error': 'Nenhum cliente com erros',
          'table': {
            'seller': 'Vendedor',
            'client_code': 'Código do cliente',
            'legal_name': 'Razão social',
            'cif': 'NIF',
            'observation': 'Observação'
          },
          'no_data_to_import': 'Você deve escolher pelo menos um cliente para modificar ou adicionar',
          'import_success': 'Clientes importados com sucesso'
        },
        'clients_list_create': 'Criar cliente',
        'fields': {
          'client': 'buscar cliente',
          'seller': 'vendedor',
          'cfia': 'CFIA',
          'cif': 'NIF',
          'client_code': 'código do cliente',
          'email': 'Correio eletrônico',
          'employees_quantity': 'número de empregados',
          'lounges_quantity': 'número de saloes',
          'legal_name': 'razão social',
          'receive_communications': 'Receber Comunicações',
          'receive_communications_options': {
            'receive_communications': 'Receber Comunicações'
          },
          'discharge_date': 'data alta',
          'status': 'estado',
          'status_options': {
            'active': 'Ativo',
            'inactive': 'Inativo'
          },
          'recruiting_lr': 'recrutamento LR',
          'recruiting_lr_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'conditions': 'Condições',
          'conditions_options': {
            'image_conditions': 'Dou o meu consentimento para que a sociedade possa capturar a minha imagem'
          }
        },
        'create_button': 'Criar cliente',
        'create_success': 'Cliente criado com sucesso',
        'approve_client_record_success': 'Arquivo de cliente bem sucedido',
        'update_button': 'Editar cliente',
        'update_success': 'Cliente editado com sucesso',
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja desaprovar este arquivo de cliente?'
        },
        'disapprove_success': 'arquivo de cliente reprovado com sucesso',
        'approve_client_record_window': {
          'title': 'Aprova o arquivo do cliente',
          'search_button': 'aprova'
        }
      }
    },
    'contracts': {
      'header': {
        'contracts_list': 'Contratos',
        'contracts_sda': 'SDA',
        'contracts_history': 'Histórico',
        'contracts_zips': 'Zips'
      },
      'list': {
        'contracts_list': 'Lista de contratos',
        'create_contract': 'Criar um contrato',
        'export_contracts': 'Contratos de exportação',
        'export_zip_pdfs': 'Exportar PDFs Zip',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Status',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'since': 'De',
          'until': 'Para cima',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social'
        },
        'no_results': 'nenhum resultado encontrado',
        'forward_email': 'Reenviar Email',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'observations': 'Observações',
          'timestamp': 'Timestamp',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'employees_quantity': 'Funcionários',
          'email': 'Correio eletrônico',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'pdf': 'Veja PDF',
          'salons': 'SALÕES',
          'premium': 'PREMIUM',
          'premium_agreement': 'Premium Acordo',
          'premium_ATS': 'Premium ATS',
          'premium_PTS': 'Premium PTS',
          'premium_Brands': 'Premium Marcas',
          'premium_MTKG': 'Premium Pacote de Apoio',
          'premium_rappel_1': 'Premium % RAPPEL',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_variable_discount_1': 'Premium Dto Variável',
          'premium_variable_discount_2': 'Premium Dto Variável 2',
          'premium_salon': 'Premium Tipo de Cliente',
          'premium_education': 'Premium Educação',
          'premium_potential': 'Premium Potencial',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_date': 'Fecha',
          'premium_salon_value': 'Valor do salão',
          'premium_MTKG_Subtype': 'Premium Pacote de Apoio Seleção',
          'premium_section_1': 'Premium Section',
          'premium_section_2': 'Premium Section 2',
          'premium_discount_1': 'PremiumDesconto',
          'premium_discount_2': 'PremiumDesconto 2',
          'premium_event': 'Premium Evento',
          'prestige': 'PRESTIGE',
          'prestige_agreement': 'Prestige ACUERDO',
          'prestige_ATS': 'Prestige ATS',
          'prestige_PTS': 'Prestige PTS',
          'prestige_Brands': 'Prestige MARCAS',
          'prestige_MTKG': 'Prestige Pacote de Apoio',
          'prestige_salon': 'Prestige Tipo de Cliente',
          'prestige_education': 'Prestige Educação',
          'prestige_potential': 'Prestige Potencial',
          'prestige_rappel_1': 'Prestige % RAPPEL',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'Prestige RAPPEL Freqüência',
          'prestige_variable_discount_1': 'Prestige Dto Variável 1',
          'prestige_variable_discount_2': 'Prestige Dto Variável 2',
          'prestige_discount_total': 'Prestige DTO (TOTAL)',
          'prestige_date': 'Data',
          'prestige_salon_value': 'Valor do salão',
          'prestige_MTKG_Subtype': 'Prestige Pacote de Apoio Seleção',
          'prestige_section_1': 'Prestige Section',
          'prestige_section_2': 'Prestige Section 2',
          'prestige_discount_1': 'PrestigeDesconto 1',
          'prestige_discount_2': 'PrestigeDesconto 2',
          'prestige_event': 'Prestige Evento',
          'dso': 'DSO',
          'dso_agreement': 'WELLA FY27',
          'dso_PTS': 'Prestige PTS',
          'dso_Brands': 'MARCAS',
          'dso_MTKG': 'Pacote de Apoio',
          'dso_salon': 'Tipo de Cliente',
          'dso_education': 'EDUCAÇÃO',
          'dso_potential': 'POTENCIAL',
          'dso_rappel': '% Rappel Wella, Nioxin, Sebastian, SP, wedo y Briogeo',
          'briogeo_rappel': '% Rappel Briogeo',
          'dso_rappel_marketing': '% RAPPEL MARKETING',
          'dso_rappel_frequency': 'RAPPEL FREQÜÊNCIA',
          'dso_discount': 'DTO (TOTAL)',
          'dso_date': 'Data',
          'dso_salon_value': 'Valor do salão',
          'dso_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'dso_section': 'Section',
          'has_prestige_condition_FY2223': 'Condições especiais Prestige',
          'iso': 'ISO',
          'wella': 'WELLA',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'wella_quantity': 'WELLA & NIOXIN & OPI QUANTIDADE',
          'wella_support': 'Wella apoio',
          'wella_discount': 'WELLA & NIOXIN & OPI Desconto',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_euros': '€ Sassoon',
          'rappel_antecipado': 'Rappel antecipado',
          'sebastian_man_rappel': 'Sebastian Man rappel',
          'sebastian_man_discount': 'Sebastian Man desconto',
          'nioxin_quantity': 'Nioxin quantidade',
          'nioxin_support': 'Nioxin apoio',
          'sp_quantity': 'SP quantidade',
          'sp_support': 'SP apoio',
          'system_ec_quantity': 'System EC quantidade',
          'system_ec_support': 'System EC apoio',
          'sebastian_quantity': 'Sebastian quantidade',
          'sebastian_support': 'Sebastian apoio',
          'sebastian_brand_rappel': 'Sebastian rappel acordo',
          'sebastian_growth_rappel': 'Sebastian rappel crescimento',
          'sebastian_total_rappel': 'Sebastian rappel total',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'system_ec_potential': 'Potencial System EC',
          'sebastian_potential': 'Potencial Sebastian',
          'seb_man_rappel': 'Rappel Sebman/Nioxin',
          'seb_man_discount': 'Desconto Sebman/Nioxin',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_rappel': 'Rappel Opi',
          'changeds': 'MODIFICAÇÕES',
          'changed_quantity': 'Montante',
          'changed_franchise': 'Franquia',
          'changed_rappel_period': 'Freq Rappel',
          'changed_associates': 'Associados',
          'changed_MTKG': 'MKTG',
          'digital_signature': 'Consentimiento',
          'virtual_signed': 'Digital',
          'virtual_signApproved': 'Aprovado',
          'mail_auto_renew': 'Auto-renovável',
          'mail_new_package': 'Novo pacote',
          'dados_pessoais': 'Dados Pessoais',
          'dto_zto_wellastore': 'DTO ZTO wellastore',
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated': 'Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses prorrateados',
          'has_email_invoices': '¿desea fra electrónica?',
          'email_invoices_1': 'mail fra electrónica 1',
          'email_invoices_2': 'mail fra electrónica 2'
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Contrato de arquivo'
        },
        'question_modal': {
          'title': 'Aviso',
          'question': 'Tem certeza de que deseja arquivar este contrato?'
        },
        'contracts_list_create': 'Criar um contrato',
        'client_not_have_relations': 'Este cliente não possui associações',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial e descontos',
        'observations': 'Observações',
        'block_premium': 'PREMIUM',
        'block_prestige': 'PRESTIGE',
        'block_wella': 'WELLA',
        'block_opi': 'OPI',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'contract_mode': 'Modo de contrato',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'app_creation_cate': 'Data',
          'associate_accounts': 'Conta associada',
          'brands': 'MARCAS',
          'prestige': 'PRESTIGE',
          'prestige_date': 'Data',
          'prestige_Brands': 'Adicionar marcas',
          'prestige_Brands_view': 'Marcas',
          'prestige_MTKG_Subtype_Brands': 'Seleção do pacote de suporte, até duas opções',
          'prestige_ATS': 'ATS',
          'prestige_PTS': 'PTS',
          'prestige_event': 'Prestige Event',
          'prestige_MTKG': 'Pacote de suporte',
          'prestige_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'prestige_salon': 'Digite Cliente',
          'prestige_salon_options': {
            'grand_salon': 'Grand Salon',
            'imagen': 'Imagen',
            'partner': 'Partner'
          },
          'prestige_salon_value': 'Valor do salão',
          'prestige_education': 'Educação',
          'prestige_potential': 'Potencial',
          'prestige_rappel_frequency': 'Rappel Freqüência',
          'prestige_section_1': 'Seção',
          'prestige_section_2': 'Seção 2',
          'prestige_section_3': 'Seção 3',
          'prestige_rappel_1': 'Rappel',
          'prestige_rappel_2': 'Rappel 2',
          'prestige_rappel_3': 'Rappel 3',
          'prestige_rappel_marketing_1': 'Rappel Marketing',
          'prestige_rappel_marketing_2': 'Rappel Marketing 2',
          'prestige_rappel_marketing_3': 'Rappel Marketing 3',
          'prestige_discount_1': 'Desconto',
          'prestige_discount_2': 'Desconto 2',
          'prestige_discount_3': 'Desconto 3',
          'prestige_variable_discount_1': 'Desconto Variável',
          'prestige_variable_discount_2': 'Desconto Variável 2',
          'prestige_variable_discount_3': 'Desconto Variável 3',
          'premium': 'PREMIUM',
          'premium_date': 'Data',
          'premium_Brands': 'Adicionar marcas',
          'premium_Brands_view': 'Marcas',
          'premium_MTKG': 'Pacote de suporte',
          'premium_ATS_1': 'ATS',
          'premium_ATS_2': 'ATS 2',
          'premium_ATS_3': 'ATS 3',
          'premium_PTS_1': 'PTS',
          'premium_PTS_2': 'PTS 2',
          'premium_PTS_3': 'PTS 3',
          'premium_event': 'Premium Event',
          'premium_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'premium_section_1': 'Seção',
          'premium_section_2': 'Seção 2',
          'premium_rappel_1': 'Rappel',
          'premium_section_3': 'Seção 3',
          'premium_rappel_2': 'Rappel 2',
          'premium_rappel_3': 'Rappel 3',
          'premium_rappel_marketing_1': 'Rappel Marketing',
          'premium_rappel_marketing_2': 'Rappel Marketing 2',
          'premium_rappel_marketing_3': 'Rappel Marketing 3',
          'premium_discount_1': 'Desconto',
          'premium_discount_2': 'Desconto 2',
          'premium_discount_3': 'Desconto 3',
          'premium_variable_discount_1': 'Desconto Variável',
          'premium_variable_discount_2': 'Desconto Variável 2',
          'premium_variable_discount_3': 'Desconto Variável 3',
          'premium_education_1': 'Educação',
          'premium_education_2': 'Educação 2',
          'premium_education_3': 'Educação 3',
          'premium_salon': 'Digite Cliente',
          'premium_salon_options': {
            'wella_create': 'Wella Create',
            'wella_artist': 'Wella Artist',
            'wella_business': 'Wella Business Club',
            'wella_vip': 'Wella Vip'
          },
          'premium_salon_value': 'Valor do salão',
          'premium_potential': 'Potential',
          'premium_rappel_frequency': 'Rappel Freqüência',
          'dso': 'DSO',
          'dso_date': 'Data',
          'dso_drands_view': 'Marcas',
          'dso_MTKG_Subtype_Brands': 'Seleção do pacote de suporte, até duas opções',
          'dso_PTS': 'PTS',
          'dso_MTKG': 'Pacote de suporte',
          'dso_MTKG_Subtype': 'Pacote de Apoio Seleção',
          'dso_salon': 'Digite Cliente',
          'dso_salon_options': {
            'grand_salon': 'Grand Salon',
            'imagen': 'Imagen',
            'partner': 'Partner'
          },
          'dso_salon_value': 'Valor do salão',
          'dso_education': 'Educação',
          'dso_potential': 'Potencial',
          'dso_rappel_frequency': 'Rappel Freqüência',
          'dso_section': 'Seção',
          'dso_rappel': 'Rappel',
          'briogeo_rappel': 'Rappel Briogeo',
          'dso_rappel_marketing': 'Rappel Marketing',
          'dso_discount': 'Desconto',
          'has_prestige_condition_FY2223': 'O Prestige FY2223 tem condições especiais?',
          'BRAND_WELLA': 'Wella',
          'BRAND_SP': 'SP',
          'BRAND_NIOXIN': 'Nioxin',
          'BRAND_SP_DIAMOND': 'SSP',
          'BRAND_SASSOON': 'Sassoon',
          'BRAND_SEBASTIAN': 'Sebastian',
          'iso': 'ISO',
          'wella': 'WELLA',
          'wella_quantity': 'Quantidade',
          'wella_discount': 'Wella DTO Wella/OPI/Nioxim',
          'wella_volume_rappel': 'Rapel Wella/OPI/Nioxim',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'seb_man_rappel': 'Rappel Nioxin/OPIOPI',
          'seb_man_discount': 'Desconto Nioxin/OPI',
          'observations': 'Observações',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'pdf': 'Adicionar arquivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          },
          'salon_options': {
            'grand_salon': 'Grand Salon',
            'imagen': 'Imagen',
            'partner': 'Partner'
          },
          'premium_MTKG_options': {
            'wella_app': 'Wella APP',
            'congreso': '€ Congreso',
            'evento_app': 'Evento Wella + Wella APP',
            'evento_congreso': 'Evento Wella + € Congreso',
            'rappel_mkt': 'Rappel MKT',
            'evento_rappel_mkt': 'Evento Wella + Rappel MKT'
          },
          'prestige_MTKG_options': {
            'wella_app': 'Wella APP',
            'congreso': '€ Congreso',
            'evento_sebastian': 'Evento Sebastian + Wella APP',
            'evento_sebastian_congreso': 'Evento Sebastian + € Congreso',
            'rappel_mkt': 'Rappel MKT',
            'evento_rappel_mkt': 'Evento Sebastian + Rappel MKT'
          },
          'MTKG_options': {
            'congreso_eventos': '€ Congresso / Eventos',
            'rappel_marketing': 'Rappel Marketing',
            'prestige_app': 'PRESTIGE APP',
            'wella_app': 'WELLA APP'
          },
          'MTKG_Subtype_digital_options': {
            'koibox': 'Koibox',
            'google_adwords': 'Google Adwords',
            'treatwell': 'Treatwell (Disponible solo en MAD/BCN)'
          },
          'prorated': 'Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses rateados',
          'opi': 'OPI',
          'opi_rappel': 'OPI rappel',
          'opi_quantity': 'quantidade OPI',
          'opi_discount': 'desconto OPI',
          'add_Brands': 'Adicionar marcas',
          'view_brands': 'Marcas'
        },
        'create_button': 'Criar um contrato',
        'create_success': 'Contrato criado com sucesso',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado com sucesso',
        'archive_success': 'Contrato arquivado com sucesso',
        'send_mail_success': 'O email foi enviado com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Posso',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Año'
          },
          'download_button': 'descargar zip'
        }
      },
      'sda': {
        'sda_list': 'Contratos SDA',
        'create_contract_sda': 'Criar contrato SDA',
        'export_zip_pdfs': 'Exportar Zip PDFs',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Não exportado'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'sda_sp': 'SDA System Professional',
          'sda_sp_options': {
            'ok': 'ok'
          },
          'sda_sp_internet': 'SDA SP Internet',
          'sda_sp_internet_options': {
            'ok': 'ok'
          },
          'sda_sp_men': 'SDA SP Men',
          'sda_sp_men_options': {
            'ok': 'ok'
          },
          'sda_system_ec': 'SDA System EC',
          'sda_system_ec_options': {
            'ok': 'ok'
          },
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_options': {
            'ok': 'ok'
          },
          'sda_sebastian_internet': 'SDA Sebastian Internet',
          'sda_sebastian_internet_options': {
            'ok': 'ok'
          },
          'sda_ghd': 'SDA GHD',
          'sda_ghd_options': {
            'ok': 'ok'
          },
          'sda_wedo': 'SDA Wedo',
          'sda_wedo_options': {
            'ok': 'ok'
          },
          'sp_date': 'SP Data',
          'sp_internet_date': 'SP Internet Data',
          'sp_men_date': 'SP Men Data',
          'sp_system_ec_date': 'System EC Data',
          'sebastian_date': 'Sebastian Data',
          'sebastian_internet_date': 'Sebastian Internet Data',
          'sda_ghd_date': 'SDA GHD Data',
          'sda_wedo_date': 'SDA Wedo Data',
          'sda_date': 'SDA Data Ult',
          'normal_sda_pdf': 'SDA PDF',
          'system_ec_sda_pdf': 'SDA System EC PDF',
          'sebastian_sda_pdf': 'SDA Sebastian PDF',
          'sda_wedo_pdf': 'Ver PDF SDA Wedo',
          'sda_link_pdf': 'Ver PDF',
          'normal_sda_virtual_signed': 'SDA Consentimiento digital',
          'system_ec_sda_virtual_signed': 'SDA System EC Consentimiento digital',
          'wedo_sda_virtual_signed': 'SDA Wedo Consentimiento digital',
          'sebastian_sda_virtual_signed': 'SDA Sebastian Consentimiento digital',
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Contrato de arquivo'
        },
        'create_contract_window': {
          'title': 'Criar contrato SDA',
          'fields': {
            'client': 'Cliente',
            'sda_types': 'Tipos de SDA',
            'sda_types_options': {
              'sda_sp': 'SDA SP',
              'sda_sp_internet': 'SDA SP Internet',
              'sda_sp_men': 'SDA SP Men',
              'sda_system_ec': 'SDA System EC',
              'sda_sebastian': 'SDA Sebastian',
              'sda_sebastian_internet': 'SDA Sebastian Internet',
              'sda_ghd': 'SDA GHD',
              'sda_wedo': 'SDA Wedo'
            },
            'date': 'Data',
            'pdf': 'Adicionar arquivo PDF',
            'pdf_sp_diamond': 'Adicionar arquivo PDF Sp Diamond'
          },
          'create_button': 'Criar contrato SDA',
          'create_success': 'Contrato SDA criado com sucesso'
        },
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado com sucesso',
        'archive_success': 'Contrato arquivado com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Posso',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Año'
          },
          'download_button': 'baixar zip'
        }
      },
      'history': {
        'contracts_history': 'Histórico',
        'create_histrory': 'Criar histórico',
        'export_contracts': 'Contratos de exportação',
        'export_zip_pdfs': 'Exportar PDFs Zip',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'selectYears': 'Ano',
        'filters': {
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Status',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'since': 'De',
          'until': 'Para cima',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social'
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'timestamp': 'Timestamp',
          'seller': 'VENDEDORES',
          'client': 'CLIENTES',
          'associated': 'ASSOCIADOS',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'associated_code': 'Código',
          'associated_cif': 'NIF',
          'associated_email': 'Correio eletrônico',
          'associated_legal_name': 'Razão social',
          'associated_employees': 'Empregados',
          'observations': 'Observações',
          'prorated': '¿Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses rateados',
          'manual_date': 'Data Manual',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'pdf': 'Veja PDF',
          'salons': 'SALÕES',
          'premium': 'PREMIUM',
          'premium_agreement': 'Premium Acordo',
          'premium_ATS': 'Premium ATS',
          'premium_Brands': 'Premium Marcas',
          'premium_MTKG': 'Premium Pacote de Apoio',
          'premium_rappel_1': 'Premium % RAPPEL Escalada 1',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing 1',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_variable_discount_1': 'Premium Dto Variável 1',
          'premium_variable_discount_2': 'Premium Dto Variável 2',
          'premium_salon': 'Premium Tipo de Cliente',
          'premium_education': 'Premium Educação',
          'premium_potential': 'Premium Potencial',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_date': 'Data',
          'premium_salon_value': 'Valor do salão',
          'premium_MTKG_Subtype': 'Premium Pacote de Apoio Seleção',
          'premium_section_1': 'Premium Section 2',
          'premium_section_2': 'Premium Section 2',
          'premium_discount_1': 'PremiumDesconto 1',
          'premium_discount_2': 'PremiumDesconto 2',
          'prestige': 'PRESTIGE',
          'prestige_agreement': 'Prestige ACUERDO',
          'prestige_ATS': 'Prestige ATS',
          'prestige_Brands': 'Prestige MARCAS',
          'prestige_MTKG': 'Prestige Pacote de Apoio',
          'prestige_salon': 'Prestige Tipo de Cliente',
          'prestige_education': 'Prestige Educação',
          'prestige_potential': 'Prestige Potencial',
          'prestige_rappel_1': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing 1',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'Prestige RAPPEL Freqüência',
          'prestige_variable_discount_1': 'Prestige Dto Variável 1',
          'prestige_variable_discount_2': 'Prestige Dto Variável 2',
          'prestige_discount_total': 'Prestige DTO (TOTAL)',
          'prestige_date': 'Data',
          'prestige_salon_value': 'Valor do salão',
          'prestige_MTKG_Subtype': 'Prestige Pacote de Apoio Seleção',
          'prestige_section_1': 'Prestige Section 2',
          'prestige_section_2': 'Prestige Section 2',
          'prestige_discount_1': 'PrestigeDesconto 1',
          'prestige_discount_2': 'PrestigeDesconto 2',
          'iso': 'ISO',
          'wella': 'WELLA',
          'wella_quantity': 'Wella quantidade',
          'wella_support': 'Wella apoio',
          'wella_discount': 'Desconto',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'rappel_antecipado': 'Rappel antecipado',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'nioxin_quantity': 'Nioxin quantidade',
          'nioxin_support': 'Nioxin apoio',
          'sp_quantity': 'SP quantidade',
          'sp_support': 'SP apoio',
          'system_ec_quantity': 'System EC quantidade',
          'system_ec_support': 'System EC apoio',
          'sebastian_quantity': 'Sebastian quantidade',
          'sebastian_support': 'Sebastian apoio',
          'sebastian_brand_rappel': 'Sebastian rappel acordo',
          'sebastian_growth_rappel': 'Sebastian rappel crescimento',
          'sebastian_total_rappel': 'Sebastian rappel total',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'system_ec_potential': 'Potencial System EC',
          'sebastian_potential': 'Potencial Sebastian',
          'seb_man_rappel': 'Rappel Nioxin/Sebman',
          'seb_man_discount': 'Desconto Nioxin/Sebman',
          'wella_date': 'Data',
          'wella_salon': 'Salão',
          'wella_rappel': 'Rappel',
          'wella_variable_discount': 'DTO Variable',
          'wella_trade': 'Trade',
          'sp': 'SYSTEM',
          'sp_date': 'Data',
          'sp_salon': 'Salon',
          'sp_discount': 'DTO',
          'sp_rappel': 'Rappel',
          'sp_variable_discount': 'DTO Variable',
          'sebastian': 'SEBASTIAN',
          'sebastian_date': 'Data',
          'sebastian_salon': 'Salon',
          'sebastian_discount': 'DTO',
          'sebastian_rappel': 'Rappel',
          'sassoon': 'SASSON',
          'sassoon_date': 'Data',
          'sassoon_quantity': 'Professional',
          'sassoon_salon': 'Salon',
          'sassoon_discount': 'DTO',
          'sassoon_rappel': 'Rappel',
          'sassoon_potential': 'Potencial',
          'sp_diamond': 'SP DIAMOND',
          'sp_diamond_date': 'Data',
          'sp_diamond_quantity': 'Professional',
          'sp_diamond_salon': 'Salon',
          'sp_diamond_discount': 'DTO',
          'sp_diamond_rappel': 'Rappel',
          'sp_diamond_potential': 'Potencial',
          'nioxin': 'NIOXIN',
          'nioxin_date': 'Data',
          'nioxin_salon': 'Salon',
          'nioxin_discount': 'DTO',
          'nioxin_summer_discount': 'DTO Verano',
          'nioxin_rappel': 'Rappel',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_discount': 'DTO',
          'opi_rappel': 'Rappel Opi',
          'opi_potential': 'Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'comments': 'Comentarios',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mail_conditions': 'Condições de correio',
          'mail_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'image_conditions': 'Condiciones imagen',
          'image_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea archivar este contrato?'
        },
        'contracts_history_create': 'Crear historial',
        'client_not_have_relations': 'Este cliente não possui associações',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial y descuentos',
        'observations': 'Observaciones',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'associate_accounts': 'Asociar cuentas',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses prorrateados',
          'manual_date': 'Data Manual',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'pdf': 'Agregar archivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          },
          'wella_date': 'Wella Data',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Wella Descuento',
          'wella_rappel': 'Wella Rappel',
          'wella_potential': 'Wella Potencial',
          'wella_variable_discount': 'Wella Descuento Variable',
          'wella_trade': 'Wella Trade',
          'sp_date': 'System Data',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'System Descuento',
          'sp_rappel': 'System Rappel',
          'sp_potential': 'System Potencial',
          'sp_variable_discount': 'System Descuento Variable',
          'sp_diamond_date': 'SP Diamond Data',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Diamond Descuento',
          'sp_diamond_rappel': 'Diamond Rappel',
          'sp_diamond_potential': 'Diamond Potencial',
          'sebastian_date': 'Sebastian Data',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Sebastian Descuento',
          'sebastian_rappel': 'Sebastian Rappel',
          'sebastian_potential': 'Sebastian Potencial',
          'sassoon_date': 'Sassoon Data',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Sassoon Descuento',
          'sassoon_rappel': 'Sassoon Rappel',
          'sassoon_potential': 'Sassoon Potencial',
          'nioxin_date': 'Nioxin fecha',
          'nioxin_quantity': 'Nioxin Professional',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_discount': 'NioxinDescuento',
          'nioxin_summer_discount': 'Nioxin Desc. Verano',
          'nioxin_rappel': 'Nioxin Rappel',
          'nioxin_potential': 'Nioxin Potencial',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Opi Descuento',
          'opi_rappel': 'Opi Rappel',
          'opi_potential': 'Opi Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'create_button': 'Crear contrato',
        'create_success': 'Contrato creado con éxito',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito',
        'export_zip_pdfs_window': {
          'title': 'Descargar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'download_button': 'descargar zip'
        },
        'create_history_window': {
          'title': 'Crear Historial',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'start_button': 'Generar Histrorial'
        },
        'message': {
          'status': {
            'finalized': 'Proceso finalizado con exito'
          }
        }
      },
      'zips': {
        'contract_list': 'Lista de arquivos Zips',
        'export_zip_pdfs': 'Gerar Zip',
        'please_wait': 'Por favor, aguarde um momento',
        'see_filters': 'Ver filtros',
        'filters': {
          'sort_ascending': 'Ordenar Ascendentemente',
          'sort_descending': 'Ordenar Descendentemente',
          'sort_options': {
            'created_at': 'Fecha de creación'
          },
          'limit': 'Límite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'seller_type': 'Tipo de Contracto',
          'seller_type_options': {
            'Tipo': 'Tipo de Contracto',
            'DSO': 'DSO',
            'ISO': 'ISO',
            'OPI': 'OPI'
          },
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Si',
            'no': 'No'
          },
          'since': 'Desde',
          'until': 'Hasta',
          'seller': 'Vendedor',
          'delegation': 'Delegación',
          'client_code': 'ID cliente',
          'client_cif': 'NIF',
          'legal_name': 'Razón social'
        },
        'no_results': 'Nenhum resultado encontrado',
        'forward_email': 'Encaminhar e-mail',
        'limit_zips': 'Você atingiu o limite máximo de Zips permitidos.',
        'table': {
          'date': 'Data',
          'zipPDF': 'ZipPDF',
          'since': 'Desde',
          'until': 'Até',
          'state': 'State',
          'sizeFile': 'tamanho Zip',
          'totalPDFs': 'Total de PDFs',
          'expire': 'Data de Expiração',
          'actions': 'Ações',
          'year': 'Ano',
          'month': 'Mês'
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Livrar-se de',
          'question': 'Tem certeza de que deseja excluir este zip?'
        },
        'create_success': 'Zip gerado com sucesso',
        'delete_success': 'Zip excluído com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mês',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Maio',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Ano'
          },
          'download_button': 'baixar zip'
        }
      }
    },
    'reports': {
      'header': {
        'master_data': 'Master Data',
        'sda': 'SDA',
        'potential': 'Potencial',
        'cci': 'CCI',
        'education': 'Educação'
      },
      'master_data': {
        'master_data_list': 'Relatório Master Data',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'export': {
          'no_data': 'Você deve selecionar pelo menos um contrato'
        },
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'groupings': {
          'name': 'Agrupar por:',
          'codeClient': 'Código do cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor'
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'pages': 'Páginas',
          'pages_options': {
            'all': 'Todas Pág.',
            'current': 'Pag. atual'
          },
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'associated_accounts': 'Contas associadas',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'contractMode': 'Ano fiscal',
          'premium_agreement': 'Premium Acordo',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_rappel_1': 'Premium % RAPPEL',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_3': 'Premium % RAPPEL Escalada 3',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_cto_to': 'PREMIUM CTO VÁLIDO DE',
          'premium_cto_from': 'PREMIUM CTO VÁLIDO ATÉ',
          'prestige_agreement': 'ACUERDO',
          'prestige_discount_total': 'DTOS (TOTAL) wella&Nioxin&Sebastian&WeDO&SP',
          'prestige_rappel_1': '% RAPPEL',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 2',
          'prestige_rappel_3': 'Prestige % RAPPEL Escalada 3',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'RAPPEL Freqüência',
          'prestige_cto_to': 'CTO VÁLIDO DE',
          'prestige_cto_from': 'CTO VÁLIDO ATÉ',
          'dso': 'DSO',
          'dso_agreement': 'WELLA FY27',
          'dso_discount_total': 'DTOS (TOTAL)wella&Nioxin&Sebastian&WeDO&Sassoon&SP, Briogeo',
          'dso_rappel': '% Rappel Wella, Nioxin, Sebastian, SP, wedo, Sassoon y Briogeo',
          'briogeo_rappel': '% Rappel Briogeo',
          'dso_rappel_marketing': '% RAPPEL MARKETING',
          'dso_rappel_frequency': 'RAPPEL FREQÜÊNCIA',
          'dso_cto_to': 'CTO VÁLIDO DE',
          'dso_cto_from': 'CTO VÁLIDO ATÉ',
          'iso': 'ISO',
          'iso_cto_to': 'ISO CTO VÁLIDO DE',
          'iso_cto_from': 'ISO CTO VÁLIDO ATÉ',
          'wella': 'WELLA',
          'wella_quantity': 'ISO wella + opi + nioxin',
          'wella_support': 'Wella apoio',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'wella_total_discount': 'Desconto total da Wella',
          'wella_discount': 'ISO DTO: WELLA&NIOXIN&OPI',
          'wella_rappel_frequency': 'ISO RAPPEL FREQÜÊNCIA',
          'rappel_antecipado': 'Rappel antecipado',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'seb_man_rappel': 'Rappel Nioxin/OPI',
          'seb_man_discount': 'Desconto Nioxin/OPI',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_rappel': 'Rappel Opi',
          'opi_cto_to': 'OPI CTO VÁLIDO DE',
          'opi_cto_from': 'OPI CTO VÁLIDO ATÉ',
          'opi_rappel_frequency': 'OPI RAPPEL FREQÜÊNCIA',
          'dto_zto_wellastore': 'DTO ZTO wellastore',
          'observations': 'Observações',
          'timestamp': 'Timestamp',
          'changed_quantity': 'Montante',
          'changed_franchise': 'Criar Franquia',
          'changed_rappel_period': 'Freq Rappel',
          'changed_associates': 'Associados',
          'changed_MTKG': 'MKTG',
          'virtual_signed': 'Consentimiento digital',
          'virtual_signApproved': 'Consentimento aprovado',
          'has_email_invoices': '¿desea fra electrónica?',
          'email_invoices_1': 'mail fra electrónica 1',
          'email_invoices_2': 'mail fra electrónica 2',
          'changed_booleans': {
            'yes': 'Si',
            'no': 'No'
          },
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        }
      },
      'sda': {
        'sda_list': 'Relatório SDA',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'export': {
          'no_data': 'Você deve selecionar pelo menos um SDA'
        },
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'sda_sp': 'SDA System Professional',
          'sda_sp_internet': 'SDA SP Internet',
          'sda_sp_men': 'SDA SP Men',
          'sda_system_ec': 'SDA System EC',
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_internet': 'SDA Sebastian Internet',
          'sda_ghd': 'SDA GHD',
          'sda_wedo': 'SDA Wedo',
          'sp_date': 'SP Data',
          'sp_internet_date': 'SP Internet Data',
          'sp_men_date': 'SP Men Data',
          'sp_system_ec_date': 'System EC Data',
          'sebastian_date': 'Sebastian Data',
          'sebastian_internet_date': 'Sebastian Internet Data',
          'sda_ghd_date': 'SDA GHD Data',
          'sda_wedo_date': 'SDA Wedo Data',
          'sda_date': 'SDA Data Ult',
          'normal_sda_pdf': 'SDA PDF',
          'system_ec_sda_pdf': 'SDA System EC PDF',
          'sebastian_sda_pdf': 'SDA Sebastian PDF',
          'sda_link_pdf': 'Veja PDF',
          'sda_pdf': 'Veja PDF SDA',
          'sda_wedo_pdf': 'Veja PDF SDA Wedo',
          'sda_sassoon': 'SDA Sassoon',
          'sassoon_date': 'Sassoon Data',
          'sp_diamond': 'SP Diamond Data',
          'sda_sp_diamond_pdf': 'Veja PDF SDA SP Diamond',
          'sda_sp_diamond': 'SDA SP Diamond'
        }
      },
      'potential': {
        'potential_list': 'Relatório Potencial',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'employees_quantity': 'Número de empregados',
          'wella_potential': 'Potencial Wella',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'sassoon_potential': 'Potencial Sassoon',
          'sebastian_potential': 'Potencial Sebastian',
          'sp_diamond_potential': 'Potencial SP Diamond',
          'opi_potential': 'Potencial OPI'
        }
      },
      'cci': {
        'cci_list': 'Relatório CCI',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social',
          'image_conditions': 'Condições de imagem'
        }
      },
      'education': {
        'education_list': 'Relatório Educação',
        'export_data': 'Exportação excel',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'hasta',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Ñao exportados'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'email': 'Correo electrónico',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'wella_quantity': 'Wella cantidad',
          'wella_package': 'Pacote Wella',
          'sp_quantity': 'System cantidad',
          'sp_package': 'Pacote System',
          'nioxin_quantity': 'Nioxin cantidad',
          'nioxin_package': 'Pacote Nioxin',
          'sebastian_quantity': 'Sebastian cantidad',
          'sebastian_package': 'Pacote Sebastian',
          'sassoon_quantity': 'Sassoon cantidad',
          'sassoon_package': 'Pacote Sassoon',
          'salons': 'Quartos',
          'mkt_news': 'Condições de correio'
        }
      }
    },
    'history': {
      'header': {
        'contracts_list': 'Contratos',
        'contracts_sda_list': 'SDA'
      },
      'contracts': {
        'contracts_history': 'Histórico',
        'create_histrory': 'Criar histórico',
        'export_contracts': 'Contratos de exportação',
        'export_zip_pdfs': 'Exportar PDFs Zip',
        'please_wait': 'Aguarde um momento',
        'see_filters': 'Veja filtros',
        'selectYears': 'Ano',
        'filters': {
          'sort_ascending': 'Classifique Ascendente',
          'sort_descending': 'Classificar decrescente',
          'sort_options': {
            'created_at': 'Data de criação'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          },
          'state': 'Status',
          'state_options': {
            'green': 'Verde',
            'red': 'Vermelho',
            'yellow': 'Amarelo',
            'black': 'Preto',
            'purple': 'Roxo'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'since': 'De',
          'until': 'Para cima',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'client_code': 'Código do cliente',
          'legal_name': 'Razão social'
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'state': 'Estado',
          'state_options': {
            'ok': 'OK',
            'no_ok': 'Ñao OK',
            'pendiente_ok': 'Pendente',
            'archive': 'Arquivado',
            'retenido_asociado': 'Retenido x Associado'
          },
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'timestamp': 'Timestamp',
          'seller': 'VENDEDORES',
          'client': 'CLIENTES',
          'associated': 'ASSOCIADOS',
          'associated_1': 'Associado 1',
          'associated_2': 'Associado 2',
          'associated_3': 'Associado 3',
          'associated_4': 'Associado 4',
          'associated_5': 'Associado 5',
          'associated_code': 'Código',
          'associated_cif': 'NIF',
          'associated_email': 'Correio eletrônico',
          'associated_legal_name': 'Razão social',
          'associated_employees': 'Empregados',
          'observations': 'Observações',
          'prorated': '¿Contrato rateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses rateados',
          'manual_date': 'Data Manual',
          'training': 'Treinamento',
          'mkt_news': 'Condições de correio',
          'mkt_news_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'contractMode': 'Ano fiscal',
          'contractMode_1': 'Janeiro - Dezembro',
          'contractMode_2': 'Julho - Junho',
          'pdf': 'Veja PDF',
          'salons': 'SALÕES',
          'premium': 'PREMIUM',
          'premium_agreement': 'Premium Acordo',
          'premium_ATS': 'Premium ATS',
          'premium_Brands': 'Premium Marcas',
          'premium_MTKG': 'Premium Pacote de Apoio',
          'premium_rappel_1': 'Premium % RAPPEL Escalada 1',
          'premium_rappel_2': 'Premium % RAPPEL Escalada 2',
          'premium_rappel_marketing_1': 'Premium % RAPPEL Marketing 1',
          'premium_rappel_marketing_2': 'Premium % RAPPEL Marketing 2',
          'premium_discount_total': 'Premium Dto (TOTAL)',
          'premium_variable_discount_1': 'Premium Dto Variável 1',
          'premium_variable_discount_2': 'Premium Dto Variável 2',
          'premium_salon': 'Premium Tipo de Cliente',
          'premium_education': 'Premium Educação',
          'premium_potential': 'Premium Potencial',
          'premium_rappel_frequency': 'Premium RAPPEL Freqüência',
          'premium_date': 'Data',
          'premium_salon_value': 'Valor do salão',
          'premium_MTKG_Subtype': 'Premium Pacote de Apoio Seleção',
          'premium_section_1': 'Premium Section 2',
          'premium_section_2': 'Premium Section 2',
          'premium_discount_1': 'PremiumDesconto 1',
          'premium_discount_2': 'PremiumDesconto 2',
          'prestige': 'PRESTIGE',
          'prestige_agreement': 'Prestige ACUERDO',
          'prestige_ATS': 'Prestige ATS',
          'prestige_Brands': 'Prestige MARCAS',
          'prestige_MTKG': 'Prestige Pacote de Apoio',
          'prestige_salon': 'Prestige Tipo de Cliente',
          'prestige_education': 'Prestige Educação',
          'prestige_potential': 'Prestige Potencial',
          'prestige_rappel_1': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_2': 'Prestige % RAPPEL Escalada 1',
          'prestige_rappel_marketing_1': 'Prestige % RAPPEL Marketing 1',
          'prestige_rappel_marketing_2': 'Prestige % RAPPEL Marketing 2',
          'prestige_rappel_frequency': 'Prestige RAPPEL Freqüência',
          'prestige_variable_discount_1': 'Prestige Dto Variável 1',
          'prestige_variable_discount_2': 'Prestige Dto Variável 2',
          'prestige_discount_total': 'Prestige DTO (TOTAL)',
          'prestige_date': 'Data',
          'prestige_salon_value': 'Valor do salão',
          'prestige_MTKG_Subtype': 'Prestige Pacote de Apoio Seleção',
          'prestige_section_1': 'Prestige Section 2',
          'prestige_section_2': 'Prestige Section 2',
          'prestige_discount_1': 'PrestigeDesconto 1',
          'prestige_discount_2': 'PrestigeDesconto 2',
          'iso': 'ISO',
          'wella': 'WELLA',
          'wella_quantity': 'Wella quantidade',
          'wella_support': 'Wella apoio',
          'wella_discount': 'Desconto',
          'wella_brand_rappel': 'Wella rappel acordo',
          'wella_growth_rappel': 'Wella rappel crescimento',
          'wella_volume_rappel': 'Wella rappel volumen',
          'wella_total_rappel': 'Wella rappel total',
          'wella_potential': 'Potencial Wella',
          'rappel_antecipado': 'Rappel antecipado',
          'rappel_mktg': 'Rappel MKTG',
          'rappel_mktg_manual': 'Rappel MKTG Manual',
          'nioxin_quantity': 'Nioxin quantidade',
          'nioxin_support': 'Nioxin apoio',
          'sp_quantity': 'SP quantidade',
          'sp_support': 'SP apoio',
          'system_ec_quantity': 'System EC quantidade',
          'system_ec_support': 'System EC apoio',
          'sebastian_quantity': 'Sebastian quantidade',
          'sebastian_support': 'Sebastian apoio',
          'sebastian_brand_rappel': 'Sebastian rappel acordo',
          'sebastian_growth_rappel': 'Sebastian rappel crescimento',
          'sebastian_total_rappel': 'Sebastian rappel total',
          'nioxin_potential': 'Potencial Nioxin',
          'sp_potential': 'Potencial SP',
          'system_ec_potential': 'Potencial System EC',
          'sebastian_potential': 'Potencial Sebastian',
          'seb_man_rappel': 'Rappel Nioxin/Sebman',
          'seb_man_discount': 'Desconto Nioxin/Sebman',
          'wella_date': 'Data',
          'wella_salon': 'Salão',
          'wella_rappel': 'Rappel',
          'wella_variable_discount': 'DTO Variable',
          'wella_trade': 'Trade',
          'sp': 'SYSTEM',
          'sp_date': 'Data',
          'sp_salon': 'Salon',
          'sp_discount': 'DTO',
          'sp_rappel': 'Rappel',
          'sp_variable_discount': 'DTO Variable',
          'sebastian': 'SEBASTIAN',
          'sebastian_date': 'Data',
          'sebastian_salon': 'Salon',
          'sebastian_discount': 'DTO',
          'sebastian_rappel': 'Rappel',
          'sassoon': 'SASSON',
          'sassoon_date': 'Data',
          'sassoon_quantity': 'Professional',
          'sassoon_salon': 'Salon',
          'sassoon_discount': 'DTO',
          'sassoon_rappel': 'Rappel',
          'sassoon_potential': 'Potencial',
          'sp_diamond': 'SP DIAMOND',
          'sp_diamond_date': 'Data',
          'sp_diamond_quantity': 'Professional',
          'sp_diamond_salon': 'Salon',
          'sp_diamond_discount': 'DTO',
          'sp_diamond_rappel': 'Rappel',
          'sp_diamond_potential': 'Potencial',
          'nioxin': 'NIOXIN',
          'nioxin_date': 'Data',
          'nioxin_salon': 'Salon',
          'nioxin_discount': 'DTO',
          'nioxin_summer_discount': 'DTO Verano',
          'nioxin_rappel': 'Rappel',
          'opi': 'OPI ',
          'opi_quantity': 'Quantidade de Opi',
          'opi_discount': 'DTO',
          'opi_rappel': 'Rappel Opi',
          'opi_potential': 'Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'comments': 'Comentarios',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'mail_conditions': 'Condições de correio',
          'mail_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'image_conditions': 'Condiciones imagen',
          'image_conditions_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Archivar contrato'
        },
        'question_modal': {
          'title': 'Advertencia',
          'question': '¿Está seguro que desea archivar este contrato?'
        },
        'contracts_history_create': 'Crear historial',
        'client_not_have_relations': 'Este cliente não possui associações',
        'packages_to_buy': 'Marcas contratadas',
        'potential_and_discounts': 'Potencial y descuentos',
        'observations': 'Observaciones',
        'fields': {
          'client': 'Cliente',
          'state': 'Estatus',
          'state_options': {
            'green': 'Verde',
            'red': 'Rojo',
            'yellow': 'Amarrillo',
            'black': 'Negro',
            'purple': 'Purpura'
          },
          'associate_accounts': 'Asociar cuentas',
          'prorated': '¿Contrato prorrateado?',
          'prorated_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'prorated_month': 'Meses prorrateados',
          'manual_date': 'Data Manual',
          'observations': 'Observaciones',
          'comments': 'Comentarios',
          'pdf': 'Agregar archivo PDF',
          'conditions': 'Condiciones',
          'conditions_options': {
            'mail_conditions': 'He leído, comprendo, y doy mi consentimiento al tratamiento de datos',
            'image_conditions': 'Presto mi consentimiento para que la sociedad pueda captar mi imagen'
          },
          'wella_date': 'Wella Data',
          'wella_quantity': 'Wella Professional',
          'wella_salon': 'Wella Salon',
          'wella_discount': 'Wella Descuento',
          'wella_rappel': 'Wella Rappel',
          'wella_potential': 'Wella Potencial',
          'wella_variable_discount': 'Wella Descuento Variable',
          'wella_trade': 'Wella Trade',
          'sp_date': 'System Data',
          'sp_quantity': 'System Professional',
          'sp_salon': 'System Salon',
          'sp_discount': 'System Descuento',
          'sp_rappel': 'System Rappel',
          'sp_potential': 'System Potencial',
          'sp_variable_discount': 'System Descuento Variable',
          'sp_diamond_date': 'SP Diamond Data',
          'sp_diamond_quantity': 'SP Diamond Professional',
          'sp_diamond_salon': 'Diamond Salon',
          'sp_diamond_discount': 'Diamond Descuento',
          'sp_diamond_rappel': 'Diamond Rappel',
          'sp_diamond_potential': 'Diamond Potencial',
          'sebastian_date': 'Sebastian Data',
          'sebastian_quantity': 'Sebastian Professional',
          'sebastian_salon': 'Sebastian Salon',
          'sebastian_discount': 'Sebastian Descuento',
          'sebastian_rappel': 'Sebastian Rappel',
          'sebastian_potential': 'Sebastian Potencial',
          'sassoon_date': 'Sassoon Data',
          'sassoon_quantity': 'Sassoon Professional',
          'sassoon_salon': 'Sassoon Salon',
          'sassoon_discount': 'Sassoon Descuento',
          'sassoon_rappel': 'Sassoon Rappel',
          'sassoon_potential': 'Sassoon Potencial',
          'nioxin_date': 'Nioxin fecha',
          'nioxin_quantity': 'Nioxin Professional',
          'nioxin_salon': 'Nioxin Salon',
          'nioxin_discount': 'NioxinDescuento',
          'nioxin_summer_discount': 'Nioxin Desc. Verano',
          'nioxin_rappel': 'Nioxin Rappel',
          'nioxin_potential': 'Nioxin Potencial',
          'opi_quantity': 'Opi Professional',
          'opi_discount': 'Opi Descuento',
          'opi_rappel': 'Opi Rappel',
          'opi_potential': 'Opi Potencial',
          'kolleston_growth': 'Crecimiento Kolleston',
          'quarterly_rappel': '¿Rappel trimestral?',
          'quarterly_rappel_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'create_button': 'Crear contrato',
        'create_success': 'Contrato creado con éxito',
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado con éxito',
        'archive_success': 'Contrato archivado con éxito',
        'export_zip_pdfs_window': {
          'title': 'Descargar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'download_button': 'descargar zip'
        },
        'create_history_window': {
          'title': 'Crear Historial',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Enero',
              'february': 'Febrero',
              'march': 'Marzo',
              'april': 'Abril',
              'may': 'Mayo',
              'june': 'Junio',
              'july': 'Julio',
              'august': 'Agosto',
              'september': 'Septiembre',
              'october': 'Octubre',
              'november': 'Noviembre',
              'december': 'Diciembre'
            },
            'year': 'Año'
          },
          'start_button': 'Generar Histrorial'
        },
        'message': {
          'status': {
            'finalized': 'Proceso finalizado con exito'
          }
        }
      },
      'sda': {
        'sda_list': 'Contratos SDA',
        'create_contract_sda': 'Criar contrato SDA',
        'export_zip_pdfs': 'Exportar Zip PDFs',
        'see_filters': 'Veja filtros',
        'filters': {
          'since': 'de',
          'until': 'para cima',
          'exported': 'exportado',
          'exported_options': {
            'all': 'Mostrar tudo',
            'only_exported': 'Apenas exportado',
            'not_exported': 'Não exportado'
          },
          'limit': 'Limite',
          'limit_options': {
            '10': '10',
            '25': '25',
            '50': '50',
            '100': '100'
          }
        },
        'no_results': 'nenhum resultado encontrado',
        'table': {
          'exported': 'Exportado',
          'exported_options': {
            'yes': 'Sim',
            'no': 'Ñao'
          },
          'client': 'Cliente',
          'legal_name': 'Razão social',
          'seller': 'Vendedor',
          'delegation': 'Delegação',
          'sda_sp': 'SDA System Professional',
          'sda_sp_options': {
            'ok': 'ok'
          },
          'sda_sp_internet': 'SDA SP Internet',
          'sda_sp_internet_options': {
            'ok': 'ok'
          },
          'sda_sp_men': 'SDA SP Men',
          'sda_sp_men_options': {
            'ok': 'ok'
          },
          'sda_system_ec': 'SDA System EC',
          'sda_system_ec_options': {
            'ok': 'ok'
          },
          'sda_sebastian': 'SDA Sebastian',
          'sda_sebastian_options': {
            'ok': 'ok'
          },
          'sda_sebastian_internet': 'SDA Sebastian Internet',
          'sda_sebastian_internet_options': {
            'ok': 'ok'
          },
          'sda_ghd': 'SDA GHD',
          'sda_ghd_options': {
            'ok': 'ok'
          },
          'sda_wedo': 'SDA Wedo',
          'sda_wedo_options': {
            'ok': 'ok'
          },
          'sp_date': 'SP Data',
          'sp_internet_date': 'SP Internet Data',
          'sp_men_date': 'SP Men Data',
          'sp_system_ec_date': 'System EC Data',
          'sebastian_date': 'Sebastian Data',
          'sebastian_internet_date': 'Sebastian Internet Data',
          'sda_ghd_date': 'SDA GHD Data',
          'sda_wedo_date': 'SDA Wedo Data',
          'sda_date': 'SDA Data Ult',
          'normal_sda_pdf': 'SDA PDF',
          'system_ec_sda_pdf': 'SDA System EC PDF',
          'sebastian_sda_pdf': 'SDA Sebastian PDF',
          'sda_wedo_pdf': 'Ver PDF SDA Wedo',
          'sda_link_pdf': 'Ver PDF',
          'normal_sda_virtual_signed': 'SDA Consentimiento digital',
          'system_ec_sda_virtual_signed': 'SDA System EC Consentimiento digital',
          'wedo_sda_virtual_signed': 'SDA Wedo Consentimiento digital',
          'sebastian_sda_virtual_signed': 'SDA Sebastian Consentimiento digital',
          'booleans': {
            'yes': 'Sim',
            'no': 'Ñao'
          }
        },
        'menu_more_options': {
          'edit_contract': 'Editar contrato',
          'archive_contract': 'Contrato de arquivo'
        },
        'create_contract_window': {
          'title': 'Criar contrato SDA',
          'fields': {
            'client': 'Cliente',
            'sda_types': 'Tipos de SDA',
            'sda_types_options': {
              'sda_sp': 'SDA SP',
              'sda_sp_internet': 'SDA SP Internet',
              'sda_sp_men': 'SDA SP Men',
              'sda_system_ec': 'SDA System EC',
              'sda_sebastian': 'SDA Sebastian',
              'sda_sebastian_internet': 'SDA Sebastian Internet',
              'sda_ghd': 'SDA GHD',
              'sda_wedo': 'SDA Wedo'
            },
            'date': 'Data',
            'pdf': 'Adicionar arquivo PDF',
            'pdf_sp_diamond': 'Adicionar arquivo PDF Sp Diamond'
          },
          'create_button': 'Criar contrato SDA',
          'create_success': 'Contrato SDA criado com sucesso'
        },
        'contracts_update': 'Editar contrato',
        'update_button': 'Editar contrato',
        'update_success': 'Contrato editado com sucesso',
        'archive_success': 'Contrato arquivado com sucesso',
        'export_zip_pdfs_window': {
          'title': 'Baixar Zip de PDFs',
          'fields': {
            'month': 'Mes',
            'month_options': {
              'january': 'Janeiro',
              'february': 'Fevereiro',
              'march': 'Março',
              'april': 'Abril',
              'may': 'Posso',
              'june': 'Junho',
              'july': 'Julho',
              'august': 'Agosto',
              'september': 'Setembro',
              'october': 'Outubro',
              'november': 'Novembro',
              'december': 'Dezembro'
            },
            'year': 'Año'
          },
          'download_button': 'baixar zip'
        }
      }
    }
  },
  'utils': {
    'frequency': {
      'quarterly': 'trimestral',
      'biannual': 'semestre',
      'annual': 'anual'
    },
    'conditional': {
      'yes': 'Sim',
      'not': 'Ñao'
    },
    'type_client': 'Tipo de Cliente'
  }
});

/***/ }),

/***/ "pbmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__ = __webpack_require__("HDgC");










/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'login',
	data: function data() {
		return {
			form: {
				fields: {
					username: {
						id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('public.login.fields.username'),
						type: 'text',
						error: false,
						filters: {
							type: 'string',
							minLength: 4,
							maxLength: 100,
							required: true
						}
					},
					password: {
						id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
						display: true,
						value: '',
						name: this.$t('public.login.fields.password'),
						type: 'password',
						error: false,
						filters: {
							type: 'string',
							minLength: 4,
							maxLength: 100,
							required: true
						}
					}
				},
				active: false
			}
		};
	},

	methods: {
		formSubmit: function formSubmit() {

			var vm = this;

			if (vm.form.active) {

				return;
			}

			vm.form.active = true;

			setTimeout(function () {

				vm.$root.$emit('validate', [vm.form.fields, function (response) {

					if (!response.success) {

						vm.form.active = false;

						response.type = 'error';

						response.field.error = true;

						var dataToScroll = {
							selector: '#' + response.field.id,
							target: 'html, body'
						};

						__WEBPACK_IMPORTED_MODULE_5__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

						vm.$root.$emit('showMessage', response);

						return;
					}

					var dataToSend = {
						username: vm.form.fields.username.value,
						password: vm.form.fields.password.value
					};

					__WEBPACK_IMPORTED_MODULE_2__api_api__["a" /* default */].authentication.login(dataToSend).then(function (response) {

						vm.form.active = false;

						if (response.status != 200) {

							var message = {
								message: [vm.$t('errors.custom.001')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', message);

							return;
						}

						if (!response.data.success) {

							if (response.data.error.code == 101) {

								var _message = {
									message: [vm.$t('errors.parse.101')],
									type: 'error'
								};

								vm.$root.$emit('showMessage', _message);
							}

							return;
						}

						var route = '';

						if (route == '' && response.data.user.permissions.sellers) {

							route = __WEBPACK_IMPORTED_MODULE_3__router_routes__["a" /* default */].sellersList.name;
						}

						if (route == '' && response.data.user.permissions.clients) {

							route = __WEBPACK_IMPORTED_MODULE_3__router_routes__["a" /* default */].clientsList.name;
						}

						if (route == '' && response.data.user.permissions.contracts) {

							route = __WEBPACK_IMPORTED_MODULE_3__router_routes__["a" /* default */].contractsList.name;
						}

						if (route == '' && response.data.user.permissions.masterData) {

							route = __WEBPACK_IMPORTED_MODULE_3__router_routes__["a" /* default */].reportsMasterData.name;
						}

						if (route == '' && response.data.user.permissions.reports) {

							route = __WEBPACK_IMPORTED_MODULE_3__router_routes__["a" /* default */].reportsSDA.name;
						}

						if (route == '') {

							var _message2 = {
								message: [vm.$t('errors.custom.006')],
								type: 'error'
							};

							vm.$root.$emit('showMessage', _message2);

							return;
						}

						localStorage.setItem('sessionToken', response.data.user.sessionToken);
						localStorage.setItem('sessionUser', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.user));

						vm.$router.push({ name: route });
					});
				}]);
			}, 1000);
		}
	},
	components: {
		TextField: __WEBPACK_IMPORTED_MODULE_6__components_general_fields_text_text__["a" /* default */]
	}
});

/***/ }),

/***/ "pnIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fade-in private-container-view"},[_c('div',{staticClass:"header-sections"},[_c('ul',{staticClass:"items-container"},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.contractsList.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.contracts.header.contracts_list")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name === _vm.routes.contractsList.name}})])]),_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.contractsSDA.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.contracts.header.contracts_sda")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name === _vm.routes.contractsSDA.name}})])]),_c('router-link',{staticClass:"link",attrs:{"to":_vm.routes.contractsZips.path}},[_c('li',{staticClass:"item"},[_c('i',{staticClass:"fa fa-list icon"}),_c('div',{staticClass:"text hidden-xs"},[_vm._v(_vm._s(_vm.$t("private.contracts.header.contracts_zips")))]),_c('div',{staticClass:"bottom-bar",class:{'width-in' : _vm.$route.name === _vm.routes.contractsZips.name}})])])],1)]),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q+vm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("QhW4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_550311c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("PqU8");
function injectStyle (ssrContext) {
  __webpack_require__("yIGs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-550311c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_550311c3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q2MK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r0Rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'select-field',
	props: ['data'],
	data: function data() {
		return {
			field: {
				fakeValue: this.data.fakeValue,
				value: this.data.value,
				active: false
			}
		};
	},

	methods: {
		changeData: function changeData(option) {

			var vm = this;

			vm.field.fakeValue = option.fakeValue;
			vm.field.value = option.value;
			vm.field.active = false;

			this.$emit('changeData', option.value);
		}
	}
});

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("u54A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r9eF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sGGH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("I7qb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d044a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("vpTf");
function injectStyle (ssrContext) {
  __webpack_require__("DUzc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d044a7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d044a7a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "snNT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	getDelegations: function getDelegations(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/delegations' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	createDelegation: function createDelegation(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/delegations';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	updateDelegation: function updateDelegation(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/delegations';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	deleteDelegation: function deleteDelegation(data) {

		var url = __WEBPACK_IMPORTED_MODULE_1__config_env___default.a.api.baseUrl + '/api/delegations' + data;

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().delete(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "sssV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t5Gw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("HgCs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed171d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("J6A/");
function injectStyle (ssrContext) {
  __webpack_require__("ooDe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ed171d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed171d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tSXQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tbHi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_env__);





/* harmony default export */ __webpack_exports__["a"] = ({
	getTotalContracts: function getTotalContracts(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/count' + data;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {

			return response;
		});
	},
	getContracts: function getContracts(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts' + data;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {

			return response;
		});
	},
	createContract: function createContract(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {

			return response;
		});
	},
	updateContract: function updateContract(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data).then(function (response) {

			return response;
		});
	},
	archiveContract: function archiveContract(id) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/archive/?id=' + id;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url).then(function (response) {

			return response;
		});
	},
	exportContracts: function exportContracts(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/export';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data, {
			responseType: 'arraybuffer'
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	migrateCSVFile: function migrateCSVFile(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/migrate';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {

			return response;
		});
	},
	sendMailDigitalSignature: function sendMailDigitalSignature(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/digital-signature/send-mail';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data);
	},
	sendMailAutoRenew: function sendMailAutoRenew(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/send-mail-auto-renew';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data);
	},
	sendMailNewPackages: function sendMailNewPackages(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/send-mail-new-packages';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().put(url, data);
	},
	exportZipPDFs: function exportZipPDFs(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/exportZipPDFs';

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	getExportZipPDFs: function getExportZipPDFs(archiveId) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/contracts/exportZipPDFs/' + archiveId;

		return __WEBPACK_IMPORTED_MODULE_1__components_general_http_http__["a" /* default */].request().get(url, {
			responseType: 'arraybuffer',
			onDownloadProgress: function onDownloadProgress(progressEvent) {

				if (progressEvent.loaded > 0 && progressEvent.total > 0) {

					var percentCompleted = Math.floor(progressEvent.loaded * 100 / progressEvent.total);
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_download').text(percentCompleted + '%');
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_download').attr("aria-valuenow", percentCompleted);
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_download').css("width", percentCompleted + "%");
				}
			}
		}).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	}
});

/***/ }),

/***/ "thIQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"export-data",on:{"click":function($event){_vm.exportData()}}},[(!_vm.exportMasterDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.master_data.export_data")))]):_vm._e(),(_vm.exportMasterDataActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportMasterDataActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.reports.master_data.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('date-field',{attrs:{"data":_vm.filters.since},on:{"changeData":function($event){_vm.filters.since.value = $event; _vm.getContracts()}}}),_c('date-field',{attrs:{"data":_vm.filters.until},on:{"changeData":function($event){_vm.filters.until.value = $event; _vm.getContracts()}}}),_c('select-field',{attrs:{"data":_vm.filters.exported},on:{"changeData":function($event){_vm.filters.exported.value = $event; _vm.getContracts(); _vm.filters.skip.value = 0;}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.getContracts(); _vm.filters.skip.value = 0;}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.contracts.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e()])]):_vm._e(),(_vm.contracts.length > 0)?_c('div',[_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.contracts),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])])])})),_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',[_c('checkbox-field',{attrs:{"data":_vm.activateAllCheckbox},on:{"changeData":function($event){_vm.activateAllCheckbox.value = $event; _vm.activateAllCheckboxToggle()}}})],1),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.exported")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.client")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.legal_name")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.seller")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.associated_accounts")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_agreement")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_discount_total")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_rappel")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_rappel_marketing")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_rappel_frequency")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_cto_to")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dso_cto_from")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.wella_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.wella_discount")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.wella_brand_rappel")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.iso_cto_to")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.iso_cto_from")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.wella_volume_rappel")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.rappel_mktg")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.rappel_mktg_manual")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.wella_rappel_frequency")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.opi_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.opi_rappel")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.opi_rappel_frequency")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.opi_cto_to")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.opi_cto_from")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.dto_zto_wellastore")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.observations")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.timestamp")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.changed_quantity")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.changed_franchise")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.changed_rappel_period")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.changed_associates")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.virtual_signed")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.virtual_signApproved")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.has_email_invoices")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.email_invoices_1")))]),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.table.email_invoices_2")))])])]),_c('tbody',_vm._l((_vm.contracts),function(contract,index){return _c('tr',[_c('td',[_c('checkbox-field',{attrs:{"data":_vm.allChecks[index]},on:{"changeData":function($event){_vm.selectedContracts[index] = $event;}}})],1),_c('td',[_vm._v(_vm._s(contract.exported ? _vm.$t("private.reports.master_data.table.exported_options.yes") : _vm.$t("private.reports.master_data.table.exported_options.no")))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username + ':' + contract.seller.sellerTypeString : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount))]),_c('td',[_vm._v(_vm._s(contract.dsoSection ? contract.dsoSection : ''))]),_c('td',[_vm._v(_vm._s(contract.dsoDiscount))]),_c('td',[_vm._v(_vm._s(contract.dsoRappel))]),_c('td',[_vm._v(_vm._s(contract.dsoRappelMarketing))]),_c('td',[_vm._v(_vm._s(contract.dsoRappelFrequency ? contract.dsoRappelFrequency : ''))]),_c('td',[_vm._v(_vm._s(contract.dsoSalon ? _vm.validateDateCTO( contract ) : ''))]),_c('td',[_vm._v(_vm._s(contract.dsoSalon ? contract.endDateOfPeriod : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaDiscount))]),_c('td',[_vm._v(_vm._s(contract.wellaBrandRappel))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity ? _vm.validateDateCTO( contract ) : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity ? contract.endDateOfPeriod: ''))]),_c('td',[_vm._v(_vm._s(contract.wellaVolumeRappel))]),_c('td',[_vm._v(_vm._s(contract.rappelMKTG))]),_c('td',[_vm._v(_vm._s(contract.rappelMKTGManual ? contract.rappelMKTGManual : ''))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity ? contract.isoRappelFrequency : ''))]),_c('td',[_vm._v(_vm._s(contract.opiQuantity  ? contract.opiQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.opiRappel ? contract.opiRappel : ''))]),_c('td',[_vm._v(_vm._s(contract.opiQuantity ? contract.opiRappelFrequency : ''))]),_c('td',[_vm._v(_vm._s(contract.opiQuantity  ? _vm.validateDateCTO( contract ) : ''))]),_c('td',[_vm._v(_vm._s(contract.opiQuantity  ? contract.endDateOfPeriod : ''))]),_c('td',[_vm._v(_vm._s(contract.wellastoreDiscount ? contract.wellastoreDiscount : ''))]),_c('td',[_vm._v(_vm._s(contract.observations))]),_c('td',[_vm._v(_vm._s(contract.appCreationDate))]),_c('td',[_vm._v(_vm._s(contract.changedQuantity ? _vm.$t("private.reports.master_data.table.changed_booleans.yes") : _vm.$t("private.reports.master_data.table.changed_booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.changedFranchise ? _vm.$t("private.reports.master_data.table.changed_booleans.yes") : _vm.$t("private.reports.master_data.table.changed_booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.changedRappelPeriod ? _vm.$t("private.reports.master_data.table.changed_booleans.yes") : _vm.$t("private.reports.master_data.table.changed_booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.changedAssociates ? _vm.$t("private.reports.master_data.table.changed_booleans.yes") : _vm.$t("private.reports.master_data.table.changed_booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.virtualSigned ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.virtualSignApproved ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.emailInvoices ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.emailInvoices1 ? contract.emailInvoices1 : ''))]),_c('td',[_vm._v(_vm._s(contract.emailInvoices2 ? contract.emailInvoices2 : ''))])])}))])])]):_vm._e(),(_vm.contracts.length === 0 && !_vm.getContractsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.reports.master_data.no_results")))]):_vm._e(),(_vm.getContractsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tvGf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__("lDdF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__("xNPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_urijs__ = __webpack_require__("hBlz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_urijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_urijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_scroll_to_scroll_to__ = __webpack_require__("5sUg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_menu_more_options_menu_more_options__ = __webpack_require__("G7Rn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_fields_text_text__ = __webpack_require__("HDgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_fields_select_select__ = __webpack_require__("711T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_fields_checkbox_checkbox__ = __webpack_require__("Yu4h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_fields_date_date__ = __webpack_require__("D507");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_fields_search_search__ = __webpack_require__("Dcil");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_general_fields_file_file__ = __webpack_require__("6YFI");


















var Parse = __webpack_require__("ZVky");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contracts-sda',
  data: function data() {
    return {
      SDAsInfo: [],
      menuOptions: [{
        iconClass: 'fa fa-archive',
        name: this.$t('private.contracts.sda.menu_more_options.archive_contract'),
        action: 'archive'
      }],
      filters: {
        since: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.since'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        until: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.reports.sda.filters.until'),
          error: false,
          active: false,
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        exported: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
          value: 'all',
          name: this.$t('private.reports.sda.filters.exported'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.exported_options.all'),
            value: 'all'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.only_exported'),
            value: 'only_exported'
          }, {
            fakeValue: this.$t('private.reports.sda.filters.exported_options.not_exported'),
            value: 'not_exported'
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        limit: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: this.$t('private.reports.sda.filters.limit_options.50'),
          value: 50,
          name: this.$t('private.reports.sda.filters.limit'),
          error: false,
          active: false,
          options: [{
            fakeValue: this.$t('private.reports.sda.filters.limit_options.10'),
            value: 10
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.25'),
            value: 25
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.50'),
            value: 50
          }, {
            fakeValue: this.$t('private.reports.sda.filters.limit_options.100'),
            value: 100
          }],
          style: {
            width: '230px',
            display: 'inline-block',
            margin: '0px 10px'
          }
        },
        seller: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.seller'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        delegation: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          fakeValue: '',
          value: '',
          name: this.$t('private.contracts.list.filters.delegation'),
          error: false,
          active: false,
          options: [],
          style: {
            width: '120px',
            marginTop: '0px'
          }
        },
        clientCode: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.client_code'),
          type: 'text',
          error: false,
          style: {
            width: '150px',
            marginTop: '0px'
          }
        },
        legalName: {
          id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
          display: true,
          value: '',
          name: this.$t('private.contracts.list.filters.legal_name'),
          type: 'text',
          error: false,
          style: {
            width: '110px',
            marginTop: '0px'
          }
        },
        skip: {
          value: 0
        }
      },
      createContractWindow: {
        display: false,
        form: {
          fields: {
            client: {
              id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
              display: true,
              fakeValue: '',
              value: '',
              name: this.$t('private.contracts.sda.create_contract_window.fields.client'),
              error: false,
              active: false,
              options: [],
              filters: {
                type: 'string',
                required: true
              }
            },
            sdaTypes: {
              id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
              display: true,
              name: this.$t('private.contracts.sda.create_contract_window.fields.sda_types'),
              error: false,
              value: {
                // sdaSp  : false,
                // sdaSpInternet  : false,
                // sdaSpMen : false,
                // sdaSystemEC: false,
                sdaSebastian: false
                // sdaSebastianInternet : false,
                // sdaGHD : false,
                // sdaWedo : false
              },
              options: {
                // sdaSp : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sp'),
                // 	disabled : false
                // },
                // sdaSpInternet : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sp_internet'),
                // 	disabled : false
                // },
                // sdaSpMen : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sp_men'),
                // 	disabled : false
                // },
                // sdaSystemEC: {
                //   name: this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_system_ec'),
                //   disabled: false
                // },
                sdaSebastian: {
                  name: this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sebastian'),
                  disabled: false
                }
                // sdaSebastianInternet : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_sebastian_internet'),
                // 	disabled : false
                // },
                // sdaGHD : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_ghd'),
                // 	disabled : false
                // },
                // sdaWedo : {
                // 	name : this.$t('private.contracts.sda.create_contract_window.fields.sda_types_options.sda_wedo'),
                // 	disabled : false
                // }
              },
              filters: {
                type: 'manyOptions',
                enum: [
                // 'sdaSp',
                // 'sdaSystemEC',
                'sdaSebastian'
                // 'sdaSebastianInternet',
                // 'sdaGHD',
                // 'sdaWedo'
                ]
              }
            },
            date: {
              id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
              display: true,
              fakeValue: '',
              value: '',
              name: this.$t('private.contracts.sda.create_contract_window.fields.date'),
              error: false,
              active: false,
              filters: {
                type: 'date'
              }
            },
            pdf: {
              id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
              display: true,
              value: {},
              name: this.$t('private.contracts.sda.create_contract_window.fields.pdf'),
              pdf: true,
              readAsDataURL: true,
              fileReady: false,
              error: false,
              active: false,
              filters: {
                type: 'file',
                maxSize: 30,
                formatsAllowed: ['pdf'],
                required: true
              }
            }
          },
          active: false
        }
      },
      migrateSDAsWindow: {
        display: false,
        migrateCSVFileActiveNormal: false,
        migrateCSVFileActiveDiamond: false,
        migrateCSVFileActiveInfo: false,
        normalSDAsToCreated: [],
        normalSDAsWithErrors: [],
        diamondSDAsToCreated: [],
        diamondSDAsWithErrors: [],
        SDAsInfoToUpdated: [],
        SDAsInfoWithErrors: [],
        fields: {
          separator: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
            value: ';',
            name: this.$t('private.clients.list.import_clients_modal.fields.separator'),
            error: false,
            active: false,
            options: [{
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.coma'),
              value: ','
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.semicolon'),
              value: ';'
            }, {
              fakeValue: this.$t('private.clients.list.import_clients_modal.fields.separator_options.pipe'),
              value: '|'
            }],
            filters: {
              type: 'string',
              enum: [',', ';', '|'],
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          csvNormal: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: 'Cargar CSV - SDAs Normal',
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          },
          csvDiamond: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: 'Cargar CSV - SDAs Diamond',
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          },
          csvInfo: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            value: {},
            name: 'Cargar CSV - SDAsInfo',
            csv: true,
            readAsText: true,
            fileReady: false,
            error: false,
            active: false,
            filters: {
              type: 'file',
              maxSize: 10,
              formatsAllowed: ['vnd.ms-excel', 'csv'],
              required: true
            }
          }
        }
      },
      getSDAsInfoActive: false,
      activateFilters: false,
      haveData: false,
      nextPage: false,
      displayFoo: false,
      exportZipPDFsWindow: {
        display: false,
        downloadZipPDFsActive: false,
        fields: {
          month: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month'),
            error: false,
            active: false,
            options: [],
            // options : [{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.january'),
            // 	value : '01'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.february'),
            // 	value : '02'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.march'),
            // 	value : '03'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.april'),
            // 	value : '04'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.may'),
            // 	value : '05'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.june'),
            // 	value : '06'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.july'),
            // 	value : '07'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.august'),
            // 	value : '08'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.september'),
            // 	value : '09'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.october'),
            // 	value : '10'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.november'),
            // 	value : '11'
            // },{
            // 	fakeValue : this.$t('private.contracts.sda.export_zip_pdfs_window.fields.month_options.december'),
            // 	value : '12'
            // }],
            filters: {
              type: 'number',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          },
          year: {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            fakeValue: '',
            value: '',
            disabled: false,
            name: this.$t('private.contracts.sda.export_zip_pdfs_window.fields.year'),
            error: false,
            active: false,
            options: [],
            filters: {
              type: 'string',
              required: true
            },
            style: {
              marginTop: '40px'
            }
          }
        },
        progress: {
          display: false,
          value: 0,
          valueMax: 0,
          download: 0
        }
      }
    };
  },

  methods: {
    rowClicked: function rowClicked(element, value) {
      element.rowSelected = value;

      this.displayFoo ? this.displayFoo = false : this.displayFoo = true;
    },
    getSDAsInfo: function getSDAsInfo() {
      var vm = this;

      vm.getSDAsInfoActive = true;
      vm.SDAsInfo = [];

      var exported = vm.filters.exported.value == 'all' ? '' : vm.filters.exported.value == 'only_exported';

      var since = vm.filters.since.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.since.value).startOf('day').toDate() : '';
      var until = vm.filters.until.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.filters.until.value).endOf('day').toDate() : '';

      var dataToSend = '/?state=' + 0 + '&descending=' + 'lastDateSDA' + '&since=' + since + '&until=' + until + '&exported=' + exported + '&limit=' + (vm.filters.limit.value + 1) + '&skip=' + vm.filters.skip.value + '&seller=' + vm.filters.seller.value + '&delegation=' + vm.filters.delegation.value + '&clientCode=' + vm.filters.clientCode.value + '&legalName=' + vm.filters.legalName.value;

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAsInfo.getSDAsInfo(dataToSend).then(function (response) {
        vm.getSDAsInfoActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message);

          return;
        }

        vm.SDAsInfo = response.data.SDAsInfo;

        __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.each(vm.SDAsInfo, function (element) {
          if (element.normalSDA && element.normalSDA.pdf) {
            var uri_org = new __WEBPACK_IMPORTED_MODULE_4_urijs___default.a(element.normalSDA.pdf.url);
            var pathname = uri_org.pathname();

            element.normalSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_5__config_env___default.a.api.baseUrl + pathname;
          }

          if (element.systemECSDA && element.systemECSDA.pdf) {
            var _uri_org = new __WEBPACK_IMPORTED_MODULE_4_urijs___default.a(element.systemECSDA.pdf.url);
            var _pathname = _uri_org.pathname();

            element.systemECSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_5__config_env___default.a.api.baseUrl + _pathname;
          }

          if (element.wedoSDA && element.wedoSDA.pdf) {
            var _uri_org2 = new __WEBPACK_IMPORTED_MODULE_4_urijs___default.a(element.wedoSDA.pdf.url);
            var _pathname2 = _uri_org2.pathname();

            element.wedoSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_5__config_env___default.a.api.baseUrl + _pathname2;
          }
          if (element.sebastianSDA && element.sebastianSDA.pdf) {
            var _uri_org3 = new __WEBPACK_IMPORTED_MODULE_4_urijs___default.a(element.sebastianSDA.pdf.url);
            var _pathname3 = _uri_org3.pathname();

            element.sebastianSDA.pdf.url = __WEBPACK_IMPORTED_MODULE_5__config_env___default.a.api.baseUrl + _pathname3;
          }
        });

        if (vm.SDAsInfo.length > 0 && !vm.haveData) {
          vm.haveData = true;
        }

        if (vm.SDAsInfo.length > vm.filters.limit.value) {
          vm.nextPage = true;

          vm.SDAsInfo.pop();
        } else {
          vm.nextPage = false;
        }

        vm.allChecks = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(vm.SDAsInfo, function (SDA) {
          var field = {
            id: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId('field_'),
            display: true,
            error: false,
            value: {},
            options: {},
            filters: {
              type: 'manyOptions'
            }
          };

          field.value[SDA.objectId] = false;

          field.options[SDA.objectId] = {};

          return field;
        });
      });
    },
    goToBackPage: function goToBackPage() {
      var vm = this;

      if (vm.filters.skip.value != 0) {
        vm.filters.skip.value = vm.filters.skip.value - vm.filters.limit.value;

        vm.getSDAsInfo();
      }
    },
    goToNextPage: function goToNextPage() {
      var vm = this;

      if (vm.nextPage) {
        vm.filters.skip.value = vm.filters.skip.value + vm.filters.limit.value;

        vm.getSDAsInfo();
      }
    },
    searchClients: function searchClients(data) {
      var vm = this;

      vm.getSearchClients = true;

      var dataToSend = '?clientCode=' + data;

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].clients.getClients(dataToSend).then(function (response) {
        vm.getSearchClients = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message2 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message2);

          return;
        }

        var clients = response.data.clients;

        clients = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(clients, function (client) {
          return {
            fakeValue: client.legalName + ' (' + client.clientCode + ')',
            value: client
          };
        });

        vm.createContractWindow.form.fields.client.options = clients;
      });
    },
    clientSelected: function clientSelected(data) {
      var vm = this;

      vm.createContractWindow.form.fields.client.value = data.id;
    },
    optionSelected: function optionSelected(data) {
      var vm = this;

      if (data.action == 'delete') {
        vm.archiveContract(data.element);
      }
    },
    formCreateSubmit: function formCreateSubmit() {
      var vm = this;

      if (vm.createContractWindow.form.active) {
        return;
      }

      vm.createContractWindow.form.active = true;

      vm.$root.$emit('validate', [vm.createContractWindow.form.fields, function (response) {
        if (!response.success) {
          vm.createContractWindow.form.active = false;

          response.type = 'error';

          response.field.error = true;

          var dataToScroll = {
            selector: '#' + response.field.id,
            target: 'html, body'
          };

          __WEBPACK_IMPORTED_MODULE_7__components_general_scroll_to_scroll_to__["a" /* default */].submit(dataToScroll);

          vm.$root.$emit('showMessage', response);

          return;
        }

        var dataToSend = {
          client: vm.createContractWindow.form.fields.client.value,
          date: vm.createContractWindow.form.fields.date.value ? __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(vm.createContractWindow.form.fields.date.value).toDate() : __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().toDate(),
          // sdaSp: vm.createContractWindow.form.fields.sdaTypes.value.sdaSp,
          // sdaSpInternet: vm.createContractWindow.form.fields.sdaTypes.value.sdaSpInternet,
          // sdaSpMen: vm.createContractWindow.form.fields.sdaTypes.value.sdaSpMen,
          // sdaSystemEC: vm.createContractWindow.form.fields.sdaTypes.value.sdaSystemEC,
          sdaSebastian: vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastian,
          // sdaSebastianInternet: vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastianInternet,
          // sdaGHD: vm.createContractWindow.form.fields.sdaTypes.value.sdaGHD,
          // sdaWedo: vm.createContractWindow.form.fields.sdaTypes.value.sdaWedo,
          pdf: vm.createContractWindow.form.fields.pdf.value
        };

        __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAs.createContract(dataToSend).then(function (response) {
          vm.createContractWindow.form.active = false;

          if (response.status != 200) {
            var _message3 = {
              message: [vm.$t('errors.custom.001')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message3);

            return;
          }

          if (!response.data.success) {
            if (response.data.error.code == 101) {
              var _message4 = {
                message: [vm.$t('errors.parse.101')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message4);
            }

            return;
          }

          var message = {
            message: [vm.$t('private.contracts.sda.create_contract_window.create_success')],
            type: 'success'
          };

          vm.$root.$emit('showMessage', message);

          vm.getSDAsInfo();

          vm.createContractWindow.display = false;
          vm.createContractWindow.form.fields.client.value = '';
          vm.createContractWindow.form.fields.date.value = '';
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaSp = false
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaSpInternet = false
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaSpMen = false
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaSystemEC = false
          vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastian = false;
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaSebastianInternet = false
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaGHD = false
          // vm.createContractWindow.form.fields.sdaTypes.value.sdaWedo = false
          // vm.createContractWindow.form.fields.pdf.value = ''
        });
      }]);
    },
    parseDate: function parseDate(date) {
      var _date = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(date, 'iso') ? date.iso : date;

      return __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()(_date).format('DD-MM-YYYY');
    },
    validateSdaTypes: function validateSdaTypes() {
      var vm = this;

      var sdaTypes = vm.createContractWindow.form.fields.sdaTypes;
      sdaTypes.options['sdaSystemEC'].disabled = sdaTypes.value['sdaSebastian'];
      sdaTypes.options['sdaSebastian'].disabled = sdaTypes.value['sdaSystemEC'];

      // let values = _.values(_.omit(sdaTypes.value, ['sdaSystemEC', 'sdaWedo']))
      // let values2 = _.values(_.pick(sdaTypes.value, ['sdaSystemEC', 'sdaWedo']))
      //
      // sdaTypes.options['sdaSp'].disabled = _.some(values2)
      // sdaTypes.options['sdaSpInternet'].disabled = _.some(values2)
      // sdaTypes.options['sdaSpMen'].disabled = _.some(values2)
      // sdaTypes.options['sdaSebastian'].disabled = _.some(values2)
      // sdaTypes.options['sdaSebastianInternet'].disabled = _.some(values2)
      // sdaTypes.options['sdaGHD'].disabled = _.some(values2)
      //
      // sdaTypes.options['sdaSystemEC'].disabled = _.some(values) || sdaTypes.value['sdaWedo']
      // sdaTypes.options['sdaWedo'].disabled = _.some(values) || sdaTypes.value['sdaSystemEC']
      //
      // if (_.some(values)) {
      //   sdaTypes.value['sdaSystemEC'] = false
      //   sdaTypes.value['sdaWedo'] = false
      // }
      //
      // if (_.some(values2)) {
      //   sdaTypes.value['sdaSp'] = false
      //   sdaTypes.value['sdaSpInternet'] = false
      //   sdaTypes.value['sdaSpMen'] = false
      //   sdaTypes.value['sdaSebastian'] = false
      //   sdaTypes.value['sdaSebastianInternet'] = false
      //   sdaTypes.value['sdaGHD'] = false
      // }
    },
    getDelegations: function getDelegations() {
      var vm = this;

      vm.getDelegationsActive = true;

      var dataToSend = '/?descending=createdAt';

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].delegations.getDelegations(dataToSend).then(function (response) {
        vm.getDelegationsActive = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message5 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message5);

          return;
        }

        var delegations = response.data.delegations;

        delegations = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.map(delegations, function (delegation) {
          return {
            fakeValue: delegation.name,
            value: delegation.id
          };
        });

        vm.filters.delegation.options = delegations;
      });
    },
    resetDataMigrateSDAsWindow: function resetDataMigrateSDAsWindow() {
      var vm = this;

      vm.migrateSDAsWindow.normalSDAsToCreated = [];
      vm.migrateSDAsWindow.normalSDAsWithErrors = [];
      vm.migrateSDAsWindow.fields.csvNormal.value = {};
      vm.migrateSDAsWindow.fields.csvNormal.fileReady = false;

      vm.migrateSDAsWindow.diamondSDAsToCreated = [];
      vm.migrateSDAsWindow.diamondSDAsWithErrors = [];
      vm.migrateSDAsWindow.fields.csvNormal.value = {};
      vm.migrateSDAsWindow.fields.csvNormal.fileReady = false;

      vm.migrateSDAsWindow.SDAsInfoToUpdated = [];
      vm.migrateSDAsWindow.SDAsInfoWithErrors = [];
      vm.migrateSDAsWindow.fields.csvInfo.value = {};
      vm.migrateSDAsWindow.fields.csvInfo.fileReady = false;
    },
    migrateNormalSDAsSubmit: function migrateNormalSDAsSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateSDAsWindow.fields.separator.value,
        csv: vm.migrateSDAsWindow.fields.csvNormal.value.data
      };

      vm.migrateSDAsWindow.migrateCSVFileActiveNormal = true;

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAs.migrateCSVFile('/api/sda/migrate/normal', dataToSend).then(function (response) {
        vm.migrateSDAsWindow.migrateCSVFileActiveNormal = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message6 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message6);

          return;
        }

        vm.migrateSDAsWindow.normalSDAsToCreated = response.data.normalSDAsToCreated;
        vm.migrateSDAsWindow.normalSDAsWithErrors = response.data.normalSDAsWithErrors;
      });
    },
    migrateDiamondSDAsSubmit: function migrateDiamondSDAsSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateSDAsWindow.fields.separator.value,
        csv: vm.migrateSDAsWindow.fields.csvDiamond.value.data
      };

      vm.migrateSDAsWindow.migrateCSVFileActiveDiamond = true;

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAs.migrateCSVFile('/api/sda/migrate/diamond', dataToSend).then(function (response) {
        vm.migrateSDAsWindow.migrateCSVFileActiveDiamond = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message7 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message7);

          return;
        }

        vm.migrateSDAsWindow.diamondSDAsToCreated = response.data.diamondSDAsToCreated;
        vm.migrateSDAsWindow.diamondSDAsWithErrors = response.data.diamondSDAsWithErrors;
      });
    },
    migrateSDAsInfoSubmit: function migrateSDAsInfoSubmit() {
      var vm = this;

      var dataToSend = {
        separator: vm.migrateSDAsWindow.fields.separator.value,
        csv: vm.migrateSDAsWindow.fields.csvInfo.value.data
      };

      vm.migrateSDAsWindow.migrateCSVFileActiveInfo = true;

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAsInfo.migrateCSVFile(dataToSend).then(function (response) {
        vm.migrateSDAsWindow.migrateCSVFileActiveInfo = false;

        if (response.status != 200) {
          var message = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', message);

          return;
        }

        if (!response.data.success) {
          var _message8 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message8);

          return;
        }

        vm.migrateSDAsWindow.SDAsInfoToUpdated = response.data.SDAsInfoToUpdated;
        vm.migrateSDAsWindow.SDAsInfoWithErrors = response.data.SDAsInfoWithErrors;
      });
    },
    handleSendMailDigitalSignature: function handleSendMailDigitalSignature(element) {
      var vm = this;

      if (element.isSendMailDigitalSignature) {
        return;
      }

      element.isSendMailDigitalSignature = true;

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAs.sendMailDigitalSignature({ id: element.objectId }).then(function (response) {
        element.isSendMailDigitalSignature = false;

        if (response.status != 200) {
          var _message9 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message9);

          return;
        }

        if (!response.data.success) {
          var _message10 = void 0;
          if ('message' in response.data) {
            _message10 = {
              message: [response.data.message],
              type: 'error'
            };
          } else {
            if ('error' in response.data) {
              if (response.data.error.code == 101) {
                _message10 = {
                  message: [vm.$t('errors.parse.101')],
                  type: 'error'
                };
              } else {
                _message10 = {
                  message: [vm.$t('errors.parse.001')],
                  type: 'error'
                };
              }
            }
          }

          vm.$root.$emit('showMessage', _message10);

          return;
        }

        var message = {
          message: [vm.$t('private.contracts.list.send_mail_success')],
          type: 'success'
        };

        vm.$root.$emit('showMessage', message);
      }).catch(function (error) {
        console.log('sendMailAutoRenew > error', error);

        element.isSendMailDigitalSignature = false;

        var message = {
          message: [vm.$t('errors.parse.001')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);
      });
    },
    exportZipPDFs: function exportZipPDFs() {
      var vm = this;

      if (vm.exportZipPDFsWindow.downloadZipPDFsActive) {
        var message = {
          message: [vm.$t('private.contracts.sda.please_wait')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      var month = vm.exportZipPDFsWindow.fields.month.value;
      var year = vm.exportZipPDFsWindow.fields.year.value;

      var since = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(year).month(month - 1).startOf('month').valueOf();
      var until = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(year).month(month - 1).endOf('month').valueOf();

      vm.exportZipPDFsWindow.sessionId = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 20);
      vm.exportZipPDFsWindow.fields.month.disabled = true;
      vm.exportZipPDFsWindow.fields.year.disabled = true;
      vm.exportZipPDFsWindow.downloadZipPDFsActive = true;

      var dataToSend = {
        since: since,
        until: until,
        timeZone: __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.tz.guess(),
        sessionId: vm.exportZipPDFsWindow.sessionId
      };

      __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAs.exportZipPDFs(dataToSend).then(function (response) {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
        vm.exportZipPDFsWindow.fields.month.disabled = false;
        vm.exportZipPDFsWindow.fields.year.disabled = false;

        if (response.status == 202) {
          var _message11 = {
            message: [vm.$t('errors.custom.011')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message11);

          return;
        }

        if (response.status != 200) {
          var _message12 = {
            message: [vm.$t('errors.custom.001')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message12);

          return;
        }

        if (!response.data.success) {
          if (response.data.error.code == 101) {
            var _message14 = {
              message: [vm.$t('errors.parse.101')],
              type: 'error'
            };

            vm.$root.$emit('showMessage', _message14);

            return;
          }

          var _message13 = {
            message: [vm.$t('errors.custom.011')],
            type: 'error'
          };

          vm.$root.$emit('showMessage', _message13);

          return;
        }

        vm.exportZipPDFsWindow.downloadZipPDFsActive = true;
        vm.exportZipPDFsWindow.fields.month.disabled = true;
        vm.exportZipPDFsWindow.fields.year.disabled = true;
      });
    },
    generateMoths: function generateMoths() {
      var vm = this;

      var lang = navigator.language || navigator.userLanguage;

      __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default.a.locale(lang);

      var year = vm.exportZipPDFsWindow.fields.year.value;

      var dateNow = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()();
      var dateSelectedYear = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(year);
      var monthNow = 12;

      if (dateNow.year() === dateSelectedYear.year()) monthNow = dateSelectedYear.month() + 1;

      vm.exportZipPDFsWindow.fields.month.options = [];
      vm.exportZipPDFsWindow.fields.month.disabled = true;

      for (var i = 0; i < monthNow; ++i) {
        vm.exportZipPDFsWindow.fields.month.options.push({
          fakeValue: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.capitalize(__WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().month(i).format('MMMM')),
          value: i + 1
        });
      }

      vm.exportZipPDFsWindow.fields.month.value = '';
      vm.exportZipPDFsWindow.fields.month.fakeValue = '';
      vm.exportZipPDFsWindow.fields.month.disabled = false;
    }
  },
  components: {
    MenuMoreOptions: __WEBPACK_IMPORTED_MODULE_8__components_general_menu_more_options_menu_more_options__["a" /* default */],
    TextField: __WEBPACK_IMPORTED_MODULE_9__components_general_fields_text_text__["a" /* default */],
    SelectField: __WEBPACK_IMPORTED_MODULE_10__components_general_fields_select_select__["a" /* default */],
    CheckboxField: __WEBPACK_IMPORTED_MODULE_11__components_general_fields_checkbox_checkbox__["a" /* default */],
    DateField: __WEBPACK_IMPORTED_MODULE_12__components_general_fields_date_date__["a" /* default */],
    SearchField: __WEBPACK_IMPORTED_MODULE_13__components_general_fields_search_search__["a" /* default */],
    FileField: __WEBPACK_IMPORTED_MODULE_14__components_general_fields_file_file__["a" /* default */]
  },
  created: function created() {
    var vm = this;

    vm.getSDAsInfo();

    vm.searchClients('');

    vm.getDelegations();

    for (var i = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year() - 2; i <= __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(); i++) {
      vm.exportZipPDFsWindow.fields.year.options.push({
        fakeValue: i,
        value: i
      });
    }
  },
  mounted: function mounted() {
    var vm = this;

    var queryProgress = new Parse.Query('Progress');

    var subscriptionProgress = queryProgress.subscribe();

    subscriptionProgress.on('open', function () {
      console.log('subscriptionProgress opened');
    });

    subscriptionProgress.on('create', function (event) {
      vm.exportZipPDFsWindow.progress.display = true;
      vm.exportZipPDFsWindow.progress.valueMax = event.get('valueMax');
    });

    subscriptionProgress.on('update', function (event) {
      var sessionId = event.get('sessionId');

      if (vm.exportZipPDFsWindow.sessionId !== sessionId) return;

      var status = event.get('status');
      var count = event.get('count');
      var valueMax = event.get('valueMax');

      vm.exportZipPDFsWindow.progress.display = true;
      vm.exportZipPDFsWindow.progress.value = count;
      vm.exportZipPDFsWindow.progress.valueMax = valueMax;
      vm.exportZipPDFsWindow.progress.downloadProgress = 0;

      var porcentaje = Math.floor(count / valueMax * 100);

      if (count > 0) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_sda').text(porcentaje + '%');
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_sda').attr('aria-valuenow', porcentaje);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#progress_id_export_zippdf_sda').css('width', porcentaje + '%');
      }

      if (status === 'error') {
        vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
        vm.exportZipPDFsWindow.progress.display = false;
        vm.exportZipPDFsWindow.fields.month.disabled = false;
        vm.exportZipPDFsWindow.fields.year.disabled = false;
        vm.exportZipPDFsWindow.display = false;

        var message = {
          message: [vm.$t('errors.custom.001')],
          type: 'error'
        };

        vm.$root.$emit('showMessage', message);

        return;
      }

      if (status === 'finalized') {
        subscriptionProgress.unsubscribe();

        var archive_id = event.get('archive_id');

        if (archive_id) {
          __WEBPACK_IMPORTED_MODULE_6__api_api__["a" /* default */].SDAs.getExportZipPDFs(archive_id).then(function (response) {
            vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
            vm.exportZipPDFsWindow.fields.month.disabled = false;
            vm.exportZipPDFsWindow.fields.year.disabled = false;

            if (response.status != 200) {
              vm.exportZipPDFsWindow.downloadZipPDFsActive = false;

              var _message15 = {
                message: [vm.$t('errors.custom.001')],
                type: 'error'
              };

              vm.$root.$emit('showMessage', _message15);

              return;
            }

            var month = vm.exportZipPDFsWindow.fields.month.value;
            var year = vm.exportZipPDFsWindow.fields.year.value;

            var since = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(year).month(month - 1).startOf('month').valueOf();
            var until = __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default()().year(year).month(month - 1).endOf('month').valueOf();

            var file = new Blob([response.data], { type: 'octet/stream' });
            var fileURL = URL.createObjectURL(file);

            __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(file, 'pdfs_' + since + '_' + until + '.zip');

            setTimeout(function () {
              vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
              vm.exportZipPDFsWindow.progress.display = false;
              vm.exportZipPDFsWindow.fields.month.disabled = false;
              vm.exportZipPDFsWindow.fields.year.disabled = false;
              vm.exportZipPDFsWindow.display = false;
            }, 3000);
          });
        }
      }
    });

    subscriptionProgress.on('error', function (error) {
      console.log('on Error');
      console.log(error);
      vm.exportZipPDFsWindow.downloadZipPDFsActive = false;
      vm.exportZipPDFsWindow.fields.month.disabled = false;
      vm.exportZipPDFsWindow.fields.year.disabled = false;
      vm.exportZipPDFsWindow.progress.display = false;
      vm.exportZipPDFsWindow.display = false;
    });
  }
});

/***/ }),

/***/ "tw+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'client-record',
	data: function data() {
		return {
			routes: __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */]
		};
	},

	methods: {},
	components: {},
	created: function created() {}
});

/***/ }),

/***/ "u/mm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u54A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uLeh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__ = __webpack_require__("Ysl6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env__ = __webpack_require__("1/LL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_env__);




/* harmony default export */ __webpack_exports__["a"] = ({
	login: function login(data) {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/authentication/login';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().post(url, data).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	logout: function logout() {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/authentication/logout';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (error) {
			return error;
		});
	},
	session: function session() {

		var url = __WEBPACK_IMPORTED_MODULE_2__config_env___default.a.api.baseUrl + '/api/authentication/session';

		return __WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].request().get(url).then(function (response) {
			return response;
		}).catch(function (err) {

			var headerToDelete = {
				key: 'x-parse-session-token'
			};

			__WEBPACK_IMPORTED_MODULE_0__components_general_http_http__["a" /* default */].deleteHeader(headerToDelete);
			localStorage.removeItem('sessionToken');
			localStorage.removeItem('sessionUser');

			window.location.href = __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */].login.path;

			return err;
		});
	}
});

/***/ }),

/***/ "unWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "usps":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vEfO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vOza":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'reports',
	data: function data() {
		return {
			routes: __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */],
			sessionUser: {}
		};
	},

	methods: {},
	components: {},
	created: function created() {

		var vm = this;

		vm.sessionUser = JSON.parse(localStorage.getItem('sessionUser'));
	}
});

/***/ }),

/***/ "vkIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vpTf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-section"},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"activate-filters-container"},[_c('div',{staticClass:"create-contract",on:{"click":function($event){_vm.displayCreateContract = true; _vm.resetForm()}}},[_vm._v(_vm._s(_vm.$t("private.contracts.list.create_contract")))]),_c('div',{staticClass:"export-contract",on:{"click":function($event){_vm.exportContracts()}}},[(!_vm.exportContractsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.export_contracts")))]):_vm._e(),(_vm.exportContractsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e(),(_vm.exportContractsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.please_wait")))]):_vm._e()]),(_vm.haveData)?_c('div',{staticClass:"activate-filters",on:{"click":function($event){_vm.activateFilters ? _vm.activateFilters = false : _vm.activateFilters = true}}},[_vm._v(_vm._s(_vm.$t("private.contracts.list.see_filters")))]):_vm._e()]),(_vm.haveData)?_c('div',[(_vm.activateFilters)?_c('div',{staticClass:"filters-container"},[_c('select-field',{attrs:{"data":_vm.filters.ascending},on:{"changeData":function($event){_vm.filters.ascending.value = $event; _vm.filters.skip.value = 0; _vm.getContracts()}}}),_c('select-field',{attrs:{"data":_vm.filters.descending},on:{"changeData":function($event){_vm.filters.descending.value = $event; _vm.filters.skip.value = 0; _vm.getContracts()}}}),_c('select-field',{attrs:{"data":_vm.filters.limit},on:{"changeData":function($event){_vm.filters.limit.value = $event; _vm.filters.skip.value = 0; _vm.getContracts();}}})],1):_vm._e(),_c('div',{staticClass:"pager-controller"},[(_vm.filters.skip.value != 0)?_c('i',{staticClass:"fa fa-arrow-left back-bottom",on:{"click":function($event){_vm.goToBackPage()}}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.filters.skip.value + 1)+" - "+_vm._s(_vm.filters.skip.value + _vm.contracts.length))]),(_vm.nextPage)?_c('i',{staticClass:"fa fa-arrow-right next-bottom",on:{"click":function($event){_vm.goToNextPage()}}}):_vm._e(),_c('span',{staticStyle:{"margin-left":"30px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.totalContracts))])])]):_vm._e(),(_vm.contracts.length > 0)?_c('div',{staticClass:"list visible-xs"},_vm._l((_vm.contracts),function(contract,index){return _c('div',{staticClass:"element"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item"},[_vm._v(_vm._s(contract.id))])]),_c('menu-more-options',{attrs:{"element":contract,"side":'left',"options":_vm.menuOptions},on:{"optionSelected":_vm.optionSelected}})],1)})):_vm._e(),_c('select-field',{attrs:{"data":_vm.filters.hidden},on:{"changeData":function($event){_vm.filters.hidden.value = $event; _vm.filters.skip.value = 0; _vm.getContracts()}}}),(_vm.haveData)?_c('div',{staticClass:"table-container hidden-xs"},[_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"7"}}),_vm._m(0),_vm._m(1),_c('th'),_c('th',{attrs:{"colspan":"12"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso")))])]),_c('th',{attrs:{"colspan":"5"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.iso")))])]),_c('th',{attrs:{"colspan":"2"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.opi")))])]),_c('th',{attrs:{"colspan":"6"}}),_c('th',{attrs:{"colspan":"2"}},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.digital_signature")))])]),_c('th',{attrs:{"colspan":"10"}})]),_c('tr',{attrs:{"id":"contrats_tr"}},[_c('th'),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.state")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'state')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.exported")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'exported')}}})],1),_c('th',{staticClass:"header-column"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.pdf")))]),_c('th',{staticClass:"header-column-observations"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.observations")))])]),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.contractMode")))])]),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.timestamp")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'createdAt')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.seller")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'seller.username')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.delegation")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'delegation.name')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.client")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'client.clientCode')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.legal_name")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'client.legalName')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.employees_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'client.employeesQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.associated_1")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedAccount1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.associated_2")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedAccount2')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.associated_3")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'associatedAccount3')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.salons")))])]),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_salon")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoSalon')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_agreement")))])]),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_Brands")))])]),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_discount")))])]),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_rappel_marketing")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoRappelMarketing')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_MTKG")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoMTKG')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_MTKG_Subtype")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoMTKGSubtype')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_potential")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoPotential')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_education")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoEducation')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dso_rappel_frequency")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dsoFrequency')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.has_email_invoices")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'emailInvoices')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.wella_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.wella_discount")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaDiscount')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.wella_volume_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellaVolumeRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.rappel_mktg")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'rappelMKTG')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.rappel_mktg_manual")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'rappelMKTGManual')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.opi_quantity")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'opiQuantity')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.opi_rappel")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'opiRappel')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dto_zto_wellastore")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'wellastoreDiscount')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.prorated")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'prorated')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.prorated_month")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'proratedMonth')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.mkt_news")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'mktNews')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.email")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'client.email')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.dados_pessoais")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'dadosPessoais')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.virtual_signed")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'virtualSigned')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.virtual_signApproved")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'virtualSignApproved')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.mail_auto_renew")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'autoRenew')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.mail_new_package")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'packagesSelected')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.email_invoices_1")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'emailInvoices1')}}})],1),_c('th',{staticClass:"header-column"},[_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.email_invoices_2")))]),_c('sort-field',{on:{"changeData":function($event){_vm.actionSort($event, 'emailInvoices2')}}})],1)])]),_c('tbody',[(_vm.activateFilters)?_c('tr',[_c('td'),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.state},on:{"changeData":function($event){_vm.filters.state.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.exported},on:{"changeData":function($event){_vm.filters.exported.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{attrs:{"colspan":"2"}}),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.contractMode},on:{"changeData":function($event){_vm.filters.contractMode.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('date-field',{attrs:{"data":_vm.filters.since},on:{"changeData":function($event){_vm.filters.since.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}}),_c('date-field',{attrs:{"data":_vm.filters.until},on:{"changeData":function($event){_vm.filters.until.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.seller},on:{"changeData":function($event){_vm.filters.seller.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('select-field',{attrs:{"data":_vm.filters.delegation},on:{"changeData":function($event){_vm.filters.delegation.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.clientCode},on:{"changeData":function($event){_vm.filters.clientCode.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{staticClass:"filter-cell"},[_c('text-field',{attrs:{"data":_vm.filters.legalName},on:{"changeData":function($event){_vm.filters.legalName.value = $event; _vm.filters.skip.value = 0; _vm.filterSubmit();}}})],1),_c('td',{attrs:{"colspan":"52"}})]):_vm._e(),_vm._l((_vm.contracts),function(contract,index){return _c('tr',{class:{ selected : contract.rowSelected },on:{"click":function($event){_vm.rowClicked(contract, contract.rowSelected ? false : true)}}},[_c('td',{staticClass:"options"},[_c('menu-more-options',{attrs:{"element":contract,"side":'right',"options":_vm.menuOptions,"topClass":index > _vm.filters.limit.value - 5 ? true : false},on:{"optionSelected":_vm.optionSelected}})],1),_c('td',{class:{'green' : contract.state == 0, 'red' : contract.state == 1, 'yellow' : contract.state == 2, 'black' : contract.state == 3, 'purple' : contract.state == 4  }},[_vm._v(_vm._s(contract.state == 0 ? _vm.$t("private.contracts.list.table.state_options.ok") : contract.state == 1 ? _vm.$t("private.contracts.list.table.state_options.no_ok") : contract.state == 2 ? _vm.$t("private.contracts.list.table.state_options.pendiente_ok") : contract.state == 3 ? _vm.$t("private.contracts.list.table.state_options.archive") : contract.state == 4 ? _vm.$t("private.contracts.list.table.state_options.retenido_asociado") : ''))]),_c('td',[_vm._v(_vm._s(contract.exported ? _vm.$t("private.contracts.list.table.exported_options.yes") : _vm.$t("private.contracts.list.table.exported_options.no")))]),_c('td',{staticClass:"text-center"},[(contract.pdf)?_c('a',{attrs:{"href":contract.pdf ? contract.pdf.url : '',"target":"_blank"}},[_c('i',{staticClass:"fa fa-file-pdf-o",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}})]):_vm._e()]),_c('td',[_vm._v(_vm._s(contract.observations))]),_c('td',[_vm._v(_vm._s(contract.contractModeText))]),_c('td',[_vm._v(_vm._s(contract.appCreationDate ? _vm.parseDate( contract.appCreationDate ) : ''))]),_c('td',[_vm._v(_vm._s(contract.seller ? contract.seller.username : ''))]),_c('td',[_vm._v(_vm._s(contract.delegation ? contract.delegation.name : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.clientCode : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.legalName : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.employeesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount1 ? contract.associatedAccount1 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount2 ? contract.associatedAccount2 : ''))]),_c('td',[_vm._v(_vm._s(contract.associatedAccount3 ? contract.associatedAccount3 : ''))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.loungesQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.dsoSalon ? contract.dsoSalon.toUpperCase() : ''))]),_c('td',[_vm._v(_vm._s(_vm.getAgreement(contract, 'dsoSection')))]),_c('td',[_vm._v(_vm._s(contract.dsoBrands ? _vm.parseBrands( contract.dsoBrands ) : ''))]),_c('td',[_vm._v(_vm._s(contract.dsoDiscount))]),_c('td',[_vm._v(_vm._s(contract.dsoRappel))]),_c('td',[_vm._v(_vm._s(contract.dsoRappelMarketing))]),_c('td',[_vm._v(_vm._s(contract.dsoMTKG))]),_c('td',[_vm._v(_vm._s(contract.dsoMTKGSubtype))]),_c('td',[_vm._v(_vm._s(contract.dsoPotential))]),_c('td',[_vm._v(_vm._s(contract.dsoEducation))]),_c('td',[_vm._v(_vm._s(contract.dsoRappelFrequency ? contract.dsoRappelFrequency : ''))]),_c('td',[_vm._v(_vm._s(contract.emailInvoices ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.wellaQuantity))]),_c('td',[_vm._v(_vm._s(contract.wellaDiscount))]),_c('td',[_vm._v(_vm._s(contract.wellaVolumeRappel))]),_c('td',[_vm._v(_vm._s(contract.rappelMKTG))]),_c('td',[_vm._v(_vm._s(contract.rappelMKTGManual ? contract.rappelMKTGManual : ''))]),_c('td',[_vm._v(_vm._s(contract.opiQuantity  ? contract.opiQuantity : ''))]),_c('td',[_vm._v(_vm._s(contract.opiRappel ? contract.opiRappel : ''))]),_c('td',[_vm._v(_vm._s(contract.wellastoreDiscount ? contract.wellastoreDiscount : ''))]),_c('td',[_vm._v(_vm._s(contract.prorated ? _vm.$t("private.contracts.list.table.prorated_options.yes") : _vm.$t("private.contracts.list.table.prorated_options.no")))]),_c('td',[_vm._v(_vm._s(contract.proratedMonth))]),_c('td',[_vm._v(_vm._s(contract.mktNews ? _vm.$t("private.contracts.list.table.mkt_news_options.yes") : _vm.$t("private.contracts.list.table.mkt_news_options.no")))]),_c('td',[_vm._v(_vm._s(contract.client ? contract.client.email : ''))]),_c('td',[_vm._v(_vm._s(contract.dadosPessoais ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[_vm._v(_vm._s(contract.virtualSigned ? _vm.$t("private.contracts.list.table.booleans.yes") : _vm.$t("private.contracts.list.table.booleans.no")))]),_c('td',[(!contract.virtualSignApproved && contract.virtualSigned)?_c('div',{staticClass:"send-mail",on:{"click":function($event){_vm.handleSendMailDigitalSignature(contract);}}},[_vm._v(_vm._s(_vm.$t("private.contracts.list.forward_email")))]):_vm._e(),(contract.virtualSignApproved && contract.virtualSigned)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.table.booleans.yes")))]):_vm._e()]),_c('td',[(contract.autoRenew && !contract.packagesSelected)?_c('div',{staticClass:"send-mail",on:{"click":function($event){_vm.handleSendMailAutoRenew(contract);}}},[_vm._v(_vm._s(_vm.$t("private.contracts.list.forward_email")))]):_vm._e()]),_c('td',[( contract.packagesSelected && (contract.premiumMKTG || contract.prestigeMKTG) && !contract.sentNewPackagesMail)?_c('div',{staticClass:"send-mail",on:{"click":function($event){_vm.handleSendMailNewPackages(contract);}}},[_vm._v(_vm._s(_vm.$t("private.contracts.list.forward_email")))]):_vm._e()]),_c('td',[_vm._v(_vm._s(contract.emailInvoices1 ? contract.emailInvoices1 : ''))]),_c('td',[_vm._v(_vm._s(contract.emailInvoices2 ? contract.emailInvoices2 : ''))])])})],2)])]):_vm._e(),(_vm.displayFoo)?_c('div'):_vm._e(),(_vm.contracts.length == 0 && !_vm.getContractsActive)?_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.no_results")))]):_vm._e(),(_vm.getContractsActive)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"})]):_vm._e()],1)]),(_vm.displayCreateContract)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.contracts_list_create"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayCreateContract = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formCreateSubmit($event)}}},[_c('search-field',{attrs:{"data":_vm.formCreate.fields.client},on:{"getData":function($event){_vm.searchClients($event)},"optionSelected":function($event){_vm.clientSelected($event)}}}),_c('select-field',{attrs:{"data":_vm.formCreate.fields.state},on:{"changeData":function($event){_vm.formCreate.fields.state.value = $event}}}),_c('date-field',{attrs:{"data":_vm.formCreate.fields.appCreationDate},on:{"changeData":function($event){_vm.formCreate.fields.appCreationDate.value = $event}}}),_c('div',{staticClass:"section-title"}),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('checkbox-field',{ref:"formCreateBrands",attrs:{"data":_vm.formCreate.fields.brands},on:{"changeData":function($event){_vm.formCreate.fields.brands.value = $event; _vm.actionSelectedBrands($event)}}})],1)]),_c('input',{attrs:{"type":"submit","hidden":"hidden"}}),(_vm.formCreate.fields.client.value != '' && Object.keys(_vm.formCreate.fields.associateAccounts.value).length == 0)?_c('div',{staticClass:"section-text"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.client_not_have_relations")))]):_vm._e(),_c('checkbox-field',{attrs:{"data":_vm.formCreate.fields.associateAccounts},on:{"changeData":function($event){_vm.formCreate.fields.associateAccounts.value = $event}}}),(_vm.formCreate.fields.brands.options.dso.value)?_c('div',[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.fields.dso")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select-field',{ref:"dsoSalon",attrs:{"data":_vm.formCreate.fields.dsoSalon},on:{"changeData":function($event){_vm.formCreate.fields.dsoSalon.value = $event; _vm.actionSelectDSOSalon($event)}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('checkbox-field',{ref:"dsoBrands",attrs:{"data":_vm.formCreate.fields.dsoBrands},on:{"changeData":function($event){_vm.formCreate.fields.dsoBrands.value = $event;}}})],1),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('select-field',{ref:"dsoMTKG",attrs:{"data":_vm.formCreate.fields.dsoMTKG},on:{"changeData":function($event){_vm.formCreate.fields.dsoMTKG.value = $event; _vm.actionSelectDSOMTKG($event)}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('text-field',{ref:"dsoMTKGSubtype",attrs:{"data":_vm.formCreate.fields.dsoMTKGSubtype},on:{"changeData":function($event){_vm.formCreate.fields.dsoMTKGSubtype.value = $event}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"dsoPTS",attrs:{"data":_vm.formCreate.fields.dsoPTS},on:{"changeData":function($event){_vm.formCreate.fields.dsoPTS.value = $event}}})],1)])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('text-field',{ref:"dsoSection",attrs:{"data":_vm.formCreate.fields.dsoSection},on:{"changeData":function($event){_vm.formCreate.fields.dsoSection.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{ref:"dsoRappel",attrs:{"data":_vm.formCreate.fields.dsoRappel},on:{"changeData":function($event){_vm.formCreate.fields.dsoRappel.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{ref:"briogeoRappel",attrs:{"data":_vm.formCreate.fields.briogeoRappel},on:{"changeData":function($event){_vm.formCreate.fields.briogeoRappel.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{ref:"dsoDiscount",attrs:{"data":_vm.formCreate.fields.dsoDiscount},on:{"changeData":function($event){_vm.formCreate.fields.dsoDiscount.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('text-field',{ref:"dsoRappelMarketing",attrs:{"data":_vm.formCreate.fields.dsoRappelMarketing},on:{"changeData":function($event){_vm.formCreate.fields.dsoRappelMarketing.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('text-field',{ref:"dsoEducation",attrs:{"data":_vm.formCreate.fields.dsoEducation},on:{"changeData":function($event){_vm.formCreate.fields.dsoEducation.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{ref:"dsoPotential",attrs:{"data":_vm.formCreate.fields.dsoPotential},on:{"changeData":function($event){_vm.formCreate.fields.dsoPotential.value = $event}}})],1),_c('div',{staticClass:"col-md-6"},[_c('select-field',{ref:"dsoRappelFrequency",attrs:{"data":_vm.formCreate.fields.dsoRappelFrequency},on:{"changeData":function($event){_vm.formCreate.fields.dsoRappelFrequency.value = $event}}})],1)])]):_vm._e(),(_vm.formCreate.fields.brands.options.iso.value)?_c('div',[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.fields.iso")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"wellaQuantity",attrs:{"data":_vm.formCreate.fields.wellaQuantity},on:{"changeData":function($event){_vm.formCreate.fields.wellaQuantity.value = $event; _vm.onChangeIsoQuantity($event)}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"wellaDiscount",attrs:{"data":_vm.formCreate.fields.wellaDiscount},on:{"changeData":function($event){_vm.formCreate.fields.wellaDiscount.value = $event;}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"wellaVolumeRappel",attrs:{"data":_vm.formCreate.fields.wellaVolumeRappel},on:{"changeData":function($event){_vm.formCreate.fields.wellaVolumeRappel.value = $event;}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"rappelMKTG",attrs:{"data":_vm.formCreate.fields.rappelMKTG},on:{"changeData":function($event){_vm.formCreate.fields.rappelMKTG.value = $event;}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"rappelMKTGManual",attrs:{"data":_vm.formCreate.fields.rappelMKTGManual},on:{"changeData":function($event){_vm.formCreate.fields.rappelMKTGManual.value = $event; _vm.onChangeWellaTradeManual($event)}}})],1)])]):_vm._e(),(_vm.formCreate.fields.brands.options.opi.value)?_c('div',[_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.fields.opi")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"opiQuantity",attrs:{"data":_vm.formCreate.fields.opiQuantity},on:{"changeData":function($event){_vm.formCreate.fields.opiQuantity.value = $event; _vm.onChangeOpiQuantity($event)}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"opiDiscount",attrs:{"data":_vm.formCreate.fields.opiDiscount},on:{"changeData":function($event){_vm.formCreate.fields.opiDiscount.value = $event;}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{ref:"opiRappel",attrs:{"data":_vm.formCreate.fields.opiRappel},on:{"changeData":function($event){_vm.formCreate.fields.opiRappel.value = $event;}}})],1)])]):_vm._e(),_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.observations")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('textarea-field',{attrs:{"data":_vm.formCreate.fields.observations},on:{"changeData":function($event){_vm.formCreate.fields.observations.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('select-field',{attrs:{"data":_vm.formCreate.fields.prorated},on:{"changeData":function($event){_vm.formCreate.fields.prorated.value = $event; _vm.validateProrated()}}})],1),_c('div',{staticClass:"col-md-6"},[_c('select-field',{ref:"proratedMonth",attrs:{"data":_vm.formCreate.fields.proratedMonth},on:{"changeData":function($event){_vm.formCreate.fields.proratedMonth.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('select-field',{attrs:{"data":_vm.formCreate.fields.mktNews},on:{"changeData":function($event){_vm.formCreate.fields.mktNews.value = $event}}})],1)]),_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.formCreate.fields.pdf},on:{"changeData":function($event){_vm.formCreate.fields.pdf.value = $event}}})],1)]),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formCreateSubmit}},[(!_vm.formCreate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.create_button")))]):_vm._e(),(_vm.formCreate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayCreateContract = false}}})]):_vm._e(),(_vm.displayUpdateContract)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal fade-in"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.contracts_update"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.displayUpdateContract = false}}})]),_c('div',{staticClass:"body"},[_c('form',{staticClass:"form",on:{"submit":function($event){$event.preventDefault();return _vm.formUpdateSubmit($event)}}},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.clientCode},on:{"changeData":function($event){_vm.formUpdate.fields.clientCode.value = $event}}}),_c('select-field',{attrs:{"data":_vm.formUpdate.fields.state},on:{"changeData":function($event){_vm.formUpdate.fields.state.value = $event}}}),_c('input',{attrs:{"type":"submit","hidden":"hidden"}}),(_vm.formUpdate.fields.client.value != '' && Object.keys(_vm.formUpdate.fields.associateAccounts.value).length == 0)?_c('div',{staticClass:"section-text"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.client_not_have_relations")))]):_vm._e(),_c('checkbox-field',{attrs:{"data":_vm.formUpdate.fields.associateAccounts},on:{"changeData":function($event){_vm.formUpdate.fields.associateAccounts.value = $event}}}),_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.fields.dso")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoDate},on:{"changeData":function($event){_vm.formUpdate.fields.dsoDate.value = $event}}})],1),_c('div',{staticClass:"col-md-6"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoSalon},on:{"changeData":function($event){_vm.formUpdate.fields.dsoSalon.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('checkbox-field',{attrs:{"data":_vm.formUpdate.fields.dsoBrands},on:{"changeData":function($event){_vm.formUpdate.fields.dsoBrands.value = $event}}})],1),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoMTKG},on:{"changeData":function($event){_vm.formUpdate.fields.dsoMTKG.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoMTKGSubtype},on:{"changeData":function($event){_vm.formUpdate.fields.dsoMTKGSubtype.value = $event}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoPTS},on:{"changeData":function($event){_vm.formUpdate.fields.dsoPTS.value = $event}}})],1)])])]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoSection},on:{"changeData":function($event){_vm.formUpdate.fields.dsoSection.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoRappel},on:{"changeData":function($event){_vm.formUpdate.fields.dsoRappel.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.briogeoRappel},on:{"changeData":function($event){_vm.formUpdate.fields.briogeoRappel.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoDiscount},on:{"changeData":function($event){_vm.formUpdate.fields.dsoDiscount.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoRappelMarketing},on:{"changeData":function($event){_vm.formUpdate.fields.dsoRappelMarketing.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoEducation},on:{"changeData":function($event){_vm.formUpdate.fields.dsoEducation.value = $event}}})],1),_c('div',{staticClass:"col-md-3"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoPotential},on:{"changeData":function($event){_vm.formUpdate.fields.dsoPotential.value = $event}}})],1),_c('div',{staticClass:"col-md-6"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.dsoSalon.value ? _vm.formUpdate.fields.dsoRappelFrequency : ''},on:{"changeData":function($event){_vm.formUpdate.fields.dsoRappelFrequency.value = $event}}})],1)]),_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.fields.iso")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.wellaQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.wellaQuantity.value = $event;}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.wellaDiscount},on:{"changeData":function($event){_vm.formUpdate.fields.wellaDiscount.value = $event}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.wellaVolumeRappel},on:{"changeData":function($event){_vm.formUpdate.fields.wellaVolumeRappel.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.rappelMKTG},on:{"changeData":function($event){_vm.formUpdate.fields.rappelMKTG.value = $event}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.rappelMKTGManual},on:{"changeData":function($event){_vm.formUpdate.fields.rappelMKTGManual.value = $event}}})],1)]),_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.fields.opi")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.opiQuantity},on:{"changeData":function($event){_vm.formUpdate.fields.opiQuantity.value = $event}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.opiDiscount},on:{"changeData":function($event){_vm.formUpdate.fields.opiDiscount.value = $event}}})],1),_c('div',{staticClass:"col-md-4"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.opiRappel},on:{"changeData":function($event){_vm.formUpdate.fields.opiRappel.value = $event}}})],1)]),_c('div',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.observations")))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('textarea-field',{attrs:{"data":_vm.formUpdate.fields.observations},on:{"changeData":function($event){_vm.formUpdate.fields.observations.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.prorated},on:{"changeData":function($event){_vm.formUpdate.fields.prorated.value = $event}}})],1),_c('div',{staticClass:"col-md-6"},[_c('text-field',{attrs:{"data":_vm.formUpdate.fields.proratedMonth},on:{"changeData":function($event){_vm.formUpdate.fields.proratedMonth.value = $event}}})],1)]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('select-field',{attrs:{"data":_vm.formUpdate.fields.mktNews},on:{"changeData":function($event){_vm.formUpdate.fields.mktNews.value = $event}}})],1)]),_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.formUpdate.fields.pdf},on:{"changeData":function($event){_vm.formUpdate.fields.pdf.value = $event}}})],1)]),_c('input',{attrs:{"type":"submit","hidden":"hidden"}})],1),_c('div',{staticClass:"button",on:{"click":_vm.formUpdateSubmit}},[(!_vm.formUpdate.active)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.update_button")))]):_vm._e(),(_vm.formUpdate.active)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.displayUpdateContract = false}}})]):_vm._e(),(_vm.migrateContractsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in"},[_c('div',{staticClass:"header"},[_vm._v("Migrar Contratos - CSV"),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.migrateContractsWindow.display = false; _vm.resetDataMigrateContractsWindow ()}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('file-field',{attrs:{"data":_vm.migrateContractsWindow.fields.csv},on:{"changeData":function($event){_vm.migrateContractsWindow.fields.csv.value = $event;}}})],1),_c('div',{staticClass:"col-md-6"},[(_vm.migrateContractsWindow.fields.csv.value.data)?_c('div',{staticClass:"button",on:{"click":function($event){_vm.migrateContractsSubmit()}}},[(!_vm.migrateContractsWindow.migrateCSVFileActive)?_c('span',[_vm._v("Enviar CSV")]):_vm._e(),(_vm.migrateContractsWindow.migrateCSVFileActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e()]),(_vm.migrateContractsWindow.migrateCSVFileActive)?_c('div',{staticClass:"loading-container"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t("private.clients.list.import_clients_modal.please_wait")))])]):_vm._e()]),(!_vm.migrateContractsWindow.migrateCSVFileActive && (_vm.migrateContractsWindow.contractsToCreated.length > 0 || _vm.migrateContractsWindow.contractsWithErrors.length > 0))?_c('div',[_c('hr'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Contratos Migrados ' + _vm.migrateContractsWindow.contractsToCreated.length))]),_c('div',{staticClass:"col-md-6"},[_vm._v(_vm._s('Contratos con errores ' + _vm.migrateContractsWindow.contractsWithErrors.length))])]),_c('hr'),(_vm.migrateContractsWindow.contractsWithErrors.length > 0)?_c('div',{staticClass:"table-container"},[_c('div',{staticClass:"title"},[_vm._v("Datos con Errores")]),_c('table',{staticClass:"table table-bordered table-sm",staticStyle:{"display":"inline-table"}},[_vm._m(2),_c('tbody',_vm._l((_vm.migrateContractsWindow.contractsWithErrors),function(contract,index){return _c('tr',[_c('td',[_vm._v(_vm._s(contract.contract ? contract.contract.client : contract.client))]),_c('td',[_vm._v(_vm._s(contract.error.field ? contract.error.field : ''))]),_c('td',[_vm._v(_vm._s(contract.error.value ? contract.error.value : ''))]),_c('td',[_vm._v(_vm._s(contract.error.message ? contract.error.message : ''))])])}))])]):_vm._e()]):_vm._e()])])]),_c('div',{staticClass:"back-screen",on:{"click":function($event){_vm.migrateContractsWindow.display = false; _vm.resetDataMigrateContractsWindow()}}})]):_vm._e(),(_vm.exportZipPDFsWindow.display)?_c('div',{staticClass:"window-modal-container"},[_c('div',{staticClass:"window-modal import fade-in",staticStyle:{"height":"500px"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t("private.contracts.list.export_zip_pdfs_window.title"))),_c('i',{staticClass:"fa fa-times icon round-icon first-color",on:{"click":function($event){_vm.exportZipPDFsWindow.display = false;}}})]),_c('div',{staticClass:"body"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-md-center"},[_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.year},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.year.value = $event; _vm.generateMoths()}}})],1),_c('div',{staticClass:"col-md-4"},[_c('select-field',{attrs:{"data":_vm.exportZipPDFsWindow.fields.month},on:{"changeData":function($event){_vm.exportZipPDFsWindow.fields.month.value = $event;}}})],1)])]),(_vm.exportZipPDFsWindow.fields.year.value && _vm.exportZipPDFsWindow.fields.month.value)?_c('div',{staticClass:"button",on:{"click":_vm.exportZipPDFs}},[(!_vm.exportZipPDFsWindow.downloadZipPDFsActive)?_c('span',[_vm._v(_vm._s(_vm.$t("private.contracts.list.export_zip_pdfs_window.download_button")))]):_vm._e(),(_vm.exportZipPDFsWindow.downloadZipPDFsActive)?_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw icon"}):_vm._e()]):_vm._e(),(_vm.exportZipPDFsWindow.progress.display)?_c('div',{staticStyle:{"margin":"10px 100px"}},[_c('span',[_vm._v("Comprimiendo")]),_c('div',{staticClass:"progress"},[_c('div',{ref:"progressIdExportZiPpdf",staticClass:"progress-bar progress-bar-success progress-bar-striped",staticStyle:{"width":"0%"},attrs:{"id":"progress_id_export_zippdf","role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}})]),_c('br'),_c('span',[_vm._v("Descargando")]),_c('div',{staticClass:"progress"},[_c('div',{ref:"progressIdExportZipPdfDownload",staticClass:"progress-bar progress-bar-success progress-bar-striped",staticStyle:{"width":"0%"},attrs:{"id":"progress_id_export_zippdf_download","role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}})])]):_vm._e()])]),_c('div',{staticClass:"back-screen"})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"colspan":"5"}},[_c('span',[_vm._v("Vendedores")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{attrs:{"colspan":"3"}},[_c('span',[_vm._v("Asociados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Contrato")]),_c('th',[_vm._v("Campo")]),_c('th',[_vm._v("Valor")]),_c('th',[_vm._v("Descripción")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wWPP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locales_i18n__ = __webpack_require__("0Wv9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_js__ = __webpack_require__("oQbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_js__);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'data-validator',
	data: function data() {
		return {};
	},

	methods: {
		validate: function (_validate) {
			function validate(_x) {
				return _validate.apply(this, arguments);
			}

			validate.toString = function () {
				return _validate.toString();
			};

			return validate;
		}(function (data) {

			for (var i in data) {

				var field = data[i];

				if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(field, 'disabled') && field.disabled) continue;

				if (field.filters.type == 'string') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (field.filters.minLength) {

						if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(field.value) < field.filters.minLength && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.min_length').replace('%name%', field.name).replace('%length%', field.filters.minLength)]
							};

							return response;
						}
					}

					if (field.filters.maxLength) {

						if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(field.value) > field.filters.maxLength && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.max_length').replace('%name%', field.name).replace('%length%', field.filters.maxLength)]
							};

							return response;
						}
					}

					if (field.filters.enum) {

						if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.inArray(field.value, field.filters.enum) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.invalid_option').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.string(field.value) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}
				}

				if (field.filters.type == 'boolean') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.boolean(field.value) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}
				}

				if (field.filters.type == 'email') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value) || __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isUndefined(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (field.filters.minLength) {

						if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(field.value) < field.filters.minLength && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value) && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isUndefined(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.min_length').replace('%name%', field.name).replace('%length%', field.filters.minLength)]
							};

							return response;
						}
					}

					if (field.filters.maxLength) {

						if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(field.value) > field.filters.maxLength && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value) && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isUndefined(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.max_length').replace('%name%', field.name).replace('%length%', field.filters.maxLength)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isUndefined(field.value) && field.value != '' && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.email(field.value)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}
				}

				if (field.filters.type == 'number') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.number(field.value * 1)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}

					if (field.filters.smallerThan) {

						if (field.value < field.filters.smallerThan && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.numeric.smaller_than').replace('%name%', field.name).replace('%number%', field.filters.smallerThan)]
							};

							return response;
						}
					}

					if (field.filters.greatherThan && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

						if (field.value > field.filters.greatherThan) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.numeric.greather_than').replace('%name%', field.name).replace('%number%', field.filters.greatherThan)]
							};

							return response;
						}
					}
				}

				if (field.filters.type == 'url') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.url(field.value) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}
				}

				if (field.filters.type == 'date') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.date(new Date(field.value)) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}

					if (field.filters.smallerThan) {

						if (new Date(field.value) < new Date(field.filters.smallerThan) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								key: i,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.date.smaller_than').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (field.filters.greatherThan) {

						if (new Date(field.value) > new Date(field.filters.greatherThan) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								key: i,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.date.greather_than').replace('%name%', field.name)]
							};

							return response;
						}
					}
				}

				if (field.filters.type == 'array') {

					if (field.filters.required) {

						if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(field.value) == 0) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.array(field.value) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

						var response = {
							success: false,
							field: field,
							message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
						};

						return response;
					}

					if (field.filters.enum) {

						if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.inArray(field.value, field.filters.enum) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(field.value)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.invalid_option').replace('%name%', field.name)]
							};

							return response;
						}
					}
				}

				if (field.filters.type == 'file') {

					if (field.filters.required) {

						if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(field.value, 'data')) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.required').replace('%name%', field.name)]
							};

							return response;
						}
					}

					if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.has(field.value, 'data')) {

						if (field.filters.maxSize) {

							if (field.value.size > field.filters.maxSize) {

								var response = {
									success: false,
									field: field,
									message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.file.size').replace('%size%', field.filters.maxSize)]
								};

								return response;
							}
						}

						if (field.filters.formatsAllowed) {

							if (!__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(field.filters.formatsAllowed, field.value.format)) {

								var response = {
									success: false,
									field: field,
									message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.file.format').replace('%formats%', field.filters.formatsAllowed.join(', '))]
								};

								return response;
							}
						}
					}
				}

				if (field.filters.type == 'manyFields') {

					for (var j = 0; j < __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.size(field.value); j++) {

						var datoToValidate = {
							field: field.value[j]
						};

						var success = true;

						validate(datoToValidate, function (response) {

							if (!response.success) {

								success = false;

								return response;
							}
						});

						if (!success) {

							return;
						}
					}
				}

				if (field.filters.type == 'manyOptions') {

					for (var j in field.value) {

						var option = field.value[j];

						if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.boolean(option) && !__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.empty(option)) {

							var response = {
								success: false,
								field: field,
								message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.type').replace('%name%', field.name)]
							};

							return response;
						}

						if (field.filters.enum) {

							if (!__WEBPACK_IMPORTED_MODULE_2_is_js___default.a.inArray(j, field.filters.enum)) {

								var response = {
									success: false,
									field: field,
									message: [__WEBPACK_IMPORTED_MODULE_0__locales_i18n__["a" /* default */].t('data_validator.invalid_option').replace('%name%', field.name)]
								};

								return response;
							}
						}
					}
				}
			}

			var response = {
				success: true
			};

			return response;
		})
	},
	created: function created() {

		var vm = this;

		vm.$root.$on('validate', function (data) {

			var dataToValidate = data[0];
			var cb = data[1];

			cb(vm.validate(dataToValidate));
		});
	}
});

/***/ }),

/***/ "wtYE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("OScl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8b264e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("Go9E");
function injectStyle (ssrContext) {
  __webpack_require__("q2MK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a8b264e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a8b264e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "yIGs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yQYn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__ = __webpack_require__("gMwH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f774123_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__ = __webpack_require__("59qL");
function injectStyle (ssrContext) {
  __webpack_require__("/euX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f774123"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_script_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f774123_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_template_pug__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yeTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{staticClass:"field-container",style:(_vm.data.style)},[(_vm.field.fakeValue !== '')?_c('div',{staticClass:"field-title fade-in"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.fakeValue),expression:"field.fakeValue"}],staticClass:"select-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"text","placeholder":_vm.data.name,"id":_vm.data.id},domProps:{"value":(_vm.field.fakeValue)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "fakeValue", $event.target.value)},_vm.getData],"click":function($event){_vm.data.error = false; _vm.field.active ? _vm.field.active = false : _vm.field.active = true;}}}),_c('i',{staticClass:"fa fa-search search-icon"}),(_vm.field.active)?_c('div',{staticClass:"options-container"},[_c('ul',{staticClass:"options",on:{"click":function($event){_vm.field.active = false}}},_vm._l((_vm.data.options),function(option){return _c('li',{staticClass:"fade-in option",on:{"click":function($event){_vm.optionSelected(option)}}},[_vm._v(_vm._s(option.fakeValue))])}))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ykU3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api__ = __webpack_require__("P9l9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_routes__ = __webpack_require__("KWv7");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'sellers',
	data: function data() {
		return {
			routes: __WEBPACK_IMPORTED_MODULE_1__router_routes__["a" /* default */]
		};
	},

	methods: {},
	components: {},
	created: function created() {}
});

/***/ }),

/***/ "ymJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"private-header"},[_c('ul',{staticClass:"sections-container"},[_c('li',{staticClass:"section hidden-xs"}),_c('li',{staticClass:"section middle hidden-xs"},[_vm._v(_vm._s(_vm.$t("views_names." + _vm.$route.name)))]),_c('li',{staticClass:"section right-side"},[_c('ul',{staticClass:"items-container"},[_c('li',{staticClass:"item visible-xs item-left",on:{"click":function($event){_vm.asideToggle()}}},[_c('i',{staticClass:"fa fa-bars icon"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z9Du":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data.display)?_c('div',{staticClass:"field-container",style:(_vm.data.style)},[(_vm.field.value !== '')?_c('div',{staticClass:"field-title fade-in"},[_vm._v(_vm._s(_vm.data.name))]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.field.fakeValue),expression:"field.fakeValue"}],staticClass:"select-field",class:{ 'shadow-in-error' : _vm.data.error },attrs:{"type":"text","placeholder":_vm.data.name,"id":_vm.data.id,"onfocus":"document.activeElement.blur()","disabled":_vm.data.disabled},domProps:{"value":(_vm.field.fakeValue)},on:{"click":function($event){_vm.data.error = false; _vm.field.active ? _vm.field.active = false : _vm.field.active = true;},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.field, "fakeValue", $event.target.value)}}}),_c('i',{staticClass:"fa fa-caret-down caret-select-field"}),(_vm.field.active)?_c('div',{staticClass:"options-container"},[_c('ul',{staticClass:"options",on:{"click":function($event){_vm.field.active = false}}},_vm._l((_vm.data.options),function(option){return _c('li',{staticClass:"fade-in option",on:{"click":function($event){_vm.changeData(option)}}},[_vm._v(_vm._s(option.fakeValue))])}))]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zxDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.a1dd1dd37cf4e04f004a.js